import CSS from 'csstype';
import React, { JSX } from 'react';

interface IIconProps {
  className: string;
  color: string;
  large?: boolean;
  small?: boolean;
  style?: CSS.Properties;
}

// keep the icons alphabetized
export const AddIcon = ({ color, large, small, style, className }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M7.58333 6.41667V2.91667C7.58333 2.59583 7.32083 2.33333 7 2.33333C6.67917 2.33333 6.41667 2.59583 6.41667 2.91667V6.41667H2.91667C2.59583 6.41667 2.33333 6.67917 2.33333 7C2.33333 7.32083 2.59583 7.58333 2.91667 7.58333H6.41667V11.0833C6.41667 11.4042 6.67917 11.6667 7 11.6667C7.32083 11.6667 7.58333 11.4042 7.58333 11.0833V7.58333H11.0833C11.4042 7.58333 11.6667 7.32083 11.6667 7C11.6667 6.67917 11.4042 6.41667 11.0833 6.41667H7.58333Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M9.75 8.25V3.75C9.75 3.3375 9.4125 3 9 3C8.5875 3 8.25 3.3375 8.25 3.75V8.25H3.75C3.3375 8.25 3 8.5875 3 9C3 9.4125 3.3375 9.75 3.75 9.75H8.25V14.25C8.25 14.6625 8.5875 15 9 15C9.4125 15 9.75 14.6625 9.75 14.25V9.75H14.25C14.6625 9.75 15 9.4125 15 9C15 8.5875 14.6625 8.25 14.25 8.25H9.75Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M8.66667 7.33333V3.33333C8.66667 2.96667 8.36667 2.66667 8 2.66667C7.63333 2.66667 7.33333 2.96667 7.33333 3.33333V7.33333H3.33333C2.96667 7.33333 2.66667 7.63333 2.66667 8C2.66667 8.36667 2.96667 8.66667 3.33333 8.66667H7.33333V12.6667C7.33333 13.0333 7.63333 13.3333 8 13.3333C8.36667 13.3333 8.66667 13.0333 8.66667 12.6667V8.66667H12.6667C13.0333 8.66667 13.3333 8.36667 13.3333 8C13.3333 7.63333 13.0333 7.33333 12.6667 7.33333H8.66667Z'
        fill={color}
      />
    </svg>
  );
};

export const ActivityIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M8.10784 2.09031C7.89858 2.13136 7.72824 2.30562 7.66939 2.53876L5.73097 9.44887L4.20783 5.33443L4.20764 5.33422C4.12811 5.11053 3.94385 4.95797 3.73308 4.941C3.52213 4.92424 3.32133 5.04607 3.21528 5.25493L2.03831 7.60223H0.56123C0.413074 7.60008 0.270367 7.66583 0.164891 7.78466C0.0594141 7.90371 0 8.06594 0 8.23526C0 8.40458 0.0594141 8.56702 0.164891 8.68585C0.270367 8.80489 0.413069 8.87064 0.56123 8.86828H2.36127C2.56094 8.87043 2.74614 8.74945 2.84596 8.55177L3.63056 6.99564L5.29223 11.5321V11.5323C5.38191 11.7768 5.59568 11.9316 5.8275 11.9197C6.05933 11.9081 6.26013 11.7326 6.33063 11.4799L8.19988 4.78046L9.69987 9.94995H9.70006C9.76812 10.1917 9.95595 10.3636 10.1772 10.3866C10.3985 10.4096 10.6104 10.2791 10.7156 10.0555L11.7771 7.9454H13.4388C13.5869 7.94777 13.7296 7.88202 13.8351 7.76297C13.9406 7.64415 14 7.4817 14 7.31238C14 7.14306 13.9406 6.98083 13.8351 6.86179C13.7296 6.74296 13.5869 6.67721 13.4388 6.67936H11.4541C11.2544 6.67742 11.0692 6.7984 10.9694 6.99587L10.3694 8.20907L8.73088 2.51189V2.5121C8.64345 2.21428 8.37835 2.03465 8.10781 2.09008L8.10784 2.09031Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M10.4244 4.09031C10.1553 4.13136 9.93631 4.30562 9.86064 4.53876L7.36838 11.4489L5.41006 7.33443L5.40982 7.33422C5.30757 7.11053 5.07066 6.95797 4.79968 6.941C4.52845 6.92424 4.27028 7.04607 4.13393 7.25493L2.62068 9.60223H0.721581C0.531096 9.60008 0.347615 9.66583 0.212002 9.78466C0.0763895 9.90371 0 10.0659 0 10.2353C0 10.4046 0.0763895 10.567 0.212002 10.6858C0.347615 10.8049 0.531089 10.8706 0.721581 10.8683H3.03592C3.29264 10.8704 3.53075 10.7494 3.65909 10.5518L4.66787 8.99564L6.80429 13.5321V13.5323C6.9196 13.7768 7.19445 13.9316 7.4925 13.9197C7.79056 13.9081 8.04874 13.7326 8.13938 13.4799L10.5427 6.78046L12.4713 11.95H12.4715C12.559 12.1917 12.8005 12.3636 13.085 12.3866C13.3696 12.4096 13.642 12.2791 13.7771 12.0555L15.142 9.9454H17.2784C17.4689 9.94777 17.6524 9.88202 17.788 9.76297C17.9236 9.64415 18 9.4817 18 9.31238C18 9.14306 17.9236 8.98083 17.788 8.86179C17.6524 8.74296 17.4689 8.67721 17.2784 8.67936H14.7267C14.47 8.67742 14.2319 8.7984 14.1035 8.99587L13.3321 10.2091L11.2254 4.51189V4.5121C11.113 4.21428 10.7722 4.03465 10.4243 4.09008L10.4244 4.09031Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M9.2661 3.09031C9.02695 3.13136 8.83227 3.30562 8.76501 3.53876L6.54967 10.4489L4.80894 6.33443L4.80873 6.33422C4.71784 6.11053 4.50726 5.95797 4.26638 5.941C4.02529 5.92424 3.7958 6.04607 3.67461 6.25493L2.32949 8.60223H0.641405C0.472085 8.60008 0.308991 8.66583 0.188446 8.78466C0.0679018 8.90371 0 9.06594 0 9.23526C0 9.40458 0.0679018 9.56702 0.188446 9.68585C0.308991 9.80489 0.472079 9.87064 0.641405 9.86828H2.6986C2.92679 9.87043 3.13845 9.74945 3.25253 9.55177L4.14921 7.99564L6.04826 12.5321V12.5323C6.15076 12.7768 6.39507 12.9316 6.66 12.9197C6.92494 12.9081 7.15443 12.7326 7.235 12.4799L9.37129 5.78046L11.0856 10.95H11.0858C11.1636 11.1917 11.3782 11.3636 11.6311 11.3866C11.884 11.4096 12.1262 11.2791 12.2463 11.0555L13.4596 8.9454H15.3586C15.5279 8.94777 15.691 8.88202 15.8116 8.76297C15.9321 8.64415 16 8.4817 16 8.31238C16 8.14306 15.9321 7.98083 15.8116 7.86179C15.691 7.74296 15.5279 7.67721 15.3586 7.67936H13.0904C12.8622 7.67742 12.6505 7.7984 12.5365 7.99587L11.8508 9.20907L9.97814 3.51189V3.5121C9.87823 3.21428 9.57525 3.03465 9.26607 3.09008L9.2661 3.09031Z'
        fill={color}
      />
    </svg>
  );
};

export const AIIcon = ({ small, large }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_d_5679_52490)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M13.521 2H8.47899C7.85291 1.99999 7.33617 1.99998 6.91525 2.03437C6.47806 2.07009 6.07618 2.14675 5.6987 2.33909C5.1133 2.63736 4.63736 3.1133 4.33909 3.6987C4.14675 4.07618 4.07009 4.47806 4.03437 4.91525C3.99998 5.33617 3.99999 5.8529 4 6.47898V11.521C3.99999 12.1471 3.99998 12.6638 4.03437 13.0848C4.07009 13.5219 4.14675 13.9238 4.33909 14.3013C4.63736 14.8867 5.1133 15.3626 5.6987 15.6609C6.07618 15.8532 6.47806 15.9299 6.91525 15.9656C7.33617 16 7.85289 16 8.47897 16H13.521C14.1471 16 14.6638 16 15.0848 15.9656C15.5219 15.9299 15.9238 15.8532 16.3013 15.6609C16.8867 15.3626 17.3626 14.8867 17.6609 14.3013C17.8532 13.9238 17.9299 13.5219 17.9656 13.0848C18 12.6638 18 12.1471 18 11.521V6.47897C18 5.85289 18 5.33617 17.9656 4.91525C17.9299 4.47806 17.8532 4.07618 17.6609 3.6987C17.3626 3.1133 16.8867 2.63736 16.3013 2.33909C15.9238 2.14675 15.5219 2.07009 15.0848 2.03437C14.6638 1.99998 14.1471 1.99999 13.521 2ZM10.6311 4.98811L9.72036 7.72031L6.98816 8.63105V9.36891L9.72036 10.2796L10.6311 13.0118H11.369L12.2797 10.2796L15.0119 9.36891V8.63105L12.2797 7.72031L11.369 4.98811H10.6311Z'
            fill='url(#paint0_linear_5679_52490)'
          />
        </g>
        <defs>
          <filter
            id='filter0_d_5679_52490'
            x='0'
            y='0'
            width='22'
            height='22'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='2' />
            <feGaussianBlur stdDeviation='2' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.541176 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 0.25 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_5679_52490'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect1_dropShadow_5679_52490'
              result='shape'
            />
          </filter>
          <linearGradient
            id='paint0_linear_5679_52490'
            x1='11'
            y1='2'
            x2='11'
            y2='16'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#DB08D3' />
            <stop offset='1' stop-color='#5D66FA' />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='26'
        height='26'
        viewBox='0 0 26 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_d_5323_151337)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M16.2413 2H9.7587C8.95375 1.99999 8.28936 1.99998 7.74818 2.0442C7.18608 2.09012 6.66938 2.18868 6.18404 2.43598C5.43139 2.81947 4.81947 3.43139 4.43598 4.18404C4.18868 4.66938 4.09012 5.18608 4.0442 5.74818C3.99998 6.28936 3.99999 6.95373 4 7.75869V14.2413C3.99999 15.0463 3.99998 15.7106 4.0442 16.2518C4.09012 16.8139 4.18868 17.3306 4.43598 17.816C4.81947 18.5686 5.43139 19.1805 6.18404 19.564C6.66938 19.8113 7.18608 19.9099 7.74818 19.9558C8.28937 20 8.95372 20 9.75868 20H16.2413C17.0463 20 17.7106 20 18.2518 19.9558C18.8139 19.9099 19.3306 19.8113 19.816 19.564C20.5686 19.1805 21.1805 18.5686 21.564 17.816C21.8113 17.3306 21.9099 16.8139 21.9558 16.2518C22 15.7106 22 15.0463 22 14.2413V7.75868C22 6.95372 22 6.28937 21.9558 5.74818C21.9099 5.18608 21.8113 4.66938 21.564 4.18404C21.1805 3.43139 20.5686 2.81947 19.816 2.43598C19.3306 2.18868 18.8139 2.09012 18.2518 2.0442C17.7106 1.99998 17.0463 1.99999 16.2413 2ZM12.5257 5.84186L11.3547 9.35469L7.84192 10.5256V11.4743L11.3547 12.6453L12.5257 16.1581H13.4744L14.6453 12.6453L18.1581 11.4743V10.5256L14.6453 9.35469L13.4744 5.84186H12.5257Z'
            fill='url(#paint0_linear_5323_151337)'
          />
        </g>
        <defs>
          <filter
            id='filter0_d_5323_151337'
            x='0'
            y='0'
            width='26'
            height='26'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='2' />
            <feGaussianBlur stdDeviation='2' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.541176 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 0.25 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_5323_151337'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect1_dropShadow_5323_151337'
              result='shape'
            />
          </filter>
          <linearGradient
            id='paint0_linear_5323_151337'
            x1='13'
            y1='2'
            x2='13'
            y2='20'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#DB08D3' />
            <stop offset='1' stop-color='#5D66FA' />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_5679_52488)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.8812 2H9.11885C8.40333 1.99999 7.81277 1.99998 7.33171 2.03928C6.83207 2.08011 6.37278 2.16772 5.94137 2.38753C5.27235 2.72842 4.72842 3.27235 4.38753 3.94137C4.16772 4.37278 4.08011 4.83207 4.03928 5.33171C3.99998 5.81277 3.99999 6.40332 4 7.11883V12.8812C3.99999 13.5967 3.99998 14.1872 4.03928 14.6683C4.08011 15.1679 4.16772 15.6272 4.38753 16.0586C4.72842 16.7277 5.27235 17.2716 5.94137 17.6125C6.37278 17.8323 6.83207 17.9199 7.33171 17.9607C7.81277 18 8.40331 18 9.11882 18H14.8812C15.5967 18 16.1872 18 16.6683 17.9607C17.1679 17.9199 17.6272 17.8323 18.0586 17.6125C18.7277 17.2716 19.2716 16.7277 19.6125 16.0586C19.8323 15.6272 19.9199 15.1679 19.9607 14.6683C20 14.1872 20 13.5967 20 12.8812V7.11883C20 6.40331 20 5.81277 19.9607 5.33171C19.9199 4.83207 19.8323 4.37278 19.6125 3.94137C19.2716 3.27235 18.7277 2.72842 18.0586 2.38753C17.6272 2.16772 17.1679 2.08011 16.6683 2.03928C16.1872 1.99998 15.5967 1.99999 14.8812 2ZM11.5784 5.41499L10.5376 8.5375L7.41504 9.57834V10.4216L10.5376 11.4625L11.5784 14.585H12.4217L13.4625 11.4624L16.585 10.4216V9.57834L13.4625 8.5375L12.4217 5.41499H11.5784Z'
          fill='url(#paint0_linear_5679_52488)'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_5679_52488'
          x='0'
          y='0'
          width='24'
          height='24'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.541176 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 0.25 0'
          />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5679_52488' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_5679_52488'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_5679_52488'
          x1='12'
          y1='2'
          x2='12'
          y2='18'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#DB08D3' />
          <stop offset='1' stop-color='#5D66FA' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ArrowIcon = ({ color, small, large, style, className }: IIconProps) => {
  if (large) {
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.0762 10.02C13.8107 9.702 13.3382 9.6585 13.0202 9.924L9.75018 12.6488V3.75C9.75018 3.336 9.41418 3 9.00018 3C8.58618 3 8.25018 3.336 8.25018 3.75V12.6488L4.98018 9.924C4.66143 9.6585 4.18893 9.702 3.92418 10.02C3.65868 10.338 3.70143 10.8112 4.02018 11.076L8.52018 14.826C8.55543 14.856 8.59743 14.8703 8.63643 14.8927C8.66718 14.9108 8.69418 14.9318 8.72793 14.9452C8.81568 14.9797 8.90718 15 9.00018 15C9.09318 15 9.18468 14.9797 9.27243 14.9452C9.30618 14.9318 9.33318 14.9108 9.36393 14.8927C9.40293 14.8703 9.44493 14.856 9.48018 14.826L13.9802 11.076C14.2982 10.8112 14.3417 10.338 14.0762 10.02Z'
        fill={color}
      />
    </svg>;
  }
  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.9475 7.79398C10.741 7.54665 10.3735 7.51282 10.1262 7.71932L7.58282 9.83857V2.91732C7.58282 2.59532 7.32149 2.33398 6.99949 2.33398C6.67749 2.33398 6.41615 2.59532 6.41615 2.91732V9.83857L3.87282 7.71932C3.6249 7.51282 3.2574 7.54665 3.05149 7.79398C2.84499 8.04132 2.87824 8.4094 3.12615 8.61532L6.62615 11.532C6.65357 11.5553 6.68624 11.5664 6.71657 11.5839C6.74049 11.5979 6.76149 11.6142 6.78774 11.6247C6.85599 11.6516 6.92715 11.6673 6.99949 11.6673C7.07182 11.6673 7.14299 11.6516 7.21124 11.6247C7.23749 11.6142 7.25849 11.5979 7.2824 11.5839C7.31274 11.5664 7.3454 11.5553 7.37282 11.532L10.8728 8.61532C11.1202 8.4094 11.154 8.04132 10.9475 7.79398Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.5128 8.90601C12.2768 8.62335 11.8568 8.58468 11.5741 8.82068L8.66747 11.2427V3.33268C8.66747 2.96468 8.36881 2.66602 8.00081 2.66602C7.63281 2.66602 7.33414 2.96468 7.33414 3.33268V11.2427L4.42747 8.82068C4.14414 8.58468 3.72414 8.62335 3.48881 8.90601C3.25281 9.18868 3.29081 9.60935 3.57414 9.84468L7.57414 13.178C7.60547 13.2047 7.64281 13.2173 7.67747 13.2373C7.70481 13.2533 7.72881 13.272 7.75881 13.284C7.83681 13.3147 7.91814 13.3327 8.00081 13.3327C8.08347 13.3327 8.16481 13.3147 8.24281 13.284C8.27281 13.272 8.29681 13.2533 8.32414 13.2373C8.35881 13.2173 8.39614 13.2047 8.42747 13.178L12.4275 9.84468C12.7101 9.60935 12.7488 9.18868 12.5128 8.90601Z'
        fill={color}
      />
    </svg>
  );
};

export const ArrowUpIcon = ({ color, small, large, style, className }: IIconProps) => {
  if (large) {
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      style={style}
      fill={color}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.35034 11.8809H13.5593L8.99737 6.25636L4.35034 11.8809ZM13.9139 14.2137H4.08557C3.30173 14.2137 2.59255 13.7448 2.23679 12.9901C1.83437 12.1351 1.95101 11.1238 2.53772 10.4123L7.45304 4.46473C8.23687 3.51176 9.76372 3.51176 10.5464 4.46473L15.4605 10.4112C16.0484 11.1238 16.1662 12.1351 15.7626 12.9901C15.4069 13.7448 14.6989 14.2137 13.9139 14.2137V14.2137Z'
        fill='#4FC1B5'
      />
    </svg>;
  }
  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M3.6788 9.05776H10.2566L6.99812 5.04025L3.6788 9.05776ZM10.5099 10.7241H3.48967C2.92979 10.7241 2.42322 10.3892 2.16911 9.8501C1.88167 9.2394 1.96499 8.51704 2.38407 8.00882L5.89501 3.76052C6.4549 3.07983 7.54551 3.07983 8.10456 3.76052L11.6147 8.00798C12.0346 8.51705 12.1187 9.2394 11.8305 9.8501C11.5763 10.3892 11.0706 10.7241 10.5099 10.7241V10.7241Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.01458 10.4693H11.9079L7.99776 5.64829L4.01458 10.4693ZM12.2119 12.4689H3.78763C3.11577 12.4689 2.50789 12.067 2.20296 11.4201C1.85803 10.6873 1.95801 9.82044 2.4609 9.21056L6.67403 4.11262C7.34589 3.29579 8.65462 3.29579 9.32548 4.11262L13.5376 9.20956C14.0415 9.82044 14.1425 10.6873 13.7965 11.4201C13.4916 12.067 12.8847 12.4689 12.2119 12.4689V12.4689Z'
        fill={color}
      />
    </svg>
  );
};

export const AlertIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.41703 5.24935C6.41703 4.92735 6.67837 4.66602 7.00037 4.66602C7.32237 4.66602 7.5837 4.92735 7.5837 5.24935V7.58268C7.5837 7.90468 7.32237 8.16602 7.00037 8.16602C6.67837 8.16602 6.41703 7.90468 6.41703 7.58268V5.24935ZM6.41703 9.33268C6.41703 9.01068 6.67837 8.74935 7.00037 8.74935C7.32237 8.74935 7.5837 9.01068 7.5837 9.33268C7.5837 9.65468 7.32237 9.91602 7.00037 9.91602C6.67837 9.91602 6.41703 9.65468 6.41703 9.33268ZM12.1714 10.7053C12.0379 10.9415 11.7777 11.0827 11.4755 11.0827H2.52486C2.22269 11.0827 1.96252 10.9415 1.82952 10.7053C1.76652 10.5944 1.68369 10.3687 1.83944 10.112L6.31419 2.69318C6.58661 2.24168 7.41377 2.24168 7.68619 2.69318L12.1615 10.112C12.3167 10.3687 12.2344 10.5944 12.1714 10.7053ZM13.1608 9.50943L8.68544 2.09002C8.33602 1.51135 7.70602 1.16602 7.00019 1.16602C6.29436 1.16602 5.66436 1.51135 5.31552 2.09002L0.840191 9.50943C0.508274 10.0595 0.498357 10.721 0.813357 11.2787C1.15111 11.8778 1.80736 12.2493 2.52486 12.2493H11.4755C12.1936 12.2493 12.8493 11.8778 13.1876 11.2787C13.5026 10.721 13.4927 10.0595 13.1608 9.50943Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.24963 6.75C8.24963 6.336 8.58563 6 8.99963 6C9.41363 6 9.74963 6.336 9.74963 6.75V9.75C9.74963 10.164 9.41363 10.5 8.99963 10.5C8.58563 10.5 8.24963 10.164 8.24963 9.75V6.75ZM8.24963 12C8.24963 11.586 8.58563 11.25 8.99963 11.25C9.41363 11.25 9.74963 11.586 9.74963 12C9.74963 12.414 9.41363 12.75 8.99963 12.75C8.58563 12.75 8.24963 12.414 8.24963 12ZM15.6482 13.7648C15.4764 14.0685 15.1419 14.25 14.7534 14.25H3.24541C2.85691 14.25 2.52241 14.0685 2.35141 13.7648C2.27041 13.6223 2.16391 13.332 2.36416 13.002L8.11741 3.4635C8.46766 2.883 9.53116 2.883 9.88141 3.4635L15.6354 13.002C15.8349 13.332 15.7292 13.6223 15.6482 13.7648ZM16.9202 12.2273L11.1662 2.688C10.7169 1.944 9.90691 1.5 8.99941 1.5C8.09191 1.5 7.28191 1.944 6.83341 2.688L1.07941 12.2273C0.652658 12.9345 0.639908 13.785 1.04491 14.502C1.47916 15.2723 2.32291 15.75 3.24541 15.75H14.7534C15.6767 15.75 16.5197 15.2723 16.9547 14.502C17.3597 13.785 17.3469 12.9345 16.9202 12.2273Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.33431 6.00065C7.33431 5.63265 7.63298 5.33398 8.00098 5.33398C8.36898 5.33398 8.66764 5.63265 8.66764 6.00065V8.66732C8.66764 9.03532 8.36898 9.33398 8.00098 9.33398C7.63298 9.33398 7.33431 9.03532 7.33431 8.66732V6.00065ZM7.33431 10.6673C7.33431 10.2993 7.63298 10.0007 8.00098 10.0007C8.36898 10.0007 8.66764 10.2993 8.66764 10.6673C8.66764 11.0353 8.36898 11.334 8.00098 11.334C7.63298 11.334 7.33431 11.0353 7.33431 10.6673ZM13.9108 12.236C13.7581 12.506 13.4608 12.6673 13.1154 12.6673H2.88611C2.54078 12.6673 2.24344 12.506 2.09144 12.236C2.01944 12.1093 1.92478 11.8513 2.10278 11.558L7.21678 3.07932C7.52811 2.56332 8.47344 2.56332 8.78478 3.07932L13.8994 11.558C14.0768 11.8513 13.9828 12.1093 13.9108 12.236ZM15.0414 10.8693L9.92677 2.38998C9.52744 1.72865 8.80744 1.33398 8.00078 1.33398C7.19411 1.33398 6.47411 1.72865 6.07544 2.38998L0.960776 10.8693C0.581442 11.498 0.570109 12.254 0.930109 12.8913C1.31611 13.576 2.06611 14.0007 2.88611 14.0007H13.1154C13.9361 14.0007 14.6854 13.576 15.0721 12.8913C15.4321 12.254 15.4208 11.498 15.0414 10.8693Z'
        fill={color}
      />
    </svg>
  );
};

export const AvailableIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.57703 4.89614L6.3697 7.79472L5.41712 6.57789C5.21878 6.32356 4.85128 6.27922 4.59812 6.47814C4.34437 6.67647 4.29945 7.04339 4.49837 7.29656L5.91645 9.10897C6.02728 9.25014 6.19645 9.33239 6.37612 9.33239H6.3802C6.56045 9.33181 6.73078 9.24664 6.83987 9.10256L9.50512 5.60256C9.70053 5.34589 9.65095 4.98072 9.39428 4.78531C9.13703 4.58989 8.77187 4.64006 8.57703 4.89614ZM6.99935 11.666C4.42627 11.666 2.33268 9.57243 2.33268 6.99935C2.33268 4.42627 4.42627 2.33268 6.99935 2.33268C9.57243 2.33268 11.666 4.42627 11.666 6.99935C11.666 9.57243 9.57243 11.666 6.99935 11.666ZM6.99935 1.16602C3.7776 1.16602 1.16602 3.77818 1.16602 6.99935C1.16602 10.2205 3.7776 12.8327 6.99935 12.8327C10.2211 12.8327 12.8327 10.2205 12.8327 6.99935C12.8327 3.77818 10.2211 1.16602 6.99935 1.16602Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.80372 5.59698L7.28105 8.90965L6.19238 7.51898C5.96572 7.22832 5.54572 7.17765 5.25638 7.40498C4.96638 7.63165 4.91505 8.05098 5.14238 8.34032L6.76305 10.4117C6.88972 10.573 7.08305 10.667 7.28838 10.667H7.29305C7.49905 10.6663 7.69372 10.569 7.81838 10.4043L10.8644 6.40432C11.0877 6.11098 11.0311 5.69365 10.7377 5.47032C10.4437 5.24698 10.0264 5.30432 9.80372 5.59698ZM8.00065 13.334C5.05998 13.334 2.66732 10.9413 2.66732 8.00065C2.66732 5.05998 5.05998 2.66732 8.00065 2.66732C10.9413 2.66732 13.334 5.05998 13.334 8.00065C13.334 10.9413 10.9413 13.334 8.00065 13.334ZM8.00065 1.33398C4.31865 1.33398 1.33398 4.31932 1.33398 8.00065C1.33398 11.682 4.31865 14.6673 8.00065 14.6673C11.6827 14.6673 14.6673 11.682 14.6673 8.00065C14.6673 4.31932 11.6827 1.33398 8.00065 1.33398Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.80372 5.59698L7.28105 8.90965L6.19238 7.51898C5.96572 7.22832 5.54572 7.17765 5.25638 7.40498C4.96638 7.63165 4.91505 8.05098 5.14238 8.34032L6.76305 10.4117C6.88972 10.573 7.08305 10.667 7.28838 10.667H7.29305C7.49905 10.6663 7.69372 10.569 7.81838 10.4043L10.8644 6.40432C11.0877 6.11098 11.0311 5.69365 10.7377 5.47032C10.4437 5.24698 10.0264 5.30432 9.80372 5.59698ZM8.00065 13.334C5.05998 13.334 2.66732 10.9413 2.66732 8.00065C2.66732 5.05998 5.05998 2.66732 8.00065 2.66732C10.9413 2.66732 13.334 5.05998 13.334 8.00065C13.334 10.9413 10.9413 13.334 8.00065 13.334ZM8.00065 1.33398C4.31865 1.33398 1.33398 4.31932 1.33398 8.00065C1.33398 11.682 4.31865 14.6673 8.00065 14.6673C11.6827 14.6673 14.6673 11.682 14.6673 8.00065C14.6673 4.31932 11.6827 1.33398 8.00065 1.33398Z'
        fill={color}
      />
    </svg>
  );
};

export const CalendarIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.08333 9.33268C4.08333 9.01185 4.34583 8.74935 4.66667 8.74935C4.9875 8.74935 5.25 9.01185 5.25 9.33268C5.25 9.65352 4.9875 9.91602 4.66667 9.91602C4.34583 9.91602 4.08333 9.65352 4.08333 9.33268ZM7 8.74935H9.33333C9.65417 8.74935 9.91667 9.01185 9.91667 9.33268C9.91667 9.65352 9.65417 9.91602 9.33333 9.91602H7C6.67917 9.91602 6.41667 9.65352 6.41667 9.33268C6.41667 9.01185 6.67917 8.74935 7 8.74935ZM10.5 11.666H3.5C3.17858 11.666 2.91667 11.4041 2.91667 11.0827V7.58268H11.0833V11.0827C11.0833 11.4041 10.8214 11.666 10.5 11.666ZM3.5 3.49935H4.08333V4.08268C4.08333 4.40352 4.34583 4.66602 4.66667 4.66602C4.9875 4.66602 5.25 4.40352 5.25 4.08268V3.49935H8.75V4.08268C8.75 4.40352 9.0125 4.66602 9.33333 4.66602C9.65417 4.66602 9.91667 4.40352 9.91667 4.08268V3.49935H10.5C10.8214 3.49935 11.0833 3.76127 11.0833 4.08268V6.41602H2.91667V4.08268C2.91667 3.76127 3.17858 3.49935 3.5 3.49935ZM10.5 2.33268H9.91667V1.74935C9.91667 1.42852 9.65417 1.16602 9.33333 1.16602C9.0125 1.16602 8.75 1.42852 8.75 1.74935V2.33268H5.25V1.74935C5.25 1.42852 4.9875 1.16602 4.66667 1.16602C4.34583 1.16602 4.08333 1.42852 4.08333 1.74935V2.33268H3.5C2.53517 2.33268 1.75 3.11785 1.75 4.08268V11.0827C1.75 12.0475 2.53517 12.8327 3.5 12.8327H10.5C11.4648 12.8327 12.25 12.0475 12.25 11.0827V4.08268C12.25 3.11785 11.4648 2.33268 10.5 2.33268Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.25 12C5.25 11.5875 5.5875 11.25 6 11.25C6.4125 11.25 6.75 11.5875 6.75 12C6.75 12.4125 6.4125 12.75 6 12.75C5.5875 12.75 5.25 12.4125 5.25 12ZM9 11.25H12C12.4125 11.25 12.75 11.5875 12.75 12C12.75 12.4125 12.4125 12.75 12 12.75H9C8.5875 12.75 8.25 12.4125 8.25 12C8.25 11.5875 8.5875 11.25 9 11.25ZM13.5 15H4.5C4.08675 15 3.75 14.6632 3.75 14.25V9.75H14.25V14.25C14.25 14.6632 13.9132 15 13.5 15ZM4.5 4.5H5.25V5.25C5.25 5.6625 5.5875 6 6 6C6.4125 6 6.75 5.6625 6.75 5.25V4.5H11.25V5.25C11.25 5.6625 11.5875 6 12 6C12.4125 6 12.75 5.6625 12.75 5.25V4.5H13.5C13.9132 4.5 14.25 4.83675 14.25 5.25V8.25H3.75V5.25C3.75 4.83675 4.08675 4.5 4.5 4.5ZM13.5 3H12.75V2.25C12.75 1.8375 12.4125 1.5 12 1.5C11.5875 1.5 11.25 1.8375 11.25 2.25V3H6.75V2.25C6.75 1.8375 6.4125 1.5 6 1.5C5.5875 1.5 5.25 1.8375 5.25 2.25V3H4.5C3.2595 3 2.25 4.0095 2.25 5.25V14.25C2.25 15.4905 3.2595 16.5 4.5 16.5H13.5C14.7405 16.5 15.75 15.4905 15.75 14.25V5.25C15.75 4.0095 14.7405 3 13.5 3Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.66667 10.6673C4.66667 10.3006 4.96667 10.0007 5.33333 10.0007C5.7 10.0007 6 10.3006 6 10.6673C6 11.034 5.7 11.334 5.33333 11.334C4.96667 11.334 4.66667 11.034 4.66667 10.6673ZM8 10.0007H10.6667C11.0333 10.0007 11.3333 10.3006 11.3333 10.6673C11.3333 11.034 11.0333 11.334 10.6667 11.334H8C7.63333 11.334 7.33333 11.034 7.33333 10.6673C7.33333 10.3006 7.63333 10.0007 8 10.0007ZM12 13.334H4C3.63267 13.334 3.33333 13.0347 3.33333 12.6673V8.66732H12.6667V12.6673C12.6667 13.0347 12.3673 13.334 12 13.334ZM4 4.00065H4.66667V4.66732C4.66667 5.03398 4.96667 5.33398 5.33333 5.33398C5.7 5.33398 6 5.03398 6 4.66732V4.00065H10V4.66732C10 5.03398 10.3 5.33398 10.6667 5.33398C11.0333 5.33398 11.3333 5.03398 11.3333 4.66732V4.00065H12C12.3673 4.00065 12.6667 4.29998 12.6667 4.66732V7.33398H3.33333V4.66732C3.33333 4.29998 3.63267 4.00065 4 4.00065ZM12 2.66732H11.3333V2.00065C11.3333 1.63398 11.0333 1.33398 10.6667 1.33398C10.3 1.33398 10 1.63398 10 2.00065V2.66732H6V2.00065C6 1.63398 5.7 1.33398 5.33333 1.33398C4.96667 1.33398 4.66667 1.63398 4.66667 2.00065V2.66732H4C2.89733 2.66732 2 3.56465 2 4.66732V12.6673C2 13.77 2.89733 14.6673 4 14.6673H12C13.1027 14.6673 14 13.77 14 12.6673V4.66732C14 3.56465 13.1027 2.66732 12 2.66732Z'
        fill={color}
      />
    </svg>
  );
};

export const BoxSearchIcon = ({ color }: IIconProps) => {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.50765 8.75011V12.0755H4.8364V13.2497H0.333344V8.75025L1.50765 8.75011Z'
        fill={color}
      />
      <path
        d='M11.5877 10.7574C12.1259 9.93948 12.2213 8.90696 11.8417 8.00431C11.4622 7.10166 10.6578 6.44758 9.69675 6.25999C8.73569 6.07239 7.7444 6.37615 7.05328 7.06981C6.36217 7.76346 6.06231 8.75598 6.25338 9.71635C6.44461 10.6766 7.10177 11.4786 8.00582 11.8546C8.90987 12.2308 9.94196 12.1317 10.7579 11.5903L12.8372 13.6663L13.667 12.8335L11.5877 10.7574ZM9.14221 10.8952C8.67419 10.8961 8.22517 10.7108 7.89386 10.3802C7.56269 10.0497 7.37634 9.60114 7.37606 9.13326C7.37578 8.66539 7.56156 8.21651 7.89246 7.88563C8.22335 7.55474 8.67208 7.36894 9.1401 7.36922C9.60797 7.3695 10.0566 7.55584 10.3871 7.88716C10.7175 8.21833 10.9027 8.6675 10.9019 9.13537C10.9028 9.60282 10.7178 10.0517 10.3879 10.3829C10.0579 10.714 9.60969 10.9005 9.14221 10.9013V10.8952Z'
        fill={color}
      />
      <path
        d='M4.83654 0.333079V1.50732H1.50779V4.83607H0.333553V0.333008L4.83654 0.333079Z'
        fill={color}
      />
      <path
        d='M13.2504 0.333078V4.83614H12.0762V1.50739H8.75077V0.333149L13.2504 0.333078Z'
        fill={color}
      />
    </svg>
  );
};

export const CaretIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (large) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.99993 11.9996C8.82893 11.9996 8.65868 11.9419 8.51993 11.8256L4.01993 8.07562C3.70193 7.81087 3.65843 7.33762 3.92393 7.01962C4.18868 6.70162 4.66118 6.65887 4.97993 6.92362L9.00818 10.2806L13.0297 7.04437C13.3522 6.78487 13.8247 6.83587 14.0842 7.15837C14.3437 7.48087 14.2927 7.95262 13.9702 8.21287L9.47018 11.8339C9.33293 11.9441 9.16643 11.9996 8.99993 11.9996Z'
          fill={color}
        />
      </svg>
    );
  }

  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.9993 9.33304C6.8663 9.33304 6.73388 9.28812 6.62596 9.19771L3.12596 6.28104C2.87863 6.07512 2.8448 5.70704 3.0513 5.45971C3.25721 5.21237 3.62471 5.17912 3.87263 5.38504L7.00571 7.99604L10.1335 5.47896C10.3844 5.27712 10.7519 5.31679 10.9537 5.56762C11.1555 5.81846 11.1159 6.18537 10.865 6.38779L7.36505 9.20412C7.2583 9.28987 7.1288 9.33304 6.9993 9.33304Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.00059 10.6663C7.84859 10.6663 7.69726 10.615 7.57392 10.5117L3.57392 7.17833C3.29126 6.943 3.25259 6.52233 3.48859 6.23966C3.72392 5.957 4.14392 5.919 4.42726 6.15433L8.00792 9.13833L11.5826 6.26166C11.8693 6.031 12.2893 6.07633 12.5199 6.363C12.7506 6.64966 12.7053 7.069 12.4186 7.30033L8.41859 10.519C8.29659 10.617 8.14859 10.6663 8.00059 10.6663Z'
        fill={color}
      />
    </svg>
  );
};

export const ClockIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.33268 6.41602H7.58268V4.66602C7.58268 4.34343 7.32135 4.08268 6.99935 4.08268C6.67735 4.08268 6.41602 4.34343 6.41602 4.66602V6.99935C6.41602 7.32193 6.67735 7.58268 6.99935 7.58268H9.33268C9.65527 7.58268 9.91602 7.32193 9.91602 6.99935C9.91602 6.67677 9.65527 6.41602 9.33268 6.41602ZM6.99935 11.666C4.42627 11.666 2.33268 9.57243 2.33268 6.99935C2.33268 4.42627 4.42627 2.33268 6.99935 2.33268C9.57243 2.33268 11.666 4.42627 11.666 6.99935C11.666 9.57243 9.57243 11.666 6.99935 11.666ZM6.99935 1.16602C3.78285 1.16602 1.16602 3.78285 1.16602 6.99935C1.16602 10.2158 3.78285 12.8327 6.99935 12.8327C10.2158 12.8327 12.8327 10.2158 12.8327 6.99935C12.8327 3.78285 10.2158 1.16602 6.99935 1.16602Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12 8.25H9.75V6C9.75 5.58525 9.414 5.25 9 5.25C8.586 5.25 8.25 5.58525 8.25 6V9C8.25 9.41475 8.586 9.75 9 9.75H12C12.4148 9.75 12.75 9.41475 12.75 9C12.75 8.58525 12.4148 8.25 12 8.25ZM9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15ZM9 1.5C4.8645 1.5 1.5 4.8645 1.5 9C1.5 13.1355 4.8645 16.5 9 16.5C13.1355 16.5 16.5 13.1355 16.5 9C16.5 4.8645 13.1355 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10.6673 7.33398H8.66732V5.33398C8.66732 4.96532 8.36865 4.66732 8.00065 4.66732C7.63265 4.66732 7.33398 4.96532 7.33398 5.33398V8.00065C7.33398 8.36932 7.63265 8.66732 8.00065 8.66732H10.6673C11.036 8.66732 11.334 8.36932 11.334 8.00065C11.334 7.63198 11.036 7.33398 10.6673 7.33398ZM8.00065 13.334C5.05998 13.334 2.66732 10.9413 2.66732 8.00065C2.66732 5.05998 5.05998 2.66732 8.00065 2.66732C10.9413 2.66732 13.334 5.05998 13.334 8.00065C13.334 10.9413 10.9413 13.334 8.00065 13.334ZM8.00065 1.33398C4.32465 1.33398 1.33398 4.32465 1.33398 8.00065C1.33398 11.6767 4.32465 14.6673 8.00065 14.6673C11.6767 14.6673 14.6673 11.6767 14.6673 8.00065C14.6673 4.32465 11.6767 1.33398 8.00065 1.33398Z'
        fill={color}
      />
    </svg>
  );
};

export const CloseIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.82498 7.00015L10.3292 4.4959C10.5573 4.26781 10.5573 3.89915 10.3292 3.67106C10.1011 3.44298 9.73248 3.44298 9.5044 3.67106L7.00015 6.17531L4.4959 3.67106C4.26781 3.44298 3.89915 3.44298 3.67106 3.67106C3.44298 3.89915 3.44298 4.26781 3.67106 4.4959L6.17531 7.00015L3.67106 9.5044C3.44298 9.73248 3.44298 10.1011 3.67106 10.3292C3.78481 10.443 3.93415 10.5001 4.08348 10.5001C4.23281 10.5001 4.38215 10.443 4.4959 10.3292L7.00015 7.82498L9.5044 10.3292C9.61815 10.443 9.76748 10.5001 9.91681 10.5001C10.0661 10.5001 10.2155 10.443 10.3292 10.3292C10.5573 10.1011 10.5573 9.73248 10.3292 9.5044L7.82498 7.00015Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.0607 9.00019L13.2804 5.78044C13.5737 5.48719 13.5737 5.01319 13.2804 4.71994C12.9872 4.42669 12.5132 4.42669 12.2199 4.71994L9.00019 7.93969L5.78044 4.71994C5.48719 4.42669 5.01319 4.42669 4.71994 4.71994C4.42669 5.01319 4.42669 5.48719 4.71994 5.78044L7.93969 9.00019L4.71994 12.2199C4.42669 12.5132 4.42669 12.9872 4.71994 13.2804C4.86619 13.4267 5.05819 13.5002 5.25019 13.5002C5.44219 13.5002 5.63419 13.4267 5.78044 13.2804L9.00019 10.0607L12.2199 13.2804C12.3662 13.4267 12.5582 13.5002 12.7502 13.5002C12.9422 13.5002 13.1342 13.4267 13.2804 13.2804C13.5737 12.9872 13.5737 12.5132 13.2804 12.2199L10.0607 9.00019Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.94283 8.00017L11.8048 5.13817C12.0655 4.8775 12.0655 4.45617 11.8048 4.1955C11.5442 3.93483 11.1228 3.93483 10.8622 4.1955L8.00017 7.0575L5.13817 4.1955C4.8775 3.93483 4.45617 3.93483 4.1955 4.1955C3.93483 4.45617 3.93483 4.8775 4.1955 5.13817L7.0575 8.00017L4.1955 10.8622C3.93483 11.1228 3.93483 11.5442 4.1955 11.8048C4.3255 11.9348 4.49617 12.0002 4.66683 12.0002C4.8375 12.0002 5.00817 11.9348 5.13817 11.8048L8.00017 8.94283L10.8622 11.8048C10.9922 11.9348 11.1628 12.0002 11.3335 12.0002C11.5042 12.0002 11.6748 11.9348 11.8048 11.8048C12.0655 11.5442 12.0655 11.1228 11.8048 10.8622L8.94283 8.00017Z'
        fill={color}
      />
    </svg>
  );
};

export const CodeIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.88786 3.13399L12.7042 6.63399C12.8786 6.8504 12.8757 7.15957 12.6978 7.37365L9.78111 10.8737C9.66561 11.0119 9.49995 11.0831 9.33253 11.0831C9.2007 11.0831 9.06886 11.0387 8.9592 10.9483C8.71186 10.7418 8.67861 10.3737 8.88453 10.1258L11.4961 6.99332L8.97845 3.86549C8.7772 3.61407 8.81628 3.24716 9.0677 3.04532C9.31853 2.84232 9.68545 2.88316 9.88786 3.13399ZM4.21804 3.12629C4.42396 2.87896 4.79087 2.84571 5.03996 3.05163C5.28729 3.25813 5.32054 3.62563 5.11462 3.87354L2.50304 7.00604L5.02071 10.1345C5.22196 10.3853 5.18287 10.7522 4.93146 10.9546C4.82412 11.041 4.69462 11.0835 4.56629 11.0835C4.39596 11.0835 4.22679 11.0089 4.11129 10.866L1.29496 7.36596C1.12054 7.14896 1.12346 6.83979 1.30137 6.62629L4.21804 3.12629Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.3018 3.58114L14.5205 7.58114C14.7198 7.82848 14.7165 8.18181 14.5131 8.42648L11.1798 12.4265C11.0478 12.5845 10.8585 12.6658 10.6671 12.6658C10.5165 12.6658 10.3658 12.6151 10.2405 12.5118C9.95781 12.2758 9.91981 11.8551 10.1551 11.5718L13.1398 7.99181L10.2625 4.41714C10.0325 4.12981 10.0771 3.71048 10.3645 3.47981C10.6511 3.24781 11.0705 3.29448 11.3018 3.58114ZM4.82201 3.57227C5.05734 3.2896 5.47668 3.2516 5.76134 3.48693C6.04401 3.72293 6.08201 4.14293 5.84668 4.42627L2.86201 8.00627L5.73934 11.5816C5.96934 11.8683 5.92468 12.2876 5.63734 12.5189C5.51468 12.6176 5.36668 12.6663 5.22001 12.6663C5.02534 12.6663 4.83201 12.5809 4.70001 12.4176L1.48134 8.4176C1.28201 8.1696 1.28534 7.81627 1.48868 7.57227L4.82201 3.57227Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.3018 3.58114L14.5205 7.58114C14.7198 7.82848 14.7165 8.18181 14.5131 8.42648L11.1798 12.4265C11.0478 12.5845 10.8585 12.6658 10.6671 12.6658C10.5165 12.6658 10.3658 12.6151 10.2405 12.5118C9.95781 12.2758 9.91981 11.8551 10.1551 11.5718L13.1398 7.99181L10.2625 4.41714C10.0325 4.12981 10.0771 3.71048 10.3645 3.47981C10.6511 3.24781 11.0705 3.29448 11.3018 3.58114ZM4.82201 3.57227C5.05734 3.2896 5.47668 3.2516 5.76134 3.48693C6.04401 3.72293 6.08201 4.14293 5.84668 4.42627L2.86201 8.00627L5.73934 11.5816C5.96934 11.8683 5.92468 12.2876 5.63734 12.5189C5.51468 12.6176 5.36668 12.6663 5.22001 12.6663C5.02534 12.6663 4.83201 12.5809 4.70001 12.4176L1.48134 8.4176C1.28201 8.1696 1.28534 7.81627 1.48868 7.57227L4.82201 3.57227Z'
        fill={color}
      />
    </svg>
  );
};

export const CollapseIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.58155 3.94106L8.64822 2.87521C8.87591 2.64752 9.24549 2.64752 9.47359 2.87562C9.70087 3.10372 9.70046 3.47289 9.47318 3.70017L9.47277 3.70058L7.41945 5.75143C7.19258 5.97829 6.82465 5.97911 6.59655 5.75349L4.5255 3.70223C4.29657 3.47578 4.29451 3.10661 4.52137 2.87727L4.52343 2.87521C4.7503 2.64835 5.11782 2.64711 5.34633 2.87315L6.41465 3.93157L6.41465 1.22571C6.41465 0.903149 6.67575 0.64205 6.99831 0.64205C7.32045 0.642463 7.58114 0.903149 7.58155 1.2253L7.58155 3.94106ZM4.52525 10.2983L6.59672 8.2475C6.82482 8.02188 7.19234 8.02229 7.4192 8.24915L9.47293 10.2996C9.70062 10.5273 9.70103 10.8973 9.47335 11.125C9.24525 11.3531 8.87608 11.3526 8.6488 11.1254L7.58172 10.0599L7.58172 12.7749C7.58131 12.9361 7.51613 13.0822 7.41095 13.1873C7.30536 13.2929 7.15934 13.3581 6.99847 13.3581C6.67591 13.3581 6.41481 13.097 6.41523 12.7749L6.41482 10.0694L5.34649 11.127C5.11716 11.3539 4.74758 11.3514 4.52154 11.1229C4.29509 10.8948 4.29674 10.5269 4.5236 10.3L4.52525 10.2983Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.74883 5.0661L11.1203 3.69572C11.413 3.40298 11.8882 3.40298 12.1815 3.69625C12.4737 3.98953 12.4731 4.46417 12.1809 4.75638L12.1804 4.75691L9.54041 7.39371C9.24873 7.6854 8.77567 7.68646 8.4824 7.39637L5.81961 4.75903C5.52528 4.46788 5.52263 3.99324 5.81431 3.69837L5.81696 3.69572C6.10864 3.40404 6.58117 3.40245 6.87497 3.69307L8.24853 5.0539L8.24853 1.57493C8.24853 1.16022 8.58423 0.824516 8.99894 0.824516C9.41313 0.825046 9.7483 1.16021 9.74883 1.5744L9.74883 5.0661ZM5.8193 13.2398L8.48261 10.603C8.77589 10.3129 9.24841 10.3134 9.54009 10.6051L12.1806 13.2413C12.4733 13.5341 12.4739 14.0098 12.1811 14.3025C11.8879 14.5958 11.4132 14.5953 11.121 14.3031L9.74904 12.9332L9.74904 16.4239C9.74851 16.6312 9.66472 16.819 9.52949 16.9542C9.39372 17.09 9.20598 17.1737 8.99916 17.1737C8.58444 17.1737 8.24874 16.838 8.24927 16.4239L8.24874 12.9454L6.87518 14.3052C6.58032 14.5969 6.10514 14.5937 5.81452 14.2999C5.52337 14.0066 5.52549 13.5336 5.81718 13.2419L5.8193 13.2398Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.66631 4.50406L9.88536 3.28595C10.1456 3.02574 10.568 3.02574 10.8286 3.28643C11.0884 3.54711 11.0879 3.96902 10.8282 4.22876L10.8277 4.22924L8.48104 6.57306C8.22177 6.83233 7.80128 6.83327 7.54059 6.57542L5.17367 4.23112C4.91204 3.97232 4.90968 3.55041 5.16895 3.28831L5.17131 3.28596C5.43058 3.02668 5.85061 3.02527 6.11176 3.2836L7.3327 4.49322L7.3327 1.40081C7.3327 1.03217 7.6311 0.733771 7.99974 0.733771C8.36791 0.734243 8.66583 1.03217 8.66631 1.40034V4.50406ZM5.17339 11.7695L7.54078 9.42572C7.80147 9.16786 8.22149 9.16833 8.48076 9.4276L10.8279 11.771C11.0881 12.0312 11.0886 12.454 10.8284 12.7142C10.5677 12.9749 10.1458 12.9744 9.88602 12.7147L8.66649 11.4971L8.66649 14.5999C8.66602 14.7842 8.59154 14.951 8.47133 15.0713C8.35065 15.1919 8.18378 15.2664 7.99993 15.2664C7.63129 15.2664 7.33289 14.968 7.33336 14.5999L7.33289 11.5079L6.11195 12.7166C5.84985 12.9759 5.42747 12.973 5.16914 12.7119C4.91034 12.4512 4.91223 12.0307 5.1715 11.7714L5.17339 11.7695Z'
        fill={color}
      />
    </svg>
  );
};

export const ColumnsIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M10.8 13H3.20005C2.61648 13 2.05692 12.7756 1.64439 12.3764C1.23171 11.977 1 11.4355 1 10.8709V3.12908C1 2.56447 1.23172 2.02296 1.64439 1.6236C2.05692 1.22438 2.61648 1 3.20005 1H10.8C11.3835 1 11.9431 1.22438 12.3556 1.6236C12.7683 2.02296 13 2.56447 13 3.12908V10.8709C13 11.4355 12.7683 11.977 12.3556 12.3764C11.9431 12.7756 11.3835 13 10.8 13ZM8.19995 11.8387L8.20009 2.16135H5.80001V11.8387H8.19995ZM2.20002 3.12908V10.8709C2.20002 11.1276 2.30535 11.3737 2.49285 11.5553C2.68034 11.7367 2.93481 11.8387 3.20002 11.8387H4.59996V2.16135H3.20002C2.93481 2.16135 2.68034 2.26328 2.49285 2.44473C2.30535 2.62632 2.20002 2.87243 2.20002 3.12909V3.12908ZM11.7999 3.12908C11.7999 2.87243 11.6946 2.62631 11.5071 2.44472C11.3196 2.26327 11.0651 2.16134 10.7999 2.16134H9.39996V11.8386H10.7999C11.0651 11.8386 11.3196 11.7367 11.5071 11.5553C11.6946 11.3737 11.7999 11.1276 11.7999 10.8709V3.12908Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M13.7499 16.5H4.25006C3.5206 16.5 2.82115 16.2195 2.30548 15.7205C1.78964 15.2213 1.5 14.5444 1.5 13.8387V4.16135C1.5 3.45559 1.78965 2.7787 2.30548 2.2795C2.82115 1.78047 3.5206 1.5 4.25006 1.5H13.7499C14.4794 1.5 15.1789 1.78048 15.6945 2.2795C16.2104 2.7787 16.5 3.45559 16.5 4.16135V13.8387C16.5 14.5444 16.2103 15.2213 15.6945 15.7205C15.1789 16.2195 14.4794 16.5 13.7499 16.5ZM10.4999 15.0483L10.5001 2.95168H7.50001V15.0483H10.4999ZM3.00003 4.16135V13.8387C3.00003 14.1595 3.13169 14.4671 3.36606 14.6941C3.60043 14.9209 3.91851 15.0483 4.25002 15.0483H5.99996V2.95169H4.25002C3.91852 2.95169 3.60043 3.0791 3.36606 3.30592C3.13169 3.5329 3.00003 3.84054 3.00003 4.16136V4.16135ZM14.9999 4.16135C14.9999 3.84053 14.8682 3.53288 14.6339 3.3059C14.3995 3.07909 14.0814 2.95167 13.7499 2.95167H12V15.0483H13.7499C14.0814 15.0483 14.3995 14.9209 14.6339 14.6941C14.8682 14.4671 14.9999 14.1595 14.9999 13.8386V4.16135Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M12.4333 15H3.56672C2.8859 15 2.23307 14.7382 1.75178 14.2725C1.27033 13.8065 0.999999 13.1748 0.999999 12.5161V3.48392C0.999999 2.82522 1.27034 2.19345 1.75178 1.72753C2.23307 1.26177 2.8859 1 3.56672 1H12.4333C13.1141 1 13.7669 1.26178 14.2482 1.72753C14.7297 2.19345 15 2.82522 15 3.48392V12.5161C15 13.1748 14.7297 13.8065 14.2482 14.2725C13.7669 14.7382 13.1141 15 12.4333 15ZM9.39994 13.6451L9.4001 2.3549H6.60001V13.6451H9.39994ZM2.40003 3.48392V12.5161C2.40003 12.8155 2.52291 13.1026 2.74166 13.3145C2.9604 13.5262 3.25727 13.6451 3.56669 13.6451H5.19996V2.35491H3.56669C3.25728 2.35491 2.9604 2.47383 2.74166 2.68552C2.52291 2.89737 2.40003 3.18451 2.40003 3.48394V3.48392ZM13.5999 3.48392C13.5999 3.1845 13.477 2.89736 13.2583 2.6855C13.0395 2.47381 12.7426 2.3549 12.4332 2.3549H10.8V13.6451H12.4332C12.7426 13.6451 13.0395 13.5262 13.2583 13.3145C13.477 13.1026 13.5999 12.8155 13.5999 12.5161V3.48392Z'
        fill={color}
      />
    </svg>
  );
};

export const CompassIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.29754 7.70687L6.71404 6.69071L7.70104 6.29171L7.28454 7.30787L6.29754 7.70687ZM9.14771 4.85146C8.98787 4.68229 8.73704 4.61696 8.50662 4.70796L6.04904 5.70079C5.90321 5.75971 5.78712 5.87462 5.72762 6.02046L4.70971 8.50429C4.62337 8.71487 4.67412 8.94237 4.81354 9.10396C4.81821 9.10979 4.82171 9.11737 4.82696 9.12379C4.83629 9.13371 4.84737 9.14187 4.85787 9.15179C4.96754 9.26437 5.11629 9.33262 5.27379 9.33262C5.34671 9.33262 5.42079 9.31921 5.49196 9.29062L7.94954 8.29837C8.09537 8.23887 8.21146 8.12396 8.27096 7.97812L9.28887 5.49429C9.38337 5.26446 9.31804 5.01246 9.14771 4.85146ZM6.99935 11.666C4.42627 11.666 2.33268 9.57243 2.33268 6.99935C2.33268 4.42627 4.42627 2.33268 6.99935 2.33268C9.57243 2.33268 11.666 4.42627 11.666 6.99935C11.666 9.57243 9.57243 11.666 6.99935 11.666ZM6.99935 1.16602C3.78285 1.16602 1.16602 3.78285 1.16602 6.99935C1.16602 10.2158 3.78285 12.8327 6.99935 12.8327C10.2158 12.8327 12.8327 10.2158 12.8327 6.99935C12.8327 3.78285 10.2158 1.16602 6.99935 1.16602Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.09768 9.90967L8.63318 8.60317L9.90217 8.09017L9.36668 9.39667L8.09768 9.90967ZM11.7622 6.23843C11.5567 6.02093 11.2342 5.93692 10.9379 6.05393L7.77817 7.33043C7.59067 7.40618 7.44142 7.55393 7.36492 7.74143L6.05617 10.9349C5.94517 11.2057 6.01042 11.4982 6.18967 11.7059C6.19567 11.7134 6.20017 11.7232 6.20692 11.7314C6.21892 11.7442 6.23317 11.7547 6.24667 11.7674C6.38767 11.9122 6.57892 11.9999 6.78142 11.9999C6.87517 11.9999 6.97042 11.9827 7.06192 11.9459L10.2217 10.6702C10.4092 10.5937 10.5584 10.4459 10.6349 10.2584L11.9437 7.06493C12.0652 6.76943 11.9812 6.44543 11.7622 6.23843ZM9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15ZM9 1.5C4.8645 1.5 1.5 4.8645 1.5 9C1.5 13.1355 4.8645 16.5 9 16.5C13.1355 16.5 16.5 13.1355 16.5 9C16.5 4.8645 13.1355 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.19858 8.80925L7.67458 7.64792L8.80258 7.19192L8.32658 8.35325L7.19858 8.80925ZM10.4559 5.54592C10.2733 5.35258 9.98658 5.27792 9.72325 5.38192L6.91458 6.51658C6.74792 6.58392 6.61525 6.71525 6.54725 6.88192L5.38392 9.72058C5.28525 9.96125 5.34325 10.2213 5.50258 10.4059C5.50792 10.4126 5.51192 10.4213 5.51792 10.4286C5.52858 10.4399 5.54125 10.4493 5.55325 10.4606C5.67858 10.5893 5.84858 10.6673 6.02858 10.6673C6.11192 10.6673 6.19658 10.6519 6.27792 10.6193L9.08658 9.48525C9.25325 9.41725 9.38592 9.28592 9.45392 9.11925L10.6173 6.28058C10.7253 6.01792 10.6506 5.72992 10.4559 5.54592ZM8.00065 13.334C5.05998 13.334 2.66732 10.9413 2.66732 8.00065C2.66732 5.05998 5.05998 2.66732 8.00065 2.66732C10.9413 2.66732 13.334 5.05998 13.334 8.00065C13.334 10.9413 10.9413 13.334 8.00065 13.334ZM8.00065 1.33398C4.32465 1.33398 1.33398 4.32465 1.33398 8.00065C1.33398 11.6767 4.32465 14.6673 8.00065 14.6673C11.6767 14.6673 14.6673 11.6767 14.6673 8.00065C14.6673 4.32465 11.6767 1.33398 8.00065 1.33398Z'
        fill={color}
      />
    </svg>
  );
};

export const CtuIcon = ({ large, small }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M3.89906 7.21812C3.36236 7.09789 2.88675 6.82751 2.50339 6.43751C1.98226 5.89676 1.69054 5.19122 1.70612 4.44048C1.7217 3.68975 2.02839 2.99889 2.58006 2.47334C3.71456 1.4071 5.52411 1.43761 6.61316 2.54841C6.99652 2.92376 7.24211 3.40409 7.34933 3.92958C7.39545 4.12489 7.57934 4.24512 7.77881 4.19996C7.97828 4.1548 8.10108 3.97475 8.05496 3.77944C7.91719 3.11906 7.59492 2.5185 7.11931 2.03751C5.76976 0.686826 3.50009 0.642249 2.08948 1.97827C1.39943 2.624 1.01607 3.495 1.00049 4.44028C0.984921 5.37104 1.33773 6.27185 1.99723 6.93292C2.47284 7.41325 3.07064 7.74344 3.73017 7.90884C3.76072 7.90884 3.79127 7.92409 3.82241 7.92409C3.99134 7.92409 4.1291 7.8191 4.17523 7.65371C4.20578 7.45841 4.09856 7.26311 3.89909 7.21796L3.89906 7.21812Z'
          fill='black'
        />
        <path
          d='M3.59372 3.50961C3.68597 3.43454 3.77761 3.35946 3.88483 3.29965C4.45208 2.99937 5.14213 3.10435 5.58725 3.55477C5.63338 3.59993 5.6795 3.65975 5.72502 3.72016C5.83224 3.88556 6.06226 3.93012 6.23118 3.81048C6.4001 3.7055 6.43065 3.48029 6.32343 3.3149C6.26233 3.22458 6.20063 3.1495 6.10899 3.05978C5.43452 2.38414 4.37605 2.21875 3.53266 2.68443C3.36374 2.77474 3.22597 2.87973 3.08821 2.99996C2.96541 3.12019 2.84261 3.25508 2.73539 3.42048C2.24422 4.23041 2.36702 5.28147 3.0265 5.95711C3.10317 6.03218 3.17985 6.10725 3.2721 6.16706C3.3332 6.21222 3.40987 6.24213 3.48653 6.24213C3.59375 6.24213 3.70097 6.19697 3.77764 6.10724C3.90044 5.9571 3.86989 5.73189 3.70097 5.61166C3.63987 5.5665 3.59375 5.52134 3.54763 5.47676C3.10317 5.02634 3.0265 4.33545 3.34816 3.8099C3.42483 3.68967 3.50147 3.59993 3.59372 3.50961Z'
          fill='black'
        />
        <path
          d='M12.8999 11.1525L9.67969 7.87924L10.9987 6.64821C11.0909 6.55789 11.1365 6.43825 11.1059 6.30276C11.0754 6.18253 10.9831 6.07755 10.8603 6.04764L4.83375 4.32102C4.71095 4.29111 4.57318 4.32102 4.48093 4.41134C4.38869 4.50166 4.34316 4.63655 4.37371 4.75679L5.89157 10.7027C5.92212 10.8229 6.01437 10.9279 6.13717 10.9578C6.16772 10.973 6.19826 10.973 6.22941 10.973C6.32166 10.973 6.4133 10.9431 6.47501 10.868L7.79401 9.62176L11.0142 12.895C11.0753 12.9548 11.1676 13 11.2748 13C11.367 13 11.4587 12.9701 11.5204 12.895L12.8699 11.634C13.0377 11.5126 13.0377 11.2873 12.8999 11.1525ZM11.3054 12.1583L8.08522 8.88506C8.05467 8.85515 8.03909 8.85515 8.00854 8.82524C7.87077 8.75017 7.70186 8.75017 7.57906 8.8704L6.44456 9.93664L5.23339 5.17733L10.0332 6.54385L8.91307 7.60892C8.88252 7.63883 8.85198 7.68399 8.8364 7.72915C8.82083 7.77431 8.80585 7.81947 8.80585 7.86404C8.80585 7.95436 8.8364 8.04409 8.91307 8.11916L12.1333 11.3924L11.3054 12.1583Z'
          fill='black'
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M4.86542 9.29083C4.14981 9.13052 3.51566 8.77002 3.00452 8.25001C2.30968 7.52901 1.92072 6.58829 1.9415 5.58731C1.96227 4.58633 2.37119 3.66519 3.10675 2.96445C4.61941 1.5428 7.03214 1.58347 8.48421 3.06454C8.99535 3.56501 9.32281 4.20545 9.46577 4.90611C9.52727 5.16652 9.77246 5.32683 10.0384 5.26661C10.3044 5.2064 10.4681 4.96633 10.4066 4.70592C10.2229 3.82542 9.79323 3.02467 9.15909 2.38334C7.35969 0.582435 4.33346 0.522999 2.45264 2.30436C1.53258 3.16533 1.02143 4.32666 1.00066 5.58704C0.979894 6.82805 1.4503 8.02914 2.32964 8.91056C2.96379 9.551 3.76085 9.99126 4.64022 10.2118C4.68096 10.2118 4.72169 10.2321 4.76322 10.2321C4.98845 10.2321 5.17214 10.0921 5.23364 9.87162C5.27437 9.61121 5.13141 9.35081 4.86545 9.29061L4.86542 9.29083Z'
          fill='black'
        />
        <path
          d='M4.45732 4.34622C4.58031 4.24613 4.7025 4.14603 4.84546 4.06628C5.60179 3.6659 6.52186 3.80588 7.11536 4.40644C7.17686 4.46665 7.23835 4.54641 7.29905 4.62697C7.44202 4.84749 7.7487 4.90691 7.97393 4.74739C8.19916 4.60742 8.23989 4.30714 8.09692 4.08661C8.01546 3.96619 7.9332 3.86608 7.81101 3.74645C6.91172 2.84561 5.50042 2.62508 4.3759 3.24598C4.15067 3.36641 3.96699 3.50639 3.7833 3.6667C3.61957 3.827 3.45584 4.00686 3.31288 4.22738C2.65798 5.3073 2.82171 6.70871 3.70103 7.60956C3.80325 7.70965 3.90548 7.80974 4.02849 7.8895C4.10995 7.94971 4.21218 7.98959 4.3144 7.98959C4.45736 7.98959 4.60032 7.92938 4.70255 7.80974C4.86627 7.60955 4.82554 7.30927 4.60032 7.14896C4.51885 7.08874 4.45735 7.02853 4.39586 6.9691C3.80325 6.36854 3.70103 5.44735 4.1299 4.74661C4.23213 4.58631 4.33432 4.46666 4.45732 4.34622Z'
          fill='black'
        />
        <path
          d='M16.8672 14.5366L12.5736 10.1723L14.3322 8.53094C14.4552 8.41051 14.5159 8.251 14.4752 8.07035C14.4345 7.91004 14.3115 7.77007 14.1477 7.73019L6.11231 5.42803C5.94859 5.38815 5.7649 5.42803 5.64189 5.54845C5.5189 5.66888 5.4582 5.84874 5.49893 6.00905L7.52274 13.9369C7.56348 14.0972 7.68647 14.2372 7.85021 14.277C7.89094 14.2974 7.93167 14.2974 7.9732 14.2974C8.09619 14.2974 8.21839 14.2575 8.30066 14.1574L10.0593 12.4957L14.353 16.86C14.4344 16.9397 14.5574 16.9999 14.7004 16.9999C14.8234 16.9999 14.9456 16.9601 15.0278 16.86L16.8272 15.1787C17.0509 15.0168 17.0509 14.7165 16.8672 14.5366ZM14.7412 15.8777L10.4476 11.5134C10.4069 11.4735 10.3861 11.4735 10.3454 11.4337C10.1617 11.3336 9.93646 11.3336 9.77273 11.4939L8.26006 12.9155L6.64517 6.56977L13.0449 8.3918L11.5514 9.81189C11.5107 9.85177 11.47 9.91198 11.4492 9.9722C11.4284 10.0324 11.4085 10.0926 11.4085 10.1521C11.4085 10.2725 11.4492 10.3921 11.5514 10.4922L15.845 14.8565L14.7412 15.8777Z'
          fill='black'
        />
      </svg>
    );
  }

  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.38224 8.25447C3.75608 8.1142 3.2012 7.79876 2.75395 7.34376C2.14597 6.71289 1.80563 5.88975 1.82381 5.0139C1.84198 4.13804 2.19979 3.33204 2.8434 2.71889C4.16698 1.47495 6.27813 1.51054 7.54868 2.80648C7.99594 3.24439 8.28246 3.80477 8.40755 4.41785C8.46136 4.6457 8.6759 4.78597 8.90862 4.73328C9.14133 4.6806 9.2846 4.47054 9.23078 4.24268C9.07005 3.47224 8.69408 2.77158 8.1392 2.21043C6.56473 0.63463 3.91677 0.582624 2.27106 2.14132C1.46601 2.89467 1.01875 3.91083 1.00058 5.01366C0.982408 6.09954 1.39402 7.15049 2.16343 7.92174C2.71831 8.48213 3.41574 8.86735 4.1852 9.06031C4.22084 9.06031 4.25648 9.0781 4.29282 9.0781C4.48989 9.0781 4.65062 8.95562 4.70443 8.76266C4.74007 8.53481 4.61498 8.30696 4.38227 8.25428L4.38224 8.25447Z'
        fill='black'
      />
      <path
        d='M4.02601 3.92785C4.13363 3.84027 4.24055 3.75269 4.36563 3.6829C5.02742 3.33257 5.83248 3.45505 6.35179 3.98054C6.4056 4.03323 6.45941 4.10302 6.51253 4.1735C6.63762 4.36646 6.90597 4.41845 7.10304 4.27887C7.30012 4.1564 7.33576 3.89365 7.21066 3.70069C7.13938 3.59532 7.0674 3.50773 6.96049 3.40305C6.17361 2.61481 4.93873 2.42185 3.95477 2.96514C3.75769 3.07051 3.59697 3.193 3.43624 3.33327C3.29298 3.47354 3.14971 3.63091 3.02463 3.82387C2.45159 4.76879 2.59485 5.99503 3.36425 6.78327C3.4537 6.87085 3.54315 6.95843 3.65078 7.02822C3.72206 7.08091 3.81151 7.1158 3.90096 7.1158C4.02605 7.1158 4.15113 7.06312 4.24058 6.95843C4.38384 6.78326 4.3482 6.52052 4.15113 6.38024C4.07985 6.32756 4.02604 6.27487 3.97223 6.22287C3.4537 5.69738 3.36425 4.89134 3.73952 4.2782C3.82897 4.13793 3.91838 4.03323 4.02601 3.92785Z'
        fill='black'
      />
      <path
        d='M14.8831 12.8445L11.1261 9.02578L12.665 7.58957C12.7726 7.4842 12.8257 7.34462 12.7901 7.18655C12.7544 7.04629 12.6468 6.92381 12.5035 6.88892L5.47254 4.87453C5.32928 4.83963 5.16855 4.87453 5.06092 4.9799C4.9533 5.08527 4.90019 5.24264 4.93583 5.38292L6.70667 12.3198C6.74231 12.46 6.84993 12.5825 6.9932 12.6174C7.02884 12.6352 7.06448 12.6352 7.10082 12.6352C7.20844 12.6352 7.31536 12.6003 7.38735 12.5127L8.92618 11.0587L12.6831 14.8775C12.7544 14.9473 12.862 15 12.9871 15C13.0947 15 13.2016 14.9651 13.2736 14.8775L14.8481 13.4064C15.0438 13.2647 15.0438 13.0019 14.8831 12.8445ZM13.0228 14.018L9.26592 10.1992C9.23028 10.1643 9.21211 10.1643 9.17647 10.1294C9.01574 10.0419 8.81867 10.0419 8.67541 10.1821L7.35182 11.4261L5.93879 5.87355L11.5386 7.46782L10.2318 8.7104C10.1961 8.7453 10.1605 8.79799 10.1423 8.85067C10.1241 8.90336 10.1067 8.95604 10.1067 9.00805C10.1067 9.11342 10.1423 9.2181 10.2318 9.30569L13.9887 13.1244L13.0228 14.018Z'
        fill='black'
      />
    </svg>
  );
};

export const CubeIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.9022 9.31468L7.58301 10.8567V6.93981L11.083 5.31438V9.0674C11.083 9.16888 11.0142 9.26336 10.9022 9.31468V9.31468ZM3.09376 9.31527C2.98351 9.26394 2.91584 9.16946 2.91701 9.06332V5.31438L6.41699 6.93981V10.8579L3.09376 9.31527ZM6.82927 2.9586C6.88235 2.93352 6.94127 2.92127 7.00019 2.92127C7.05852 2.92127 7.11744 2.93352 7.17052 2.9586L10.2791 4.40149L7.00019 5.92486L3.7207 4.40149L6.82927 2.9586ZM12.0493 4.23872C12.0476 4.23405 12.0482 4.2288 12.0458 4.22413C12.0441 4.21947 12.0394 4.21655 12.0365 4.21189C12.0097 4.16756 11.977 4.12849 11.9461 4.08766C11.928 4.06783 11.9134 4.04567 11.8936 4.02876C11.7565 3.86779 11.5949 3.72606 11.3943 3.63333L7.66094 1.89942C7.66035 1.89942 7.65977 1.89942 7.65977 1.89884C7.24036 1.70521 6.75911 1.70579 6.33853 1.89942L2.60696 3.63275C2.4063 3.72548 2.24413 3.86662 2.10705 4.02759C2.08546 4.04567 2.06971 4.07016 2.05046 4.09174C2.02013 4.13082 1.98921 4.16873 1.96355 4.21072C1.96063 4.21597 1.95596 4.21947 1.95363 4.22413C1.9513 4.22938 1.95188 4.23463 1.94955 4.23988C1.82646 4.45101 1.75005 4.68838 1.75005 4.938V9.05961C1.74538 9.61367 2.07905 10.1292 2.60054 10.373L6.33328 12.1064C6.54444 12.2049 6.77078 12.2539 6.99769 12.2539C7.22402 12.2539 7.45036 12.2049 7.66094 12.1069L11.3925 10.3736C11.9128 10.1333 12.2494 9.62125 12.25 9.06836V4.93741C12.2494 4.68779 12.173 4.45042 12.0493 4.23872V4.23872Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.3893 12.1964L9.80566 14.3258V8.91678L14.639 6.67214V11.8549C14.639 11.995 14.5439 12.1255 14.3893 12.1964V12.1964ZM3.60543 12.1972C3.45318 12.1263 3.35974 11.9958 3.36135 11.8492V6.67214L8.19466 8.91678V14.3275L3.60543 12.1972ZM8.76349 3.41398C8.83679 3.37935 8.91815 3.36243 8.99952 3.36243C9.08007 3.36243 9.16143 3.37935 9.23474 3.41398L13.5275 5.40654L8.99952 7.51024L4.4707 5.40654L8.76349 3.41398ZM15.9729 5.18336C15.9705 5.17691 15.9713 5.16966 15.9681 5.16322C15.9656 5.15678 15.9592 5.15275 15.9552 5.14631C15.9181 5.0851 15.873 5.03114 15.8303 4.97476C15.8053 4.94737 15.7852 4.91677 15.7578 4.89341C15.5685 4.67112 15.3454 4.47541 15.0683 4.34735L9.91272 1.9529C9.91192 1.9529 9.91111 1.9529 9.91111 1.9521C9.33192 1.6847 8.66734 1.68551 8.08654 1.9529L2.93342 4.34655C2.65631 4.4746 2.43237 4.66951 2.24306 4.8918C2.21326 4.91677 2.19151 4.9506 2.16493 4.9804C2.12304 5.03436 2.08034 5.08671 2.0449 5.1447C2.04087 5.15195 2.03443 5.15678 2.0312 5.16322C2.02798 5.17047 2.02879 5.17772 2.02557 5.18497C1.85559 5.47652 1.75007 5.80432 1.75007 6.14903V11.8408C1.74362 12.6059 2.2044 13.3179 2.92456 13.6545L8.07929 16.0482C8.3709 16.1843 8.68345 16.252 8.99681 16.252C9.30937 16.252 9.62192 16.1843 9.91272 16.049L15.0658 13.6553C15.7844 13.3235 16.2492 12.6164 16.25 11.8529V6.14822C16.2492 5.80351 16.1437 5.47572 15.9729 5.18336V5.18336Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.4593 10.6466L8.66602 12.4089V7.93246L12.666 6.07482V10.364C12.666 10.48 12.5873 10.5879 12.4593 10.6466V10.6466ZM3.53502 10.6473C3.40902 10.5886 3.33169 10.4806 3.33302 10.3593V6.07482L7.33301 7.93246V12.4103L3.53502 10.6473ZM7.80558 3.3807C7.86625 3.35204 7.93358 3.33804 8.00091 3.33804C8.06758 3.33804 8.13491 3.35204 8.19558 3.3807L11.7482 5.02971L8.00091 6.77071L4.25293 5.02971L7.80558 3.3807ZM13.7707 4.84369C13.7687 4.83836 13.7693 4.83236 13.7667 4.82702C13.7647 4.82169 13.7593 4.81836 13.756 4.81303C13.7253 4.76237 13.688 4.71771 13.6527 4.67105C13.632 4.64839 13.6153 4.62306 13.5927 4.60373C13.436 4.41977 13.2513 4.2578 13.022 4.15182L8.75536 2.17021C8.75469 2.17021 8.75402 2.17021 8.75402 2.16954C8.27469 1.94825 7.7247 1.94892 7.24403 2.17021L2.97938 4.15116C2.75005 4.25714 2.56472 4.41844 2.40805 4.6024C2.38339 4.62306 2.36539 4.65106 2.34339 4.67572C2.30872 4.72038 2.27339 4.7637 2.24405 4.81169C2.24072 4.81769 2.23539 4.82169 2.23272 4.82702C2.23005 4.83302 2.23072 4.83902 2.22805 4.84502C2.08739 5.08631 2.00006 5.35759 2.00006 5.64287V10.3533C1.99472 10.9865 2.37605 11.5757 2.97205 11.8543L7.23803 13.8353C7.47936 13.9479 7.73803 14.0039 7.99736 14.0039C8.25603 14.0039 8.51469 13.9479 8.75536 13.8359L13.02 11.855C13.6147 11.5804 13.9993 10.9952 14 10.3633V5.6422C13.9993 5.35692 13.912 5.08564 13.7707 4.84369V4.84369Z'
        fill={color}
      />
    </svg>
  );
};

export const CustomizeIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M12.3291 2.33102H8.87967C8.69485 1.80861 8.30155 1.38674 7.79379 1.16582C7.28597 0.944727 6.70957 0.944727 6.20175 1.16582C5.69394 1.38672 5.30066 1.80861 5.11587 2.33102H1.66642C1.29844 2.33102 1 2.62971 1 2.99802C1 3.36632 1.29844 3.66501 1.66642 3.66501H5.11587C5.30069 4.18742 5.69399 4.60929 6.20175 4.83021C6.70957 5.0513 7.28597 5.0513 7.79379 4.83021C8.3016 4.60931 8.69488 4.18742 8.87967 3.66501H12.3291C12.6971 3.66501 12.9955 3.36632 12.9955 2.99802C12.9955 2.62971 12.6971 2.33102 12.3291 2.33102ZM6.99775 3.66501C6.72813 3.66501 6.48527 3.50254 6.38207 3.25335C6.27887 3.00397 6.33595 2.71718 6.52655 2.52642C6.71714 2.33566 7.00366 2.27853 7.25285 2.38181C7.50183 2.4851 7.66416 2.72815 7.66416 2.99802C7.66416 3.17501 7.59387 3.34455 7.46891 3.46961C7.34396 3.59467 7.17458 3.66501 6.99775 3.66501Z'
          fill={color}
        />
        <path
          d='M12.3291 10.3349H8.87967C8.69485 9.81252 8.30155 9.39064 7.79379 9.16972C7.28597 8.94863 6.70957 8.94863 6.20175 9.16972C5.69394 9.39063 5.30066 9.81252 5.11587 10.3349H1.66642C1.29844 10.3349 1 10.6336 1 11.0019C1 11.3702 1.29844 11.6689 1.66642 11.6689H5.11587C5.30069 12.1913 5.69399 12.6132 6.20175 12.8341C6.70957 13.0552 7.28597 13.0552 7.79379 12.8341C8.3016 12.6132 8.69488 12.1913 8.87967 11.6689H12.3291C12.6971 11.6689 12.9955 11.3702 12.9955 11.0019C12.9955 10.6336 12.6971 10.3349 12.3291 10.3349ZM6.99775 11.6689C6.72813 11.6689 6.48527 11.5064 6.38207 11.2573C6.27887 11.0079 6.33595 10.7211 6.52655 10.5303C6.71714 10.3396 7.00366 10.2824 7.25285 10.3857C7.50183 10.489 7.66416 10.7321 7.66416 11.0019C7.66416 11.1789 7.59387 11.3485 7.46891 11.4735C7.34396 11.5986 7.17458 11.6689 6.99775 11.6689Z'
          fill={color}
        />
        <path
          d='M10.998 5C10.5852 5.00093 10.1827 5.12972 9.84594 5.36849C9.50901 5.60726 9.25406 5.94449 9.11611 6.33402H1.66837C1.30039 6.33402 1.00195 6.63271 1.00195 7.00102C1.00195 7.36932 1.30039 7.66802 1.66837 7.66802H9.11611C9.27974 8.1316 9.60831 8.51853 10.0392 8.75522C10.4698 8.99176 10.9724 9.06137 11.451 8.95063C11.9296 8.8399 12.351 8.55684 12.6341 8.15505C12.9175 7.75343 13.0432 7.26137 12.9873 6.77284C12.9313 6.28431 12.6974 5.83356 12.3305 5.50659C11.9636 5.1796 11.4893 4.99929 10.998 5ZM10.998 7.668C10.7284 7.668 10.4856 7.50553 10.3824 7.25633C10.2792 7.00695 10.3362 6.72016 10.5268 6.5294C10.7174 6.33864 11.0039 6.28151 11.2531 6.3848C11.5021 6.48809 11.6644 6.73114 11.6644 7.00101C11.6644 7.17799 11.5942 7.34753 11.4692 7.47259C11.3443 7.59766 11.1749 7.668 10.998 7.668Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M16.1073 2.77468H11.5075C11.2611 2.07814 10.7366 1.51565 10.0595 1.22109C9.38232 0.926304 8.61369 0.926304 7.93652 1.22109C7.25935 1.51563 6.73491 2.07814 6.48849 2.77468H1.88867C1.39797 2.77468 1 3.17293 1 3.664C1 4.15507 1.39797 4.55332 1.88867 4.55332H6.48849C6.73496 5.24986 7.25942 5.81235 7.93652 6.10691C8.61369 6.4017 9.38232 6.4017 10.0595 6.10691C10.7367 5.81237 11.2611 5.24986 11.5075 4.55332H16.1073C16.598 4.55332 16.996 4.15507 16.996 3.664C16.996 3.17293 16.598 2.77468 16.1073 2.77468ZM8.99797 4.55332C8.63844 4.55332 8.31459 4.3367 8.17697 4.00445C8.03935 3.67194 8.11548 3.28956 8.36963 3.03521C8.62379 2.78087 9.00586 2.70469 9.33816 2.8424C9.67017 2.98012 9.88663 3.30419 9.88663 3.66401C9.88663 3.89999 9.7929 4.12604 9.62628 4.29279C9.45965 4.45954 9.23378 4.55332 8.99797 4.55332Z'
          fill={color}
        />
        <path
          d='M16.1073 13.4466H11.5075C11.2611 12.75 10.7366 12.1875 10.0595 11.893C9.38232 11.5982 8.61369 11.5982 7.93652 11.893C7.25935 12.1875 6.73491 12.75 6.48849 13.4466H1.88867C1.39797 13.4466 1 13.8448 1 14.3359C1 14.8269 1.39797 15.2252 1.88867 15.2252H6.48849C6.73496 15.9217 7.25942 16.4842 7.93652 16.7788C8.61369 17.0736 9.38232 17.0736 10.0595 16.7788C10.7367 16.4842 11.2611 15.9217 11.5075 15.2252H16.1073C16.598 15.2252 16.996 14.8269 16.996 14.3359C16.996 13.8448 16.598 13.4466 16.1073 13.4466ZM8.99797 15.2252C8.63844 15.2252 8.31459 15.0086 8.17697 14.6763C8.03935 14.3438 8.11548 13.9614 8.36963 13.7071C8.62379 13.4527 9.00586 13.3766 9.33816 13.5143C9.67017 13.652 9.88663 13.9761 9.88663 14.3359C9.88663 14.5719 9.7929 14.7979 9.62628 14.9647C9.45965 15.1314 9.23378 15.2252 8.99797 15.2252Z'
          fill={color}
        />
        <path
          d='M14.3317 6.33203C13.7812 6.33327 13.2444 6.50499 12.7954 6.82335C12.3461 7.14171 12.0061 7.59134 11.8222 8.11071H1.89062C1.39992 8.11071 1.00195 8.50897 1.00195 9.00003C1.00195 9.4911 1.39992 9.88936 1.89062 9.88936H11.8222C12.0404 10.5075 12.4785 11.0234 13.053 11.339C13.6273 11.6543 14.2975 11.7471 14.9357 11.5995C15.574 11.4519 16.1358 11.0744 16.5134 10.5387C16.8913 10.0032 17.059 9.34716 16.9843 8.69579C16.9097 8.04443 16.5978 7.44344 16.1085 7.00748C15.6193 6.5715 14.9868 6.33108 14.3317 6.33203ZM14.3317 9.88933C13.9722 9.88933 13.6483 9.67271 13.5107 9.34045C13.3731 9.00795 13.4492 8.62556 13.7034 8.37122C13.9575 8.11688 14.3396 8.0407 14.6719 8.17841C15.0039 8.31613 15.2204 8.64019 15.2204 9.00002C15.2204 9.236 15.1266 9.46205 14.96 9.6288C14.7934 9.79555 14.5675 9.88933 14.3317 9.88933Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M14.2175 2.55295H10.1931C9.97748 1.94344 9.51862 1.45122 8.92622 1.19347C8.33376 0.935511 7.66128 0.935511 7.06882 1.19347C6.47636 1.45121 6.01752 1.94344 5.80193 2.55295H1.77751C1.34818 2.55295 1 2.90146 1 3.33117C1 3.76088 1.34818 4.10939 1.77751 4.10939H5.80193C6.01756 4.71889 6.47641 5.21112 7.06882 5.46887C7.66128 5.72683 8.33376 5.72683 8.92622 5.46887C9.51868 5.21113 9.97752 4.71889 10.1931 4.10939H14.2175C14.6469 4.10939 14.995 3.76088 14.995 3.33117C14.995 2.90146 14.6469 2.55295 14.2175 2.55295ZM7.99749 4.10939C7.68293 4.10939 7.39959 3.91982 7.27919 3.62908C7.15879 3.33812 7.22539 3.00351 7.44775 2.78094C7.67011 2.55837 8.00439 2.49171 8.29512 2.61222C8.5856 2.73273 8.77498 3.01631 8.77498 3.33118C8.77498 3.53767 8.69298 3.73549 8.5472 3.8814C8.40142 4.02732 8.2038 4.10939 7.99749 4.10939Z'
        fill={color}
      />
      <path
        d='M14.2175 11.8908H10.1931C9.97748 11.2813 9.51862 10.7891 8.92622 10.5314C8.33376 10.2734 7.66128 10.2734 7.06882 10.5314C6.47636 10.7891 6.01752 11.2813 5.80193 11.8908H1.77751C1.34818 11.8908 1 12.2393 1 12.6691C1 13.0988 1.34818 13.4473 1.77751 13.4473H5.80193C6.01756 14.0568 6.47641 14.549 7.06882 14.8068C7.66128 15.0647 8.33376 15.0647 8.92622 14.8068C9.51868 14.549 9.97752 14.0568 10.1931 13.4473H14.2175C14.6469 13.4473 14.995 13.0988 14.995 12.6691C14.995 12.2393 14.6469 11.8908 14.2175 11.8908ZM7.99749 13.4473C7.68293 13.4473 7.39959 13.2577 7.27919 12.967C7.15879 12.676 7.22539 12.3414 7.44775 12.1188C7.67011 11.8963 8.00439 11.8296 8.29512 11.9501C8.5856 12.0706 8.77498 12.3542 8.77498 12.6691C8.77498 12.8756 8.69298 13.0734 8.5472 13.2193C8.40142 13.3652 8.2038 13.4473 7.99749 13.4473Z'
        fill={color}
      />
      <path
        d='M12.6643 5.66602C12.1827 5.6671 11.713 5.81736 11.3201 6.09595C10.927 6.37453 10.6296 6.76799 10.4686 7.22247H1.77946C1.35014 7.22247 1.00195 7.57097 1.00195 8.00069C1.00195 8.4304 1.35014 8.7789 1.77946 8.7789H10.4686C10.6595 9.31979 11.0429 9.77124 11.5455 10.0474C12.048 10.3234 12.6343 10.4046 13.1927 10.2754C13.7512 10.1462 14.2427 9.81593 14.5731 9.34714C14.9037 8.87856 15.0504 8.30445 14.9851 7.73446C14.9198 7.16447 14.6468 6.63856 14.2188 6.25707C13.7908 5.87556 13.2374 5.66518 12.6643 5.66602ZM12.6643 8.77888C12.3497 8.77888 12.0664 8.58932 11.946 8.29858C11.8255 8.00761 11.8921 7.673 12.1145 7.45043C12.3369 7.22787 12.6712 7.16121 12.9619 7.28172C13.2524 7.40223 13.4417 7.68581 13.4417 8.00068C13.4417 8.20717 13.3597 8.40498 13.214 8.5509C13.0682 8.69681 12.8706 8.77888 12.6643 8.77888Z'
        fill={color}
      />
    </svg>
  );
};

export const DeleteIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M4.16058 10.7143C4.15003 10.9833 4.24354 11.2457 4.42076 11.4445C4.59798 11.6432 4.84459 11.7623 5.10697 11.7757H8.89232C9.15471 11.7623 9.40132 11.6432 9.57854 11.4445C9.75576 11.2457 9.84926 10.9833 9.83872 10.7143V4.34675H4.16058V10.7143ZM10.312 2.75461H8.65578L8.18271 2.22406H5.81732L5.34424 2.75461H3.6875V3.81595H10.312V2.75461Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M4.82795 14.8062C4.81245 15.1905 4.94984 15.5654 5.21025 15.8493C5.47066 16.1332 5.83302 16.3032 6.21857 16.3224H11.7807C12.1663 16.3032 12.5286 16.1332 12.789 15.8493C13.0494 15.5654 13.1868 15.1905 13.1713 14.8062V5.70966H4.82795V14.8062ZM13.8668 3.43517H11.4331L10.738 2.67725H7.26235L6.56721 3.43517H4.13281V4.95138H13.8668V3.43517Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M4.7555 12.245C4.74345 12.5524 4.85031 12.8523 5.05285 13.0794C5.25539 13.3066 5.53723 13.4426 5.8371 13.4579H10.1632C10.4631 13.4426 10.7449 13.3066 10.9475 13.0794C11.15 12.8523 11.2569 12.5524 11.2448 12.245V4.96773H4.7555V12.245ZM11.7857 3.14813H9.89288L9.35222 2.54179H6.64893L6.10827 3.14813H4.21484V4.3611H11.7857V3.14813Z'
        fill={color}
      />
    </svg>
  );
};

export const DownloadIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.41897 7.04427C6.41788 7.02966 6.41732 7.01489 6.41732 7V2.33333C6.41732 2.01133 6.67807 1.75 7.00065 1.75C7.32323 1.75 7.58398 2.01133 7.58398 2.33333V6.9999L8.98398 5.95C9.24182 5.75575 9.60757 5.80883 9.80065 6.06667C9.99432 6.3245 9.94182 6.69025 9.68398 6.88333L7.35065 8.63333C7.2474 8.71092 7.12373 8.75 7.00065 8.75C6.8834 8.75 6.76615 8.71442 6.66523 8.64383L4.3319 7.00233C4.06823 6.81683 4.00465 6.45283 4.19015 6.18975C4.37565 5.92608 4.73907 5.8625 5.00273 6.048L6.41897 7.04427ZM3.50065 9.91667V10.5H10.5007V9.91667C10.5007 9.59583 10.7632 9.33333 11.084 9.33333C11.4048 9.33333 11.6673 9.59583 11.6673 9.91667V11.0823L11.6673 11.0833C11.6673 11.4042 11.4048 11.6667 11.084 11.6667H2.91732C2.59648 11.6667 2.33398 11.4042 2.33398 11.0833V9.91667C2.33398 9.59583 2.59648 9.33333 2.91732 9.33333C3.23815 9.33333 3.50065 9.59583 3.50065 9.91667Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.33457 8.0506C7.33332 8.0339 7.33268 8.01702 7.33268 8V2.66667C7.33268 2.29867 7.63068 2 7.99935 2C8.36802 2 8.66602 2.29867 8.66602 2.66667V7.99988L10.266 6.8C10.5607 6.578 10.9787 6.63867 11.1993 6.93333C11.4207 7.228 11.3607 7.646 11.066 7.86667L8.39935 9.86667C8.28135 9.95533 8.14002 10 7.99935 10C7.86535 10 7.73135 9.95933 7.61601 9.87867L4.94935 8.00267C4.64802 7.79067 4.57535 7.37467 4.78735 7.074C4.99935 6.77267 5.41468 6.7 5.71602 6.912L7.33457 8.0506ZM3.99935 11.3333V12H11.9993V11.3333C11.9993 10.9667 12.2993 10.6667 12.666 10.6667C13.0327 10.6667 13.3327 10.9667 13.3327 11.3333V12.6655L13.3327 12.6667C13.3327 13.0333 13.0327 13.3333 12.666 13.3333H12.6649H3.33381L3.33268 13.3333C2.96602 13.3333 2.66602 13.0333 2.66602 12.6667V11.3333C2.66602 10.9667 2.96602 10.6667 3.33268 10.6667C3.69935 10.6667 3.99935 10.9667 3.99935 11.3333Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.33457 8.0506C7.33332 8.0339 7.33268 8.01702 7.33268 8V2.66667C7.33268 2.29867 7.63068 2 7.99935 2C8.36802 2 8.66602 2.29867 8.66602 2.66667V7.99988L10.266 6.8C10.5607 6.578 10.9787 6.63867 11.1993 6.93333C11.4207 7.228 11.3607 7.646 11.066 7.86667L8.39935 9.86667C8.28135 9.95533 8.14002 10 7.99935 10C7.86535 10 7.73135 9.95933 7.61601 9.87867L4.94935 8.00267C4.64802 7.79067 4.57535 7.37467 4.78735 7.074C4.99935 6.77267 5.41468 6.7 5.71602 6.912L7.33457 8.0506ZM3.99935 11.3333V12H11.9993V11.3333C11.9993 10.9667 12.2993 10.6667 12.666 10.6667C13.0327 10.6667 13.3327 10.9667 13.3327 11.3333V12.6655L13.3327 12.6667C13.3327 13.0333 13.0327 13.3333 12.666 13.3333H12.6649H3.33381L3.33268 13.3333C2.96602 13.3333 2.66602 13.0333 2.66602 12.6667V11.3333C2.66602 10.9667 2.96602 10.6667 3.33268 10.6667C3.69935 10.6667 3.99935 10.9667 3.99935 11.3333Z'
        fill={color}
      />
    </svg>
  );
};

export const DistributionIcon = ({ color }: IIconProps) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.6667 5.66667C13.2382 5.66667 12.8295 5.7803 12.4689 5.99747L10.0025 3.5311C10.2197 3.1705 10.3333 2.7617 10.3333 2.33333C10.3333 1.04673 9.2866 0 8 0C6.7134 0 5.66667 1.04673 5.66667 2.33333C5.66667 2.76173 5.7803 3.1705 5.99747 3.5311L3.5311 5.99747C3.1705 5.7803 2.76173 5.66667 2.33333 5.66667C1.04673 5.66667 0 6.7134 0 8C0 9.2866 1.04673 10.3333 2.33333 10.3333C2.7617 10.3333 3.1705 10.2197 3.5311 10.0025L5.99747 12.4689C5.7803 12.8295 5.66667 13.2382 5.66667 13.6667C5.66667 14.9533 6.7134 16 8 16C9.2866 16 10.3333 14.9533 10.3333 13.6667C10.3333 13.2383 10.2197 12.8295 10.0025 12.4689L12.4689 10.0025C12.8295 10.2197 13.2383 10.3333 13.6667 10.3333C14.9533 10.3333 16 9.2866 16 8C16 6.7134 14.9533 5.66667 13.6667 5.66667ZM11.3569 7.66667L8.33333 8.33333V4.6431C8.79483 4.57743 9.2277 4.3745 9.57937 4.05077L11.9492 6.42063C11.6256 6.77253 11.4228 7.20397 11.3569 7.66667ZM8 0.666667C8.919 0.666667 9.66667 1.41433 9.66667 2.33333C9.66667 3.2461 8.92747 4 8 4C7.07693 4 6.33333 3.25057 6.33333 2.33333C6.33333 1.41433 7.081 0.666667 8 0.666667ZM6.42063 4.05077C6.7681 4.3713 7.46354 4.76686 8.33333 4.6431V6.5988V8.33333C7.9993 8.33333 4.97593 8.33333 4.6431 8.33333C4.76054 7.50859 4.3675 6.76217 4.05077 6.42063L6.42063 4.05077ZM0.666667 8C0.666667 7.081 1.41433 6.33333 2.33333 6.33333C3.24607 6.33333 4 7.0725 4 8C4 8.9274 3.24617 9.66667 2.33333 9.66667C1.41433 9.66667 0.666667 8.919 0.666667 8ZM4.6431 8.33333C4.97587 8.33333 7.99933 8.33333 8.33333 8.33333C8.33333 8.66737 8.33333 11.0241 8.33333 11.3569C7.74987 11.2737 6.7831 11.6159 6.42063 11.9492L4.05077 9.57937C4.3816 9.22003 4.57887 8.78443 4.6431 8.33333ZM8 15.3333C7.081 15.3333 6.33333 14.5857 6.33333 13.6667C6.33333 13.2889 6.457 12.9324 6.69103 12.6358C7.35897 11.7891 8.63923 11.7867 9.30897 12.6358C9.33167 12.6773 9.66667 13.0428 9.66667 13.6667C9.66667 14.5857 8.919 15.3333 8 15.3333ZM9.57937 11.9492C9.23057 11.6273 8.7959 11.4229 8.33333 11.3569C8.33333 11.0241 8.33333 8.66733 8.33333 8.33333L11.3569 7.66667C11.3248 8.67523 11.6142 9.21243 11.9492 9.57937L9.57937 11.9492ZM13.6667 9.66667C12.754 9.66667 12 8.9275 12 8C12 7.07233 12.7539 6.33333 13.6667 6.33333C14.5857 6.33333 15.3333 7.081 15.3333 8C15.3333 8.919 14.5857 9.66667 13.6667 9.66667Z'
        fill={color}
      />
    </svg>
  );
};

export const EmailIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.0827 10.5007H2.91602C2.5946 10.5007 2.33268 10.2393 2.33268 9.91732V4.22982L6.64935 7.46732C6.75318 7.54548 6.87627 7.58398 6.99935 7.58398C7.12243 7.58398 7.24552 7.54548 7.34935 7.46732L11.666 4.22982V9.91732C11.666 10.2393 11.4041 10.5007 11.0827 10.5007ZM10.6936 3.50065L6.99935 6.27148L3.3051 3.50065H10.6936ZM11.0827 2.33398H2.91602C1.95118 2.33398 1.16602 3.11915 1.16602 4.08398V9.91732C1.16602 10.8822 1.95118 11.6673 2.91602 11.6673H11.0827C12.0475 11.6673 12.8327 10.8822 12.8327 9.91732V4.08398C12.8327 3.11915 12.0475 2.33398 11.0827 2.33398Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.25 13.5H3.75C3.33675 13.5 3 13.164 3 12.75V5.4375L8.55 9.6C8.6835 9.7005 8.84175 9.75 9 9.75C9.15825 9.75 9.3165 9.7005 9.45 9.6L15 5.4375V12.75C15 13.164 14.6632 13.5 14.25 13.5ZM13.7498 4.5L9 8.0625L4.25025 4.5H13.7498ZM14.25 3H3.75C2.5095 3 1.5 4.0095 1.5 5.25V12.75C1.5 13.9905 2.5095 15 3.75 15H14.25C15.4905 15 16.5 13.9905 16.5 12.75V5.25C16.5 4.0095 15.4905 3 14.25 3Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.6673 11.9993H3.33398C2.96665 11.9993 2.66732 11.7007 2.66732 11.3327V4.83268L7.60065 8.53268C7.71932 8.62202 7.85998 8.66602 8.00065 8.66602C8.14132 8.66602 8.28198 8.62202 8.40065 8.53268L13.334 4.83268V11.3327C13.334 11.7007 13.0347 11.9993 12.6673 11.9993ZM12.2227 3.99935L8.00065 7.16602L3.77865 3.99935H12.2227ZM12.6673 2.66602H3.33398C2.23132 2.66602 1.33398 3.56335 1.33398 4.66602V11.3327C1.33398 12.4353 2.23132 13.3327 3.33398 13.3327H12.6673C13.77 13.3327 14.6673 12.4353 14.6673 11.3327V4.66602C14.6673 3.56335 13.77 2.66602 12.6673 2.66602Z'
        fill={color}
      />
    </svg>
  );
};

export const EditIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M3.0625 9.13259V10.8634H4.70224L9.54182 5.75684L7.90208 4.02601L3.0625 9.13259ZM10.8107 4.41771C10.8512 4.37499 10.8834 4.32425 10.9054 4.26838C10.9273 4.21252 10.9386 4.15263 10.9386 4.09215C10.9386 4.03167 10.9273 3.97178 10.9054 3.91592C10.8834 3.86005 10.8512 3.80931 10.8107 3.76659L9.7868 2.68584C9.74633 2.64303 9.69826 2.60906 9.64534 2.58589C9.59241 2.56271 9.53568 2.55078 9.47838 2.55078C9.42108 2.55078 9.36434 2.56271 9.31142 2.58589C9.2585 2.60906 9.21042 2.64303 9.16995 2.68584L8.3696 3.53066L10.0093 5.26149L10.8097 4.41668L10.8107 4.41771Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M3.9375 11.7416V13.967H6.04574L12.2681 7.40138L10.1598 5.17601L3.9375 11.7416ZM13.8994 5.67963C13.9516 5.62471 13.993 5.55947 14.0212 5.48764C14.0494 5.41581 14.0639 5.33882 14.0639 5.26105C14.0639 5.18329 14.0494 5.1063 14.0212 5.03447C13.993 4.96264 13.9516 4.8974 13.8994 4.84247L12.583 3.45295C12.531 3.3979 12.4692 3.35423 12.4011 3.32443C12.3331 3.29463 12.2602 3.2793 12.1865 3.2793C12.1128 3.2793 12.0399 3.29463 11.9718 3.32443C11.9038 3.35423 11.842 3.3979 11.7899 3.45295L10.7609 4.53914L12.8692 6.7645L13.8982 5.67831L13.8994 5.67963Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M3.5 10.4381V12.4162H5.37399L10.9049 6.58009L9.03095 4.60199L3.5 10.4381ZM12.355 5.04965C12.4014 5.00083 12.4382 4.94283 12.4633 4.87899C12.4884 4.81514 12.5013 4.7467 12.5013 4.67758C12.5013 4.60846 12.4884 4.54001 12.4633 4.47617C12.4382 4.41232 12.4014 4.35433 12.355 4.30551L11.1849 3.07037C11.1387 3.02144 11.0837 2.98262 11.0232 2.95614C10.9628 2.92965 10.8979 2.91602 10.8324 2.91602C10.7669 2.91602 10.7021 2.92965 10.6416 2.95614C10.5811 2.98262 10.5262 3.02144 10.4799 3.07037L9.56526 4.03587L11.4392 6.01397L12.3539 5.04847L12.355 5.04965Z'
        fill={color}
      />
    </svg>
  );
};

export const ExpandIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.59855 0.820508C6.82665 0.594882 7.19417 0.595295 7.42104 0.822158L9.47436 2.873C9.70246 3.10028 9.70287 3.47027 9.47518 3.69796L9.47477 3.69837C9.24708 3.92606 8.87791 3.92565 8.65022 3.69879L7.58314 2.63335L7.58314 5.34829C7.58314 5.50916 7.51797 5.65517 7.41237 5.76077C7.30719 5.86595 7.16117 5.93112 6.9999 5.93153C6.67775 5.93112 6.41665 5.67002 6.41665 5.34829L6.41665 2.64243L5.34833 3.70002C5.11899 3.92689 4.749 3.92482 4.52296 3.69631C4.29692 3.4678 4.29857 3.09987 4.52502 2.87342L4.52708 2.87135L6.59855 0.820508ZM6.41665 8.64779C6.41665 8.32523 6.67734 8.06455 6.99989 8.06455C7.32245 8.06455 7.58314 8.32523 7.58314 8.64779L7.58314 11.3636L8.64981 10.2977C8.87791 10.0696 9.24708 10.07 9.47518 10.2981C9.70246 10.5262 9.70246 10.895 9.47477 11.1227L9.47436 11.1231L7.42104 13.1739C7.19417 13.4008 6.82665 13.4012 6.59855 13.1756L4.52708 11.1247C4.29816 10.8983 4.29651 10.5287 4.52296 10.2998L4.52502 10.2977C4.75189 10.0708 5.1194 10.0696 5.34792 10.2956L6.41665 11.3537L6.41665 8.64779Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.48466 1.05611C8.77793 0.766017 9.25046 0.766548 9.54214 1.05823L12.1821 3.69503C12.4754 3.98724 12.4759 4.46295 12.1832 4.75569L12.1827 4.75622C11.8899 5.04896 11.4153 5.04843 11.1225 4.75675L9.75056 3.38691L9.75056 6.87754C9.75056 7.08437 9.66677 7.27211 9.531 7.40787C9.39577 7.54311 9.20803 7.6269 9.00067 7.62743C8.58648 7.6269 8.25079 7.2912 8.25079 6.87754L8.25079 3.39858L6.87723 4.75834C6.58237 5.05002 6.10666 5.04737 5.81604 4.75357C5.52542 4.45977 5.52754 3.98671 5.81869 3.69556L5.82134 3.69291L8.48466 1.05611ZM8.25079 11.1198C8.25079 10.705 8.58595 10.3699 9.00067 10.3699C9.41539 10.3699 9.75056 10.705 9.75056 11.1198L9.75056 14.6115L11.122 13.2411C11.4153 12.9478 11.8899 12.9483 12.1832 13.2416C12.4754 13.5349 12.4754 14.009 12.1827 14.3017L12.1821 14.3023L9.54214 16.9391C9.25046 17.2308 8.77793 17.2313 8.48466 16.9412L5.82134 14.3044C5.52701 14.0132 5.52489 13.5381 5.81604 13.2437L5.81869 13.2411C6.11037 12.9494 6.5829 12.9478 6.8767 13.2384L8.25079 14.5987L8.25079 11.1198Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.5426 0.938003C7.80329 0.680145 8.22331 0.680616 8.48258 0.939888L10.8292 3.28371C11.0899 3.54346 11.0904 3.96631 10.8302 4.22652L10.8297 4.22699C10.5695 4.48721 10.1476 4.48674 9.88736 4.22746L8.66784 3.00983L8.66784 6.11261C8.66784 6.29646 8.59336 6.46334 8.47268 6.58401C8.35247 6.70422 8.18559 6.7787 8.00128 6.77918C7.63311 6.7787 7.33471 6.48031 7.33471 6.11261L7.33471 3.0202L6.11377 4.22888C5.85167 4.48815 5.42882 4.48579 5.17049 4.22464C4.91216 3.96348 4.91405 3.54298 5.17285 3.28418L5.17521 3.28183L7.5426 0.938003ZM7.33471 9.88347C7.33471 9.51483 7.63264 9.2169 8.00128 9.2169C8.36991 9.2169 8.66784 9.51483 8.66784 9.88347L8.66784 12.9872L9.88689 11.7691C10.1476 11.5084 10.5695 11.5089 10.8302 11.7696C11.0899 12.0302 11.0899 12.4517 10.8297 12.7119L10.8292 12.7124L8.48258 15.0562C8.22331 15.3155 7.80329 15.3159 7.5426 15.0581L5.17521 12.7143C4.91358 12.4555 4.91169 12.0331 5.17049 11.7714L5.17285 11.7691C5.43212 11.5098 5.85214 11.5084 6.1133 11.7667L7.33471 12.9759L7.33471 9.88347Z'
        fill={color}
      />
    </svg>
  );
};

export const ExternalLinkIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.0833 10.5V7C11.0833 6.678 11.3441 6.41667 11.6667 6.41667C11.9892 6.41667 12.25 6.678 12.25 7V10.5C12.25 11.4648 11.4648 12.25 10.5 12.25H3.5C2.53517 12.25 1.75 11.4648 1.75 10.5V3.5C1.75 2.53517 2.53517 1.75 3.5 1.75H7C7.32258 1.75 7.58333 2.01133 7.58333 2.33333C7.58333 2.65533 7.32258 2.91667 7 2.91667H3.5C3.178 2.91667 2.91667 3.17858 2.91667 3.5V10.5C2.91667 10.8214 3.178 11.0833 3.5 11.0833H10.5C10.822 11.0833 11.0833 10.8214 11.0833 10.5ZM10.2539 2.92133L9.33048 2.91667C9.00789 2.91492 8.74831 2.65242 8.75006 2.33042C8.75181 2.009 9.01256 1.75 9.33339 1.75H9.33631L11.6679 1.76167C11.9887 1.76342 12.2483 2.02358 12.2483 2.34442L12.2501 4.66608C12.2501 4.98867 11.9893 5.25 11.6673 5.25H11.6667C11.3447 5.25 11.0834 4.98925 11.0834 4.66725L11.0828 3.74208L7.41248 7.41242C7.29873 7.52617 7.14939 7.58333 7.00006 7.58333C6.85073 7.58333 6.70139 7.52617 6.58764 7.41242C6.35956 7.18433 6.35956 6.81567 6.58764 6.58758L10.2539 2.92133Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.25 13.5V9C14.25 8.586 14.5852 8.25 15 8.25C15.4148 8.25 15.75 8.586 15.75 9V13.5C15.75 14.7405 14.7405 15.75 13.5 15.75H4.5C3.2595 15.75 2.25 14.7405 2.25 13.5V4.5C2.25 3.2595 3.2595 2.25 4.5 2.25H9C9.41475 2.25 9.75 2.586 9.75 3C9.75 3.414 9.41475 3.75 9 3.75H4.5C4.086 3.75 3.75 4.08675 3.75 4.5V13.5C3.75 13.9132 4.086 14.25 4.5 14.25H13.5C13.914 14.25 14.25 13.9132 14.25 13.5ZM13.1836 3.756L11.9963 3.75C11.5816 3.74775 11.2478 3.41025 11.2501 2.99625C11.2523 2.583 11.5876 2.25 12.0001 2.25H12.0038L15.0016 2.265C15.4141 2.26725 15.7478 2.60175 15.7478 3.01425L15.7501 5.99925C15.7501 6.414 15.4148 6.75 15.0008 6.75H15.0001C14.5861 6.75 14.2501 6.41475 14.2501 6.00075L14.2493 4.81125L9.53032 9.53025C9.38408 9.6765 9.19208 9.75 9.00007 9.75C8.80807 9.75 8.61608 9.6765 8.46982 9.53025C8.17658 9.237 8.17658 8.763 8.46982 8.46975L13.1836 3.756Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.6667 12V8C12.6667 7.632 12.9647 7.33333 13.3333 7.33333C13.702 7.33333 14 7.632 14 8V12C14 13.1027 13.1027 14 12 14H4C2.89733 14 2 13.1027 2 12V4C2 2.89733 2.89733 2 4 2H8C8.36867 2 8.66667 2.29867 8.66667 2.66667C8.66667 3.03467 8.36867 3.33333 8 3.33333H4C3.632 3.33333 3.33333 3.63267 3.33333 4V12C3.33333 12.3673 3.632 12.6667 4 12.6667H12C12.368 12.6667 12.6667 12.3673 12.6667 12ZM11.7187 3.33867L10.6634 3.33333C10.2947 3.33133 9.99807 3.03133 10.0001 2.66333C10.0021 2.296 10.3001 2 10.6667 2H10.6701L13.3347 2.01333C13.7014 2.01533 13.9981 2.31267 13.9981 2.67933L14.0001 5.33267C14.0001 5.70133 13.7021 6 13.3341 6H13.3334C12.9654 6 12.6667 5.702 12.6667 5.334L12.6661 4.27667L8.4714 8.47133C8.3414 8.60133 8.17073 8.66667 8.00007 8.66667C7.8294 8.66667 7.65873 8.60133 7.52873 8.47133C7.26807 8.21067 7.26807 7.78933 7.52873 7.52867L11.7187 3.33867Z'
        fill={color}
      />
    </svg>
  );
};

export const EyeIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.99938 7.87493C6.51696 7.87493 6.12438 7.48235 6.12438 6.99993C6.12438 6.51751 6.51696 6.12493 6.99938 6.12493C7.48179 6.12493 7.87438 6.51751 7.87438 6.99993C7.87438 7.48235 7.48179 7.87493 6.99938 7.87493ZM6.99938 4.95826C5.87354 4.95826 4.95771 5.8741 4.95771 6.99993C4.95771 8.12576 5.87354 9.0416 6.99938 9.0416C8.12521 9.0416 9.04105 8.12576 9.04105 6.99993C9.04105 5.8741 8.12521 4.95826 6.99938 4.95826ZM7.12754 9.9152C4.6157 9.97353 2.97712 7.82511 2.43345 6.99736C3.03195 6.06111 4.53929 4.14428 6.87145 4.08478C9.37337 4.0212 11.0213 6.17486 11.565 7.00261C10.967 7.93886 9.45912 9.8557 7.12754 9.9152ZM12.7555 6.70978C12.3834 6.06111 10.3277 2.80961 6.8417 2.9187C3.61704 3.00036 1.74162 5.8412 1.24345 6.70978C1.1402 6.88945 1.1402 7.11053 1.24345 7.2902C1.61037 7.93011 3.5937 11.083 7.01379 11.083C7.06162 11.083 7.10945 11.0824 7.15729 11.0813C10.3814 10.999 12.2574 8.15878 12.7555 7.2902C12.8582 7.11053 12.8582 6.88945 12.7555 6.70978Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.49996 10.6875C8.84525 10.6875 8.31246 10.1547 8.31246 9.50001C8.31246 8.8453 8.84525 8.31251 9.49996 8.31251C10.1547 8.31251 10.6875 8.8453 10.6875 9.50001C10.6875 10.1547 10.1547 10.6875 9.49996 10.6875ZM9.49996 6.72917C7.97204 6.72917 6.72913 7.97209 6.72913 9.50001C6.72913 11.0279 7.97204 12.2708 9.49996 12.2708C11.0279 12.2708 12.2708 11.0279 12.2708 9.50001C12.2708 7.97209 11.0279 6.72917 9.49996 6.72917ZM9.67389 13.4564C6.26497 13.5356 4.04118 10.6199 3.30335 9.49652C4.1156 8.2259 6.16126 5.62448 9.32635 5.54373C12.7218 5.45744 14.9583 8.38027 15.6961 9.50365C14.8846 10.7743 12.8382 13.3757 9.67389 13.4564ZM17.3119 9.10623C16.8068 8.2259 14.017 3.81315 9.28597 3.96119C4.90964 4.07202 2.36443 7.92744 1.68835 9.10623C1.54822 9.35006 1.54822 9.65011 1.68835 9.89394C2.1863 10.7624 4.87797 15.0414 9.51951 15.0414C9.58443 15.0414 9.64935 15.0406 9.71426 15.039C14.0898 14.9274 16.6358 11.0727 17.3119 9.89394C17.4512 9.65011 17.4512 9.35006 17.3119 9.10623Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.00068 8.99936C7.44935 8.99936 7.00068 8.5507 7.00068 7.99936C7.00068 7.44803 7.44935 6.99936 8.00068 6.99936C8.55202 6.99936 9.00068 7.44803 9.00068 7.99936C9.00068 8.5507 8.55202 8.99936 8.00068 8.99936ZM8.00068 5.66603C6.71402 5.66603 5.66735 6.7127 5.66735 7.99936C5.66735 9.28603 6.71402 10.3327 8.00068 10.3327C9.28735 10.3327 10.334 9.28603 10.334 7.99936C10.334 6.7127 9.28735 5.66603 8.00068 5.66603ZM8.14715 11.3311C5.27648 11.3978 3.40382 8.94243 2.78248 7.99643C3.46648 6.92643 5.18915 4.73576 7.85448 4.66776C10.7138 4.5951 12.5972 7.05643 13.2185 8.00243C12.5352 9.07243 10.8118 11.2631 8.14715 11.3311ZM14.5792 7.66776C14.1538 6.92643 11.8045 3.21043 7.82048 3.3351C4.13515 3.42843 1.99182 6.6751 1.42248 7.66776C1.30448 7.8731 1.30448 8.12576 1.42248 8.3311C1.84182 9.06243 4.10848 12.6658 8.01715 12.6658C8.07182 12.6658 8.12648 12.6651 8.18115 12.6638C11.8658 12.5698 14.0098 9.32376 14.5792 8.3311C14.6965 8.12576 14.6965 7.8731 14.5792 7.66776Z'
        fill={color}
      />
    </svg>
  );
};

export const EyeOffIcon = ({ color, style, className, large }: IIconProps) => {
  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.49996 10.6875C8.84525 10.6875 8.31246 10.1547 8.31246 9.50001C8.31246 8.8453 8.84525 8.31251 9.49996 8.31251C10.1547 8.31251 10.6875 8.8453 10.6875 9.50001C10.6875 10.1547 10.1547 10.6875 9.49996 10.6875ZM9.49996 6.72917C7.97204 6.72917 6.72913 7.97209 6.72913 9.50001C6.72913 11.0279 7.97204 12.2708 9.49996 12.2708C11.0279 12.2708 12.2708 11.0279 12.2708 9.50001C12.2708 7.97209 11.0279 6.72917 9.49996 6.72917ZM9.67389 13.4564C6.26497 13.5356 4.04118 10.6199 3.30335 9.49652C4.1156 8.2259 6.16126 5.62448 9.32635 5.54373C12.7218 5.45744 14.9583 8.38027 15.6961 9.50365C14.8846 10.7743 12.8382 13.3757 9.67389 13.4564ZM17.3119 9.10623C16.8068 8.2259 14.017 3.81315 9.28597 3.96119C4.90964 4.07202 2.36443 7.92744 1.68835 9.10623C1.54822 9.35006 1.54822 9.65011 1.68835 9.89394C2.1863 10.7624 4.87797 15.0414 9.51951 15.0414C9.58443 15.0414 9.64935 15.0406 9.71426 15.039C14.0898 14.9274 16.6358 11.0727 17.3119 9.89394C17.4512 9.65011 17.4512 9.35006 17.3119 9.10623Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.5792 8.33167C14.3025 8.81367 13.6518 9.82567 12.6372 10.751L11.6965 9.81033C12.4032 9.17633 12.9145 8.479 13.2185 8.003C12.5972 7.057 10.7152 4.59567 7.85448 4.66833C7.45448 4.67833 7.07915 4.741 6.72182 4.83567L5.66848 3.78233C6.31648 3.52633 7.03048 3.35567 7.82048 3.33567C11.8038 3.211 14.1538 6.927 14.5792 7.66833C14.6965 7.87367 14.6965 8.12633 14.5792 8.33167ZM9.27915 11.1643L10.3325 12.2177C9.68515 12.4737 8.97048 12.6443 8.18115 12.6643C8.12648 12.6657 8.07182 12.6663 8.01715 12.6663C4.10848 12.6663 1.84182 9.063 1.42248 8.33167C1.30448 8.12633 1.30448 7.87367 1.42248 7.66833C1.69848 7.18633 2.34915 6.17433 3.36382 5.24833L4.30448 6.18967C3.59782 6.82367 3.08715 7.521 2.78248 7.997C3.40382 8.943 5.27715 11.3983 8.14715 11.3317C8.54715 11.3217 8.92248 11.259 9.27915 11.1643ZM8.00048 8.99967C7.44915 8.99967 7.00048 8.55167 7.00048 7.99967C7.00048 7.983 7.00782 7.96767 7.00848 7.95033L8.05048 8.99233C8.03315 8.993 8.01782 8.99967 8.00048 8.99967ZM3.13848 2.195C2.87848 1.935 2.45648 1.935 2.19582 2.195C1.93582 2.45567 1.93582 2.87767 2.19582 3.13767L5.94982 6.89167C5.76515 7.23033 5.66715 7.607 5.66715 7.99967C5.66715 9.28633 6.71448 10.333 8.00048 10.333C8.39382 10.333 8.77048 10.235 9.10915 10.051L12.8625 13.8043C12.9931 13.935 13.1632 13.9997 13.3338 13.9997C13.5045 13.9997 13.6751 13.935 13.8052 13.8043C14.0658 13.5443 14.0658 13.1223 13.8052 12.8617L3.13848 2.195Z'
        fill={color}
      />
    </svg>
  );
};

export const FilterIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M13.9938 3.07368C13.9932 3.32856 13.9005 3.57278 13.7362 3.75262C13.5718 3.93245 13.3493 4.03317 13.1175 4.03262L2.86546 4.00812C2.63367 4.00756 2.41162 3.90578 2.24815 3.72516C2.08468 3.54455 1.99319 3.29989 1.9938 3.04501C1.99441 2.79013 2.08707 2.54591 2.2514 2.36607C2.41573 2.18624 2.63826 2.08552 2.87005 2.08607L13.1221 2.11057C13.3539 2.11113 13.5759 2.21291 13.7394 2.39353C13.9029 2.57414 13.9944 2.8188 13.9938 3.07368Z'
          fill={color}
        />
        <path
          d='M12.5299 7.10971C12.5296 7.23592 12.5067 7.36083 12.4625 7.47732C12.4183 7.59381 12.3537 7.6996 12.2723 7.78865C12.1909 7.87769 12.0944 7.94825 11.9883 7.99629C11.8821 8.04434 11.7684 8.06892 11.6536 8.06865L4.30491 8.05109C4.19014 8.05081 4.07656 8.02568 3.97064 7.97713C3.86472 7.92858 3.76854 7.85757 3.6876 7.76813C3.60666 7.6787 3.54254 7.5726 3.4989 7.4559C3.45526 7.3392 3.43295 7.21418 3.43325 7.08798C3.43355 6.96177 3.45646 6.83686 3.50066 6.72037C3.54485 6.60388 3.60948 6.49809 3.69085 6.40904C3.77222 6.32 3.86873 6.24944 3.97488 6.2014C4.08103 6.15335 4.19474 6.12877 4.3095 6.12904L11.6582 6.1466C11.89 6.14716 12.1121 6.24894 12.2755 6.42956C12.439 6.61017 12.5305 6.85483 12.5299 7.10971Z'
          fill={color}
        />
        <path
          d='M10.3449 11.1423C10.3446 11.2685 10.3217 11.3934 10.2775 11.5099C10.2333 11.6264 10.1687 11.7322 10.0873 11.8212C10.006 11.9103 9.90945 11.9808 9.8033 12.0289C9.69715 12.0769 9.58345 12.1015 9.46868 12.1012L6.47483 12.0941C6.24305 12.0935 6.02099 11.9917 5.85752 11.8111C5.69406 11.6305 5.60256 11.3858 5.60317 11.1309C5.60378 10.8761 5.69644 10.6318 5.86077 10.452C6.0251 10.2722 6.24764 10.1715 6.47943 10.172L9.47348 10.1792C9.70523 10.1798 9.92723 10.2816 10.0907 10.4622C10.2541 10.6428 10.3455 10.8874 10.3449 11.1423Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M17.0341 3.82926C17.0333 4.15819 16.9098 4.47336 16.6907 4.70542C16.4716 4.93749 16.1749 5.06745 15.8659 5.06671L2.19646 5.03405C1.88741 5.03331 1.59133 4.90193 1.37335 4.66882C1.15538 4.43571 1.03336 4.11995 1.03415 3.79102C1.03493 3.46209 1.15846 3.14692 1.37754 2.91486C1.59663 2.68279 1.89334 2.55283 2.20239 2.55357L15.8718 2.58623C16.1808 2.58697 16.4769 2.71835 16.6949 2.95146C16.9129 3.18457 17.0349 3.50032 17.0341 3.82926Z'
          fill={color}
        />
        <path
          d='M15.0849 9.03876C15.0845 9.20163 15.054 9.36283 14.995 9.51316C14.9361 9.6635 14.85 9.80002 14.7415 9.91492C14.633 10.0298 14.5043 10.1209 14.3628 10.1829C14.2213 10.2449 14.0697 10.2766 13.9166 10.2762L4.11833 10.2528C3.96531 10.2524 3.81386 10.22 3.67263 10.1573C3.5314 10.0947 3.40316 10.003 3.29523 9.88757C3.1873 9.77215 3.10179 9.63522 3.04359 9.4846C2.98539 9.33399 2.95563 9.17264 2.95602 9.00977C2.95641 8.8469 2.98694 8.6857 3.04586 8.53536C3.10478 8.38503 3.19094 8.24851 3.29942 8.1336C3.4079 8.0187 3.53658 7.92765 3.6781 7.86566C3.81963 7.80367 3.97124 7.77195 4.12426 7.77232L13.9226 7.79573C14.2316 7.79647 14.5277 7.92784 14.7457 8.16096C14.9636 8.39407 15.0857 8.70982 15.0849 9.03876Z'
          fill={color}
        />
        <path
          d='M12.169 14.2417C12.1686 14.4045 12.1381 14.5657 12.0792 14.7161C12.0202 14.8664 11.9341 15.0029 11.8256 15.1178C11.7171 15.2327 11.5884 15.3238 11.4469 15.3858C11.3054 15.4478 11.1538 15.4795 11.0008 15.4791L7.00896 15.4696C6.69991 15.4689 6.40383 15.3375 6.18585 15.1044C5.96788 14.8713 5.84586 14.5555 5.84665 14.2266C5.84743 13.8976 5.97095 13.5825 6.19004 13.3504C6.40913 13.1183 6.70584 12.9884 7.01489 12.9891L11.007 12.9987C11.316 12.9995 11.612 13.1309 11.8299 13.364C12.0478 13.5971 12.1698 13.9128 12.169 14.2417Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M15.0324 3.23162C15.0316 3.53748 14.9235 3.83056 14.7318 4.04638C14.54 4.26219 14.2804 4.38308 14.01 4.38243L2.04926 4.35385C1.77884 4.3532 1.51979 4.23108 1.32909 4.01435C1.13839 3.79762 1.03167 3.50403 1.0324 3.19817C1.03313 2.89231 1.14126 2.59923 1.33299 2.38341C1.52472 2.16759 1.78435 2.04671 2.05477 2.04736L14.0155 2.07594C14.2859 2.07659 14.545 2.19871 14.7357 2.41544C14.9264 2.63217 15.0331 2.92576 15.0324 3.23162Z'
        fill={color}
      />
      <path
        d='M13.3248 8.07704C13.3245 8.22849 13.2977 8.37839 13.2462 8.51819C13.1946 8.65798 13.1192 8.78494 13.0242 8.8918C12.9293 8.99866 12.8167 9.08334 12.6929 9.141C12.569 9.19866 12.4364 9.22817 12.3025 9.22785L3.72895 9.20736C3.59505 9.20704 3.46254 9.1769 3.33897 9.11865C3.2154 9.0604 3.1032 8.97518 3.00878 8.86786C2.91435 8.76055 2.83955 8.63324 2.78865 8.4932C2.73774 8.35316 2.71173 8.20313 2.71209 8.05168C2.71245 7.90024 2.73918 7.75034 2.79076 7.61054C2.84233 7.47074 2.91774 7.34379 3.01268 7.23693C3.10761 7.13007 3.22022 7.04539 3.34406 6.98773C3.46791 6.93007 3.60056 6.90055 3.73446 6.90087L12.308 6.92136C12.5784 6.92201 12.8374 7.04413 13.0281 7.26086C13.2188 7.47759 13.3256 7.77118 13.3248 8.07704Z'
        fill={color}
      />
      <path
        d='M10.7734 12.9165C10.7731 13.0679 10.7463 13.2178 10.6948 13.3576C10.6432 13.4974 10.5678 13.6244 10.4729 13.7312C10.3779 13.8381 10.2653 13.9228 10.1415 13.9804C10.0176 14.0381 9.88496 14.0676 9.75107 14.0673L6.25825 14.0589C5.98783 14.0583 5.72877 13.9362 5.53807 13.7194C5.34738 13.5027 5.24065 13.2091 5.24138 12.9032C5.24212 12.5974 5.35024 12.3043 5.54197 12.0885C5.7337 11.8727 5.99334 11.7518 6.26376 11.7524L9.75682 11.7608C10.0272 11.7615 10.2862 11.8837 10.4768 12.1004C10.6675 12.3171 10.7742 12.6107 10.7734 12.9165Z'
        fill={color}
      />
    </svg>
  );
};

export const FlashIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.00866 7.46716H7.00058C7.16624 7.46716 7.32433 7.53775 7.43458 7.66083C7.54483 7.78391 7.59791 7.94841 7.58041 8.11291L7.31849 10.5337L9.99249 6.53383H7.00058C6.83491 6.53383 6.67683 6.46325 6.56658 6.34016C6.45574 6.21708 6.40266 6.05258 6.42074 5.88808L6.68266 3.46783L4.00866 7.46716ZM6.48199 13.4172C6.41549 13.4172 6.34841 13.4061 6.28249 13.3822C6.03049 13.29 5.87299 13.038 5.90216 12.7714L6.35074 8.63383H2.91724C2.70199 8.63383 2.50424 8.51541 2.40274 8.32583C2.30124 8.13566 2.31291 7.90525 2.43249 7.72616L7.03441 0.843414C7.18316 0.619414 7.46549 0.527248 7.71808 0.619414C7.97066 0.710998 8.12816 0.963581 8.09899 1.23016L7.65041 5.36716H11.0839C11.2992 5.36716 11.4969 5.48616 11.5984 5.67575C11.6999 5.86591 11.6882 6.09575 11.5687 6.27483L6.96674 13.1582C6.85649 13.3238 6.67216 13.4172 6.48199 13.4172Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.15315 9.5998H8.9999C9.2129 9.5998 9.41615 9.69055 9.5579 9.8488C9.69965 10.0071 9.7679 10.2186 9.7454 10.4301L9.40865 13.5426L12.8467 8.3998H8.9999C8.7869 8.3998 8.58365 8.30905 8.4419 8.1508C8.2994 7.99255 8.23115 7.78105 8.2544 7.56955L8.59115 4.4578L5.15315 9.5998ZM8.33315 17.2498C8.24765 17.2498 8.1614 17.2356 8.07665 17.2048C7.75265 17.0863 7.55015 16.7623 7.58765 16.4196L8.1644 11.0998H3.7499C3.47315 11.0998 3.2189 10.9476 3.0884 10.7038C2.9579 10.4593 2.9729 10.1631 3.12665 9.9328L9.0434 1.08355C9.23465 0.795553 9.59765 0.677053 9.9224 0.795553C10.2472 0.913303 10.4497 1.23805 10.4122 1.5808L9.8354 6.8998H14.2499C14.5267 6.8998 14.7809 7.0528 14.9114 7.29655C15.0419 7.54105 15.0269 7.83655 14.8732 8.0668L8.9564 16.9168C8.81465 17.1298 8.57765 17.2498 8.33315 17.2498Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.57993 8.53251H7.99926C8.1886 8.53251 8.36926 8.61317 8.49526 8.75384C8.62126 8.89451 8.68193 9.08251 8.66193 9.27051L8.3626 12.0372L11.4186 7.46584H7.99926C7.80993 7.46584 7.62926 7.38517 7.50326 7.24451C7.3766 7.10384 7.31593 6.91584 7.3366 6.72784L7.63593 3.96184L4.57993 8.53251ZM7.4066 15.3325C7.3306 15.3325 7.25393 15.3198 7.1786 15.2925C6.8906 15.1872 6.7106 14.8992 6.74393 14.5945L7.2566 9.86584H3.3326C3.0866 9.86584 2.8606 9.73051 2.7446 9.51384C2.6286 9.29651 2.64193 9.03317 2.7786 8.82851L8.03793 0.962507C8.20793 0.706507 8.5306 0.601174 8.81926 0.706507C9.10793 0.811174 9.28793 1.09984 9.2546 1.40451L8.74193 6.13251H12.6659C12.9119 6.13251 13.1379 6.26851 13.2539 6.48517C13.3699 6.70251 13.3566 6.96517 13.2199 7.16984L7.9606 15.0365C7.8346 15.2258 7.62393 15.3325 7.4066 15.3325Z'
        fill={color}
      />
    </svg>
  );
};

export const FunnelIcon = ({ color, large, small, style, className }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.34472 10.1833L7.52656 11.0775V8.42162C7.52656 8.32479 7.55106 8.22971 7.59656 8.14454L10.1049 3.50004H3.87489L6.27939 8.15387C6.32256 8.23671 6.34472 8.32887 6.34472 8.42162V10.1833ZM8.10989 12.8334C7.98564 12.8334 7.86139 12.7937 7.75814 12.715L5.40964 10.9387C5.26381 10.8285 5.17806 10.6564 5.17806 10.4738V8.56396L2.39847 3.18446C2.30456 3.00362 2.31214 2.78721 2.41831 2.61337C2.52389 2.43954 2.71289 2.33337 2.91647 2.33337H11.0831C11.2885 2.33337 11.4786 2.44129 11.5842 2.61804C11.6892 2.79421 11.6939 3.01296 11.5965 3.19379L8.69322 8.56921V12.25C8.69322 12.4711 8.56839 12.6735 8.37006 12.7721C8.28781 12.813 8.19856 12.8334 8.10989 12.8334Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.15792 13.0928L9.67742 14.2425V10.8278C9.67742 10.7033 9.70892 10.581 9.76742 10.4715L12.9924 4.5H4.98242L8.07392 10.4835C8.12942 10.59 8.15792 10.7085 8.15792 10.8278V13.0928ZM10.4274 16.5C10.2677 16.5 10.1079 16.449 9.97517 16.3478L6.95567 14.064C6.76817 13.9222 6.65792 13.701 6.65792 13.4662V11.0107L3.08417 4.09425C2.96342 3.86175 2.97317 3.5835 3.10967 3.36C3.24542 3.1365 3.48842 3 3.75017 3H14.2502C14.5142 3 14.7587 3.13875 14.8944 3.366C15.0294 3.5925 15.0354 3.87375 14.9102 4.10625L11.1774 11.0175V15.75C11.1774 16.0343 11.0169 16.2945 10.7619 16.4213C10.6562 16.4738 10.5414 16.5 10.4274 16.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.25181 11.638L8.60248 12.66V9.62463C8.60248 9.51396 8.63048 9.40529 8.68248 9.30796L11.5491 3.99996H4.42914L7.17715 9.31863C7.22648 9.41329 7.25181 9.51863 7.25181 9.62463V11.638ZM9.26915 14.6666C9.12714 14.6666 8.98514 14.6213 8.86714 14.5313L6.18314 12.5013C6.01648 12.3753 5.91848 12.1786 5.91848 11.97V9.78729L2.74181 3.63929C2.63448 3.43263 2.64314 3.18529 2.76448 2.98663C2.88514 2.78796 3.10114 2.66663 3.33381 2.66663H12.6671C12.9018 2.66663 13.1191 2.78996 13.2398 2.99196C13.3598 3.19329 13.3651 3.44329 13.2538 3.64996L9.93581 9.79329V14C9.93581 14.2526 9.79315 14.484 9.56648 14.5966C9.47248 14.6433 9.37048 14.6666 9.26915 14.6666Z'
        fill={color}
      />
    </svg>
  );
};

export const GlobeIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.52593 11.4047C9.13785 10.5308 9.77427 9.24577 9.90143 7.58268H11.6252C11.4018 9.36302 10.1733 10.8318 8.52593 11.4047ZM2.37293 7.58268H4.11827C4.23843 9.25218 4.86668 10.532 5.48677 11.4099C3.83185 10.84 2.59752 9.36827 2.37293 7.58268ZM5.5049 2.58333C4.89124 3.45717 4.24899 4.74633 4.12065 6.41642H2.37299C2.59815 4.62442 3.84124 3.148 5.5049 2.58333ZM5.29549 6.41571C5.47399 4.50705 6.45049 3.17821 7.01458 2.56396C7.59791 3.18871 8.55924 4.5053 8.72549 6.41571H5.29549ZM5.29602 7.58268H8.72718C8.54868 9.49427 7.56985 10.8231 7.00635 11.4373C6.3956 10.7898 5.45877 9.49135 5.29602 7.58268ZM11.6252 6.41602H9.90318C9.7836 4.7541 9.16235 3.47835 8.54518 2.6016C10.1832 3.1791 11.4029 4.64268 11.6252 6.41602ZM12.8327 6.99935C12.8327 3.78868 10.2246 1.17652 7.01568 1.16718C7.01335 1.16718 7.01102 1.1666 7.0081 1.1666C7.00577 1.1666 7.00227 1.16602 6.99935 1.16602C3.78285 1.16602 1.16602 3.78343 1.16602 6.99935C1.16602 10.2158 3.78285 12.8327 6.99935 12.8327C7.00285 12.8327 7.00577 12.8321 7.0081 12.8321C7.00927 12.8321 7.00985 12.8327 7.01102 12.8327C7.01277 12.8327 7.01452 12.8315 7.01568 12.8315C10.2246 12.8228 12.8327 10.21 12.8327 6.99935Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.9627 14.664C11.7495 13.5405 12.5677 11.8883 12.7312 9.75H14.9475C14.6603 12.039 13.0807 13.9275 10.9627 14.664ZM3.05175 9.75H5.29575C5.45025 11.8965 6.258 13.542 7.05525 14.6707C4.9275 13.938 3.3405 12.0457 3.05175 9.75ZM7.07857 3.32227C6.28957 4.44577 5.46382 6.10327 5.29882 8.25052H3.05182C3.34132 5.94652 4.93957 4.04827 7.07857 3.32227ZM6.80933 8.24961C7.03883 5.79561 8.29433 4.08711 9.01958 3.29736C9.76958 4.10061 11.0056 5.79336 11.2193 8.24961H6.80933ZM6.81 9.75H11.2215C10.992 12.2077 9.7335 13.9162 9.009 14.706C8.22375 13.8735 7.01925 12.204 6.81 9.75ZM14.9475 8.25H12.7335C12.5798 6.11325 11.781 4.473 10.9875 3.34575C13.0935 4.08825 14.6618 5.97 14.9475 8.25ZM16.5 9C16.5 4.872 13.1467 1.5135 9.021 1.5015C9.018 1.5015 9.015 1.50075 9.01125 1.50075C9.00825 1.50075 9.00375 1.5 9 1.5C4.8645 1.5 1.5 4.86525 1.5 9C1.5 13.1355 4.8645 16.5 9 16.5C9.0045 16.5 9.00825 16.4993 9.01125 16.4993C9.01275 16.4993 9.0135 16.5 9.015 16.5C9.01725 16.5 9.0195 16.4985 9.021 16.4985C13.1467 16.4872 16.5 13.128 16.5 9Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.74532 13.0353C10.4447 12.0367 11.172 10.568 11.3173 8.66732H13.2873C13.032 10.702 11.628 12.3807 9.74532 13.0353ZM2.71332 8.66732H4.70798C4.84532 10.5753 5.56332 12.038 6.27198 13.0413C4.38065 12.39 2.96998 10.708 2.71332 8.66732ZM6.29271 2.95378C5.59138 3.95244 4.85738 5.42578 4.71071 7.33444H2.71338C2.97071 5.28644 4.39138 3.59911 6.29271 2.95378ZM6.05339 7.33364C6.25739 5.15231 7.37339 3.63364 8.01805 2.93164C8.68472 3.64564 9.78339 5.15031 9.97339 7.33364H6.05339ZM6.05398 8.66732H9.97532C9.77132 10.852 8.65265 12.3707 8.00865 13.0726C7.31065 12.3327 6.23998 10.8487 6.05398 8.66732ZM13.2873 7.33398H11.3193C11.1827 5.43465 10.4727 3.97665 9.76732 2.97465C11.6393 3.63465 13.0333 5.30732 13.2873 7.33398ZM14.6673 8.00065C14.6673 4.33132 11.6867 1.34598 8.01932 1.33532C8.01665 1.33532 8.01398 1.33465 8.01065 1.33465C8.00798 1.33465 8.00398 1.33398 8.00065 1.33398C4.32465 1.33398 1.33398 4.32532 1.33398 8.00065C1.33398 11.6767 4.32465 14.6673 8.00065 14.6673C8.00465 14.6673 8.00798 14.6667 8.01065 14.6667C8.01198 14.6667 8.01265 14.6673 8.01398 14.6673C8.01599 14.6673 8.01798 14.666 8.01932 14.666C11.6867 14.656 14.6673 11.67 14.6673 8.00065Z'
        fill={color}
      />
    </svg>
  );
};

export const HamburgerIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.303 3.5H11.6964C12.0009 3.5 12.25 3.74908 12.25 4.05358V4.11308C12.25 4.41758 12.0009 4.66667 11.6964 4.66667H2.303C1.9985 4.66667 1.75 4.41758 1.75 4.11308V4.05358C1.75 3.74908 1.9985 3.5 2.303 3.5ZM11.6964 6.41667H2.303C1.9985 6.41667 1.75 6.66575 1.75 6.97025V7.02975C1.75 7.33425 1.9985 7.58333 2.303 7.58333H11.6964C12.0009 7.58333 12.25 7.33425 12.25 7.02975V6.97025C12.25 6.66575 12.0009 6.41667 11.6964 6.41667ZM11.6964 9.33333H2.303C1.9985 9.33333 1.75 9.58242 1.75 9.88692V9.94642C1.75 10.2509 1.9985 10.5 2.303 10.5H11.6964C12.0009 10.5 12.25 10.2509 12.25 9.94642V9.88692C12.25 9.58242 12.0009 9.33333 11.6964 9.33333Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.961 4.5H15.0382C15.4298 4.5 15.75 4.82025 15.75 5.21175V5.28825C15.75 5.67975 15.4298 6 15.0382 6H2.961C2.5695 6 2.25 5.67975 2.25 5.28825V5.21175C2.25 4.82025 2.5695 4.5 2.961 4.5ZM15.0382 8.25H2.961C2.5695 8.25 2.25 8.57025 2.25 8.96175V9.03825C2.25 9.42975 2.5695 9.75 2.961 9.75H15.0382C15.4298 9.75 15.75 9.42975 15.75 9.03825V8.96175C15.75 8.57025 15.4298 8.25 15.0382 8.25ZM15.0382 12H2.961C2.5695 12 2.25 12.3203 2.25 12.7118V12.7882C2.25 13.1798 2.5695 13.5 2.961 13.5H15.0382C15.4298 13.5 15.75 13.1798 15.75 12.7882V12.7118C15.75 12.3203 15.4298 12 15.0382 12Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.632 4H13.3673C13.7153 4 14 4.28467 14 4.63267V4.70067C14 5.04867 13.7153 5.33333 13.3673 5.33333H2.632C2.284 5.33333 2 5.04867 2 4.70067V4.63267C2 4.28467 2.284 4 2.632 4ZM13.3673 7.33333H2.632C2.284 7.33333 2 7.618 2 7.966V8.034C2 8.382 2.284 8.66667 2.632 8.66667H13.3673C13.7153 8.66667 14 8.382 14 8.034V7.966C14 7.618 13.7153 7.33333 13.3673 7.33333ZM13.3673 10.6667H2.632C2.284 10.6667 2 10.9513 2 11.2993V11.3673C2 11.7153 2.284 12 2.632 12H13.3673C13.7153 12 14 11.7153 14 11.3673V11.2993C14 10.9513 13.7153 10.6667 13.3673 10.6667Z'
        fill={color}
      />
    </svg>
  );
};

export const ImageIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.66667 5.83333C5.14967 5.83333 5.54167 5.44133 5.54167 4.95833C5.54167 4.47533 5.14967 4.08333 4.66667 4.08333C4.18367 4.08333 3.79167 4.47533 3.79167 4.95833C3.79167 5.44133 4.18367 5.83333 4.66667 5.83333ZM10.5 11.0833H3.82725L7.9135 7.67375C8.057 7.55183 8.31717 7.55242 8.45775 7.67317L11.0833 9.91317V10.5C11.0833 10.822 10.822 11.0833 10.5 11.0833ZM3.5 2.91667H10.5C10.822 2.91667 11.0833 3.178 11.0833 3.5V8.379L9.21492 6.78533C8.63742 6.29417 7.73383 6.29417 7.16158 6.78183L2.91667 10.3238V3.5C2.91667 3.178 3.178 2.91667 3.5 2.91667ZM10.5 1.75H3.5C2.53517 1.75 1.75 2.53517 1.75 3.5V10.5C1.75 11.4648 2.53517 12.25 3.5 12.25H10.5C11.4648 12.25 12.25 11.4648 12.25 10.5V3.5C12.25 2.53517 11.4648 1.75 10.5 1.75Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6 7.5C6.621 7.5 7.125 6.996 7.125 6.375C7.125 5.754 6.621 5.25 6 5.25C5.379 5.25 4.875 5.754 4.875 6.375C4.875 6.996 5.379 7.5 6 7.5ZM13.5 14.25H4.92075L10.1745 9.86625C10.359 9.7095 10.6935 9.71025 10.8743 9.8655L14.25 12.7455V13.5C14.25 13.914 13.914 14.25 13.5 14.25ZM4.5 3.75H13.5C13.914 3.75 14.25 4.086 14.25 4.5V10.773L11.8477 8.724C11.1053 8.0925 9.9435 8.0925 9.20775 8.7195L3.75 13.2735V4.5C3.75 4.086 4.086 3.75 4.5 3.75ZM13.5 2.25H4.5C3.2595 2.25 2.25 3.2595 2.25 4.5V13.5C2.25 14.7405 3.2595 15.75 4.5 15.75H13.5C14.7405 15.75 15.75 14.7405 15.75 13.5V4.5C15.75 3.2595 14.7405 2.25 13.5 2.25Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.33333 6.66667C5.88533 6.66667 6.33333 6.21867 6.33333 5.66667C6.33333 5.11467 5.88533 4.66667 5.33333 4.66667C4.78133 4.66667 4.33333 5.11467 4.33333 5.66667C4.33333 6.21867 4.78133 6.66667 5.33333 6.66667ZM12 12.6667H4.374L9.044 8.77C9.208 8.63067 9.50533 8.63133 9.666 8.76933L12.6667 11.3293V12C12.6667 12.368 12.368 12.6667 12 12.6667ZM4 3.33333H12C12.368 3.33333 12.6667 3.632 12.6667 4V9.576L10.5313 7.75467C9.87133 7.19333 8.83867 7.19333 8.18467 7.75067L3.33333 11.7987V4C3.33333 3.632 3.632 3.33333 4 3.33333ZM12 2H4C2.89733 2 2 2.89733 2 4V12C2 13.1027 2.89733 14 4 14H12C13.1027 14 14 13.1027 14 12V4C14 2.89733 13.1027 2 12 2Z'
        fill={color}
      />
    </svg>
  );
};

export const InfoIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.41406 4.66699C6.41406 4.34499 6.6754 4.08366 6.9974 4.08366C7.3194 4.08366 7.58073 4.34499 7.58073 4.66699C7.58073 4.98899 7.3194 5.25033 6.9974 5.25033C6.6754 5.25033 6.41406 4.98899 6.41406 4.66699ZM6.41406 6.41699C6.41406 6.09499 6.6754 5.83366 6.9974 5.83366C7.3194 5.83366 7.58073 6.09499 7.58073 6.41699V9.33366C7.58073 9.65566 7.3194 9.91699 6.9974 9.91699C6.6754 9.91699 6.41406 9.65566 6.41406 9.33366V6.41699ZM6.9974 11.667C4.42431 11.667 2.33073 9.57341 2.33073 7.00033C2.33073 4.42724 4.42431 2.33366 6.9974 2.33366C9.57048 2.33366 11.6641 4.42724 11.6641 7.00033C11.6641 9.57341 9.57048 11.667 6.9974 11.667ZM6.9974 1.16699C3.77565 1.16699 1.16406 3.77858 1.16406 7.00033C1.16406 10.2221 3.77565 12.8337 6.9974 12.8337C10.2186 12.8337 12.8307 10.2221 12.8307 7.00033C12.8307 3.77858 10.2186 1.16699 6.9974 1.16699Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.25 6C8.25 5.586 8.586 5.25 9 5.25C9.414 5.25 9.75 5.586 9.75 6C9.75 6.414 9.414 6.75 9 6.75C8.586 6.75 8.25 6.414 8.25 6ZM8.25 8.25C8.25 7.836 8.586 7.5 9 7.5C9.414 7.5 9.75 7.836 9.75 8.25V12C9.75 12.414 9.414 12.75 9 12.75C8.586 12.75 8.25 12.414 8.25 12V8.25ZM9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15ZM9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1423 4.85775 16.5 9 16.5C13.1415 16.5 16.5 13.1423 16.5 9C16.5 4.85775 13.1415 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.33594 5.33301C7.33594 4.96501 7.6346 4.66634 8.0026 4.66634C8.3706 4.66634 8.66927 4.96501 8.66927 5.33301C8.66927 5.70101 8.3706 5.99967 8.0026 5.99967C7.6346 5.99967 7.33594 5.70101 7.33594 5.33301ZM7.33594 7.33301C7.33594 6.96501 7.6346 6.66634 8.0026 6.66634C8.3706 6.66634 8.66927 6.96501 8.66927 7.33301V10.6663C8.66927 11.0343 8.3706 11.333 8.0026 11.333C7.6346 11.333 7.33594 11.0343 7.33594 10.6663V7.33301ZM8.0026 13.333C5.06194 13.333 2.66927 10.9403 2.66927 7.99967C2.66927 5.05901 5.06194 2.66634 8.0026 2.66634C10.9433 2.66634 13.3359 5.05901 13.3359 7.99967C13.3359 10.9403 10.9433 13.333 8.0026 13.333ZM8.0026 1.33301C4.3206 1.33301 1.33594 4.31767 1.33594 7.99967C1.33594 11.6817 4.3206 14.6663 8.0026 14.6663C11.6839 14.6663 14.6693 11.6817 14.6693 7.99967C14.6693 4.31767 11.6839 1.33301 8.0026 1.33301Z'
        fill={color}
      />
    </svg>
  );
};

export const InfoStaticIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.41602 4.66602C6.41602 4.34402 6.67735 4.08268 6.99935 4.08268C7.32135 4.08268 7.58268 4.34402 7.58268 4.66602C7.58268 4.98802 7.32135 5.24935 6.99935 5.24935C6.67735 5.24935 6.41602 4.98802 6.41602 4.66602ZM6.41602 6.41602C6.41602 6.09402 6.67735 5.83268 6.99935 5.83268C7.32135 5.83268 7.58268 6.09402 7.58268 6.41602V9.33268C7.58268 9.65468 7.32135 9.91602 6.99935 9.91602C6.67735 9.91602 6.41602 9.65468 6.41602 9.33268V6.41602ZM6.99935 11.666C4.42627 11.666 2.33268 9.57243 2.33268 6.99935C2.33268 4.42627 4.42627 2.33268 6.99935 2.33268C9.57243 2.33268 11.666 4.42627 11.666 6.99935C11.666 9.57243 9.57243 11.666 6.99935 11.666ZM6.99935 1.16602C3.7776 1.16602 1.16602 3.7776 1.16602 6.99935C1.16602 10.2211 3.7776 12.8327 6.99935 12.8327C10.2205 12.8327 12.8327 10.2211 12.8327 6.99935C12.8327 3.7776 10.2205 1.16602 6.99935 1.16602Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.33398 5.33398C7.33398 4.96598 7.63265 4.66732 8.00065 4.66732C8.36865 4.66732 8.66732 4.96598 8.66732 5.33398C8.66732 5.70198 8.36865 6.00065 8.00065 6.00065C7.63265 6.00065 7.33398 5.70198 7.33398 5.33398ZM7.33398 7.33398C7.33398 6.96598 7.63265 6.66732 8.00065 6.66732C8.36865 6.66732 8.66732 6.96598 8.66732 7.33398V10.6673C8.66732 11.0353 8.36865 11.334 8.00065 11.334C7.63265 11.334 7.33398 11.0353 7.33398 10.6673V7.33398ZM8.00065 13.334C5.05998 13.334 2.66732 10.9413 2.66732 8.00065C2.66732 5.05998 5.05998 2.66732 8.00065 2.66732C10.9413 2.66732 13.334 5.05998 13.334 8.00065C13.334 10.9413 10.9413 13.334 8.00065 13.334ZM8.00065 1.33398C4.31865 1.33398 1.33398 4.31865 1.33398 8.00065C1.33398 11.6827 4.31865 14.6673 8.00065 14.6673C11.682 14.6673 14.6673 11.6827 14.6673 8.00065C14.6673 4.31865 11.682 1.33398 8.00065 1.33398Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.33398 5.33398C7.33398 4.96598 7.63265 4.66732 8.00065 4.66732C8.36865 4.66732 8.66732 4.96598 8.66732 5.33398C8.66732 5.70198 8.36865 6.00065 8.00065 6.00065C7.63265 6.00065 7.33398 5.70198 7.33398 5.33398ZM7.33398 7.33398C7.33398 6.96598 7.63265 6.66732 8.00065 6.66732C8.36865 6.66732 8.66732 6.96598 8.66732 7.33398V10.6673C8.66732 11.0353 8.36865 11.334 8.00065 11.334C7.63265 11.334 7.33398 11.0353 7.33398 10.6673V7.33398ZM8.00065 13.334C5.05998 13.334 2.66732 10.9413 2.66732 8.00065C2.66732 5.05998 5.05998 2.66732 8.00065 2.66732C10.9413 2.66732 13.334 5.05998 13.334 8.00065C13.334 10.9413 10.9413 13.334 8.00065 13.334ZM8.00065 1.33398C4.31865 1.33398 1.33398 4.31865 1.33398 8.00065C1.33398 11.6827 4.31865 14.6673 8.00065 14.6673C11.682 14.6673 14.6673 11.6827 14.6673 8.00065C14.6673 4.31865 11.682 1.33398 8.00065 1.33398Z'
        fill={color}
      />
    </svg>
  );
};

export const InventoryRulesIcon = ({
  color,
  large,
  small,
  style,
  className,
}: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M6.01961 13H2.2549C1.9098 13 1.61427 12.8826 1.36831 12.6478C1.12277 12.4126 1 12.13 1 11.8V3.4C1 3.07 1.12277 2.7874 1.36831 2.5522C1.61427 2.3174 1.9098 2.2 2.2549 2.2H4.87451C4.98954 1.85 5.21438 1.5624 5.54902 1.3372C5.88366 1.1124 6.24967 1 6.64706 1C7.06536 1 7.43932 1.1124 7.76894 1.3372C8.09814 1.5624 8.32026 1.85 8.43529 2.2H11.0392C11.3843 2.2 11.6798 2.3174 11.9258 2.5522C12.1713 2.7874 12.2941 3.07 12.2941 3.4V6.4H11.0392V3.4H9.78431V4C9.78431 4.33 9.66154 4.6124 9.416 4.8472C9.17004 5.0824 8.87451 5.2 8.52941 5.2H4.76471C4.41961 5.2 4.12429 5.0824 3.87875 4.8472C3.63278 4.6124 3.5098 4.33 3.5098 4V3.4H2.2549V11.8H6.01961V13ZM8.84314 10.675L11.949 7.705C12.0641 7.595 12.2105 7.54 12.3882 7.54C12.566 7.54 12.7124 7.595 12.8275 7.705C12.9425 7.815 13 7.955 13 8.125C13 8.295 12.9425 8.435 12.8275 8.545L9.28235 11.935C9.15686 12.055 9.01046 12.115 8.84314 12.115C8.67582 12.115 8.52941 12.055 8.40392 11.935L6.61569 10.225C6.50065 10.115 6.44314 9.975 6.44314 9.805C6.44314 9.635 6.50065 9.495 6.61569 9.385C6.73072 9.275 6.87712 9.22 7.0549 9.22C7.23268 9.22 7.37909 9.275 7.49412 9.385L8.84314 10.675ZM6.64706 3.4C6.82484 3.4 6.97396 3.3424 7.09443 3.2272C7.21448 3.1124 7.27451 2.97 7.27451 2.8C7.27451 2.63 7.21448 2.4874 7.09443 2.3722C6.97396 2.2574 6.82484 2.2 6.64706 2.2C6.46928 2.2 6.32037 2.2574 6.20031 2.3722C6.07984 2.4874 6.01961 2.63 6.01961 2.8C6.01961 2.97 6.07984 3.1124 6.20031 3.2272C6.32037 3.3424 6.46928 3.4 6.64706 3.4Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M7.69281 17H2.6732C2.21307 17 1.81903 16.8435 1.49108 16.5304C1.16369 16.2168 1 15.84 1 15.4V4.2C1 3.76 1.16369 3.3832 1.49108 3.0696C1.81903 2.75653 2.21307 2.6 2.6732 2.6H6.16601C6.31939 2.13333 6.61917 1.74987 7.06536 1.4496C7.51155 1.14987 7.99956 1 8.52941 1C9.08715 1 9.58576 1.14987 10.0253 1.4496C10.4642 1.74987 10.7603 2.13333 10.9137 2.6H14.3856C14.8458 2.6 15.2398 2.75653 15.5677 3.0696C15.8951 3.3832 16.0588 3.76 16.0588 4.2V8.2H14.3856V4.2H12.7124V5C12.7124 5.44 12.5487 5.81653 12.2213 6.1296C11.8934 6.4432 11.4993 6.6 11.0392 6.6H6.01961C5.55948 6.6 5.16572 6.4432 4.83833 6.1296C4.51038 5.81653 4.34641 5.44 4.34641 5V4.2H2.6732V15.4H7.69281V17ZM11.4575 13.9L15.5987 9.94C15.7521 9.79333 15.9473 9.72 16.1843 9.72C16.4214 9.72 16.6166 9.79333 16.7699 9.94C16.9233 10.0867 17 10.2733 17 10.5C17 10.7267 16.9233 10.9133 16.7699 11.06L12.0431 15.58C11.8758 15.74 11.6806 15.82 11.4575 15.82C11.2344 15.82 11.0392 15.74 10.8719 15.58L8.48758 13.3C8.3342 13.1533 8.25752 12.9667 8.25752 12.74C8.25752 12.5133 8.3342 12.3267 8.48758 12.18C8.64096 12.0333 8.83617 11.96 9.0732 11.96C9.31024 11.96 9.50545 12.0333 9.65882 12.18L11.4575 13.9ZM8.52941 4.2C8.76645 4.2 8.96528 4.1232 9.12591 3.9696C9.28598 3.81653 9.36601 3.62667 9.36601 3.4C9.36601 3.17333 9.28598 2.9832 9.12591 2.8296C8.96528 2.67653 8.76645 2.6 8.52941 2.6C8.29237 2.6 8.09382 2.67653 7.93375 2.8296C7.77312 2.9832 7.69281 3.17333 7.69281 3.4C7.69281 3.62667 7.77312 3.81653 7.93375 3.9696C8.09382 4.1232 8.29237 4.2 8.52941 4.2Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M6.85621 15H2.46405C2.06144 15 1.71665 14.863 1.4297 14.5891C1.14323 14.3147 1 13.985 1 13.6V3.8C1 3.415 1.14323 3.0853 1.4297 2.8109C1.71665 2.53697 2.06144 2.4 2.46405 2.4H5.52026C5.65447 1.99167 5.91678 1.65613 6.30719 1.3934C6.6976 1.13113 7.12462 1 7.58824 1C8.07625 1 8.51254 1.13113 8.8971 1.3934C9.28117 1.65613 9.54031 1.99167 9.67451 2.4H12.7124C13.115 2.4 13.4598 2.53697 13.7468 2.8109C14.0332 3.0853 14.1765 3.415 14.1765 3.8V7.3H12.7124V3.8H11.2484V4.5C11.2484 4.885 11.1051 5.21447 10.8187 5.4884C10.5317 5.7628 10.1869 5.9 9.78431 5.9H5.39216C4.98954 5.9 4.645 5.7628 4.35854 5.4884C4.07158 5.21447 3.9281 4.885 3.9281 4.5V3.8H2.46405V13.6H6.85621V15ZM10.1503 12.2875L13.7739 8.8225C13.9081 8.69417 14.0789 8.63 14.2863 8.63C14.4937 8.63 14.6645 8.69417 14.7987 8.8225C14.9329 8.95083 15 9.11417 15 9.3125C15 9.51083 14.9329 9.67417 14.7987 9.8025L10.6627 13.7575C10.5163 13.8975 10.3455 13.9675 10.1503 13.9675C9.95512 13.9675 9.78431 13.8975 9.63791 13.7575L7.55163 11.7625C7.41743 11.6342 7.35033 11.4708 7.35033 11.2725C7.35033 11.0742 7.41743 10.9108 7.55163 10.7825C7.68584 10.6542 7.85664 10.59 8.06405 10.59C8.27146 10.59 8.44227 10.6542 8.57647 10.7825L10.1503 12.2875ZM7.58824 3.8C7.79564 3.8 7.96962 3.7328 8.11017 3.5984C8.25023 3.46447 8.32026 3.29833 8.32026 3.1C8.32026 2.90167 8.25023 2.7353 8.11017 2.6009C7.96962 2.46697 7.79564 2.4 7.58824 2.4C7.38083 2.4 7.20709 2.46697 7.06703 2.6009C6.92648 2.7353 6.85621 2.90167 6.85621 3.1C6.85621 3.29833 6.92648 3.46447 7.06703 3.5984C7.20709 3.7328 7.38083 3.8 7.58824 3.8Z'
        fill={color}
      />
    </svg>
  );
};

export const LayersIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.481 9.7542L7.00087 12.3264L2.52075 9.7542L3.83834 9.19341L6.61352 10.7863C6.7333 10.8556 6.86709 10.8898 7.00087 10.8898C7.13465 10.8898 7.26765 10.8556 7.38821 10.7863L10.1634 9.19263L11.481 9.7542ZM6.61352 7.67427C6.7333 7.7435 6.86709 7.77772 7.00087 7.77772C7.13465 7.77772 7.26765 7.7435 7.38821 7.67427L10.1634 6.08057L11.481 6.64214L7.00087 9.21431L2.52075 6.64214L3.83834 6.08057L6.61352 7.67427ZM7.00087 1.62354L11.481 3.53147L7.00087 6.10365L2.52075 3.53147L7.00087 1.62354ZM13.9987 6.49325C13.9808 6.19846 13.798 5.93946 13.5266 5.82357L11.8527 5.1111L13.6098 4.1023C13.8657 3.95607 14.0158 3.67684 13.9987 3.38206C13.9808 3.08805 13.798 2.82827 13.5266 2.71237L7.30417 0.0624183C7.10972 -0.0208061 6.88961 -0.0208061 6.69516 0.0624183L0.472777 2.71237C0.201326 2.82827 0.0185433 3.08805 0.00143172 3.38206C-0.0164576 3.67684 0.134435 3.95607 0.390331 4.1023L2.1466 5.1111L0.472777 5.82357C0.201326 5.93946 0.0185433 6.19846 0.00143172 6.49325C-0.0164576 6.78803 0.134435 7.06726 0.390331 7.21349L2.1466 8.22229L0.472777 8.93476C0.201326 9.05065 0.0185433 9.30965 0.00143172 9.60444C-0.0164576 9.89923 0.134435 10.1785 0.390331 10.3247L6.61271 13.8971C6.73249 13.9663 6.86627 14.0006 7.00005 14.0006C7.13384 14.0006 7.26684 13.9663 7.3874 13.8971L13.6098 10.3247C13.8657 10.1785 14.0158 9.89923 13.9987 9.60444C13.9808 9.31043 13.798 9.05065 13.5273 8.93476L11.8535 8.22151L13.6098 7.21349C13.8657 7.06726 14.0158 6.78803 13.9987 6.49325Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.1211 12.1477L9.00099 15.0873L3.88086 12.1477L5.38668 11.5067L8.55831 13.3272C8.6952 13.4064 8.8481 13.4455 9.00099 13.4455C9.15388 13.4455 9.30589 13.4064 9.44367 13.3272L12.6153 11.5059L14.1211 12.1477ZM8.55831 9.7706C8.6952 9.84971 8.8481 9.88882 9.00099 9.88882C9.15388 9.88882 9.30589 9.84971 9.44367 9.7706L12.6153 7.94922L14.1211 8.59101L9.00099 11.5306L3.88086 8.59101L5.38668 7.94922L8.55831 9.7706ZM9.00099 2.85547L14.1211 5.03597L9.00099 7.9756L3.88086 5.03597L9.00099 2.85547ZM16.9985 8.42086C16.978 8.08396 16.7691 7.78795 16.4589 7.6555L14.546 6.84126L16.554 5.68834C16.8465 5.52123 17.018 5.20211 16.9985 4.86521C16.978 4.5292 16.7691 4.2323 16.4589 4.09986L9.34763 1.07134C9.1254 0.976222 8.87384 0.976222 8.65161 1.07134L1.54032 4.09986C1.23009 4.2323 1.02119 4.5292 1.00164 4.86521C0.981191 5.20211 1.15364 5.52123 1.44609 5.68834L3.45325 6.84126L1.54032 7.6555C1.23009 7.78795 1.02119 8.08396 1.00164 8.42086C0.981191 8.75775 1.15364 9.07687 1.44609 9.24399L3.45325 10.3969L1.54032 11.2112C1.23009 11.3436 1.02119 11.6396 1.00164 11.9765C0.981191 12.3134 1.15364 12.6325 1.44609 12.7996L8.55738 16.8824C8.69428 16.9615 8.84717 17.0006 9.00006 17.0006C9.15296 17.0006 9.30496 16.9615 9.44274 16.8824L16.554 12.7996C16.8465 12.6325 17.018 12.3134 16.9985 11.9765C16.978 11.6405 16.7691 11.3436 16.4598 11.2112L14.5469 10.396L16.554 9.24399C16.8465 9.07687 17.018 8.75775 16.9985 8.42086Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.8011 10.9509L8.00093 13.7068L3.20081 10.9509L4.61251 10.3501L7.58592 12.0568C7.71425 12.131 7.85759 12.1676 8.00093 12.1676C8.14427 12.1676 8.28677 12.131 8.41594 12.0568L11.3893 10.3492L12.8011 10.9509ZM7.58592 8.72244C7.71425 8.79661 7.85759 8.83327 8.00093 8.83327C8.14427 8.83327 8.28677 8.79661 8.41594 8.72244L11.3893 7.01489L12.8011 7.61657L8.00093 10.3725L3.20081 7.61657L4.61251 7.01489L7.58592 8.72244ZM8.00093 2.2395L12.8011 4.28372L8.00093 7.03962L3.20081 4.28372L8.00093 2.2395ZM15.4986 7.45705C15.4794 7.14121 15.2836 6.8637 14.9927 6.73953L13.1994 5.97618L15.0819 4.89532C15.3561 4.73865 15.5169 4.43948 15.4986 4.12363C15.4794 3.80863 15.2836 3.53029 14.9927 3.40612L8.3259 0.566877C8.11756 0.477708 7.88172 0.477708 7.67338 0.566877L1.00655 3.40612C0.715706 3.53029 0.519868 3.80863 0.501534 4.12363C0.482367 4.43948 0.644038 4.73865 0.918211 4.89532L2.79993 5.97618L1.00655 6.73953C0.715706 6.8637 0.519868 7.14121 0.501534 7.45705C0.482367 7.77289 0.644038 8.07207 0.918211 8.22874L2.79993 9.3096L1.00655 10.073C0.715706 10.1971 0.519868 10.4746 0.501534 10.7905C0.482367 11.1063 0.644038 11.4055 0.918211 11.5622L7.58505 15.3898C7.71338 15.4639 7.85672 15.5006 8.00006 15.5006C8.1434 15.5006 8.2859 15.4639 8.41507 15.3898L15.0819 11.5622C15.3561 11.4055 15.5169 11.1063 15.4986 10.7905C15.4794 10.4755 15.2836 10.1971 14.9936 10.073L13.2002 9.30877L15.0819 8.22874C15.3561 8.07207 15.5169 7.77289 15.4986 7.45705Z'
        fill={color}
      />
    </svg>
  );
};

export const LinkIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.25045 9.33333H4.20629C2.97779 9.33333 1.86945 8.43792 1.76037 7.2135C1.63612 5.831 2.72637 4.66667 4.08379 4.66667H5.25045C5.57245 4.66667 5.83379 4.40592 5.83379 4.08333C5.83379 3.76075 5.57245 3.5 5.25045 3.5H4.2057C2.42712 3.5 0.839871 4.77575 0.613538 6.53975C0.339954 8.67358 2.00245 10.5 4.08379 10.5H5.25045C5.57245 10.5 5.83379 10.2392 5.83379 9.91667C5.83379 9.59408 5.57245 9.33333 5.25045 9.33333ZM4.66712 7C4.66712 7.32258 4.92845 7.58333 5.25045 7.58333H8.75045C9.07246 7.58333 9.33379 7.32258 9.33379 7C9.33379 6.67742 9.07246 6.41667 8.75045 6.41667H5.25045C4.92845 6.41667 4.66712 6.67742 4.66712 7ZM9.7766 3.50012C11.5657 3.50012 13.171 4.7817 13.3898 6.55795C13.6517 8.68478 11.9927 10.5001 9.91718 10.5001H8.75051C8.42851 10.5001 8.16718 10.2394 8.16718 9.91678C8.16718 9.5942 8.42851 9.33345 8.75051 9.33345H9.91718C11.2746 9.33345 12.3648 8.16912 12.2406 6.78662C12.1315 5.5622 11.0232 4.66678 9.7941 4.66678H8.75051C8.42851 4.66678 8.16718 4.40603 8.16718 4.08345C8.16718 3.76087 8.4256 3.50012 8.89576 3.50012H9.7766Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.99912 10.6667H4.80579C3.40179 10.6667 2.13512 9.64333 2.01046 8.244C1.86846 6.664 3.11446 5.33333 4.66579 5.33333H5.99912C6.36712 5.33333 6.66579 5.03533 6.66579 4.66667C6.66579 4.298 6.36712 4 5.99912 4H4.80512C2.77246 4 0.958457 5.458 0.699791 7.474C0.387124 9.91267 2.28712 12 4.66579 12H5.99912C6.36712 12 6.66579 11.702 6.66579 11.3333C6.66579 10.9647 6.36712 10.6667 5.99912 10.6667ZM5.33246 8C5.33246 8.36867 5.63112 8.66667 5.99912 8.66667H9.99912C10.3671 8.66667 10.6658 8.36867 10.6658 8C10.6658 7.63133 10.3671 7.33333 9.99912 7.33333H5.99912C5.63112 7.33333 5.33246 7.63133 5.33246 8ZM11.1719 4.00013C13.2165 4.00013 15.0512 5.4648 15.3012 7.4948C15.6005 9.92547 13.7045 12.0001 11.3325 12.0001H9.99919C9.63119 12.0001 9.33252 11.7021 9.33252 11.3335C9.33252 10.9648 9.63119 10.6668 9.99919 10.6668H11.3325C12.8839 10.6668 14.1299 9.33613 13.9879 7.75613C13.8632 6.3568 12.5965 5.33347 11.1919 5.33347H9.99919C9.63119 5.33347 9.33252 5.03547 9.33252 4.6668C9.33252 4.29813 9.62786 4.00013 10.1652 4.00013H11.1719Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.99912 10.6667H4.80579C3.40179 10.6667 2.13512 9.64333 2.01046 8.244C1.86846 6.664 3.11446 5.33333 4.66579 5.33333H5.99912C6.36712 5.33333 6.66579 5.03533 6.66579 4.66667C6.66579 4.298 6.36712 4 5.99912 4H4.80512C2.77246 4 0.958457 5.458 0.699791 7.474C0.387124 9.91267 2.28712 12 4.66579 12H5.99912C6.36712 12 6.66579 11.702 6.66579 11.3333C6.66579 10.9647 6.36712 10.6667 5.99912 10.6667ZM5.33246 8C5.33246 8.36867 5.63112 8.66667 5.99912 8.66667H9.99912C10.3671 8.66667 10.6658 8.36867 10.6658 8C10.6658 7.63133 10.3671 7.33333 9.99912 7.33333H5.99912C5.63112 7.33333 5.33246 7.63133 5.33246 8ZM11.1719 4.00013C13.2165 4.00013 15.0512 5.4648 15.3012 7.4948C15.6005 9.92547 13.7045 12.0001 11.3325 12.0001H9.99919C9.63119 12.0001 9.33252 11.7021 9.33252 11.3335C9.33252 10.9648 9.63119 10.6668 9.99919 10.6668H11.3325C12.8839 10.6668 14.1299 9.33613 13.9879 7.75613C13.8632 6.3568 12.5965 5.33347 11.1919 5.33347H9.99919C9.63119 5.33347 9.33252 5.03547 9.33252 4.6668C9.33252 4.29813 9.62786 4.00013 10.1652 4.00013H11.1719Z'
        fill={color}
      />
    </svg>
  );
};

export const LoaderIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.41602 1.74935C6.41602 1.42677 6.67735 1.16602 6.99935 1.16602C7.32135 1.16602 7.58268 1.42677 7.58268 1.74935V2.91602C7.58268 3.2386 7.32135 3.49935 6.99935 3.49935C6.67735 3.49935 6.41602 3.2386 6.41602 2.91602V1.74935ZM11.0827 6.41602H12.2493C12.5713 6.41602 12.8327 6.67677 12.8327 6.99935C12.8327 7.32193 12.5713 7.58268 12.2493 7.58268H11.0827C10.7607 7.58268 10.4993 7.32193 10.4993 6.99935C10.4993 6.67677 10.7607 6.41602 11.0827 6.41602ZM3.49935 6.99935C3.49935 6.67677 3.23802 6.41602 2.91602 6.41602H1.74935C1.42735 6.41602 1.16602 6.67677 1.16602 6.99935C1.16602 7.32193 1.42735 7.58268 1.74935 7.58268H2.91602C3.23802 7.58268 3.49935 7.32193 3.49935 6.99935ZM2.80326 2.94711C3.02784 2.71611 3.39651 2.70852 3.62809 2.93252L4.46751 3.74336C4.69909 3.96677 4.70551 4.33661 4.48151 4.56819C4.36717 4.68661 4.21492 4.74611 4.06209 4.74611C3.91626 4.74611 3.77042 4.69244 3.65667 4.58277L2.81726 3.77194C2.58567 3.54852 2.57926 3.17869 2.80326 2.94711ZM9.93655 4.74634C10.0824 4.74634 10.2282 4.69209 10.342 4.58301L11.1814 3.77217C11.413 3.54817 11.4194 3.17834 11.1954 2.94734C10.972 2.71634 10.6033 2.70876 10.3705 2.93276L9.53113 3.74301C9.29955 3.96701 9.29313 4.33684 9.51713 4.56784C9.63147 4.68626 9.78372 4.74634 9.93655 4.74634ZM6.41602 11.0827C6.41602 10.7601 6.67735 10.4993 6.99935 10.4993C7.32135 10.4993 7.58268 10.7601 7.58268 11.0827V12.2493C7.58268 12.5719 7.32135 12.8327 6.99935 12.8327C6.67735 12.8327 6.41602 12.5719 6.41602 12.2493V11.0827ZM10.3418 9.41586C10.1103 9.19245 9.74102 9.19945 9.51702 9.43045C9.29302 9.66203 9.29943 10.0319 9.53102 10.2553L10.3704 11.0661C10.4842 11.1758 10.63 11.2294 10.7758 11.2294C10.9287 11.2294 11.0809 11.1699 11.1953 11.0515C11.4193 10.8199 11.4128 10.4501 11.1813 10.2267L10.3418 9.41586ZM2.81743 10.2267L3.65685 9.41586C3.88902 9.19245 4.25827 9.19945 4.48168 9.43045C4.70568 9.66203 4.69927 10.0319 4.46768 10.2553L3.62827 11.0661C3.51452 11.1758 3.36868 11.2294 3.22285 11.2294C3.07002 11.2294 2.91777 11.1699 2.80343 11.0515C2.57943 10.8199 2.58585 10.4501 2.81743 10.2267Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.33398 2.00065C7.33398 1.63198 7.63265 1.33398 8.00065 1.33398C8.36865 1.33398 8.66732 1.63198 8.66732 2.00065V3.33398C8.66732 3.70265 8.36865 4.00065 8.00065 4.00065C7.63265 4.00065 7.33398 3.70265 7.33398 3.33398V2.00065ZM12.6673 7.33398H14.0007C14.3687 7.33398 14.6673 7.63198 14.6673 8.00065C14.6673 8.36932 14.3687 8.66732 14.0007 8.66732H12.6673C12.2993 8.66732 12.0007 8.36932 12.0007 8.00065C12.0007 7.63198 12.2993 7.33398 12.6673 7.33398ZM4.00065 8.00065C4.00065 7.63198 3.70198 7.33398 3.33398 7.33398H2.00065C1.63265 7.33398 1.33398 7.63198 1.33398 8.00065C1.33398 8.36932 1.63265 8.66732 2.00065 8.66732H3.33398C3.70198 8.66732 4.00065 8.36932 4.00065 8.00065ZM3.20512 3.36952C3.46178 3.10552 3.88312 3.09685 4.14778 3.35285L5.10712 4.27952C5.37178 4.53485 5.37912 4.95752 5.12312 5.22218C4.99245 5.35752 4.81845 5.42552 4.64378 5.42552C4.47712 5.42552 4.31045 5.36418 4.18045 5.23885L3.22112 4.31218C2.95645 4.05685 2.94912 3.63418 3.20512 3.36952ZM11.3575 5.42578C11.5241 5.42578 11.6908 5.36378 11.8208 5.23912L12.7801 4.31245C13.0448 4.05645 13.0521 3.63378 12.7961 3.36978C12.5408 3.10578 12.1195 3.09712 11.8535 3.35312L10.8941 4.27912C10.6295 4.53512 10.6221 4.95778 10.8781 5.22178C11.0088 5.35712 11.1828 5.42578 11.3575 5.42578ZM7.33398 12.6673C7.33398 12.2987 7.63265 12.0007 8.00065 12.0007C8.36865 12.0007 8.66732 12.2987 8.66732 12.6673V14.0007C8.66732 14.3693 8.36865 14.6673 8.00065 14.6673C7.63265 14.6673 7.33398 14.3693 7.33398 14.0007V12.6673ZM11.8207 10.7624C11.556 10.5071 11.134 10.5151 10.878 10.7791C10.622 11.0437 10.6293 11.4664 10.894 11.7217L11.8533 12.6484C11.9833 12.7737 12.15 12.8351 12.3167 12.8351C12.4913 12.8351 12.6653 12.7671 12.796 12.6317C13.052 12.3671 13.0447 11.9444 12.78 11.6891L11.8207 10.7624ZM3.22132 11.6891L4.18065 10.7624C4.44598 10.5071 4.86798 10.5151 5.12332 10.7791C5.37932 11.0437 5.37198 11.4664 5.10732 11.7217L4.14798 12.6484C4.01798 12.7737 3.85132 12.8351 3.68465 12.8351C3.50998 12.8351 3.33598 12.7671 3.20532 12.6317C2.94932 12.3671 2.95665 11.9444 3.22132 11.6891Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.33398 2.00065C7.33398 1.63198 7.63265 1.33398 8.00065 1.33398C8.36865 1.33398 8.66732 1.63198 8.66732 2.00065V3.33398C8.66732 3.70265 8.36865 4.00065 8.00065 4.00065C7.63265 4.00065 7.33398 3.70265 7.33398 3.33398V2.00065ZM12.6673 7.33398H14.0007C14.3687 7.33398 14.6673 7.63198 14.6673 8.00065C14.6673 8.36932 14.3687 8.66732 14.0007 8.66732H12.6673C12.2993 8.66732 12.0007 8.36932 12.0007 8.00065C12.0007 7.63198 12.2993 7.33398 12.6673 7.33398ZM4.00065 8.00065C4.00065 7.63198 3.70198 7.33398 3.33398 7.33398H2.00065C1.63265 7.33398 1.33398 7.63198 1.33398 8.00065C1.33398 8.36932 1.63265 8.66732 2.00065 8.66732H3.33398C3.70198 8.66732 4.00065 8.36932 4.00065 8.00065ZM3.20512 3.36952C3.46178 3.10552 3.88312 3.09685 4.14778 3.35285L5.10712 4.27952C5.37178 4.53485 5.37912 4.95752 5.12312 5.22218C4.99245 5.35752 4.81845 5.42552 4.64378 5.42552C4.47712 5.42552 4.31045 5.36418 4.18045 5.23885L3.22112 4.31218C2.95645 4.05685 2.94912 3.63418 3.20512 3.36952ZM11.3575 5.42578C11.5241 5.42578 11.6908 5.36378 11.8208 5.23912L12.7801 4.31245C13.0448 4.05645 13.0521 3.63378 12.7961 3.36978C12.5408 3.10578 12.1195 3.09712 11.8535 3.35312L10.8941 4.27912C10.6295 4.53512 10.6221 4.95778 10.8781 5.22178C11.0088 5.35712 11.1828 5.42578 11.3575 5.42578ZM7.33398 12.6673C7.33398 12.2987 7.63265 12.0007 8.00065 12.0007C8.36865 12.0007 8.66732 12.2987 8.66732 12.6673V14.0007C8.66732 14.3693 8.36865 14.6673 8.00065 14.6673C7.63265 14.6673 7.33398 14.3693 7.33398 14.0007V12.6673ZM11.8207 10.7624C11.556 10.5071 11.134 10.5151 10.878 10.7791C10.622 11.0437 10.6293 11.4664 10.894 11.7217L11.8533 12.6484C11.9833 12.7737 12.15 12.8351 12.3167 12.8351C12.4913 12.8351 12.6653 12.7671 12.796 12.6317C13.052 12.3671 13.0447 11.9444 12.78 11.6891L11.8207 10.7624ZM3.22132 11.6891L4.18065 10.7624C4.44598 10.5071 4.86798 10.5151 5.12332 10.7791C5.37932 11.0437 5.37198 11.4664 5.10732 11.7217L4.14798 12.6484C4.01798 12.7737 3.85132 12.8351 3.68465 12.8351C3.50998 12.8351 3.33598 12.7671 3.20532 12.6317C2.94932 12.3671 2.95665 11.9444 3.22132 11.6891Z'
        fill={color}
      />
    </svg>
  );
};

export const LogInIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.91678 2.33301H11.0835C11.4043 2.33301 11.6668 2.59551 11.6668 2.91634V11.083C11.6668 11.4038 11.4043 11.6663 11.0835 11.6663H9.91678C9.59595 11.6663 9.33345 11.4038 9.33345 11.083C9.33345 10.7622 9.59595 10.4997 9.91678 10.4997H10.5001V3.49967H9.91678C9.59595 3.49967 9.33345 3.23717 9.33345 2.91634C9.33345 2.59551 9.59595 2.33301 9.91678 2.33301ZM6.06667 4.19991C6.32567 4.00682 6.69025 4.05932 6.88333 4.31657L8.63333 6.64991C8.785 6.85174 8.78967 7.12824 8.64383 7.33532L7.00233 9.66866C6.88858 9.83024 6.70833 9.91657 6.52458 9.91657C6.40908 9.91657 6.29183 9.88216 6.18975 9.81041C5.92608 9.62491 5.8625 9.26091 6.048 8.99724L7.05017 7.57274C7.04231 7.57353 7.03492 7.57572 7.02759 7.57791C7.01858 7.58058 7.00964 7.58324 7 7.58324H2.33333C2.01133 7.58324 1.75 7.32191 1.75 6.99991C1.75 6.67732 2.01133 6.41657 2.33333 6.41657H7H7.00058L5.95 5.01599C5.75692 4.75874 5.80883 4.39299 6.06667 4.19991Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.33398 2.00065C7.33398 1.63198 7.63265 1.33398 8.00065 1.33398C8.36865 1.33398 8.66732 1.63198 8.66732 2.00065V3.33398C8.66732 3.70265 8.36865 4.00065 8.00065 4.00065C7.63265 4.00065 7.33398 3.70265 7.33398 3.33398V2.00065ZM12.6673 7.33398H14.0007C14.3687 7.33398 14.6673 7.63198 14.6673 8.00065C14.6673 8.36932 14.3687 8.66732 14.0007 8.66732H12.6673C12.2993 8.66732 12.0007 8.36932 12.0007 8.00065C12.0007 7.63198 12.2993 7.33398 12.6673 7.33398ZM4.00065 8.00065C4.00065 7.63198 3.70198 7.33398 3.33398 7.33398H2.00065C1.63265 7.33398 1.33398 7.63198 1.33398 8.00065C1.33398 8.36932 1.63265 8.66732 2.00065 8.66732H3.33398C3.70198 8.66732 4.00065 8.36932 4.00065 8.00065ZM3.20512 3.36952C3.46178 3.10552 3.88312 3.09685 4.14778 3.35285L5.10712 4.27952C5.37178 4.53485 5.37912 4.95752 5.12312 5.22218C4.99245 5.35752 4.81845 5.42552 4.64378 5.42552C4.47712 5.42552 4.31045 5.36418 4.18045 5.23885L3.22112 4.31218C2.95645 4.05685 2.94912 3.63418 3.20512 3.36952ZM11.3575 5.42578C11.5241 5.42578 11.6908 5.36378 11.8208 5.23912L12.7801 4.31245C13.0448 4.05645 13.0521 3.63378 12.7961 3.36978C12.5408 3.10578 12.1195 3.09712 11.8535 3.35312L10.8941 4.27912C10.6295 4.53512 10.6221 4.95778 10.8781 5.22178C11.0088 5.35712 11.1828 5.42578 11.3575 5.42578ZM7.33398 12.6673C7.33398 12.2987 7.63265 12.0007 8.00065 12.0007C8.36865 12.0007 8.66732 12.2987 8.66732 12.6673V14.0007C8.66732 14.3693 8.36865 14.6673 8.00065 14.6673C7.63265 14.6673 7.33398 14.3693 7.33398 14.0007V12.6673ZM11.8207 10.7624C11.556 10.5071 11.134 10.5151 10.878 10.7791C10.622 11.0437 10.6293 11.4664 10.894 11.7217L11.8533 12.6484C11.9833 12.7737 12.15 12.8351 12.3167 12.8351C12.4913 12.8351 12.6653 12.7671 12.796 12.6317C13.052 12.3671 13.0447 11.9444 12.78 11.6891L11.8207 10.7624ZM3.22132 11.6891L4.18065 10.7624C4.44598 10.5071 4.86798 10.5151 5.12332 10.7791C5.37932 11.0437 5.37198 11.4664 5.10732 11.7217L4.14798 12.6484C4.01798 12.7737 3.85132 12.8351 3.68465 12.8351C3.50998 12.8351 3.33598 12.7671 3.20532 12.6317C2.94932 12.3671 2.95665 11.9444 3.22132 11.6891Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.33398 2.00065C7.33398 1.63198 7.63265 1.33398 8.00065 1.33398C8.36865 1.33398 8.66732 1.63198 8.66732 2.00065V3.33398C8.66732 3.70265 8.36865 4.00065 8.00065 4.00065C7.63265 4.00065 7.33398 3.70265 7.33398 3.33398V2.00065ZM12.6673 7.33398H14.0007C14.3687 7.33398 14.6673 7.63198 14.6673 8.00065C14.6673 8.36932 14.3687 8.66732 14.0007 8.66732H12.6673C12.2993 8.66732 12.0007 8.36932 12.0007 8.00065C12.0007 7.63198 12.2993 7.33398 12.6673 7.33398ZM4.00065 8.00065C4.00065 7.63198 3.70198 7.33398 3.33398 7.33398H2.00065C1.63265 7.33398 1.33398 7.63198 1.33398 8.00065C1.33398 8.36932 1.63265 8.66732 2.00065 8.66732H3.33398C3.70198 8.66732 4.00065 8.36932 4.00065 8.00065ZM3.20512 3.36952C3.46178 3.10552 3.88312 3.09685 4.14778 3.35285L5.10712 4.27952C5.37178 4.53485 5.37912 4.95752 5.12312 5.22218C4.99245 5.35752 4.81845 5.42552 4.64378 5.42552C4.47712 5.42552 4.31045 5.36418 4.18045 5.23885L3.22112 4.31218C2.95645 4.05685 2.94912 3.63418 3.20512 3.36952ZM11.3575 5.42578C11.5241 5.42578 11.6908 5.36378 11.8208 5.23912L12.7801 4.31245C13.0448 4.05645 13.0521 3.63378 12.7961 3.36978C12.5408 3.10578 12.1195 3.09712 11.8535 3.35312L10.8941 4.27912C10.6295 4.53512 10.6221 4.95778 10.8781 5.22178C11.0088 5.35712 11.1828 5.42578 11.3575 5.42578ZM7.33398 12.6673C7.33398 12.2987 7.63265 12.0007 8.00065 12.0007C8.36865 12.0007 8.66732 12.2987 8.66732 12.6673V14.0007C8.66732 14.3693 8.36865 14.6673 8.00065 14.6673C7.63265 14.6673 7.33398 14.3693 7.33398 14.0007V12.6673ZM11.8207 10.7624C11.556 10.5071 11.134 10.5151 10.878 10.7791C10.622 11.0437 10.6293 11.4664 10.894 11.7217L11.8533 12.6484C11.9833 12.7737 12.15 12.8351 12.3167 12.8351C12.4913 12.8351 12.6653 12.7671 12.796 12.6317C13.052 12.3671 13.0447 11.9444 12.78 11.6891L11.8207 10.7624ZM3.22132 11.6891L4.18065 10.7624C4.44598 10.5071 4.86798 10.5151 5.12332 10.7791C5.37932 11.0437 5.37198 11.4664 5.10732 11.7217L4.14798 12.6484C4.01798 12.7737 3.85132 12.8351 3.68465 12.8351C3.50998 12.8351 3.33598 12.7671 3.20532 12.6317C2.94932 12.3671 2.95665 11.9444 3.22132 11.6891Z'
        fill={color}
      />
    </svg>
  );
};

export const SparkleIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M10.8173 12H3.18265C2.5306 12 2 11.4695 2 10.8173V3.18265C2 2.5306 2.53047 2 3.18265 2H8.71115V2.92302H3.18265C3.03945 2.92302 2.92302 3.03945 2.92302 3.18265V10.8173C2.92302 10.9605 3.03945 11.077 3.18265 11.077H10.8173C10.9605 11.077 11.077 10.9605 11.077 10.8173V5.28898H12V10.8173C12 11.4695 11.4695 12 10.8173 12Z'
          fill={color}
        />
        <path
          d='M9.61169 6.99997C9.61169 7.08792 9.55353 7.16545 9.46901 7.18998L8.98126 7.33159C8.18061 7.56393 7.5639 8.18064 7.33143 8.98129L7.18981 9.46904C7.16529 9.55357 7.08789 9.61172 6.99993 9.61172C6.91198 9.61172 6.83445 9.55357 6.80992 9.46904L6.66831 8.98129C6.43597 8.18064 5.81926 7.56393 5.01861 7.33159L4.53086 7.18998C4.44633 7.16545 4.38818 7.08792 4.38818 6.99997C4.38818 6.91201 4.44633 6.83461 4.53086 6.81009L5.01861 6.66847C5.81926 6.436 6.43597 5.81929 6.66831 5.01864L6.80992 4.53089C6.83445 4.44636 6.91198 4.38821 6.99993 4.38821C7.08789 4.38821 7.16529 4.44636 7.18981 4.53089L7.33143 5.01864C7.5639 5.81929 8.18061 6.436 8.98126 6.66847L9.46901 6.81009C9.55353 6.83461 9.61169 6.91201 9.61169 6.99997Z'
          fill={color}
        />
        <path
          d='M9.61169 6.99997C9.61169 7.08792 9.55353 7.16545 9.46901 7.18998L8.98126 7.33159C8.18061 7.56393 7.5639 8.18064 7.33143 8.98129L7.18981 9.46904C7.16529 9.55357 7.08789 9.61172 6.99993 9.61172C6.91198 9.61172 6.83445 9.55357 6.80992 9.46904L6.66831 8.98129C6.43597 8.18064 5.81926 7.56393 5.01861 7.33159L4.53086 7.18998C4.44633 7.16545 4.38818 7.08792 4.38818 6.99997C4.38818 6.91201 4.44633 6.83461 4.53086 6.81009L5.01861 6.66847C5.81926 6.436 6.43597 5.81929 6.66831 5.01864L6.80992 4.53089C6.83445 4.44636 6.91198 4.38821 6.99993 4.38821C7.08789 4.38821 7.16529 4.44636 7.18981 4.53089L7.33143 5.01864C7.5639 5.81929 8.18061 6.436 8.98126 6.66847L9.46901 6.81009C9.55353 6.83461 9.61169 6.91201 9.61169 6.99997Z'
          fill={color}
        />
        <path
          d='M11.7359 3.39187C11.7359 3.47982 11.6777 3.55722 11.5932 3.58174L11.3526 3.65163C11.1172 3.72007 10.9359 3.90137 10.8675 4.13674L10.7977 4.37739C10.7732 4.46191 10.6956 4.52006 10.6077 4.52006C10.5197 4.52006 10.4423 4.46191 10.4178 4.37739L10.3479 4.13674C10.2795 3.90137 10.0982 3.72007 9.86281 3.65163L9.62216 3.58174C9.53764 3.55722 9.47949 3.47982 9.47949 3.39187C9.47949 3.30392 9.53764 3.22638 9.62216 3.20186L9.86281 3.1321C10.0982 3.06367 10.2795 2.88236 10.3479 2.64699L10.4178 2.40634C10.4423 2.32182 10.5197 2.26367 10.6077 2.26367C10.6956 2.26367 10.7732 2.32182 10.7977 2.40634L10.8675 2.64699C10.9359 2.88236 11.1172 3.06367 11.3526 3.1321L11.5932 3.20186C11.6777 3.22638 11.7359 3.30392 11.7359 3.39187Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M14.3443 16H3.65571C2.74285 16 2 15.2573 2 14.3443V3.65571C2 2.74285 2.74266 2 3.65571 2H11.3956V3.29223H3.65571C3.45523 3.29223 3.29223 3.45523 3.29223 3.65571V14.3443C3.29223 14.5448 3.45523 14.7078 3.65571 14.7078H14.3443C14.5448 14.7078 14.7078 14.5448 14.7078 14.3443V6.60458H16V14.3443C16 15.2573 15.2573 16 14.3443 16Z'
          fill={color}
        />
        <path
          d='M12.6567 8.99996C12.6567 9.12309 12.5752 9.23164 12.4569 9.26597L11.7741 9.46424C10.6531 9.78951 9.78975 10.6529 9.4643 11.7738L9.26603 12.4567C9.2317 12.575 9.12333 12.6564 9.0002 12.6564C8.87707 12.6564 8.76852 12.575 8.73419 12.4567L8.53592 11.7738C8.21065 10.6529 7.34726 9.78951 6.22634 9.46424L5.54349 9.26597C5.42516 9.23164 5.34375 9.12309 5.34375 8.99996C5.34375 8.87683 5.42516 8.76846 5.54349 8.73413L6.22634 8.53586C7.34726 8.21041 8.21065 7.34701 8.53592 6.2261L8.73419 5.54325C8.76852 5.42492 8.87707 5.34351 9.0002 5.34351C9.12333 5.34351 9.2317 5.42492 9.26603 5.54325L9.4643 6.2261C9.78975 7.34701 10.6531 8.21041 11.7741 8.53586L12.4569 8.73413C12.5752 8.76846 12.6567 8.87683 12.6567 8.99996Z'
          fill={color}
        />
        <path
          d='M12.6567 8.99996C12.6567 9.12309 12.5752 9.23164 12.4569 9.26597L11.7741 9.46424C10.6531 9.78951 9.78975 10.6529 9.4643 11.7738L9.26603 12.4567C9.2317 12.575 9.12333 12.6564 9.0002 12.6564C8.87707 12.6564 8.76852 12.575 8.73419 12.4567L8.53592 11.7738C8.21065 10.6529 7.34726 9.78951 6.22634 9.46424L5.54349 9.26597C5.42516 9.23164 5.34375 9.12309 5.34375 8.99996C5.34375 8.87683 5.42516 8.76846 5.54349 8.73413L6.22634 8.53586C7.34726 8.21041 8.21065 7.34701 8.53592 6.2261L8.73419 5.54325C8.76852 5.42492 8.87707 5.34351 9.0002 5.34351C9.12333 5.34351 9.2317 5.42492 9.26603 5.54325L9.4643 6.2261C9.78975 7.34701 10.6531 8.21041 11.7741 8.53586L12.4569 8.73413C12.5752 8.76846 12.6567 8.87683 12.6567 8.99996Z'
          fill={color}
        />
        <path
          d='M15.6306 3.94861C15.6306 4.07174 15.5492 4.18011 15.4309 4.21444L15.094 4.31228C14.7645 4.40809 14.5106 4.66192 14.4148 4.99144L14.3172 5.32834C14.2828 5.44667 14.1743 5.52808 14.0512 5.52808C13.928 5.52808 13.8197 5.44667 13.7853 5.32834L13.6875 4.99144C13.5917 4.66192 13.3378 4.40809 13.0083 4.31228L12.6714 4.21444C12.5531 4.18011 12.4717 4.07174 12.4717 3.94861C12.4717 3.82548 12.5531 3.71693 12.6714 3.6826L13.0083 3.58494C13.3378 3.48913 13.5917 3.2353 13.6875 2.90578L13.7853 2.56888C13.8197 2.45055 13.928 2.36914 14.0512 2.36914C14.1743 2.36914 14.2828 2.45055 14.3172 2.56888L14.4148 2.90578C14.5106 3.2353 14.7645 3.48913 15.094 3.58494L15.4309 3.6826C15.5492 3.71693 15.6306 3.82548 15.6306 3.94861Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M12.5808 14H3.41918C2.63673 14 2 13.3634 2 12.5808V3.41918C2 2.63673 2.63657 2 3.41918 2H10.0534V3.10762H3.41918C3.24734 3.10762 3.10762 3.24734 3.10762 3.41918V12.5808C3.10762 12.7527 3.24734 12.8924 3.41918 12.8924H12.5808C12.7527 12.8924 12.8924 12.7527 12.8924 12.5808V5.94678H14V12.5808C14 13.3634 13.3634 14 12.5808 14Z'
        fill={color}
      />
      <path
        d='M11.1344 7.99998C11.1344 8.10552 11.0646 8.19856 10.9632 8.22799L10.3779 8.39793C9.41712 8.67674 8.67707 9.41679 8.39811 10.3776L8.22817 10.9629C8.19874 11.0643 8.10585 11.1341 8.00031 11.1341C7.89477 11.1341 7.80173 11.0643 7.7723 10.9629L7.60236 10.3776C7.32355 9.41679 6.5835 8.67674 5.62272 8.39793L5.03742 8.22799C4.93599 8.19856 4.86621 8.10552 4.86621 7.99998C4.86621 7.89444 4.93599 7.80155 5.03742 7.77212L5.62272 7.60218C6.5835 7.32322 7.32355 6.58317 7.60236 5.62238L7.7723 5.03708C7.80173 4.93566 7.89477 4.86588 8.00031 4.86588C8.10585 4.86588 8.19874 4.93566 8.22817 5.03708L8.39811 5.62238C8.67707 6.58317 9.41712 7.32322 10.3779 7.60218L10.9632 7.77212C11.0646 7.80155 11.1344 7.89444 11.1344 7.99998Z'
        fill={color}
      />
      <path
        d='M11.1344 7.99998C11.1344 8.10552 11.0646 8.19856 10.9632 8.22799L10.3779 8.39793C9.41712 8.67674 8.67707 9.41679 8.39811 10.3776L8.22817 10.9629C8.19874 11.0643 8.10585 11.1341 8.00031 11.1341C7.89477 11.1341 7.80173 11.0643 7.7723 10.9629L7.60236 10.3776C7.32355 9.41679 6.5835 8.67674 5.62272 8.39793L5.03742 8.22799C4.93599 8.19856 4.86621 8.10552 4.86621 7.99998C4.86621 7.89444 4.93599 7.80155 5.03742 7.77212L5.62272 7.60218C6.5835 7.32322 7.32355 6.58317 7.60236 5.62238L7.7723 5.03708C7.80173 4.93566 7.89477 4.86588 8.00031 4.86588C8.10585 4.86588 8.19874 4.93566 8.22817 5.03708L8.39811 5.62238C8.67707 6.58317 9.41712 7.32322 10.3779 7.60218L10.9632 7.77212C11.0646 7.80155 11.1344 7.89444 11.1344 7.99998Z'
        fill={color}
      />
      <path
        d='M13.6833 3.67024C13.6833 3.77578 13.6135 3.86866 13.512 3.89809L13.2233 3.98196C12.9408 4.06408 12.7233 4.28165 12.6411 4.56409L12.5574 4.85287C12.528 4.95429 12.435 5.02407 12.3294 5.02407C12.2239 5.02407 12.131 4.95429 12.1016 4.85287L12.0177 4.56409C11.9356 4.28165 11.718 4.06408 11.4356 3.98196L11.1468 3.89809C11.0454 3.86866 10.9756 3.77578 10.9756 3.67024C10.9756 3.5647 11.0454 3.47166 11.1468 3.44223L11.4356 3.35852C11.718 3.2764 11.9356 3.05883 12.0177 2.77639L12.1016 2.48761C12.131 2.38619 12.2239 2.31641 12.3294 2.31641C12.435 2.31641 12.528 2.38619 12.5574 2.48761L12.6411 2.77639C12.7233 3.05883 12.9408 3.2764 13.2233 3.35852L13.512 3.44223C13.6135 3.47166 13.6833 3.5647 13.6833 3.67024Z'
        fill={color}
      />
    </svg>
  );
};

export const RefreshIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.91678 2.33301H11.0835C11.4043 2.33301 11.6668 2.59551 11.6668 2.91634V11.083C11.6668 11.4038 11.4043 11.6663 11.0835 11.6663H9.91678C9.59595 11.6663 9.33345 11.4038 9.33345 11.083C9.33345 10.7622 9.59595 10.4997 9.91678 10.4997H10.5001V3.49967H9.91678C9.59595 3.49967 9.33345 3.23717 9.33345 2.91634C9.33345 2.59551 9.59595 2.33301 9.91678 2.33301ZM6.06667 4.19991C6.32567 4.00682 6.69025 4.05932 6.88333 4.31657L8.63333 6.64991C8.785 6.85174 8.78967 7.12824 8.64383 7.33532L7.00233 9.66866C6.88858 9.83024 6.70833 9.91657 6.52458 9.91657C6.40908 9.91657 6.29183 9.88216 6.18975 9.81041C5.92608 9.62491 5.8625 9.26091 6.048 8.99724L7.05017 7.57274C7.04231 7.57353 7.03492 7.57572 7.02759 7.57791C7.01858 7.58058 7.00964 7.58324 7 7.58324H2.33333C2.01133 7.58324 1.75 7.32191 1.75 6.99991C1.75 6.67732 2.01133 6.41657 2.33333 6.41657H7H7.00058L5.95 5.01599C5.75692 4.75874 5.80883 4.39299 6.06667 4.19991Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.7501 3H14.2501C14.6627 3 15.0001 3.3375 15.0001 3.75V14.25C15.0001 14.6625 14.6627 15 14.2501 15H12.7501C12.3376 15 12.0001 14.6625 12.0001 14.25C12.0001 13.8375 12.3376 13.5 12.7501 13.5H13.5001V4.5H12.7501C12.3376 4.5 12.0001 4.1625 12.0001 3.75C12.0001 3.3375 12.3376 3 12.7501 3ZM7.8 5.4003C8.133 5.15205 8.60175 5.21955 8.85 5.5503L11.1 8.5503C11.295 8.8098 11.301 9.1653 11.1135 9.43155L9.003 12.4316C8.85675 12.6393 8.625 12.7503 8.38875 12.7503C8.24025 12.7503 8.0895 12.706 7.95825 12.6138C7.61925 12.3753 7.5375 11.9073 7.776 11.5683L9.0645 9.7368C9.0544 9.73781 9.0449 9.74063 9.03547 9.74344C9.02389 9.74688 9.0124 9.7503 9 9.7503H3C2.586 9.7503 2.25 9.4143 2.25 9.0003C2.25 8.58555 2.586 8.2503 3 8.2503H9H9.00075L7.65 6.44955C7.40175 6.1188 7.4685 5.64855 7.8 5.4003Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.3335 2.66699H12.6668C13.0335 2.66699 13.3335 2.96699 13.3335 3.33366V12.667C13.3335 13.0337 13.0335 13.3337 12.6668 13.3337H11.3335C10.9668 13.3337 10.6668 13.0337 10.6668 12.667C10.6668 12.3003 10.9668 12.0003 11.3335 12.0003H12.0001V4.00033H11.3335C10.9668 4.00033 10.6668 3.70033 10.6668 3.33366C10.6668 2.96699 10.9668 2.66699 11.3335 2.66699ZM6.93333 4.80059C7.22933 4.57993 7.646 4.63993 7.86667 4.93393L9.86667 7.60059C10.04 7.83126 10.0453 8.14726 9.87867 8.38393L8.00267 11.0506C7.87267 11.2353 7.66667 11.3339 7.45667 11.3339C7.32467 11.3339 7.19067 11.2946 7.074 11.2126C6.77267 11.0006 6.7 10.5846 6.912 10.2833L8.05733 8.65526C8.04836 8.65616 8.03991 8.65867 8.03153 8.66116C8.02123 8.66422 8.01102 8.66726 8 8.66726H2.66667C2.29867 8.66726 2 8.36859 2 8.00059C2 7.63193 2.29867 7.33393 2.66667 7.33393H8H8.00067L6.8 5.73326C6.57933 5.43926 6.63867 5.02126 6.93333 4.80059Z'
        fill={color}
      />
    </svg>
  );
};

export const SafetyIcon = ({ color, large, small, style, className }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M7.00173 1C8.39864 2.24403 10.1537 2.98599 11.9999 3.11312V6.93253C12.0087 8.12498 11.5977 9.28066 10.8422 10.1875C9.89496 11.3125 8.60381 12.25 7.0018 13C5.4034 12.25 4.11231 11.3125 3.16135 10.1875C2.40584 9.28274 1.99353 8.1292 2.00008 6.9381V3.11312C3.84772 2.98799 5.60456 2.24576 7.00176 1L7.00173 1ZM3.1431 6.93247C3.13755 7.84234 3.45096 8.72399 4.02639 9.41688C4.86364 10.3705 5.87428 11.1476 7.00178 11.7044C8.12933 11.1476 9.13989 10.3705 9.97716 9.41688C10.5526 8.72406 10.866 7.84238 10.8605 6.93247V4.1517C9.46886 3.8943 8.15071 3.32235 7.00182 2.47734C5.85294 3.32267 4.53473 3.89473 3.14318 4.1517L3.1431 6.93247Z'
          fill={color}
        />
        <path
          d='M8.36443 6.18444V6.72442H8.70455C8.7399 6.72442 8.76855 6.7538 8.76855 6.79004V8.12506C8.76766 8.46489 8.63556 8.79052 8.40117 9.03084C8.16677 9.27116 7.84919 9.40658 7.51771 9.40759H6.48811C6.15632 9.40709 5.83823 9.27182 5.60344 9.0315C5.36873 8.7911 5.2363 8.46523 5.2354 8.12506V6.79004C5.23638 6.75355 5.26553 6.72442 5.3012 6.72442H5.63954V6.18444C5.63954 5.68539 5.89925 5.22425 6.32077 4.97474C6.74229 4.72523 7.26171 4.72521 7.68322 4.97474C8.10474 5.22427 8.36443 5.68539 8.36443 6.18444ZM6.8191 8.07064V8.41007C6.8191 8.50842 6.89691 8.58819 6.99283 8.58819C7.08876 8.58819 7.16657 8.50842 7.16657 8.41007V8.07064C7.26274 8.0174 7.33075 7.92282 7.35173 7.81283C7.3728 7.70284 7.34471 7.58893 7.27523 7.50238C7.20576 7.41583 7.10215 7.36569 6.99283 7.36569C6.8835 7.36569 6.77989 7.41583 6.71042 7.50238C6.64094 7.58893 6.61286 7.70285 6.63392 7.81283C6.6549 7.92282 6.72292 8.01741 6.8191 8.07064ZM6.08758 6.18444V6.72442H7.89808V6.18444C7.85628 5.88395 7.67529 5.62278 7.41215 5.48358C7.1491 5.34438 6.83657 5.34438 6.57352 5.48358C6.31038 5.62278 6.12939 5.88395 6.08758 6.18444Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M8.83768 1C10.7473 2.65871 13.1465 3.64799 15.6702 3.8175V8.91004C15.6823 10.5 15.1205 12.0409 14.0877 13.25C12.7928 14.75 11.0278 16 8.83777 17C6.65272 16 4.88779 14.75 3.5878 13.25C2.555 12.0437 1.99138 10.5056 2.00032 8.91747V3.8175C4.52608 3.65065 6.92772 2.66102 8.83771 1L8.83768 1ZM3.56286 8.90996C3.55527 10.1231 3.98371 11.2987 4.77034 12.2225C5.91487 13.494 7.29644 14.5301 8.83774 15.2725C10.3791 14.5301 11.7606 13.494 12.9051 12.2225C13.6917 11.2987 14.1202 10.1232 14.1126 8.90996V5.20226C12.2103 4.85907 10.4084 4.09647 8.8378 2.96979C7.26726 4.0969 5.46525 4.85964 3.56297 5.20226L3.56286 8.90996Z'
          fill={color}
        />
        <path
          d='M10.7005 7.91251V8.63247H11.1654C11.2138 8.63247 11.2529 8.67165 11.2529 8.71997V10.5C11.2517 10.9531 11.0711 11.3873 10.7507 11.7077C10.4303 12.0281 9.99614 12.2087 9.543 12.21H8.13552C7.68195 12.2094 7.24712 12.029 6.92615 11.7086C6.6053 11.388 6.42427 10.9536 6.42304 10.5V8.71997C6.42438 8.67131 6.46422 8.63247 6.51299 8.63247H6.97551V7.91251C6.97551 7.24711 7.33053 6.63226 7.90676 6.29957C8.48298 5.96689 9.19304 5.96686 9.76926 6.29957C10.3455 6.63229 10.7005 7.24711 10.7005 7.91251ZM8.58799 10.4274V10.88C8.58799 11.0111 8.69435 11.1175 8.82549 11.1175C8.95662 11.1175 9.06298 11.0111 9.06298 10.88V10.4274C9.19446 10.3565 9.28743 10.2303 9.31611 10.0837C9.3449 9.93704 9.30651 9.78515 9.21153 9.66975C9.11655 9.55435 8.97493 9.4875 8.82548 9.4875C8.67603 9.4875 8.53439 9.55435 8.43942 9.66975C8.34444 9.78516 8.30605 9.93705 8.33484 10.0837C8.36353 10.2303 8.45651 10.3565 8.58799 10.4274ZM7.58799 7.91251V8.63247H10.063V7.91251C10.0058 7.51185 9.75841 7.16363 9.3987 6.97803C9.0391 6.79242 8.61187 6.79242 8.25227 6.97803C7.89256 7.16363 7.64513 7.51185 7.58799 7.91251Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M8.672 1C10.3483 2.45137 12.4544 3.31699 14.6698 3.46531V7.92129C14.6803 9.31248 14.1872 10.6608 13.2806 11.7188C12.1439 13.0313 10.5945 14.125 8.67208 15C6.754 14.125 5.2047 13.0313 4.06354 11.7188C3.15693 10.6632 2.66216 9.31741 2.67001 7.92779V3.46531C4.88718 3.31932 6.9954 2.45339 8.67203 1L8.672 1ZM4.04164 7.92121C4.03498 8.98273 4.41108 10.0113 5.10159 10.8197C6.10629 11.9323 7.31906 12.8388 8.67205 13.4884C10.0251 12.8388 11.2378 11.9323 12.2425 10.8197C12.933 10.0114 13.3091 8.98278 13.3025 7.92121V4.67698C11.6326 4.37668 10.0508 3.70941 8.6721 2.72357C7.29345 3.70979 5.7116 4.37718 4.04174 4.67698L4.04164 7.92121Z'
        fill={color}
      />
      <path
        d='M10.307 7.04847V7.67845H10.7152C10.7576 7.67845 10.792 7.71272 10.792 7.75501V9.31252C10.7909 9.709 10.6324 10.0889 10.3511 10.3693C10.0698 10.6496 9.68875 10.8076 9.29097 10.8088H8.05546C7.65731 10.8082 7.27561 10.6504 6.99385 10.37C6.7122 10.0896 6.55329 9.7094 6.55221 9.31252V7.75501C6.55338 7.71243 6.58836 7.67845 6.63117 7.67845H7.03718V7.04847C7.03718 6.46625 7.34883 5.92825 7.85465 5.63716C8.36047 5.34606 8.98377 5.34603 9.4896 5.63716C9.99542 5.92828 10.307 6.46625 10.307 7.04847ZM8.45265 9.24904V9.64504C8.45265 9.75978 8.54601 9.85285 8.66113 9.85285C8.77624 9.85285 8.86961 9.75978 8.86961 9.64504V9.24904C8.98502 9.18693 9.06663 9.07658 9.09181 8.94826C9.11708 8.81994 9.08338 8.68704 9.00001 8.58607C8.91664 8.48509 8.79231 8.42659 8.66112 8.42659C8.52993 8.42659 8.4056 8.48509 8.32223 8.58607C8.23886 8.68704 8.20516 8.81995 8.23043 8.94826C8.25561 9.07658 8.33724 9.18694 8.45265 9.24904ZM7.57483 7.04847V7.67845H9.74743V7.04847C9.69727 6.6979 9.48007 6.3932 9.16431 6.2308C8.84864 6.0684 8.47361 6.0684 8.15795 6.2308C7.84219 6.39321 7.62499 6.6979 7.57483 7.04847Z'
        fill={color}
      />
    </svg>
  );
};

export const SaveIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.0833 10.5C11.0833 10.8214 10.822 11.0833 10.5 11.0833H9.33333V9.33333C9.33333 9.01133 9.07258 8.75 8.75 8.75H5.25C4.92742 8.75 4.66667 9.01133 4.66667 9.33333V11.0833H3.5C3.178 11.0833 2.91667 10.8214 2.91667 10.5V3.5C2.91667 3.17858 3.178 2.91667 3.5 2.91667H4.66667V5.83333C4.66667 6.15533 4.92742 6.41667 5.25 6.41667H7.58333C7.90592 6.41667 8.16667 6.15533 8.16667 5.83333C8.16667 5.51133 7.90592 5.25 7.58333 5.25H5.83333V2.91667H7.68367C7.83708 2.91667 7.987 2.97908 8.09608 3.08758L10.9124 5.90392C11.0227 6.01417 11.0833 6.16117 11.0833 6.31692V10.5ZM5.83333 11.0833H8.16667V9.91667H5.83333V11.0833ZM11.7372 5.07908L8.92092 2.26275C8.59075 1.932 8.15092 1.75 7.68367 1.75H3.5C2.53517 1.75 1.75 2.53517 1.75 3.5V10.5C1.75 11.4648 2.53517 12.25 3.5 12.25H5.25H8.75H10.5C11.4648 12.25 12.25 11.4648 12.25 10.5V6.31692C12.25 5.84908 12.0674 5.40925 11.7372 5.07908Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.25 13.5C14.25 13.9132 13.914 14.25 13.5 14.25H12V12C12 11.586 11.6648 11.25 11.25 11.25H6.75C6.33525 11.25 6 11.586 6 12V14.25H4.5C4.086 14.25 3.75 13.9132 3.75 13.5V4.5C3.75 4.08675 4.086 3.75 4.5 3.75H6V7.5C6 7.914 6.33525 8.25 6.75 8.25H9.75C10.1648 8.25 10.5 7.914 10.5 7.5C10.5 7.086 10.1648 6.75 9.75 6.75H7.5V3.75H9.879C10.0763 3.75 10.269 3.83025 10.4093 3.96975L14.0302 7.59075C14.172 7.7325 14.25 7.9215 14.25 8.12175V13.5ZM7.5 14.25H10.5V12.75H7.5V14.25ZM15.0907 6.53025L11.4698 2.90925C11.0452 2.484 10.4797 2.25 9.879 2.25H4.5C3.2595 2.25 2.25 3.2595 2.25 4.5V13.5C2.25 14.7405 3.2595 15.75 4.5 15.75H6.75H11.25H13.5C14.7405 15.75 15.75 14.7405 15.75 13.5V8.12175C15.75 7.52025 15.5153 6.95475 15.0907 6.53025Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.6667 12C12.6667 12.3673 12.368 12.6667 12 12.6667H10.6667V10.6667C10.6667 10.2987 10.3687 10 10 10H6C5.63133 10 5.33333 10.2987 5.33333 10.6667V12.6667H4C3.632 12.6667 3.33333 12.3673 3.33333 12V4C3.33333 3.63267 3.632 3.33333 4 3.33333H5.33333V6.66667C5.33333 7.03467 5.63133 7.33333 6 7.33333H8.66667C9.03533 7.33333 9.33333 7.03467 9.33333 6.66667C9.33333 6.29867 9.03533 6 8.66667 6H6.66667V3.33333H8.78133C8.95667 3.33333 9.128 3.40467 9.25267 3.52867L12.4713 6.74733C12.5973 6.87333 12.6667 7.04133 12.6667 7.21933V12ZM6.66667 12.6667H9.33333V11.3333H6.66667V12.6667ZM13.414 5.80467L10.1953 2.586C9.818 2.208 9.31533 2 8.78133 2H4C2.89733 2 2 2.89733 2 4V12C2 13.1027 2.89733 14 4 14H6H10H12C13.1027 14 14 13.1027 14 12V7.21933C14 6.68467 13.7913 6.182 13.414 5.80467Z'
        fill={color}
      />
    </svg>
  );
};

export const ScheduleIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M8.57853 1.28933C7.56268 1.14067 6.52555 1.26573 5.57408 1.65162C4.62274 2.03743 3.79143 2.67004 3.16603 3.48426C2.54065 4.29847 2.14381 5.26481 2.01641 6.28359L2.01673 6.28407L0.738675 6.09716C0.648886 6.08404 0.560144 6.1268 0.514486 6.20523C0.468908 6.28367 0.475511 6.38199 0.531316 6.45358L2.28069 8.69774C2.35494 8.79301 2.49175 8.81145 2.58864 8.7393L4.81879 7.07728C4.89086 7.02357 4.92347 6.93177 4.90141 6.84473C4.87934 6.75759 4.80703 6.69237 4.71813 6.67932L3.44362 6.4929C3.44628 6.45272 3.45207 6.41302 3.45787 6.37324H3.45795C3.59429 5.44314 4.02955 4.58271 4.69807 3.92189C5.3666 3.26107 6.23205 2.83566 7.16364 2.71011C8.09526 2.58449 9.04244 2.76552 9.86216 3.22582C10.6819 3.68613 11.3295 4.40064 11.7071 5.2614C12.0849 6.12225 12.1722 7.08262 11.9559 7.99744C11.7397 8.91232 11.2315 9.73193 10.5083 10.3325C9.78508 10.9331 8.88608 11.282 7.94708 11.3265C7.00804 11.371 6.08013 11.1087 5.3034 10.5793C5.18011 10.4958 5.03379 10.453 4.88497 10.4567C4.73615 10.4605 4.59226 10.5106 4.47323 10.6C4.28616 10.7401 4.17849 10.9621 4.1842 11.1957C4.18984 11.4293 4.30829 11.6457 4.50196 11.7765C5.46234 12.4283 6.59687 12.7753 7.7575 12.7724C8.91813 12.7695 10.0509 12.4167 11.0081 11.7602C11.9652 11.1036 12.7021 10.1737 13.1226 9.09197C13.5431 8.01015 13.6277 6.82678 13.3654 5.69604C13.103 4.56531 12.5059 3.54032 11.652 2.75406C10.798 1.96803 9.72688 1.45764 8.57848 1.28967L8.57853 1.28933Z'
          fill={color}
        />
        <path
          d='M8.11635 3.92582H8.11626C7.93153 3.92582 7.75437 3.99919 7.62375 4.12988C7.49313 4.2605 7.41977 4.43766 7.41977 4.6224V6.84532L5.62224 8.16517C5.42164 8.31245 5.31487 8.55558 5.34208 8.80296C5.36938 9.05026 5.52657 9.2643 5.75438 9.36439C5.98228 9.46441 6.24615 9.43533 6.44676 9.28805L8.80327 7.55774H8.81294L8.81286 4.62235C8.81294 4.43762 8.7395 4.26046 8.60888 4.12984C8.47827 3.99914 8.3011 3.92578 8.11636 3.92578L8.11635 3.92582Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M11.06 1.57902C9.73466 1.38586 8.38158 1.54836 7.14025 2.04977C5.89909 2.55109 4.81453 3.3731 3.9986 4.43108C3.18271 5.48905 2.66497 6.74469 2.49876 8.06848L2.49918 8.0691L0.831771 7.82624C0.714628 7.80919 0.598852 7.86475 0.539284 7.96667C0.479821 8.06858 0.488435 8.19634 0.561241 8.28937L2.84356 11.2054C2.94042 11.3292 3.11891 11.3531 3.24532 11.2594L6.15486 9.0998C6.24889 9.03 6.29144 8.91072 6.26265 8.79761C6.23387 8.6844 6.13952 8.59964 6.02354 8.58269L4.36076 8.34046C4.36422 8.28824 4.37179 8.23666 4.37935 8.18497H4.37946C4.55732 6.97642 5.12519 5.85839 5.99738 4.99973C6.86957 4.14107 7.99866 3.5883 9.21406 3.42517C10.4295 3.26193 11.6652 3.49716 12.7347 4.09527C13.8041 4.69338 14.649 5.6218 15.1417 6.74027C15.6345 7.85883 15.7484 9.10673 15.4662 10.2954C15.1841 11.4842 14.5212 12.5492 13.5776 13.3296C12.6341 14.11 11.4612 14.5634 10.2362 14.6211C9.01106 14.679 7.80047 14.3382 6.7871 13.6502C6.62626 13.5418 6.43537 13.4861 6.24121 13.4909C6.04706 13.4959 5.85932 13.5609 5.70403 13.6772C5.45997 13.8593 5.3195 14.1476 5.32695 14.4512C5.33431 14.7548 5.48885 15.0359 5.74152 15.2058C6.99447 16.0528 8.47463 16.5038 9.98884 16.5C11.503 16.4962 12.9809 16.0378 14.2297 15.1847C15.4783 14.3315 16.4397 13.1232 16.9884 11.7177C17.537 10.312 17.6474 8.7743 17.3051 7.30504C16.9628 5.83577 16.1838 4.50392 15.0698 3.48227C13.9556 2.46091 12.5582 1.79772 11.0599 1.57946L11.06 1.57902Z'
          fill={color}
        />
        <path
          d='M10.4608 5.00396H10.4607C10.2197 5.00396 9.98858 5.09929 9.81817 5.26911C9.64776 5.43883 9.55205 5.66904 9.55205 5.90908V8.79751L7.20691 10.5125C6.9452 10.7039 6.8059 11.0198 6.8414 11.3412C6.87702 11.6626 7.08209 11.9407 7.37931 12.0707C7.67664 12.2007 8.0209 12.1629 8.28262 11.9716L11.357 9.72321H11.3696L11.3695 5.90902C11.3696 5.66899 11.2738 5.43878 11.1034 5.26905C10.933 5.09923 10.7019 5.00391 10.4609 5.00391L10.4608 5.00396Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M9.81763 1.42547C8.64823 1.25435 7.45434 1.39831 6.35905 1.84252C5.2639 2.28665 4.30694 3.01489 3.587 3.95218C2.86709 4.88947 2.41027 6.00187 2.26361 7.17464L2.26398 7.1752L0.792739 6.96004C0.689378 6.94493 0.587222 6.99416 0.534662 7.08445C0.482195 7.17474 0.489796 7.28792 0.554037 7.37034L2.56784 9.95372C2.65331 10.0634 2.8108 10.0846 2.92234 10.0015L5.48958 8.08831C5.57255 8.02648 5.61009 7.92081 5.58469 7.8206C5.55929 7.7203 5.47605 7.64521 5.37371 7.6302L3.90655 7.4156C3.90961 7.36934 3.91628 7.32364 3.92296 7.27784H3.92305C4.07999 6.20716 4.58105 5.21667 5.35063 4.45597C6.1202 3.69526 7.11646 3.20554 8.18888 3.06102C9.26132 2.91641 10.3517 3.1248 11.2953 3.65468C12.2389 4.18456 12.9844 5.00708 13.4191 5.99795C13.854 6.98892 13.9545 8.09446 13.7055 9.14755C13.4566 10.2007 12.8716 11.1442 12.0391 11.8356C11.2066 12.527 10.1717 12.9286 9.09074 12.9798C8.00976 13.0311 6.94159 12.7291 6.04744 12.1196C5.90552 12.0236 5.73709 11.9743 5.56577 11.9785C5.39446 11.9829 5.22881 12.0406 5.09179 12.1435C4.87645 12.3048 4.7525 12.5603 4.75908 12.8293C4.76557 13.0982 4.90193 13.3473 5.12487 13.4978C6.23041 14.2481 7.53644 14.6477 8.8725 14.6443C10.2086 14.641 11.5126 14.2349 12.6144 13.4791C13.7162 12.7232 14.5645 11.6528 15.0486 10.4075C15.5326 9.16219 15.6301 7.79995 15.328 6.49829C15.026 5.19664 14.3387 4.01672 13.3557 3.11161C12.3726 2.20676 11.1396 1.61923 9.81758 1.42586L9.81763 1.42547Z'
        fill={color}
      />
      <path
        d='M9.28828 4.46099H9.28819C9.07553 4.46099 8.87158 4.54544 8.72122 4.69589C8.57086 4.84625 8.48642 5.0502 8.48642 5.26285V7.82179L6.41717 9.34113C6.18626 9.51068 6.06334 9.79055 6.09466 10.0753C6.12609 10.36 6.30704 10.6064 6.56929 10.7216C6.83164 10.8368 7.1354 10.8033 7.36633 10.6337L10.079 8.64189H10.0902L10.0901 5.2628C10.0902 5.05015 10.0056 4.8462 9.85526 4.69584C9.7049 4.54539 9.50096 4.46094 9.2883 4.46094L9.28828 4.46099Z'
        fill={color}
      />
    </svg>
  );
};

export const SuccessCheckMarkIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <g clip-path='url(#clip0_3709_12973)'>
          <path
            d='M6.99935 1.16602C3.77935 1.16602 1.16602 3.77935 1.16602 6.99935C1.16602 10.2193 3.77935 12.8327 6.99935 12.8327C10.2193 12.8327 12.8327 10.2193 12.8327 6.99935C12.8327 3.77935 10.2193 1.16602 6.99935 1.16602ZM5.83268 9.91602L2.91602 6.99935L3.73852 6.17685L5.83268 8.26518L10.2602 3.83768L11.0827 4.66602L5.83268 9.91602Z'
            fill={color}
          />
        </g>
        <defs>
          <clipPath id='clip0_3709_12973'>
            <rect width='14' height='14' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <g clip-path='url(#clip0_3709_12971)'>
          <path
            d='M8.00065 1.33398C4.32065 1.33398 1.33398 4.32065 1.33398 8.00065C1.33398 11.6807 4.32065 14.6673 8.00065 14.6673C11.6807 14.6673 14.6673 11.6807 14.6673 8.00065C14.6673 4.32065 11.6807 1.33398 8.00065 1.33398ZM6.66732 11.334L3.33398 8.00065L4.27398 7.06065L6.66732 9.44732L11.7273 4.38732L12.6673 5.33398L6.66732 11.334Z'
            fill={color}
          />
        </g>
        <defs>
          <clipPath id='clip0_3709_12971'>
            <rect width='16' height='16' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <g clip-path='url(#clip0_3709_12971)'>
        <path
          d='M8.00065 1.33398C4.32065 1.33398 1.33398 4.32065 1.33398 8.00065C1.33398 11.6807 4.32065 14.6673 8.00065 14.6673C11.6807 14.6673 14.6673 11.6807 14.6673 8.00065C14.6673 4.32065 11.6807 1.33398 8.00065 1.33398ZM6.66732 11.334L3.33398 8.00065L4.27398 7.06065L6.66732 9.44732L11.7273 4.38732L12.6673 5.33398L6.66732 11.334Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_3709_12971'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SyncIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.6483 6.02353C12.6441 6.03279 12.6398 6.04207 12.6359 6.0515C12.6319 6.06127 12.6287 6.07147 12.6256 6.08163C12.6205 6.09817 12.6154 6.11463 12.6067 6.12908C12.5895 6.15768 12.5669 6.18168 12.5443 6.20577C12.5378 6.21264 12.5314 6.21951 12.525 6.2265C12.518 6.2338 12.5117 6.24181 12.5055 6.24982C12.4968 6.26099 12.4881 6.27215 12.4772 6.28133C12.4445 6.30801 12.4068 6.32656 12.3692 6.34504C12.3665 6.34636 12.3638 6.34768 12.3611 6.349C12.3532 6.35286 12.3456 6.35771 12.338 6.36257C12.3273 6.36947 12.3165 6.37639 12.3045 6.3805C12.2415 6.40383 12.1745 6.41667 12.105 6.41667C12.0735 6.41667 12.0409 6.41433 12.0088 6.4085L9.52962 5.99725C9.21171 5.94475 8.99704 5.64433 9.04954 5.32642C9.10204 5.00908 9.40187 4.7915 9.72037 4.84692L10.6794 5.00558C9.95312 3.73042 8.56654 2.91667 7.04054 2.91667C5.31446 2.91667 3.7937 3.91883 3.16546 5.46875C3.07387 5.69625 2.85512 5.83333 2.62471 5.83333C2.55179 5.83333 2.47771 5.81992 2.40596 5.79075C2.10729 5.67 1.96321 5.32992 2.08454 5.03125C2.89187 3.038 4.83729 1.75 7.04054 1.75C9.03087 1.75 10.8398 2.84083 11.7527 4.543L11.968 3.39208C12.0275 3.07592 12.3331 2.8665 12.6487 2.92717C12.9655 2.98608 13.1743 3.29117 13.1148 3.60792L12.6779 5.94125C12.6723 5.971 12.6603 5.99725 12.6483 6.02353ZM10.8345 8.53137C10.9552 8.23212 11.2959 8.08862 11.594 8.20937C11.8926 8.33012 12.0367 8.6702 11.9154 8.96887C11.1081 10.9621 9.16265 12.2501 6.9594 12.2501C4.96906 12.2501 3.16015 11.1593 2.24723 9.45712L2.0314 10.6074C1.97948 10.888 1.73448 11.0835 1.45856 11.0835C1.42298 11.0835 1.38681 11.08 1.35065 11.073C1.0339 11.014 0.825647 10.709 0.885147 10.3922L1.32206 8.05887C1.3265 8.03596 1.33632 8.01562 1.34618 7.99519C1.35189 7.98337 1.35761 7.97152 1.36231 7.95912C1.36693 7.94749 1.37095 7.93546 1.37499 7.92341C1.38371 7.89736 1.39247 7.8712 1.40723 7.84887C1.41584 7.83559 1.4271 7.82497 1.43842 7.81428C1.44551 7.80758 1.45263 7.80086 1.45915 7.79345C1.46428 7.7875 1.46937 7.78151 1.47444 7.77553C1.5022 7.74281 1.52971 7.71037 1.56473 7.6867C1.56817 7.6842 1.57228 7.6827 1.57634 7.68123C1.57986 7.67995 1.58334 7.67868 1.58631 7.67678C1.6429 7.64003 1.70356 7.61145 1.77065 7.59687C1.77473 7.59592 1.77899 7.59617 1.78323 7.59641C1.78686 7.59662 1.79048 7.59682 1.79398 7.59628C1.85815 7.58578 1.9229 7.57937 1.99115 7.59103L4.47031 8.00287C4.78823 8.05478 5.0029 8.35578 4.9504 8.6737C4.90315 8.95895 4.65581 9.16137 4.37523 9.16137C4.34373 9.16137 4.31165 9.15903 4.27956 9.1532L3.32056 8.99453C4.04681 10.2697 5.4334 11.0835 6.9594 11.0835C8.68548 11.0835 10.2062 10.0813 10.8345 8.53137Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.4552 6.88403C14.4504 6.89462 14.4455 6.90522 14.441 6.916C14.4364 6.92717 14.4328 6.93882 14.4292 6.95044C14.4234 6.96934 14.4176 6.98815 14.4077 7.00467C14.3879 7.03735 14.3622 7.06479 14.3363 7.09231C14.329 7.10016 14.3216 7.10801 14.3143 7.116C14.3063 7.12434 14.2991 7.1335 14.292 7.14265C14.282 7.15542 14.2721 7.16818 14.2597 7.17867C14.2223 7.20916 14.1792 7.23036 14.1362 7.25148C14.1331 7.25299 14.1301 7.25449 14.127 7.256C14.1179 7.26041 14.1093 7.26595 14.1006 7.27151C14.0883 7.2794 14.076 7.28731 14.0623 7.292C13.9903 7.31867 13.9137 7.33333 13.8343 7.33333C13.7983 7.33333 13.761 7.33067 13.7243 7.324L10.891 6.854C10.5277 6.794 10.2823 6.45067 10.3423 6.08733C10.4023 5.72467 10.745 5.476 11.109 5.53933L12.205 5.72067C11.375 4.26333 9.79033 3.33333 8.04633 3.33333C6.07366 3.33333 4.33566 4.47867 3.61766 6.25C3.513 6.51 3.263 6.66667 2.99966 6.66667C2.91633 6.66667 2.83166 6.65133 2.74966 6.618C2.40833 6.48 2.24366 6.09133 2.38233 5.75C3.305 3.472 5.52833 2 8.04633 2C10.321 2 12.3883 3.24667 13.4317 5.192L13.6777 3.87667C13.7457 3.51533 14.095 3.276 14.4557 3.34533C14.8177 3.41267 15.0563 3.76133 14.9883 4.12333L14.489 6.79C14.4826 6.824 14.4689 6.854 14.4552 6.88403ZM12.3823 9.75013C12.5203 9.40813 12.9096 9.24413 13.2503 9.38213C13.5916 9.52013 13.7563 9.9088 13.6176 10.2501C12.6949 12.5281 10.4716 14.0001 7.9536 14.0001C5.67893 14.0001 3.6116 12.7535 2.56826 10.8081L2.3216 12.1228C2.26226 12.4435 1.98226 12.6668 1.66693 12.6668C1.62626 12.6668 1.58493 12.6628 1.5436 12.6548C1.1816 12.5875 0.943596 12.2388 1.0116 11.8768L1.51093 9.21013C1.516 9.18395 1.52722 9.16071 1.53849 9.13736C1.54501 9.12385 1.55155 9.11031 1.55693 9.09613C1.5622 9.08285 1.5668 9.0691 1.57142 9.05533C1.58139 9.02555 1.5914 8.99566 1.60826 8.97013C1.6181 8.95497 1.63097 8.94282 1.64391 8.9306C1.65202 8.92295 1.66015 8.91527 1.6676 8.9068C1.67347 8.9 1.67927 8.89316 1.68507 8.88632C1.7168 8.84892 1.74824 8.81186 1.78826 8.7848C1.79219 8.78194 1.79689 8.78023 1.80153 8.77854C1.80555 8.77708 1.80953 8.77563 1.81293 8.77347C1.8776 8.73147 1.94693 8.6988 2.0236 8.68213C2.02827 8.68106 2.03313 8.68133 2.03798 8.68161C2.04213 8.68185 2.04627 8.68208 2.05026 8.68147C2.1236 8.66947 2.1976 8.66213 2.2756 8.67547L5.10893 9.14613C5.47226 9.20547 5.7176 9.54947 5.6576 9.9128C5.6036 10.2388 5.32093 10.4701 5.00026 10.4701C4.96426 10.4701 4.9276 10.4675 4.89093 10.4608L3.79493 10.2795C4.62493 11.7368 6.2096 12.6668 7.9536 12.6668C9.92626 12.6668 11.6643 11.5215 12.3823 9.75013Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.4552 6.88403C14.4504 6.89462 14.4455 6.90522 14.441 6.916C14.4364 6.92717 14.4328 6.93882 14.4292 6.95044C14.4234 6.96934 14.4176 6.98815 14.4077 7.00467C14.3879 7.03735 14.3622 7.06479 14.3363 7.09231C14.329 7.10016 14.3216 7.10801 14.3143 7.116C14.3063 7.12434 14.2991 7.1335 14.292 7.14265C14.282 7.15542 14.2721 7.16818 14.2597 7.17867C14.2223 7.20916 14.1792 7.23036 14.1362 7.25148C14.1331 7.25299 14.1301 7.25449 14.127 7.256C14.1179 7.26041 14.1093 7.26595 14.1006 7.27151C14.0883 7.2794 14.076 7.28731 14.0623 7.292C13.9903 7.31867 13.9137 7.33333 13.8343 7.33333C13.7983 7.33333 13.761 7.33067 13.7243 7.324L10.891 6.854C10.5277 6.794 10.2823 6.45067 10.3423 6.08733C10.4023 5.72467 10.745 5.476 11.109 5.53933L12.205 5.72067C11.375 4.26333 9.79033 3.33333 8.04633 3.33333C6.07366 3.33333 4.33566 4.47867 3.61766 6.25C3.513 6.51 3.263 6.66667 2.99966 6.66667C2.91633 6.66667 2.83166 6.65133 2.74966 6.618C2.40833 6.48 2.24366 6.09133 2.38233 5.75C3.305 3.472 5.52833 2 8.04633 2C10.321 2 12.3883 3.24667 13.4317 5.192L13.6777 3.87667C13.7457 3.51533 14.095 3.276 14.4557 3.34533C14.8177 3.41267 15.0563 3.76133 14.9883 4.12333L14.489 6.79C14.4826 6.824 14.4689 6.854 14.4552 6.88403ZM12.3823 9.75013C12.5203 9.40813 12.9096 9.24413 13.2503 9.38213C13.5916 9.52013 13.7563 9.9088 13.6176 10.2501C12.6949 12.5281 10.4716 14.0001 7.9536 14.0001C5.67893 14.0001 3.6116 12.7535 2.56826 10.8081L2.3216 12.1228C2.26226 12.4435 1.98226 12.6668 1.66693 12.6668C1.62626 12.6668 1.58493 12.6628 1.5436 12.6548C1.1816 12.5875 0.943596 12.2388 1.0116 11.8768L1.51093 9.21013C1.516 9.18395 1.52722 9.16071 1.53849 9.13736C1.54501 9.12385 1.55155 9.11031 1.55693 9.09613C1.5622 9.08285 1.5668 9.0691 1.57142 9.05533C1.58139 9.02555 1.5914 8.99566 1.60826 8.97013C1.6181 8.95497 1.63097 8.94282 1.64391 8.9306C1.65202 8.92295 1.66015 8.91527 1.6676 8.9068C1.67347 8.9 1.67927 8.89316 1.68507 8.88632C1.7168 8.84892 1.74824 8.81186 1.78826 8.7848C1.79219 8.78194 1.79689 8.78023 1.80153 8.77854C1.80555 8.77708 1.80953 8.77563 1.81293 8.77347C1.8776 8.73147 1.94693 8.6988 2.0236 8.68213C2.02827 8.68106 2.03313 8.68133 2.03798 8.68161C2.04213 8.68185 2.04627 8.68208 2.05026 8.68147C2.1236 8.66947 2.1976 8.66213 2.2756 8.67547L5.10893 9.14613C5.47226 9.20547 5.7176 9.54947 5.6576 9.9128C5.6036 10.2388 5.32093 10.4701 5.00026 10.4701C4.96426 10.4701 4.9276 10.4675 4.89093 10.4608L3.79493 10.2795C4.62493 11.7368 6.2096 12.6668 7.9536 12.6668C9.92626 12.6668 11.6643 11.5215 12.3823 9.75013Z'
        fill={color}
      />
    </svg>
  );
};

export const UnavailableIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (large) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        style={style}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M15 9C15 7.6155 14.5238 6.3435 13.734 5.32725L5.32725 13.734C6.3435 14.5245 7.6155 15 9 15C12.3082 15 15 12.3083 15 9ZM3 9C3 10.3845 3.47625 11.6565 4.266 12.6728L12.6727 4.266C11.6565 3.4755 10.3845 3 9 3C5.69175 3 3 5.69175 3 9ZM9 1.5C13.1355 1.5 16.5 4.8645 16.5 9C16.5 13.1355 13.1355 16.5 9 16.5C4.8645 16.5 1.5 13.1355 1.5 9C1.5 4.8645 4.8645 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }
  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.6668 6.99996C11.6668 5.92313 11.2964 4.93379 10.6822 4.14338L4.14358 10.682C4.934 11.2968 5.92333 11.6666 7.00016 11.6666C9.57325 11.6666 11.6668 9.57304 11.6668 6.99996ZM2.3335 6.99996C2.3335 8.07679 2.70391 9.06613 3.31816 9.85654L9.85675 3.31796C9.06633 2.70313 8.077 2.33329 7.00016 2.33329C4.42708 2.33329 2.3335 4.42688 2.3335 6.99996ZM7.00016 1.16663C10.2167 1.16663 12.8335 3.78346 12.8335 6.99996C12.8335 10.2165 10.2167 12.8333 7.00016 12.8333C3.78366 12.8333 1.16683 10.2165 1.16683 6.99996C1.16683 3.78346 3.78366 1.16663 7.00016 1.16663Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.3332 8.00004C13.3332 6.76937 12.9098 5.63871 12.2078 4.73537L4.73517 12.208C5.6385 12.9107 6.76917 13.3334 7.99984 13.3334C10.9405 13.3334 13.3332 10.9407 13.3332 8.00004ZM2.6665 8.00004C2.6665 9.23071 3.08984 10.3614 3.79184 11.2647L11.2645 3.79204C10.3612 3.08937 9.2305 2.66671 7.99984 2.66671C5.05917 2.66671 2.6665 5.05937 2.6665 8.00004ZM7.99984 1.33337C11.6758 1.33337 14.6665 4.32404 14.6665 8.00004C14.6665 11.676 11.6758 14.6667 7.99984 14.6667C4.32384 14.6667 1.33317 11.676 1.33317 8.00004C1.33317 4.32404 4.32384 1.33337 7.99984 1.33337Z'
        fill={color}
      />
    </svg>
  );
};

export const VectorIcon = ({ color, small, large, style, className }: IIconProps) => {
  if (large) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        style={style}
        className={className}
      >
        <path
          d='M12.7499 15.5H3.25006C2.5206 15.5 1.82115 15.2195 1.30548 14.7205C0.78964 14.2213 0.5 13.5444 0.5 12.8387V3.16135C0.5 2.45559 0.789654 1.7787 1.30548 1.2795C1.82115 0.780469 2.5206 0.5 3.25006 0.5H12.7499C13.4794 0.5 14.1789 0.780478 14.6945 1.2795C15.2104 1.7787 15.5 2.45559 15.5 3.16135V12.8387C15.5 13.5444 15.2103 14.2213 14.6945 14.7205C14.1789 15.2195 13.4794 15.5 12.7499 15.5ZM9.49994 14.0483L9.50011 1.95168H6.50001V14.0483H9.49994ZM2.00003 3.16135V12.8387C2.00003 13.1595 2.13169 13.4671 2.36606 13.6941C2.60043 13.9209 2.91851 14.0483 3.25002 14.0483H4.99996V1.95169H3.25002C2.91852 1.95169 2.60043 2.0791 2.36606 2.30592C2.13169 2.5329 2.00003 2.84054 2.00003 3.16136V3.16135ZM13.9999 3.16135C13.9999 2.84053 13.8682 2.53288 13.6339 2.3059C13.3995 2.07909 13.0814 1.95167 12.7499 1.95167H11V14.0483H12.7499C13.0814 14.0483 13.3995 13.9209 13.6339 13.6941C13.8682 13.4671 13.9999 13.1595 13.9999 12.8386V3.16135Z'
          fill={color}
        />
      </svg>
    );
  }

  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        style={style}
        className={className}
      >
        <path
          d='M9.79995 12H2.20005C1.61648 12 1.05692 11.7756 0.644385 11.3764C0.231712 10.977 0 10.4355 0 9.87092V2.12908C0 1.56447 0.231723 1.02296 0.644385 0.623599C1.05692 0.224375 1.61648 0 2.20005 0H9.79995C10.3835 0 10.9431 0.224382 11.3556 0.623599C11.7683 1.02296 12 1.56447 12 2.12908V9.87092C12 10.4355 11.7683 10.977 11.3556 11.3764C10.9431 11.7756 10.3835 12 9.79995 12ZM7.19995 10.8387L7.20009 1.16135H4.80001V10.8387H7.19995ZM1.20002 2.12908V9.87092C1.20002 10.1276 1.30535 10.3737 1.49285 10.5553C1.68034 10.7367 1.93481 10.8387 2.20002 10.8387H3.59996V1.16135H2.20002C1.93481 1.16135 1.68034 1.26328 1.49285 1.44473C1.30535 1.62632 1.20002 1.87243 1.20002 2.12909V2.12908ZM10.7999 2.12908C10.7999 1.87243 10.6946 1.62631 10.5071 1.44472C10.3196 1.26327 10.0651 1.16134 9.79991 1.16134H8.39996V10.8386H9.79991C10.0651 10.8386 10.3196 10.7367 10.5071 10.5553C10.6946 10.3737 10.7999 10.1276 10.7999 9.87091V2.12908Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      style={style}
      className={className}
    >
      <path
        d='M11.4333 14H2.56672C1.8859 14 1.23307 13.7382 0.751784 13.2725C0.270331 12.8065 0 12.1748 0 11.5161V2.48392C0 1.82522 0.270344 1.19345 0.751784 0.727532C1.23307 0.261771 1.8859 0 2.56672 0H11.4333C12.1141 0 12.7669 0.261779 13.2482 0.727532C13.7297 1.19345 14 1.82522 14 2.48392V11.5161C14 12.1748 13.7297 12.8065 13.2482 13.2725C12.7669 13.7382 12.1141 14 11.4333 14ZM8.39994 12.6451L8.4001 1.3549H5.60001V12.6451H8.39994ZM1.40003 2.48392V11.5161C1.40003 11.8155 1.52291 12.1026 1.74166 12.3145C1.9604 12.5262 2.25728 12.6451 2.56669 12.6451H4.19996V1.35491H2.56669C2.25728 1.35491 1.9604 1.47383 1.74166 1.68552C1.52291 1.89737 1.40003 2.18451 1.40003 2.48394V2.48392ZM12.5999 2.48392C12.5999 2.1845 12.477 1.89736 12.2583 1.6855C12.0395 1.47381 11.7426 1.3549 11.4332 1.3549H9.79996V12.6451H11.4332C11.7426 12.6451 12.0395 12.5262 12.2583 12.3145C12.477 12.1026 12.5999 11.8155 12.5999 11.5161V2.48392Z'
        fill={color}
      />
    </svg>
  );
};

export const VennIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.68433 4.43591C4.33012 4.43591 3.22827 5.58623 3.22827 7C3.22827 8.41377 4.33012 9.56408 5.68433 9.56408C7.03854 9.56408 8.14039 8.41377 8.14039 7C8.14039 5.58623 7.03854 4.43591 5.68433 4.43591ZM5.68433 10.2051C3.99149 10.2051 2.61426 8.76729 2.61426 7C2.61426 5.2327 3.99149 3.79489 5.68433 3.79489C7.37717 3.79489 8.75441 5.2327 8.75441 7C8.75441 8.76729 7.37717 10.2051 5.68433 10.2051Z'
          fill={color}
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.31617 4.43591C6.96196 4.43591 5.86011 5.58623 5.86011 7C5.86011 8.41377 6.96196 9.56408 8.31617 9.56408C9.67038 9.56408 10.7722 8.41377 10.7722 7C10.7722 5.58623 9.67038 4.43591 8.31617 4.43591ZM8.31617 10.2051C6.62333 10.2051 5.24609 8.76729 5.24609 7C5.24609 5.2327 6.62333 3.79489 8.31617 3.79489C10.009 3.79489 11.3862 5.2327 11.3862 7C11.3862 8.76729 10.009 10.2051 8.31617 10.2051Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.94707 5C4.83448 5 3.11559 6.7945 3.11559 9C3.11559 11.2055 4.83448 13 6.94707 13C9.05965 13 10.7785 11.2055 10.7785 9C10.7785 6.7945 9.05965 5 6.94707 5ZM6.94707 14C4.30622 14 2.15771 11.757 2.15771 9C2.15771 6.243 4.30622 4 6.94707 4C9.58791 4 11.7364 6.243 11.7364 9C11.7364 11.757 9.58791 14 6.94707 14Z'
          fill={color}
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.0525 5C8.93995 5 7.22105 6.7945 7.22105 9C7.22105 11.2055 8.93995 13 11.0525 13C13.1651 13 14.884 11.2055 14.884 9C14.884 6.7945 13.1651 5 11.0525 5ZM11.0525 14C8.41169 14 6.26318 11.757 6.26318 9C6.26318 6.243 8.41169 4 11.0525 4C13.6934 4 15.8419 6.243 15.8419 9C15.8419 11.757 13.6934 14 11.0525 14Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.28944 4.66669C4.52896 4.66669 3.09656 6.16209 3.09656 8C3.09656 9.8379 4.52896 11.3333 6.28944 11.3333C8.04991 11.3333 9.48232 9.8379 9.48232 8C9.48232 6.16209 8.04991 4.66669 6.28944 4.66669ZM6.28944 12.1666C4.08875 12.1666 2.29834 10.2975 2.29834 8C2.29834 5.70251 4.08875 3.83336 6.28944 3.83336C8.49013 3.83336 10.2805 5.70251 10.2805 8C10.2805 10.2975 8.49013 12.1666 6.28944 12.1666Z'
        fill={color}
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.71082 4.66669C7.95035 4.66669 6.51795 6.16209 6.51795 8C6.51795 9.8379 7.95035 11.3333 9.71082 11.3333C11.4713 11.3333 12.9037 9.8379 12.9037 8C12.9037 6.16209 11.4713 4.66669 9.71082 4.66669ZM9.71082 12.1666C7.51013 12.1666 5.71973 10.2975 5.71973 8C5.71973 5.70251 7.51013 3.83336 9.71082 3.83336C11.9115 3.83336 13.7019 5.70251 13.7019 8C13.7019 10.2975 11.9115 12.1666 9.71082 12.1666Z'
        fill={color}
      />
    </svg>
  );
};

export const PersonesIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.8337 11.0833C12.8337 11.4053 12.5729 11.6667 12.2503 11.6667C11.9277 11.6667 11.667 11.4053 11.667 11.0833C11.667 10.1185 10.8818 9.33333 9.91699 9.33333C9.51858 9.33333 9.13999 9.46983 8.83433 9.71192C9.15166 10.2929 9.33366 10.9591 9.33366 11.6667C9.33366 11.9887 9.07291 12.25 8.75033 12.25C8.42774 12.25 8.16699 11.9887 8.16699 11.6667C8.16699 10.0584 6.85858 8.75 5.25033 8.75C3.64208 8.75 2.33366 10.0584 2.33366 11.6667C2.33366 11.9887 2.07291 12.25 1.75033 12.25C1.42774 12.25 1.16699 11.9887 1.16699 11.6667C1.16699 9.415 2.99924 7.58333 5.25033 7.58333C6.37441 7.58333 7.39291 8.04008 8.13199 8.77683C8.63891 8.38483 9.26307 8.16667 9.91699 8.16667C11.5252 8.16667 12.8337 9.47508 12.8337 11.0833ZM9.91699 5.25C10.239 5.25 10.5003 5.51192 10.5003 5.83333C10.5003 6.15475 10.239 6.41667 9.91699 6.41667C9.59499 6.41667 9.33366 6.15475 9.33366 5.83333C9.33366 5.51192 9.59499 5.25 9.91699 5.25ZM9.91699 7.58333C10.8818 7.58333 11.667 6.79817 11.667 5.83333C11.667 4.8685 10.8818 4.08333 9.91699 4.08333C8.95216 4.08333 8.16699 4.8685 8.16699 5.83333C8.16699 6.79817 8.95216 7.58333 9.91699 7.58333ZM5.25033 2.91667C5.89374 2.91667 6.41699 3.43992 6.41699 4.08333C6.41699 4.72675 5.89374 5.25 5.25033 5.25C4.60691 5.25 4.08366 4.72675 4.08366 4.08333C4.08366 3.43992 4.60691 2.91667 5.25033 2.91667ZM5.25033 6.41667C6.53716 6.41667 7.58366 5.37017 7.58366 4.08333C7.58366 2.7965 6.53716 1.75 5.25033 1.75C3.96349 1.75 2.91699 2.7965 2.91699 4.08333C2.91699 5.37017 3.96349 6.41667 5.25033 6.41667Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M16.5 14.25C16.5 14.664 16.1648 15 15.75 15C15.3352 15 15 14.664 15 14.25C15 13.0095 13.9905 12 12.75 12C12.2378 12 11.751 12.1755 11.358 12.4867C11.766 13.2338 12 14.0903 12 15C12 15.414 11.6648 15.75 11.25 15.75C10.8352 15.75 10.5 15.414 10.5 15C10.5 12.9323 8.81775 11.25 6.75 11.25C4.68225 11.25 3 12.9323 3 15C3 15.414 2.66475 15.75 2.25 15.75C1.83525 15.75 1.5 15.414 1.5 15C1.5 12.105 3.85575 9.75 6.75 9.75C8.19525 9.75 9.50475 10.3372 10.455 11.2845C11.1067 10.7805 11.9093 10.5 12.75 10.5C14.8177 10.5 16.5 12.1823 16.5 14.25ZM12.75 6.75C13.164 6.75 13.5 7.08675 13.5 7.5C13.5 7.91325 13.164 8.25 12.75 8.25C12.336 8.25 12 7.91325 12 7.5C12 7.08675 12.336 6.75 12.75 6.75ZM12.75 9.75C13.9905 9.75 15 8.7405 15 7.5C15 6.2595 13.9905 5.25 12.75 5.25C11.5095 5.25 10.5 6.2595 10.5 7.5C10.5 8.7405 11.5095 9.75 12.75 9.75ZM6.75 3.75C7.57725 3.75 8.25 4.42275 8.25 5.25C8.25 6.07725 7.57725 6.75 6.75 6.75C5.92275 6.75 5.25 6.07725 5.25 5.25C5.25 4.42275 5.92275 3.75 6.75 3.75ZM6.75 8.25C8.4045 8.25 9.75 6.9045 9.75 5.25C9.75 3.5955 8.4045 2.25 6.75 2.25C5.0955 2.25 3.75 3.5955 3.75 5.25C3.75 6.9045 5.0955 8.25 6.75 8.25Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.6663 12.6667C14.6663 13.0347 14.3683 13.3333 13.9997 13.3333C13.631 13.3333 13.333 13.0347 13.333 12.6667C13.333 11.564 12.4357 10.6667 11.333 10.6667C10.8777 10.6667 10.445 10.8227 10.0957 11.0993C10.4583 11.7633 10.6663 12.5247 10.6663 13.3333C10.6663 13.7013 10.3683 14 9.99967 14C9.63101 14 9.33301 13.7013 9.33301 13.3333C9.33301 11.4953 7.83767 10 5.99967 10C4.16167 10 2.66634 11.4953 2.66634 13.3333C2.66634 13.7013 2.36834 14 1.99967 14C1.63101 14 1.33301 13.7013 1.33301 13.3333C1.33301 10.76 3.42701 8.66667 5.99967 8.66667C7.28434 8.66667 8.44834 9.18867 9.29301 10.0307C9.87234 9.58267 10.5857 9.33333 11.333 9.33333C13.171 9.33333 14.6663 10.8287 14.6663 12.6667ZM11.333 6C11.701 6 11.9997 6.29933 11.9997 6.66667C11.9997 7.034 11.701 7.33333 11.333 7.33333C10.965 7.33333 10.6663 7.034 10.6663 6.66667C10.6663 6.29933 10.965 6 11.333 6ZM11.333 8.66667C12.4357 8.66667 13.333 7.76933 13.333 6.66667C13.333 5.564 12.4357 4.66667 11.333 4.66667C10.2303 4.66667 9.33301 5.564 9.33301 6.66667C9.33301 7.76933 10.2303 8.66667 11.333 8.66667ZM5.99967 3.33333C6.73501 3.33333 7.33301 3.93133 7.33301 4.66667C7.33301 5.402 6.73501 6 5.99967 6C5.26434 6 4.66634 5.402 4.66634 4.66667C4.66634 3.93133 5.26434 3.33333 5.99967 3.33333ZM5.99967 7.33333C7.47034 7.33333 8.66634 6.13733 8.66634 4.66667C8.66634 3.196 7.47034 2 5.99967 2C4.52901 2 3.33301 3.196 3.33301 4.66667C3.33301 6.13733 4.52901 7.33333 5.99967 7.33333Z'
        fill={color}
      />
    </svg>
  );
};

export const ManualOverrideIcon = ({ large, small }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.83333 7.58333C3.58225 7.58333 1.75 9.415 1.75 11.6667C1.75 11.9887 2.01075 12.25 2.33333 12.25C2.65592 12.25 2.91667 11.9887 2.91667 11.6667C2.91667 10.0584 4.22508 8.75 5.83333 8.75C7.44158 8.75 8.75 10.0584 8.75 11.6667C8.75 11.9887 9.01075 12.25 9.33333 12.25C9.65592 12.25 9.91667 11.9887 9.91667 11.6667C9.91667 9.415 8.08442 7.58333 5.83333 7.58333ZM4.66667 4.08333C4.66667 4.72675 5.18992 5.25 5.83333 5.25C6.47675 5.25 7 4.72675 7 4.08333C7 3.43992 6.47675 2.91667 5.83333 2.91667C5.18992 2.91667 4.66667 3.43992 4.66667 4.08333ZM3.5 4.08333C3.5 2.7965 4.5465 1.75 5.83333 1.75C7.12017 1.75 8.16667 2.7965 8.16667 4.08333C8.16667 5.37017 7.12017 6.41667 5.83333 6.41667C4.5465 6.41667 3.5 5.37017 3.5 4.08333ZM12.6904 3.29933L11.1679 5.04933C11.0577 5.17592 10.899 5.24883 10.731 5.25H10.7275C10.5612 5.25 10.4032 5.17942 10.2929 5.05575L9.48208 4.14983C9.26742 3.9095 9.28783 3.54083 9.52758 3.32617C9.7685 3.11092 10.1372 3.13133 10.3512 3.37167L10.7211 3.78525L11.8096 2.534C12.0213 2.29017 12.3894 2.26508 12.6327 2.47683C12.8759 2.688 12.9016 3.05667 12.6904 3.29933Z'
          fill='black'
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.5 9.75C4.60575 9.75 2.25 12.105 2.25 15C2.25 15.414 2.58525 15.75 3 15.75C3.41475 15.75 3.75 15.414 3.75 15C3.75 12.9323 5.43225 11.25 7.5 11.25C9.56775 11.25 11.25 12.9323 11.25 15C11.25 15.414 11.5852 15.75 12 15.75C12.4148 15.75 12.75 15.414 12.75 15C12.75 12.105 10.3942 9.75 7.5 9.75ZM6 5.25C6 6.07725 6.67275 6.75 7.5 6.75C8.32725 6.75 9 6.07725 9 5.25C9 4.42275 8.32725 3.75 7.5 3.75C6.67275 3.75 6 4.42275 6 5.25ZM4.5 5.25C4.5 3.5955 5.8455 2.25 7.5 2.25C9.1545 2.25 10.5 3.5955 10.5 5.25C10.5 6.9045 9.1545 8.25 7.5 8.25C5.8455 8.25 4.5 6.9045 4.5 5.25ZM16.3162 4.242L14.3587 6.492C14.217 6.65475 14.013 6.7485 13.797 6.75H13.7925C13.5787 6.75 13.3755 6.65925 13.2337 6.50025L12.1912 5.3355C11.9152 5.0265 11.9415 4.5525 12.2498 4.2765C12.5595 3.99975 13.0335 4.026 13.3088 4.335L13.7842 4.86675L15.1837 3.258C15.456 2.9445 15.9292 2.91225 16.242 3.1845C16.5547 3.456 16.5877 3.93 16.3162 4.242Z'
          fill='black'
        />
      </svg>
    );
  }

  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.66667 8.66667C4.094 8.66667 2 10.76 2 13.3333C2 13.7013 2.298 14 2.66667 14C3.03533 14 3.33333 13.7013 3.33333 13.3333C3.33333 11.4953 4.82867 10 6.66667 10C8.50467 10 10 11.4953 10 13.3333C10 13.7013 10.298 14 10.6667 14C11.0353 14 11.3333 13.7013 11.3333 13.3333C11.3333 10.76 9.23933 8.66667 6.66667 8.66667ZM5.33333 4.66667C5.33333 5.402 5.93133 6 6.66667 6C7.402 6 8 5.402 8 4.66667C8 3.93133 7.402 3.33333 6.66667 3.33333C5.93133 3.33333 5.33333 3.93133 5.33333 4.66667ZM4 4.66667C4 3.196 5.196 2 6.66667 2C8.13733 2 9.33333 3.196 9.33333 4.66667C9.33333 6.13733 8.13733 7.33333 6.66667 7.33333C5.196 7.33333 4 6.13733 4 4.66667ZM14.5033 3.77067L12.7633 5.77067C12.6373 5.91533 12.456 5.99867 12.264 6H12.26C12.07 6 11.8893 5.91933 11.7633 5.778L10.8367 4.74267C10.5913 4.468 10.6147 4.04667 10.8887 3.80133C11.164 3.55533 11.5853 3.57867 11.83 3.85333L12.2527 4.326L13.4967 2.896C13.7387 2.61733 14.1593 2.58867 14.4373 2.83067C14.7153 3.072 14.7447 3.49333 14.5033 3.77067Z'
        fill='black'
      />
    </svg>
  );
};

export const MessageIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.08378 6.41628C4.08378 6.09428 4.34511 5.83295 4.66711 5.83295C4.98911 5.83295 5.25044 6.09428 5.25044 6.41628C5.25044 6.73828 4.98911 6.99962 4.66711 6.99962C4.34511 6.99962 4.08378 6.73828 4.08378 6.41628ZM7.00044 5.83295C6.67844 5.83295 6.41711 6.09428 6.41711 6.41628C6.41711 6.73828 6.67844 6.99962 7.00044 6.99962C7.32244 6.99962 7.58378 6.73828 7.58378 6.41628C7.58378 6.09428 7.32244 5.83295 7.00044 5.83295ZM9.33378 5.83295C9.01178 5.83295 8.75044 6.09428 8.75044 6.41628C8.75044 6.73828 9.01178 6.99962 9.33378 6.99962C9.65578 6.99962 9.91711 6.73828 9.91711 6.41628C9.91711 6.09428 9.65578 5.83295 9.33378 5.83295ZM11.6078 7.17164C11.3121 9.06981 9.78201 10.6442 7.88676 10.9995C6.97151 11.1721 6.03934 11.0736 5.19351 10.7154C4.95376 10.6139 4.70584 10.5626 4.46259 10.5626C4.35176 10.5626 4.24209 10.5731 4.13418 10.5946L2.49384 10.9225L2.82226 9.27922C2.89109 8.93797 2.84909 8.57281 2.70151 8.22339C2.34334 7.37756 2.24534 6.44597 2.41743 5.53014C2.77268 3.63489 4.34651 2.10481 6.24526 1.80906C7.75609 1.57397 9.23368 2.04997 10.3 3.11631C11.3669 4.18322 11.8435 5.66139 11.6078 7.17164ZM11.1254 2.29147C9.79251 0.959141 7.94918 0.364724 6.06559 0.655807C3.68734 1.02681 1.71568 2.94247 1.27059 5.31489C1.05593 6.45706 1.17959 7.62022 1.62701 8.67781C1.68359 8.81256 1.70109 8.93797 1.67893 9.05056L1.17843 11.5519C1.13993 11.7432 1.20001 11.941 1.33826 12.0786C1.44851 12.1895 1.59726 12.2496 1.75068 12.2496C1.78859 12.2496 1.82651 12.2461 1.86501 12.2385L4.36343 11.7386C4.50693 11.7111 4.64576 11.7514 4.73851 11.7899C5.79726 12.2373 6.96043 12.3604 8.10143 12.1463C10.4744 11.7012 12.3901 9.72956 12.7611 7.35131C13.0539 5.46889 12.4583 3.62439 11.1254 2.29147Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.25015 8.24945C5.25015 7.83545 5.58615 7.49945 6.00015 7.49945C6.41415 7.49945 6.75015 7.83545 6.75015 8.24945C6.75015 8.66345 6.41415 8.99945 6.00015 8.99945C5.58615 8.99945 5.25015 8.66345 5.25015 8.24945ZM9.00015 7.49945C8.58615 7.49945 8.25015 7.83545 8.25015 8.24945C8.25015 8.66345 8.58615 8.99945 9.00015 8.99945C9.41415 8.99945 9.75015 8.66345 9.75015 8.24945C9.75015 7.83545 9.41415 7.49945 9.00015 7.49945ZM12.0002 7.49945C11.5862 7.49945 11.2502 7.83545 11.2502 8.24945C11.2502 8.66345 11.5862 8.99945 12.0002 8.99945C12.4142 8.99945 12.7502 8.66345 12.7502 8.24945C12.7502 7.83545 12.4142 7.49945 12.0002 7.49945ZM14.924 9.22063C14.5437 11.6611 12.5765 13.6854 10.1397 14.1421C8.96295 14.3641 7.76445 14.2374 6.67695 13.7769C6.3687 13.6464 6.04995 13.5804 5.7372 13.5804C5.5947 13.5804 5.4537 13.5939 5.31495 13.6216L3.20595 14.0431L3.6282 11.9304C3.7167 11.4916 3.6627 11.0221 3.47295 10.5729C3.01245 9.48538 2.88645 8.28763 3.1077 7.11013C3.56445 4.67338 5.58795 2.70613 8.0292 2.32588C9.9717 2.02363 11.8715 2.63563 13.2425 4.00663C14.6142 5.37838 15.2269 7.27888 14.924 9.22063ZM14.3037 2.94613C12.5899 1.23313 10.22 0.468878 7.7982 0.843128C4.74045 1.32013 2.20545 3.78313 1.6332 6.83338C1.3572 8.30188 1.5162 9.79738 2.09145 11.1571C2.1642 11.3304 2.1867 11.4916 2.1582 11.6364L1.5147 14.8524C1.4652 15.0984 1.54245 15.3526 1.7202 15.5296C1.86195 15.6721 2.0532 15.7494 2.25045 15.7494C2.2992 15.7494 2.34795 15.7449 2.39745 15.7351L5.6097 15.0924C5.7942 15.0571 5.9727 15.1089 6.09195 15.1584C7.4532 15.7336 8.9487 15.8919 10.4157 15.6166C13.4667 15.0444 15.9297 12.5094 16.4067 9.45163C16.7832 7.03138 16.0175 4.65988 14.3037 2.94613Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.66647 7.33281C4.66647 6.96481 4.96514 6.66614 5.33314 6.66614C5.70114 6.66614 5.99981 6.96481 5.99981 7.33281C5.99981 7.70081 5.70114 7.99947 5.33314 7.99947C4.96514 7.99947 4.66647 7.70081 4.66647 7.33281ZM7.99981 6.66614C7.63181 6.66614 7.33314 6.96481 7.33314 7.33281C7.33314 7.70081 7.63181 7.99947 7.99981 7.99947C8.36781 7.99947 8.66647 7.70081 8.66647 7.33281C8.66647 6.96481 8.36781 6.66614 7.99981 6.66614ZM10.6665 6.66614C10.2985 6.66614 9.99981 6.96481 9.99981 7.33281C9.99981 7.70081 10.2985 7.99947 10.6665 7.99947C11.0345 7.99947 11.3331 7.70081 11.3331 7.33281C11.3331 6.96481 11.0345 6.66614 10.6665 6.66614ZM13.2654 8.19607C12.9274 10.3654 11.1787 12.1647 9.01274 12.5707C7.96674 12.7681 6.90141 12.6554 5.93474 12.2461C5.66074 12.1301 5.37741 12.0714 5.09941 12.0714C4.97274 12.0714 4.84741 12.0834 4.72407 12.1081L2.84941 12.4827L3.22474 10.6047C3.30341 10.2147 3.25541 9.79741 3.08674 9.39807C2.67741 8.43141 2.56541 7.36674 2.76207 6.32007C3.16807 4.15407 4.96674 2.40541 7.13674 2.06741C8.86341 1.79874 10.5521 2.34274 11.7707 3.56141C12.9901 4.78074 13.5347 6.47007 13.2654 8.19607ZM12.7141 2.61874C11.1907 1.09607 9.08407 0.41674 6.93141 0.749407C4.21341 1.17341 1.96007 3.36274 1.45141 6.07407C1.20607 7.37941 1.34741 8.70874 1.85874 9.91741C1.92341 10.0714 1.94341 10.2147 1.91807 10.3434L1.34607 13.2021C1.30207 13.4207 1.37074 13.6467 1.52874 13.8041C1.65474 13.9307 1.82474 13.9994 2.00007 13.9994C2.04341 13.9994 2.08674 13.9954 2.13074 13.9867L4.98607 13.4154C5.15007 13.3841 5.30874 13.4301 5.41474 13.4741C6.62474 13.9854 7.95407 14.1261 9.25807 13.8814C11.9701 13.3727 14.1594 11.1194 14.5834 8.40141C14.9181 6.25007 14.2374 4.14207 12.7141 2.61874Z'
        fill={color}
      />
    </svg>
  );
};

export const RepeatIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M3.45258 2.91714H10.4502C11.6047 2.91714 12.5444 3.84055 12.5444 4.97572V6.41714C12.5444 6.73972 12.2837 7.00047 11.9611 7.00047C11.6385 7.00047 11.3777 6.73972 11.3777 6.41714V4.97572C11.3777 4.48455 10.9618 4.0838 10.4502 4.0838H3.45258L4.20683 4.83805C4.43433 5.06614 4.43433 5.4348 4.20683 5.66289C4.09308 5.77664 3.94375 5.8338 3.79442 5.8338C3.64508 5.8338 3.49575 5.77664 3.382 5.66289L1.632 3.91289C1.40392 3.6848 1.40392 3.31614 1.632 3.08805L3.382 1.33805C3.6095 1.10997 3.97875 1.10997 4.20683 1.33805C4.43433 1.56614 4.43433 1.9348 4.20683 2.16289L3.45258 2.91714ZM9.79855 8.33805C10.0266 8.10997 10.3953 8.10997 10.6234 8.33805L12.3734 10.0881C12.6015 10.3161 12.6015 10.6848 12.3734 10.9129L10.6234 12.6629C10.5096 12.7766 10.3603 12.8338 10.211 12.8338C10.0616 12.8338 9.9123 12.7766 9.79855 12.6629C9.57047 12.4348 9.57047 12.0661 9.79855 11.8381L10.5528 11.0838H3.55513C2.40013 11.0838 1.46097 10.1604 1.46097 9.02522V7.5838C1.46097 7.26122 1.7223 7.00047 2.0443 7.00047C2.3663 7.00047 2.62763 7.26122 2.62763 7.5838V9.02522C2.62763 9.51697 3.04355 9.91714 3.55513 9.91714H10.5528L9.79855 9.16289C9.57047 8.9348 9.57047 8.56614 9.79855 8.33805Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.43569 3.75019H13.4327C14.9169 3.75019 16.1252 4.93744 16.1252 6.39694V8.25019C16.1252 8.66494 15.7899 9.00019 15.3752 9.00019C14.9604 9.00019 14.6252 8.66494 14.6252 8.25019V6.39694C14.6252 5.76544 14.0904 5.25019 13.4327 5.25019H4.43569L5.40544 6.21994C5.69794 6.51319 5.69794 6.98719 5.40544 7.28044C5.25919 7.42669 5.06719 7.50019 4.87519 7.50019C4.68319 7.50019 4.49119 7.42669 4.34494 7.28044L2.09494 5.03044C1.80169 4.73719 1.80169 4.26319 2.09494 3.96994L4.34494 1.71994C4.63744 1.42669 5.11219 1.42669 5.40544 1.71994C5.69794 2.01319 5.69794 2.48719 5.40544 2.78044L4.43569 3.75019ZM12.5948 10.7199C12.888 10.4267 13.362 10.4267 13.6553 10.7199L15.9053 12.9699C16.1985 13.2632 16.1985 13.7372 15.9053 14.0304L13.6553 16.2804C13.509 16.4267 13.317 16.5002 13.125 16.5002C12.933 16.5002 12.741 16.4267 12.5948 16.2804C12.3015 15.9872 12.3015 15.5132 12.5948 15.2199L13.5645 14.2502H4.56754C3.08254 14.2502 1.87504 13.0629 1.87504 11.6034V9.75019C1.87504 9.33544 2.21104 9.00019 2.62504 9.00019C3.03904 9.00019 3.37504 9.33544 3.37504 9.75019V11.6034C3.37504 12.2357 3.90979 12.7502 4.56754 12.7502H13.5645L12.5948 11.7804C12.3015 11.4872 12.3015 11.0132 12.5948 10.7199Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.94023 3.33317H11.9376C13.2569 3.33317 14.3309 4.38851 14.3309 5.68584V7.33317C14.3309 7.70184 14.0329 7.99984 13.6642 7.99984C13.2956 7.99984 12.9976 7.70184 12.9976 7.33317V5.68584C12.9976 5.12451 12.5222 4.66651 11.9376 4.66651H3.94023L4.80223 5.52851C5.06223 5.78917 5.06223 6.21051 4.80223 6.47117C4.67223 6.60117 4.50156 6.66651 4.3309 6.66651C4.16023 6.66651 3.98956 6.60117 3.85956 6.47117L1.85956 4.47117C1.5989 4.21051 1.5989 3.78917 1.85956 3.52851L3.85956 1.52851C4.11956 1.26784 4.54156 1.26784 4.80223 1.52851C5.06223 1.78917 5.06223 2.21051 4.80223 2.47117L3.94023 3.33317ZM11.1928 9.52851C11.4534 9.26784 11.8748 9.26784 12.1354 9.52851L14.1354 11.5285C14.3961 11.7892 14.3961 12.2105 14.1354 12.4712L12.1354 14.4712C12.0054 14.6012 11.8348 14.6665 11.6641 14.6665C11.4934 14.6665 11.3228 14.6012 11.1928 14.4712C10.9321 14.2105 10.9321 13.7892 11.1928 13.5285L12.0548 12.6665H4.05743C2.73743 12.6665 1.6641 11.6112 1.6641 10.3138V8.66651C1.6641 8.29784 1.96276 7.99984 2.33076 7.99984C2.69876 7.99984 2.99743 8.29784 2.99743 8.66651V10.3138C2.99743 10.8758 3.47276 11.3332 4.05743 11.3332H12.0548L11.1928 10.4712C10.9321 10.2105 10.9321 9.78918 11.1928 9.52851Z'
        fill={color}
      />
    </svg>
  );
};

export const ShoppingIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.75 6.41667C8.42742 6.41667 8.16667 6.678 8.16667 7C8.16667 7.64342 7.64342 8.16667 7 8.16667C6.35658 8.16667 5.83333 7.64342 5.83333 7C5.83333 6.678 5.57258 6.41667 5.25 6.41667C4.92742 6.41667 4.66667 6.678 4.66667 7C4.66667 8.28683 5.71317 9.33333 7 9.33333C8.28683 9.33333 9.33333 8.28683 9.33333 7C9.33333 6.678 9.07258 6.41667 8.75 6.41667ZM10.5 11.0833H3.5C3.178 11.0833 2.91667 10.8214 2.91667 10.5V5.25H11.0833V10.5C11.0833 10.8214 10.822 11.0833 10.5 11.0833ZM4.73725 3.08758C4.84633 2.97908 4.99625 2.91667 5.14967 2.91667H8.85033C9.00375 2.91667 9.15367 2.97908 9.26275 3.08758L10.2585 4.08333H3.7415L4.73725 3.08758ZM11.7372 3.91242L10.0876 2.26275C9.75742 1.932 9.31758 1.75 8.85033 1.75H5.14967C4.68242 1.75 4.24258 1.932 3.91242 2.26275L2.26275 3.91242C1.932 4.24258 1.75 4.68242 1.75 5.15025V10.5C1.75 11.4648 2.53517 12.25 3.5 12.25H10.5C11.4648 12.25 12.25 11.4648 12.25 10.5V5.15025C12.25 4.68242 12.068 4.24258 11.7372 3.91242Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.25 8.25C10.8352 8.25 10.5 8.586 10.5 9C10.5 9.82725 9.82725 10.5 9 10.5C8.17275 10.5 7.5 9.82725 7.5 9C7.5 8.586 7.16475 8.25 6.75 8.25C6.33525 8.25 6 8.586 6 9C6 10.6545 7.3455 12 9 12C10.6545 12 12 10.6545 12 9C12 8.586 11.6648 8.25 11.25 8.25ZM13.5 14.25H4.5C4.086 14.25 3.75 13.9132 3.75 13.5V6.75H14.25V13.5C14.25 13.9132 13.914 14.25 13.5 14.25ZM6.09075 3.96975C6.231 3.83025 6.42375 3.75 6.621 3.75H11.379C11.5763 3.75 11.769 3.83025 11.9093 3.96975L13.1895 5.25H4.8105L6.09075 3.96975ZM15.0907 5.03025L12.9698 2.90925C12.5452 2.484 11.9797 2.25 11.379 2.25H6.621C6.02025 2.25 5.45475 2.484 5.03025 2.90925L2.90925 5.03025C2.484 5.45475 2.25 6.02025 2.25 6.62175V13.5C2.25 14.7405 3.2595 15.75 4.5 15.75H13.5C14.7405 15.75 15.75 14.7405 15.75 13.5V6.62175C15.75 6.02025 15.516 5.45475 15.0907 5.03025Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 7.33333C9.63133 7.33333 9.33333 7.632 9.33333 8C9.33333 8.73533 8.73533 9.33333 8 9.33333C7.26467 9.33333 6.66667 8.73533 6.66667 8C6.66667 7.632 6.36867 7.33333 6 7.33333C5.63133 7.33333 5.33333 7.632 5.33333 8C5.33333 9.47067 6.52933 10.6667 8 10.6667C9.47067 10.6667 10.6667 9.47067 10.6667 8C10.6667 7.632 10.3687 7.33333 10 7.33333ZM12 12.6667H4C3.632 12.6667 3.33333 12.3673 3.33333 12V6H12.6667V12C12.6667 12.3673 12.368 12.6667 12 12.6667ZM5.414 3.52867C5.53867 3.40467 5.71 3.33333 5.88533 3.33333H10.1147C10.29 3.33333 10.4613 3.40467 10.586 3.52867L11.724 4.66667H4.276L5.414 3.52867ZM13.414 4.47133L11.5287 2.586C11.1513 2.208 10.6487 2 10.1147 2H5.88533C5.35133 2 4.84867 2.208 4.47133 2.586L2.586 4.47133C2.208 4.84867 2 5.35133 2 5.886V12C2 13.1027 2.89733 14 4 14H12C13.1027 14 14 13.1027 14 12V5.886C14 5.35133 13.792 4.84867 13.414 4.47133Z'
        fill={color}
      />
    </svg>
  );
};

export const ShuffleIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.9136 8.33838C10.6861 8.10971 10.3163 8.10854 10.0888 8.33663C9.86008 8.56413 9.85892 8.93338 10.0864 9.16146L10.2573 9.33354H9.33333C8.0465 9.33354 7 8.28646 7 7.00021C7 5.71338 8.0465 4.66688 9.33333 4.66688H10.2597L10.0888 4.83663C9.86008 5.06413 9.85892 5.43338 10.0864 5.66146C10.2002 5.77579 10.3501 5.83354 10.5 5.83354C10.6488 5.83354 10.7981 5.77638 10.9113 5.66321L12.0779 4.50179C12.1882 4.39271 12.2494 4.24454 12.25 4.08996C12.2506 3.93479 12.1893 3.78663 12.0803 3.67696L10.9136 2.50504C10.6861 2.27638 10.3163 2.27521 10.0888 2.50329C9.86008 2.73079 9.85892 3.10004 10.0864 3.32813L10.2573 3.50021H9.33333C8.1165 3.50021 7.04375 4.12438 6.41667 5.06938C5.78958 4.12438 4.71683 3.50021 3.5 3.50021H2.33333C2.01075 3.50021 1.75 3.76096 1.75 4.08354C1.75 4.40554 2.01075 4.66688 2.33333 4.66688H3.5C4.78683 4.66688 5.83333 5.71338 5.83333 7.00021C5.83333 8.28646 4.78683 9.33354 3.5 9.33354H2.33333C2.01075 9.33354 1.75 9.59429 1.75 9.91688C1.75 10.2389 2.01075 10.5002 2.33333 10.5002H3.5C4.71683 10.5002 5.78958 9.87546 6.41667 8.93046C7.04375 9.87546 8.1165 10.5002 9.33333 10.5002H10.2597L10.0888 10.67C9.86008 10.8975 9.85892 11.2667 10.0864 11.4948C10.2002 11.6091 10.3501 11.6669 10.5 11.6669C10.6488 11.6669 10.7981 11.6097 10.9113 11.4965L12.0779 10.3351C12.1882 10.226 12.2494 10.0779 12.25 9.92329C12.2506 9.76813 12.1893 9.61996 12.0803 9.51029L10.9136 8.33838Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.0317 10.7209C13.7393 10.4269 13.2638 10.4254 12.9713 10.7186C12.6772 11.0111 12.6758 11.4859 12.9683 11.7791L13.188 12.0004H12C10.3455 12.0004 9 10.6541 9 9.00036C9 7.34586 10.3455 6.00036 12 6.00036H13.191L12.9713 6.21861C12.6772 6.51111 12.6758 6.98586 12.9683 7.27911C13.1145 7.42611 13.3073 7.50036 13.5 7.50036C13.6912 7.50036 13.8833 7.42686 14.0287 7.28136L15.5287 5.78811C15.6705 5.64786 15.7493 5.45736 15.75 5.25861C15.7507 5.05911 15.672 4.86861 15.5317 4.72761L14.0317 3.22086C13.7393 2.92686 13.2638 2.92536 12.9713 3.21861C12.6772 3.51111 12.6758 3.98586 12.9683 4.27911L13.188 4.50036H12C10.4355 4.50036 9.05625 5.30286 8.25 6.51786C7.44375 5.30286 6.0645 4.50036 4.5 4.50036H3C2.58525 4.50036 2.25 4.83561 2.25 5.25036C2.25 5.66436 2.58525 6.00036 3 6.00036H4.5C6.1545 6.00036 7.5 7.34586 7.5 9.00036C7.5 10.6541 6.1545 12.0004 4.5 12.0004H3C2.58525 12.0004 2.25 12.3356 2.25 12.7504C2.25 13.1644 2.58525 13.5004 3 13.5004H4.5C6.0645 13.5004 7.44375 12.6971 8.25 11.4821C9.05625 12.6971 10.4355 13.5004 12 13.5004H13.191L12.9713 13.7186C12.6772 14.0111 12.6758 14.4859 12.9683 14.7791C13.1145 14.9261 13.3073 15.0004 13.5 15.0004C13.6912 15.0004 13.8833 14.9269 14.0287 14.7814L15.5287 13.2881C15.6705 13.1479 15.7493 12.9574 15.75 12.7586C15.7507 12.5591 15.672 12.3686 15.5317 12.2276L14.0317 10.7209Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.4727 9.52956C12.2127 9.26822 11.79 9.26689 11.53 9.52756C11.2687 9.78756 11.2673 10.2096 11.5273 10.4702L11.7227 10.6669H10.6667C9.196 10.6669 8 9.47022 8 8.00022C8 6.52956 9.196 5.33356 10.6667 5.33356H11.7253L11.53 5.52756C11.2687 5.78756 11.2673 6.20956 11.5273 6.47022C11.6573 6.60089 11.8287 6.66689 12 6.66689C12.17 6.66689 12.3407 6.60156 12.47 6.47222L13.8033 5.14489C13.9293 5.02022 13.9993 4.85089 14 4.67422C14.0007 4.49689 13.9307 4.32756 13.806 4.20222L12.4727 2.86289C12.2127 2.60156 11.79 2.60022 11.53 2.86089C11.2687 3.12089 11.2673 3.54289 11.5273 3.80356L11.7227 4.00022H10.6667C9.276 4.00022 8.05 4.71356 7.33333 5.79356C6.61667 4.71356 5.39067 4.00022 4 4.00022H2.66667C2.298 4.00022 2 4.29822 2 4.66689C2 5.03489 2.298 5.33356 2.66667 5.33356H4C5.47067 5.33356 6.66667 6.52956 6.66667 8.00022C6.66667 9.47022 5.47067 10.6669 4 10.6669H2.66667C2.298 10.6669 2 10.9649 2 11.3336C2 11.7016 2.298 12.0002 2.66667 12.0002H4C5.39067 12.0002 6.61667 11.2862 7.33333 10.2062C8.05 11.2862 9.276 12.0002 10.6667 12.0002H11.7253L11.53 12.1942C11.2687 12.4542 11.2673 12.8762 11.5273 13.1369C11.6573 13.2676 11.8287 13.3336 12 13.3336C12.17 13.3336 12.3407 13.2682 12.47 13.1389L13.8033 11.8116C13.9293 11.6869 13.9993 11.5176 14 11.3409C14.0007 11.1636 13.9307 10.9942 13.806 10.8689L12.4727 9.52956Z'
        fill={color}
      />
    </svg>
  );
};

export const SwapIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.91669 4.66689H2.33335C2.01135 4.66689 1.75002 4.40614 1.75002 4.08356C1.75002 3.76097 2.01135 3.50022 2.33335 3.50022H9.96452L9.05569 2.79439C8.80135 2.59664 8.75527 2.22972 8.95302 1.97597C9.15077 1.72106 9.51769 1.67497 9.77144 1.87272L12.0243 3.62272C12.1684 3.73414 12.2512 3.90622 12.25 4.08881C12.2489 4.27022 12.1625 4.44114 12.0167 4.55022L9.68335 6.30022C9.57835 6.37897 9.45527 6.41689 9.33394 6.41689C9.1566 6.41689 8.98102 6.33639 8.86669 6.18356C8.6736 5.92572 8.72552 5.55997 8.98335 5.36689L9.91669 4.66689ZM4.08335 8.75022H11.6667C11.9887 8.75022 12.25 9.01097 12.25 9.33356C12.25 9.65614 11.9887 9.91689 11.6667 9.91689H4.03551L4.94435 10.6227C5.19868 10.8205 5.24476 11.1874 5.04701 11.4411C4.9321 11.5893 4.76001 11.6669 4.58618 11.6669C4.46076 11.6669 4.33476 11.6272 4.2286 11.5444L1.97576 9.79439C1.83168 9.68297 1.74885 9.51089 1.75001 9.32831C1.75118 9.14689 1.83751 8.97597 1.98335 8.86689L4.31668 7.11689C4.5751 6.92381 4.94026 6.97572 5.13335 7.23356C5.32643 7.49139 5.27451 7.85714 5.01668 8.05022L4.08335 8.75022Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.75 6.00029H3.00002C2.58602 6.00029 2.25002 5.66504 2.25002 5.25029C2.25002 4.83554 2.58602 4.50029 3.00002 4.50029H12.8115L11.643 3.59279C11.316 3.33854 11.2568 2.86679 11.511 2.54054C11.7653 2.21279 12.237 2.15354 12.5633 2.40779L15.4598 4.65779C15.645 4.80104 15.7515 5.02229 15.75 5.25704C15.7485 5.49029 15.6375 5.71004 15.45 5.85029L12.45 8.10029C12.315 8.20154 12.1568 8.25029 12.0008 8.25029C11.7728 8.25029 11.547 8.14679 11.4 7.95029C11.1518 7.61879 11.2185 7.14854 11.55 6.90029L12.75 6.00029ZM5.25002 11.2503H15C15.414 11.2503 15.75 11.5855 15.75 12.0003C15.75 12.415 15.414 12.7503 15 12.7503H5.18852L6.35702 13.6578C6.68402 13.912 6.74327 14.3838 6.48902 14.71C6.34127 14.9005 6.12002 15.0003 5.89652 15.0003C5.73527 15.0003 5.57327 14.9493 5.43677 14.8428L2.54027 12.5928C2.35502 12.4495 2.24852 12.2283 2.25002 11.9935C2.25152 11.7603 2.36252 11.5405 2.55002 11.4003L5.55002 9.15029C5.88227 8.90204 6.35177 8.96879 6.60002 9.30029C6.84827 9.63179 6.78152 10.102 6.45002 10.3503L5.25002 11.2503Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.3334 5.33359H2.66669C2.29869 5.33359 2.00002 5.03559 2.00002 4.66692C2.00002 4.29826 2.29869 4.00026 2.66669 4.00026H11.388L10.3494 3.19359C10.0587 2.96759 10.006 2.54826 10.232 2.25826C10.458 1.96692 10.8774 1.91426 11.1674 2.14026L13.742 4.14026C13.9067 4.26759 14.0014 4.46426 14 4.67292C13.9987 4.88026 13.9 5.07559 13.7334 5.20026L11.0667 7.20026C10.9467 7.29026 10.806 7.33359 10.6674 7.33359C10.4647 7.33359 10.264 7.24159 10.1334 7.06692C9.91269 6.77226 9.97202 6.35426 10.2667 6.13359L11.3334 5.33359ZM4.66668 10.0003H13.3333C13.7013 10.0003 14 10.2983 14 10.6669C14 11.0356 13.7013 11.3336 13.3333 11.3336H4.61201L5.65068 12.1403C5.94135 12.3663 5.99401 12.7856 5.76801 13.0756C5.63668 13.2449 5.44001 13.3336 5.24135 13.3336C5.09801 13.3336 4.95401 13.2883 4.83268 13.1936L2.25801 11.1936C2.09335 11.0663 1.99868 10.8696 2.00001 10.6609C2.00135 10.4536 2.10001 10.2583 2.26668 10.1336L4.93335 8.13359C5.22868 7.91292 5.64601 7.97226 5.86668 8.26692C6.08735 8.56159 6.02801 8.97959 5.73335 9.20026L4.66668 10.0003Z'
        fill={color}
      />
    </svg>
  );
};

export const FlameIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.37166 5.55125C3.18632 6.834 3.21141 8.8675 4.44691 10.1269C5.05007 10.7435 5.85157 11.0836 6.70557 11.0842H6.70849C7.56424 11.0842 8.36866 10.7441 8.97474 10.1269C10.2324 8.84475 10.2301 6.75934 8.96949 5.47892L7.22766 3.69917C7.05149 5.147 6.50841 6.4175 5.54124 6.4175C5.24491 6.4175 4.76191 6.28567 4.37166 5.55125ZM6.70849 12.2508H6.70441C5.53424 12.2497 4.43641 11.7859 3.61332 10.943C1.91349 9.2105 1.91116 6.39125 3.60807 4.66167L4.18149 4.08184C4.32966 3.93367 4.54491 3.8765 4.74849 3.92959C4.95091 3.98442 5.10841 4.14367 5.16091 4.34667C5.29507 4.86525 5.45491 5.12017 5.54299 5.217C5.75007 4.99884 6.12457 4.11742 6.12457 2.62584C6.12457 2.54009 6.12457 2.459 6.11991 2.37792C6.10882 2.20584 6.17474 2.03725 6.29957 1.91825C6.53116 1.69834 6.90215 1.69834 7.1244 1.927L9.80191 4.66225C11.5052 6.39125 11.5082 9.2105 9.80774 10.9436C8.97999 11.7871 7.87982 12.2508 6.70849 12.2508Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.62098 7.13741C4.09698 8.78666 4.12923 11.4012 5.71773 13.0204C6.49323 13.8132 7.52373 14.2504 8.62173 14.2512H8.62548C9.72573 14.2512 10.76 13.8139 11.5392 13.0204C13.1562 11.3719 13.1532 8.69066 11.5325 7.04441L9.29298 4.75616C9.06648 6.61766 8.36823 8.25116 7.12473 8.25116C6.74373 8.25116 6.12273 8.08166 5.62098 7.13741ZM8.62548 15.7512H8.62023C7.11573 15.7497 5.70423 15.1534 4.64598 14.0697C2.46048 11.8422 2.45748 8.21741 4.63923 5.99366L5.37648 5.24816C5.56698 5.05766 5.84373 4.98416 6.10548 5.05241C6.36573 5.12291 6.56823 5.32766 6.63573 5.58866C6.80823 6.25541 7.01373 6.58316 7.12698 6.70766C7.39323 6.42716 7.87473 5.29391 7.87473 3.37616C7.87473 3.26591 7.87473 3.16166 7.86873 3.05741C7.85448 2.83616 7.93923 2.61941 8.09973 2.46641C8.39748 2.18366 8.87448 2.18366 9.16023 2.47766L12.6027 5.99441C14.7927 8.21741 14.7965 11.8422 12.6102 14.0704C11.546 15.1549 10.1315 15.7512 8.62548 15.7512Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.99632 6.34427C3.64165 7.81027 3.67032 10.1343 5.08232 11.5736C5.77165 12.2783 6.68765 12.6669 7.66365 12.6676H7.66698C8.64498 12.6676 9.56432 12.2789 10.257 11.5736C11.6943 10.1083 11.6917 7.72494 10.251 6.26161L8.26032 4.22761C8.05898 5.88227 7.43832 7.33427 6.33298 7.33427C5.99432 7.33427 5.44232 7.18361 4.99632 6.34427ZM7.66698 14.0009H7.66232C6.32498 13.9996 5.07032 13.4696 4.12965 12.5063C2.18698 10.5263 2.18432 7.30427 4.12365 5.32761L4.77898 4.66494C4.94832 4.49561 5.19432 4.43027 5.42698 4.49094C5.65832 4.55361 5.83832 4.73561 5.89832 4.96761C6.05165 5.56027 6.23432 5.85161 6.33498 5.96227C6.57165 5.71294 6.99965 4.70561 6.99965 3.00094C6.99965 2.90294 6.99965 2.81027 6.99432 2.71761C6.98165 2.52094 7.05698 2.32827 7.19965 2.19227C7.46432 1.94094 7.88832 1.94094 8.14232 2.20227L11.2023 5.32827C13.149 7.30427 13.1523 10.5263 11.209 12.5069C10.263 13.4709 9.00565 14.0009 7.66698 14.0009Z'
        fill={color}
      />
    </svg>
  );
};

export const SettingsIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.56869 6.77958C3.21969 7.003 3.73827 7.54783 3.95527 8.2385L3.9786 8.3085C4.2271 9.04117 4.12619 9.82983 3.70969 10.4213C3.63385 10.5287 3.65077 10.657 3.73069 10.7177L4.93935 11.6358C4.98194 11.6679 5.02335 11.6679 5.04902 11.665C5.07819 11.6603 5.12077 11.6446 5.15519 11.5956L5.28994 11.4042C5.69185 10.8343 6.33935 10.4826 7.02302 10.4627C7.79069 10.447 8.48019 10.7987 8.90952 11.4188L8.97835 11.5186C9.01277 11.5676 9.05477 11.5839 9.08452 11.5886C9.11019 11.5938 9.15218 11.5921 9.19419 11.5594L10.3964 10.6523C10.4804 10.5893 10.4991 10.4546 10.4367 10.3642L10.285 10.1454C9.89419 9.58075 9.7781 8.84808 9.97469 8.186C10.1882 7.465 10.7313 6.8945 11.4284 6.66117L11.5456 6.6215C11.6395 6.59058 11.6903 6.47392 11.657 6.36658L11.1979 4.896C11.1764 4.82717 11.132 4.79625 11.1075 4.78341C11.0725 4.76533 11.0346 4.76241 10.9984 4.77466L10.8001 4.84058C10.1217 5.06633 9.37327 4.94383 8.79869 4.51158L8.73569 4.46433C8.18969 4.05366 7.86477 3.39158 7.8671 2.69391L7.86827 2.53058C7.86827 2.453 7.83152 2.40458 7.80935 2.38241C7.78835 2.36083 7.75277 2.33516 7.7026 2.33516L6.21685 2.33341C6.12585 2.33341 6.05177 2.42033 6.05119 2.52766L6.0506 2.66883C6.04769 3.37758 5.71577 4.05191 5.16277 4.47366L5.08752 4.53083C4.4791 4.99341 3.68577 5.12408 2.9671 4.87908C2.93969 4.86975 2.91402 4.8715 2.88952 4.88433C2.87085 4.89367 2.83702 4.91758 2.82069 4.97066L2.3441 6.485C2.30969 6.59525 2.36627 6.71017 2.47302 6.74691L2.56869 6.77958ZM5.0251 12.8334C4.7416 12.8334 4.46627 12.7412 4.2341 12.5645L3.02544 11.6469C2.44794 11.2094 2.32019 10.3677 2.74019 9.77091C2.95835 9.46175 3.00327 9.0645 2.87494 8.68766L2.84285 8.58966C2.7361 8.25016 2.49227 7.9865 2.19069 7.88325H2.1901L2.09502 7.85C1.38452 7.60675 1.00535 6.85366 1.2311 6.135L1.7071 4.62125C1.81502 4.27883 2.04777 4.00233 2.36277 3.84308C2.67077 3.68791 3.01902 3.664 3.34452 3.77541C3.69394 3.89441 4.08185 3.82966 4.3811 3.60216L4.45635 3.545C4.72235 3.342 4.88277 3.01241 4.88394 2.66416L4.88452 2.52358C4.88744 1.77458 5.48535 1.16675 6.21627 1.16675H6.2186L7.70435 1.1685C8.05552 1.16908 8.38685 1.30791 8.63652 1.55933C8.89494 1.81891 9.0361 2.166 9.03494 2.53641L9.03377 2.69916C9.0326 3.02933 9.18369 3.34141 9.4386 3.53275L9.50102 3.58C9.76877 3.78125 10.1176 3.839 10.4309 3.734L10.6286 3.66808C10.9652 3.55608 11.3234 3.5835 11.6389 3.74508C11.9627 3.91075 12.2019 4.196 12.3115 4.54891L12.7706 6.0195C12.9923 6.73 12.6084 7.4965 11.916 7.72808L11.7988 7.76716C11.4628 7.88033 11.1985 8.16033 11.0929 8.51733C10.9961 8.84458 11.0521 9.2045 11.244 9.481L11.3957 9.69975C11.8122 10.3017 11.6792 11.1464 11.0994 11.5833L9.8971 12.491C9.60835 12.7092 9.25427 12.7972 8.89902 12.7407C8.54085 12.6829 8.22819 12.4846 8.01877 12.1824L7.94993 12.0821C7.74577 11.7881 7.4191 11.6096 7.07669 11.6288C6.73369 11.6382 6.43735 11.8009 6.24369 12.0762L6.10893 12.2676C5.89777 12.5668 5.58452 12.7622 5.2281 12.8182C5.15985 12.8287 5.09219 12.8334 5.0251 12.8334ZM7.00039 6.12502C6.51797 6.12502 6.12539 6.51761 6.12539 7.00002C6.12539 7.48244 6.51797 7.87502 7.00039 7.87502C7.4828 7.87502 7.87539 7.48244 7.87539 7.00002C7.87539 6.51761 7.4828 6.12502 7.00039 6.12502ZM7.00039 9.04169C5.87455 9.04169 4.95872 8.12586 4.95872 7.00002C4.95872 5.87419 5.87455 4.95836 7.00039 4.95836C8.12622 4.95836 9.04205 5.87419 9.04205 7.00002C9.04205 8.12586 8.12622 9.04169 7.00039 9.04169Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M3.30246 8.71662C4.13946 9.00387 4.80621 9.70437 5.08521 10.5924L5.11521 10.6824C5.43471 11.6244 5.30496 12.6384 4.76946 13.3989C4.67196 13.5369 4.69371 13.7019 4.79646 13.7799L6.35046 14.9604C6.40521 15.0016 6.45846 15.0016 6.49146 14.9979C6.52896 14.9919 6.58371 14.9716 6.62796 14.9086L6.80121 14.6626C7.31796 13.9299 8.15046 13.4776 9.02946 13.4521C10.0165 13.4319 10.903 13.8841 11.455 14.6814L11.5435 14.8096C11.5877 14.8726 11.6417 14.8936 11.68 14.8996C11.713 14.9064 11.767 14.9041 11.821 14.8621L13.3667 13.6959C13.4747 13.6149 13.4987 13.4416 13.4185 13.3254L13.2235 13.0441C12.721 12.3181 12.5717 11.3761 12.8245 10.5249C13.099 9.59787 13.7972 8.86437 14.6935 8.56437L14.8442 8.51337C14.965 8.47362 15.0302 8.32362 14.9875 8.18562L14.3972 6.29487C14.3695 6.20637 14.3125 6.16662 14.281 6.15012C14.236 6.12687 14.1872 6.12312 14.1407 6.13887L13.8857 6.22362C13.0135 6.51387 12.0512 6.35637 11.3125 5.80062L11.2315 5.73987C10.5295 5.21187 10.1117 4.36062 10.1147 3.46362L10.1162 3.25362C10.1162 3.15387 10.069 3.09162 10.0405 3.06312C10.0135 3.03537 9.96771 3.00237 9.90321 3.00237L7.99296 3.00012C7.87596 3.00012 7.78071 3.11187 7.77996 3.24987L7.77921 3.43137C7.77546 4.34262 7.34871 5.20962 6.63771 5.75187L6.54096 5.82537C5.75871 6.42012 4.73871 6.58812 3.81471 6.27312C3.77946 6.26112 3.74646 6.26337 3.71496 6.27987C3.69096 6.29187 3.64746 6.32262 3.62646 6.39087L3.01371 8.33787C2.96946 8.47962 3.04221 8.62737 3.17946 8.67462L3.30246 8.71662ZM6.46071 16.5001C6.09621 16.5001 5.74221 16.3816 5.44371 16.1544L3.88971 14.9746C3.14721 14.4121 2.98296 13.3299 3.52296 12.5626C3.80346 12.1651 3.86121 11.6544 3.69621 11.1699L3.65496 11.0439C3.51771 10.6074 3.20421 10.2684 2.81646 10.1356H2.81571L2.69346 10.0929C1.77996 9.78012 1.29246 8.81187 1.58271 7.88787L2.19471 5.94162C2.33346 5.50137 2.63271 5.14587 3.03771 4.94112C3.43371 4.74162 3.88146 4.71087 4.29996 4.85412C4.74921 5.00712 5.24796 4.92387 5.63271 4.63137L5.72946 4.55787C6.07146 4.29687 6.27771 3.87312 6.27921 3.42537L6.27996 3.24462C6.28371 2.28162 7.05246 1.50012 7.99221 1.50012H7.99521L9.90546 1.50237C10.357 1.50312 10.783 1.68162 11.104 2.00487C11.4362 2.33862 11.6177 2.78487 11.6162 3.26112L11.6147 3.47037C11.6132 3.89487 11.8075 4.29612 12.1352 4.54212L12.2155 4.60287C12.5597 4.86162 13.0082 4.93587 13.411 4.80087L13.6652 4.71612C14.098 4.57212 14.5585 4.60737 14.9642 4.81512C15.3805 5.02812 15.688 5.39487 15.829 5.84862L16.4192 7.73937C16.7042 8.65287 16.2107 9.63837 15.3205 9.93612L15.1697 9.98637C14.7377 10.1319 14.398 10.4919 14.2622 10.9509C14.1377 11.3716 14.2097 11.8344 14.4565 12.1899L14.6515 12.4711C15.187 13.2451 15.016 14.3311 14.2705 14.8929L12.7247 16.0599C12.3535 16.3404 11.8982 16.4536 11.4415 16.3809C10.981 16.3066 10.579 16.0516 10.3097 15.6631L10.2212 15.5341C9.95871 15.1561 9.53871 14.9266 9.09846 14.9514C8.65746 14.9634 8.27646 15.1726 8.02746 15.5266L7.85421 15.7726C7.58271 16.1574 7.17996 16.4086 6.72171 16.4806C6.63396 16.4941 6.54696 16.5001 6.46071 16.5001ZM9.00036 7.87505C8.38011 7.87505 7.87536 8.3798 7.87536 9.00005C7.87536 9.6203 8.38011 10.125 9.00036 10.125C9.62061 10.125 10.1254 9.6203 10.1254 9.00005C10.1254 8.3798 9.62061 7.87505 9.00036 7.87505ZM9.00036 11.625C7.55286 11.625 6.37536 10.4475 6.37536 9.00005C6.37536 7.55255 7.55286 6.37505 9.00036 6.37505C10.4479 6.37505 11.6254 7.55255 11.6254 9.00005C11.6254 10.4475 10.4479 11.625 9.00036 11.625Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.93508 7.74804C3.67908 8.00337 4.27175 8.62604 4.51975 9.41537L4.54642 9.49537C4.83042 10.3327 4.71508 11.234 4.23908 11.91C4.15242 12.0327 4.17175 12.1794 4.26308 12.2487L5.64442 13.298C5.69308 13.3347 5.74042 13.3347 5.76975 13.3314C5.80308 13.326 5.85175 13.308 5.89108 13.252L6.04508 13.0334C6.50442 12.382 7.24442 11.98 8.02575 11.9574C8.90308 11.9394 9.69108 12.3414 10.1817 13.05L10.2604 13.164C10.2997 13.22 10.3477 13.2387 10.3817 13.244C10.4111 13.25 10.4591 13.248 10.5071 13.2107L11.8811 12.174C11.9771 12.102 11.9984 11.948 11.9271 11.8447L11.7537 11.5947C11.3071 10.9494 11.1744 10.112 11.3991 9.35537C11.6431 8.53137 12.2637 7.87937 13.0604 7.61271L13.1944 7.56737C13.3017 7.53204 13.3597 7.39871 13.3217 7.27604L12.7971 5.59537C12.7724 5.51671 12.7217 5.48137 12.6937 5.46671C12.6537 5.44604 12.6104 5.44271 12.5691 5.45671L12.3424 5.53204C11.5671 5.79004 10.7117 5.65004 10.0551 5.15604L9.98308 5.10204C9.35908 4.63271 8.98775 3.87604 8.99042 3.07871L8.99175 2.89204C8.99175 2.80337 8.94975 2.74804 8.92442 2.72271C8.90042 2.69804 8.85975 2.66871 8.80242 2.66871L7.10442 2.66671C7.00042 2.66671 6.91575 2.76604 6.91508 2.88871L6.91442 3.05004C6.91108 3.86004 6.53175 4.63071 5.89975 5.11271L5.81375 5.17804C5.11842 5.70671 4.21175 5.85604 3.39042 5.57604C3.35908 5.56537 3.32975 5.56737 3.30175 5.58204C3.28042 5.59271 3.24175 5.62004 3.22308 5.68071L2.67842 7.41137C2.63908 7.53737 2.70375 7.66871 2.82575 7.71071L2.93508 7.74804ZM5.74242 14.6667C5.41842 14.6667 5.10375 14.5614 4.83842 14.3594L3.45708 13.3107C2.79708 12.8107 2.65108 11.8487 3.13108 11.1667C3.38042 10.8134 3.43175 10.3594 3.28508 9.92871L3.24842 9.81671C3.12642 9.42871 2.84775 9.12737 2.50308 9.00937H2.50242L2.39375 8.97137C1.58175 8.69337 1.14842 7.83271 1.40642 7.01137L1.95042 5.28137C2.07375 4.89004 2.33975 4.57404 2.69975 4.39204C3.05175 4.21471 3.44975 4.18737 3.82175 4.31471C4.22108 4.45071 4.66442 4.37671 5.00642 4.11671L5.09242 4.05137C5.39642 3.81937 5.57975 3.44271 5.58108 3.04471L5.58175 2.88404C5.58508 2.02804 6.26842 1.33337 7.10375 1.33337H7.10642L8.80442 1.33537C9.20575 1.33604 9.58442 1.49471 9.86975 1.78204C10.1651 2.07871 10.3264 2.47537 10.3251 2.89871L10.3237 3.08471C10.3224 3.46204 10.4951 3.81871 10.7864 4.03737L10.8577 4.09137C11.1637 4.32137 11.5624 4.38737 11.9204 4.26737L12.1464 4.19204C12.5311 4.06404 12.9404 4.09537 13.3011 4.28004C13.6711 4.46937 13.9444 4.79537 14.0697 5.19871L14.5944 6.87937C14.8477 7.69137 14.4091 8.56737 13.6177 8.83204L13.4837 8.87671C13.0997 9.00604 12.7977 9.32604 12.6771 9.73404C12.5664 10.108 12.6304 10.5194 12.8497 10.8354L13.0231 11.0854C13.4991 11.7734 13.3471 12.7387 12.6844 13.238L11.3104 14.2754C10.9804 14.5247 10.5757 14.6254 10.1697 14.5607C9.76042 14.4947 9.40308 14.268 9.16375 13.9227L9.08508 13.808C8.85175 13.472 8.47842 13.268 8.08708 13.29C7.69508 13.3007 7.35642 13.4867 7.13508 13.8014L6.98108 14.02C6.73975 14.362 6.38175 14.5854 5.97442 14.6494C5.89642 14.6614 5.81908 14.6667 5.74242 14.6667ZM7.99988 6.99997C7.44855 6.99997 6.99988 7.44864 6.99988 7.99997C6.99988 8.55131 7.44855 8.99997 7.99988 8.99997C8.55122 8.99997 8.99988 8.55131 8.99988 7.99997C8.99988 7.44864 8.55122 6.99997 7.99988 6.99997ZM7.99988 10.3333C6.71322 10.3333 5.66655 9.28664 5.66655 7.99997C5.66655 6.71331 6.71322 5.66664 7.99988 5.66664C9.28655 5.66664 10.3332 6.71331 10.3332 7.99997C10.3332 9.28664 9.28655 10.3333 7.99988 10.3333Z'
        fill={color}
      />
    </svg>
  );
};

export const TimerIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.75 7.00004H9.58333V5.83337C9.58333 5.51079 9.322 5.25004 9 5.25004C8.678 5.25004 8.41667 5.51079 8.41667 5.83337V7.58337C8.41667 7.90596 8.678 8.16671 9 8.16671H10.75C11.072 8.16671 11.3333 7.90596 11.3333 7.58337C11.3333 7.26079 11.072 7.00004 10.75 7.00004ZM9 11.5209C6.82883 11.5209 5.0625 9.75454 5.0625 7.58337C5.0625 5.41221 6.82883 3.64587 9 3.64587C11.1712 3.64587 12.9375 5.41221 12.9375 7.58337C12.9375 9.75454 11.1712 11.5209 9 11.5209ZM9.57633 2.36721C9.5775 2.35496 9.58333 2.34562 9.58333 2.33337V1.75004H10.1667C10.4887 1.75004 10.75 1.48929 10.75 1.16671C10.75 0.844124 10.4887 0.583374 10.1667 0.583374H7.83333C7.51133 0.583374 7.25 0.844124 7.25 1.16671C7.25 1.48929 7.51133 1.75004 7.83333 1.75004H8.41667V2.33337C8.41667 2.34562 8.4225 2.35496 8.42367 2.36721C5.79925 2.65537 3.75 4.88371 3.75 7.58337C3.75 10.4785 6.1055 12.8334 9 12.8334C11.8945 12.8334 14.25 10.4785 14.25 7.58337C14.25 4.88371 12.2007 2.65537 9.57633 2.36721Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.25 9H9.75V7.5C9.75 7.08525 9.414 6.75 9 6.75C8.586 6.75 8.25 7.08525 8.25 7.5V9.75C8.25 10.1648 8.586 10.5 9 10.5H11.25C11.664 10.5 12 10.1648 12 9.75C12 9.33525 11.664 9 11.25 9ZM9 14.8125C6.2085 14.8125 3.9375 12.5415 3.9375 9.75C3.9375 6.9585 6.2085 4.6875 9 4.6875C11.7915 4.6875 14.0625 6.9585 14.0625 9.75C14.0625 12.5415 11.7915 14.8125 9 14.8125ZM9.741 3.0435C9.7425 3.02775 9.75 3.01575 9.75 3V2.25H10.5C10.914 2.25 11.25 1.91475 11.25 1.5C11.25 1.08525 10.914 0.75 10.5 0.75H7.5C7.086 0.75 6.75 1.08525 6.75 1.5C6.75 1.91475 7.086 2.25 7.5 2.25H8.25V3C8.25 3.01575 8.2575 3.02775 8.259 3.0435C4.88475 3.414 2.25 6.279 2.25 9.75C2.25 13.4722 5.2785 16.5 9 16.5C12.7215 16.5 15.75 13.4722 15.75 9.75C15.75 6.279 13.1152 3.414 9.741 3.0435Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 7.99996H8.66667V6.66663C8.66667 6.29796 8.368 5.99996 8 5.99996C7.632 5.99996 7.33333 6.29796 7.33333 6.66663V8.66663C7.33333 9.03529 7.632 9.33329 8 9.33329H10C10.368 9.33329 10.6667 9.03529 10.6667 8.66663C10.6667 8.29796 10.368 7.99996 10 7.99996ZM8 13.1666C5.51867 13.1666 3.5 11.148 3.5 8.66663C3.5 6.18529 5.51867 4.16663 8 4.16663C10.4813 4.16663 12.5 6.18529 12.5 8.66663C12.5 11.148 10.4813 13.1666 8 13.1666ZM8.65867 2.70529C8.66 2.69129 8.66667 2.68063 8.66667 2.66663V1.99996H9.33333C9.70133 1.99996 10 1.70196 10 1.33329C10 0.964626 9.70133 0.666626 9.33333 0.666626H6.66667C6.29867 0.666626 6 0.964626 6 1.33329C6 1.70196 6.29867 1.99996 6.66667 1.99996H7.33333V2.66663C7.33333 2.68063 7.34 2.69129 7.34133 2.70529C4.342 3.03463 2 5.58129 2 8.66663C2 11.9753 4.692 14.6666 8 14.6666C11.308 14.6666 14 11.9753 14 8.66663C14 5.58129 11.658 3.03463 8.65867 2.70529Z'
        fill={color}
      />
    </svg>
  );
};

export const PaperPlaneIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.75033 10.4054L7.66766 7.158L10.9157 3.90942L8.75033 10.4054ZM10.0908 3.08458L6.84283 6.33258L3.59483 5.24992L10.0908 3.08458ZM12.8278 1.71959C12.8249 1.66533 12.815 1.61283 12.7969 1.56209C12.7911 1.544 12.7847 1.5265 12.7765 1.509C12.7485 1.44658 12.7129 1.38767 12.6627 1.3375C12.6126 1.28733 12.5537 1.25175 12.4907 1.22375C12.4737 1.21558 12.4568 1.20917 12.4387 1.20333C12.3868 1.18525 12.3337 1.17475 12.2783 1.17183C12.2655 1.17125 12.2538 1.16833 12.2404 1.16833C12.1821 1.1695 12.1232 1.17767 12.066 1.19633L1.56599 4.69634C1.32741 4.77625 1.16699 4.9985 1.16699 5.24992C1.16699 5.50134 1.32741 5.72417 1.56599 5.8035L6.53891 7.46134L8.19733 12.4348C8.27666 12.6728 8.49891 12.8333 8.75033 12.8333C9.00174 12.8333 9.22399 12.6728 9.30333 12.4348L12.8033 1.93484C12.822 1.87709 12.8307 1.81875 12.8313 1.76042C12.8319 1.74642 12.8284 1.73359 12.8278 1.71959Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.25 13.3784L9.858 9.2032L14.034 5.02645L11.25 13.3784ZM12.9735 3.96595L8.7975 8.14195L4.6215 6.74995L12.9735 3.96595ZM16.4925 2.21095C16.4888 2.1412 16.476 2.0737 16.4528 2.00845C16.4453 1.9852 16.437 1.9627 16.4265 1.9402C16.3905 1.85995 16.3448 1.7842 16.2803 1.7197C16.2158 1.6552 16.14 1.60945 16.059 1.57345C16.0373 1.56295 16.0155 1.5547 15.9923 1.5472C15.9255 1.52395 15.8573 1.51045 15.786 1.5067C15.7695 1.50595 15.7545 1.5022 15.7373 1.5022C15.6623 1.5037 15.5865 1.5142 15.513 1.5382L2.013 6.0382C1.70625 6.14095 1.5 6.4267 1.5 6.74995C1.5 7.0732 1.70625 7.3597 2.013 7.4617L8.40675 9.5932L10.539 15.9877C10.641 16.2937 10.9268 16.4999 11.25 16.4999C11.5733 16.4999 11.859 16.2937 11.961 15.9877L16.461 2.4877C16.485 2.41345 16.4963 2.33845 16.497 2.26345C16.4978 2.24545 16.4933 2.22895 16.4925 2.21095Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.99967 11.892L8.76234 8.18066L12.4743 4.46799L9.99967 11.892ZM11.5317 3.52533L7.81967 7.23733L4.10767 5.99999L11.5317 3.52533ZM14.6597 1.96533C14.6563 1.90333 14.645 1.84333 14.6243 1.78533C14.6177 1.76466 14.6103 1.74466 14.601 1.72466C14.569 1.65333 14.5283 1.58599 14.471 1.52866C14.4137 1.47133 14.3463 1.43066 14.2743 1.39866C14.255 1.38933 14.2357 1.38199 14.215 1.37533C14.1557 1.35466 14.095 1.34266 14.0317 1.33933C14.017 1.33866 14.0037 1.33533 13.9883 1.33533C13.9217 1.33666 13.8543 1.34599 13.789 1.36733L1.78901 5.36733C1.51634 5.45866 1.33301 5.71266 1.33301 5.99999C1.33301 6.28733 1.51634 6.54199 1.78901 6.63266L7.47234 8.52733L9.36767 14.2113C9.45834 14.4833 9.71234 14.6667 9.99967 14.6667C10.287 14.6667 10.541 14.4833 10.6317 14.2113L14.6317 2.21133C14.653 2.14533 14.663 2.07866 14.6637 2.01199C14.6643 1.99599 14.6603 1.98133 14.6597 1.96533Z'
        fill={color}
      />
    </svg>
  );
};

export const PlayIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.70573 8.51676V5.48401L8.34431 7.00009L6.70573 8.51676ZM7.19515 4.34768C6.90465 4.07818 6.48056 4.00818 6.1154 4.16859C5.75956 4.32376 5.53906 4.65568 5.53906 5.03426V8.96651C5.53906 9.34509 5.75956 9.67701 6.1154 9.83218C6.24548 9.88934 6.38373 9.91676 6.51965 9.91676C6.7664 9.91676 7.00848 9.82634 7.19456 9.65368L9.31906 7.68784C9.51215 7.50934 9.6224 7.25909 9.6224 7.00009C9.6224 6.74168 9.51215 6.49084 9.31906 6.31293L7.19515 4.34768ZM6.9974 11.667C4.42431 11.667 2.33073 9.57341 2.33073 7.00033C2.33073 4.42724 4.42431 2.33366 6.9974 2.33366C9.57048 2.33366 11.6641 4.42724 11.6641 7.00033C11.6641 9.57341 9.57048 11.667 6.9974 11.667ZM6.9974 1.16699C3.7809 1.16699 1.16406 3.78383 1.16406 7.00033C1.16406 10.2168 3.7809 12.8337 6.9974 12.8337C10.2139 12.8337 12.8307 10.2168 12.8307 7.00033C12.8307 3.78383 10.2139 1.16699 6.9974 1.16699Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.625 10.9497V7.05045L10.7318 8.9997L8.625 10.9497ZM9.25425 5.58945C8.88075 5.24295 8.3355 5.15295 7.866 5.3592C7.4085 5.5587 7.125 5.98545 7.125 6.4722V11.528C7.125 12.0147 7.4085 12.4415 7.866 12.641C8.03325 12.7144 8.211 12.7497 8.38575 12.7497C8.703 12.7497 9.01425 12.6334 9.2535 12.4114L11.985 9.88395C12.2332 9.65445 12.375 9.3327 12.375 8.9997C12.375 8.66745 12.2332 8.34495 11.985 8.1162L9.25425 5.58945ZM9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15ZM9 1.5C4.8645 1.5 1.5 4.8645 1.5 9C1.5 13.1355 4.8645 16.5 9 16.5C13.1355 16.5 16.5 13.1355 16.5 9C16.5 4.8645 13.1355 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.66927 9.73274V6.26674L9.54194 7.99941L7.66927 9.73274ZM8.2286 4.96807C7.8966 4.66007 7.41194 4.58007 6.9946 4.76341C6.58794 4.94074 6.33594 5.32007 6.33594 5.75274V10.2467C6.33594 10.6794 6.58794 11.0587 6.9946 11.2361C7.14327 11.3014 7.30127 11.3327 7.4566 11.3327C7.7386 11.3327 8.01527 11.2294 8.22794 11.0321L10.6559 8.78541C10.8766 8.58141 11.0026 8.29541 11.0026 7.99941C11.0026 7.70407 10.8766 7.41741 10.6559 7.21407L8.2286 4.96807ZM8.0026 13.333C5.06194 13.333 2.66927 10.9403 2.66927 7.99967C2.66927 5.05901 5.06194 2.66634 8.0026 2.66634C10.9433 2.66634 13.3359 5.05901 13.3359 7.99967C13.3359 10.9403 10.9433 13.333 8.0026 13.333ZM8.0026 1.33301C4.3266 1.33301 1.33594 4.32367 1.33594 7.99967C1.33594 11.6757 4.3266 14.6663 8.0026 14.6663C11.6786 14.6663 14.6693 11.6757 14.6693 7.99967C14.6693 4.32367 11.6786 1.33301 8.0026 1.33301Z'
        fill={color}
      />
    </svg>
  );
};

export const PriceTagIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.16039 4.92326C6.50222 5.26451 6.50222 5.81926 6.16039 6.16051C5.81856 6.50234 5.26497 6.50234 4.92314 6.16051C4.58131 5.81926 4.58131 5.26451 4.92314 4.92326C5.26497 4.58142 5.81856 4.58142 6.16039 4.92326ZM3.40327 7.52032L6.92193 11.0396L11.0391 6.9224L7.52043 3.40315L2.97918 2.97965L3.40327 7.52032ZM6.92193 12.2494C6.65068 12.2494 6.38002 12.1461 6.17293 11.9402L2.42968 8.1964C2.33343 8.10073 2.27393 7.97357 2.2611 7.83823L1.75243 2.38757C1.73668 2.2149 1.79793 2.04398 1.92102 1.9209C2.0441 1.79782 2.21443 1.7354 2.38768 1.7529L7.83835 2.26157C7.97368 2.27382 8.10027 2.33332 8.19652 2.42957L11.9398 6.17282C12.1398 6.3729 12.2501 6.6389 12.2501 6.9224C12.2501 7.2059 12.1398 7.4719 11.9398 7.67198L7.67152 11.9396C7.46502 12.1461 7.19377 12.2494 6.92193 12.2494Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.9205 6.3299C8.36 6.76865 8.36 7.4819 7.9205 7.92065C7.481 8.36015 6.76925 8.36015 6.32975 7.92065C5.89025 7.4819 5.89025 6.76865 6.32975 6.3299C6.76925 5.8904 7.481 5.8904 7.9205 6.3299ZM4.37563 9.66898L8.89963 14.1937L14.1931 8.90023L9.66913 4.37548L3.83038 3.83098L4.37563 9.66898ZM8.89963 15.7492C8.55088 15.7492 8.20288 15.6165 7.93663 15.3517L3.12388 10.5382C3.00013 10.4152 2.92363 10.2517 2.90713 10.0777L2.25313 3.06973C2.23288 2.84773 2.31163 2.62798 2.46988 2.46973C2.62813 2.31148 2.84713 2.23123 3.06988 2.25373L10.0779 2.90773C10.2519 2.92348 10.4146 2.99998 10.5384 3.12373L15.3511 7.93648C15.6084 8.19373 15.7501 8.53573 15.7501 8.90023C15.7501 9.26473 15.6084 9.60673 15.3511 9.86398L9.86338 15.351C9.59788 15.6165 9.24913 15.7492 8.89963 15.7492Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.04045 5.62658C7.43111 6.01658 7.43111 6.65058 7.04045 7.04058C6.64978 7.43125 6.01711 7.43125 5.62645 7.04058C5.23578 6.65058 5.23578 6.01658 5.62645 5.62658C6.01711 5.23591 6.64978 5.23591 7.04045 5.62658ZM3.88945 8.59465L7.91078 12.6166L12.6161 7.91131L8.59478 3.88931L3.40478 3.40531L3.88945 8.59465ZM7.91078 13.9993C7.60078 13.9993 7.29145 13.8813 7.05478 13.646L2.77678 9.36731C2.66678 9.25798 2.59878 9.11265 2.58411 8.95798L2.00278 2.72865C1.98478 2.53131 2.05478 2.33598 2.19545 2.19531C2.33611 2.05465 2.53078 1.98331 2.72878 2.00331L8.95811 2.58465C9.11278 2.59865 9.25745 2.66665 9.36745 2.77665L13.6454 7.05465C13.8741 7.28331 14.0001 7.58731 14.0001 7.91131C14.0001 8.23531 13.8741 8.53931 13.6454 8.76798L8.76745 13.6453C8.53145 13.8813 8.22145 13.9993 7.91078 13.9993Z'
        fill={color}
      />
    </svg>
  );
};

export const FlagIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M10.4997 8.5085C10.2687 8.61175 9.81426 8.75 9.04134 8.75C8.38567 8.75 7.81576 8.52658 7.21259 8.29033C6.53476 8.02492 5.83359 7.75017 4.95801 7.75017C4.34142 7.75017 3.86367 7.82425 3.49967 7.924V7V3.15933C3.73067 3.05608 4.18626 2.91667 4.95801 2.91667C5.61367 2.91667 6.18359 3.14008 6.78676 3.37633C7.46459 3.64175 8.16576 3.9165 9.04134 3.9165C9.58851 3.9165 10.0773 3.85758 10.4997 3.7415V8.5085ZM11.2393 2.73C10.9698 2.53517 10.621 2.47975 10.3066 2.58242C9.97059 2.6915 9.53309 2.74983 9.04134 2.74983C8.38567 2.74983 7.81576 2.52642 7.21259 2.29017C6.53476 2.02475 5.83359 1.75 4.95801 1.75C3.27392 1.75 2.62176 2.30533 2.50801 2.41733C2.39601 2.52642 2.33301 2.67692 2.33301 2.83325V7V8.83342V11.6667C2.33301 11.9892 2.59376 12.25 2.91634 12.25C3.23892 12.25 3.49967 11.9892 3.49967 11.6667V9.1595C3.73009 9.05683 4.18392 8.91683 4.95801 8.91683C5.61367 8.91683 6.18359 9.14025 6.78676 9.3765C7.46459 9.64192 8.16576 9.91667 9.04134 9.91667C10.0966 9.91667 10.7464 9.69617 11.1069 9.51125C11.4523 9.33217 11.6663 8.9845 11.6663 8.60358V3.56183C11.6663 3.23517 11.5071 2.92425 11.2393 2.73Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M13.5 10.9394C13.203 11.0721 12.6187 11.2499 11.625 11.2499C10.782 11.2499 10.0492 10.9626 9.27375 10.6589C8.40225 10.3176 7.50075 9.96438 6.375 9.96438C5.58225 9.96438 4.968 10.0596 4.5 10.1879V8.99988V4.06188C4.797 3.92913 5.38275 3.74988 6.375 3.74988C7.218 3.74988 7.95075 4.03713 8.72625 4.34088C9.59775 4.68213 10.4992 5.03538 11.625 5.03538C12.3285 5.03538 12.957 4.95963 13.5 4.81038V10.9394ZM14.451 3.50988C14.1045 3.25938 13.656 3.18813 13.2517 3.32013C12.8197 3.46038 12.2572 3.53538 11.625 3.53538C10.782 3.53538 10.0492 3.24813 9.27375 2.94438C8.40225 2.60313 7.50075 2.24988 6.375 2.24988C4.20975 2.24988 3.37125 2.96388 3.225 3.10788C3.081 3.24813 3 3.44163 3 3.64263V8.99988V11.3571V14.9999C3 15.4146 3.33525 15.7499 3.75 15.7499C4.16475 15.7499 4.5 15.4146 4.5 14.9999V11.7764C4.79625 11.6444 5.37975 11.4644 6.375 11.4644C7.218 11.4644 7.95075 11.7516 8.72625 12.0554C9.59775 12.3966 10.4992 12.7499 11.625 12.7499C12.9818 12.7499 13.8173 12.4664 14.2808 12.2286C14.7248 11.9984 15 11.5514 15 11.0616V4.57938C15 4.15938 14.7952 3.75963 14.451 3.50988Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.0003 9.72388C11.7363 9.84188 11.217 9.99988 10.3337 9.99988C9.58433 9.99988 8.93299 9.74454 8.24366 9.47454C7.46899 9.17121 6.66766 8.85721 5.66699 8.85721C4.96233 8.85721 4.41633 8.94188 4.00033 9.05588V7.99988V3.61054C4.26433 3.49254 4.78499 3.33321 5.66699 3.33321C6.41633 3.33321 7.06766 3.58854 7.75699 3.85854C8.53166 4.16188 9.33299 4.47588 10.3337 4.47588C10.959 4.47588 11.5177 4.40854 12.0003 4.27588V9.72388ZM12.8457 3.11988C12.5377 2.89721 12.139 2.83388 11.7797 2.95121C11.3957 3.07588 10.8957 3.14254 10.3337 3.14254C9.58433 3.14254 8.93299 2.88721 8.24366 2.61721C7.46899 2.31388 6.66766 1.99988 5.66699 1.99988C3.74233 1.99988 2.99699 2.63454 2.86699 2.76254C2.73899 2.88721 2.66699 3.05921 2.66699 3.23788V7.99988V10.0952V13.3332C2.66699 13.7019 2.96499 13.9999 3.33366 13.9999C3.70233 13.9999 4.00033 13.7019 4.00033 13.3332V10.4679C4.26366 10.3505 4.78233 10.1905 5.66699 10.1905C6.41633 10.1905 7.06766 10.4459 7.75699 10.7159C8.53166 11.0192 9.33299 11.3332 10.3337 11.3332C11.5397 11.3332 12.2823 11.0812 12.6943 10.8699C13.089 10.6652 13.3337 10.2679 13.3337 9.83254V4.07054C13.3337 3.69721 13.1517 3.34188 12.8457 3.11988Z'
        fill={color}
      />
    </svg>
  );
};

export const CheckmarkPlainIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.2486 6.40158H12.2504C12.5718 6.40158 12.8331 6.66175 12.8337 6.98316C12.8384 8.54125 12.2358 10.0083 11.1368 11.1132C10.0384 12.218 8.57535 12.8287 7.01727 12.8334H7.00035C5.4481 12.8334 3.98802 12.2314 2.88727 11.1365C1.78244 10.0381 1.17169 8.57508 1.16702 7.017C1.16235 5.45833 1.76494 3.99183 2.86394 2.887C3.96235 1.78216 5.42535 1.17141 6.98344 1.16675C7.44719 1.17375 7.91969 1.22041 8.37235 1.32891C8.68502 1.40475 8.8781 1.71975 8.80227 2.033C8.72702 2.34566 8.41027 2.53816 8.09877 2.4635C7.73652 2.376 7.3521 2.33925 6.98694 2.33341C5.74035 2.33691 4.5696 2.82575 3.6911 3.7095C2.81202 4.59325 2.33019 5.76691 2.33369 7.0135C2.33719 8.26008 2.82602 9.43025 3.70977 10.3093C4.5906 11.1849 5.75844 11.6667 7.00035 11.6667H7.01377C8.26035 11.6632 9.4311 11.1744 10.3096 10.2907C11.1887 9.40633 11.6705 8.23325 11.667 6.98666C11.6664 6.66466 11.9266 6.40216 12.2486 6.40158ZM4.83794 6.58761C5.06602 6.35952 5.43469 6.35952 5.66277 6.58761L6.97177 7.89661L10.645 3.69894C10.8574 3.45802 11.2254 3.43236 11.4681 3.64469C11.7102 3.85644 11.7347 4.22511 11.5224 4.46777L7.43902 9.13444C7.33285 9.25577 7.18119 9.32752 7.0196 9.33336H7.00035C6.84577 9.33336 6.6976 9.27211 6.58794 9.16244L4.83794 7.41244C4.60985 7.18436 4.60985 6.81569 4.83794 6.58761Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M15.7478 8.23062H15.75C16.1633 8.23062 16.4993 8.56512 16.5 8.97837C16.506 10.9816 15.7313 12.8679 14.3183 14.2884C12.906 15.7089 11.025 16.4941 9.02178 16.5001H9.00003C7.00428 16.5001 5.12703 15.7261 3.71178 14.3184C2.29128 12.9061 1.50603 11.0251 1.50003 9.02187C1.49403 7.01787 2.26878 5.13237 3.68178 3.71187C5.09403 2.29137 6.97503 1.50612 8.97828 1.50012C9.57453 1.50912 10.182 1.56912 10.764 1.70862C11.166 1.80612 11.4143 2.21112 11.3168 2.61387C11.22 3.01587 10.8128 3.26337 10.4123 3.16737C9.94653 3.05487 9.45228 3.00762 8.98278 3.00012C7.38003 3.00462 5.87478 3.63312 4.74528 4.76937C3.61503 5.90562 2.99553 7.41462 3.00003 9.01737C3.00453 10.6201 3.63303 12.1246 4.76928 13.2549C5.90178 14.3806 7.40328 15.0001 9.00003 15.0001H9.01728C10.62 14.9956 12.1253 14.3671 13.2548 13.2309C14.385 12.0939 15.0045 10.5856 15 8.98287C14.9993 8.56887 15.3338 8.23137 15.7478 8.23062ZM6.21978 8.4698C6.51303 8.17655 6.98703 8.17655 7.28028 8.4698L8.96328 10.1528L13.686 4.7558C13.959 4.44605 14.4323 4.41305 14.7443 4.68605C15.0555 4.9583 15.087 5.4323 14.814 5.7443L9.56403 11.7443C9.42753 11.9003 9.23253 11.9925 9.02478 12H9.00003C8.80128 12 8.61078 11.9213 8.46978 11.7803L6.21978 9.5303C5.92653 9.23705 5.92653 8.76305 6.21978 8.4698Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.9977 7.31604H13.9997C14.367 7.31604 14.6657 7.61337 14.6664 7.98071C14.6717 9.76137 13.983 11.438 12.727 12.7007C11.4717 13.9634 9.7997 14.6614 8.01904 14.6667H7.9997C6.2257 14.6667 4.55704 13.9787 3.29904 12.7274C2.03637 11.472 1.33837 9.80004 1.33304 8.01937C1.32771 6.23804 2.01637 4.56204 3.27237 3.29937C4.52771 2.03671 6.19971 1.33871 7.98037 1.33337C8.51037 1.34137 9.05037 1.39471 9.5677 1.51871C9.92504 1.60537 10.1457 1.96537 10.059 2.32337C9.97304 2.68071 9.61104 2.90071 9.25504 2.81537C8.84104 2.71537 8.4017 2.67337 7.98437 2.66671C6.5597 2.67071 5.2217 3.22937 4.21771 4.23937C3.21304 5.24937 2.66237 6.59071 2.66637 8.01537C2.67037 9.44004 3.22904 10.7774 4.23904 11.782C5.2457 12.7827 6.58037 13.3334 7.9997 13.3334H8.01504C9.4397 13.3294 10.7777 12.7707 11.7817 11.7607C12.7864 10.75 13.337 9.40937 13.333 7.98471C13.3324 7.61671 13.6297 7.31671 13.9977 7.31604ZM5.52837 7.52864C5.78904 7.26797 6.21037 7.26797 6.47104 7.52864L7.96704 9.02464L12.165 4.22731C12.4077 3.95197 12.8284 3.92264 13.1057 4.16531C13.3824 4.40731 13.4104 4.82864 13.1677 5.10597L8.50104 10.4393C8.37971 10.578 8.20637 10.66 8.02171 10.6666H7.99971C7.82304 10.6666 7.65371 10.5966 7.52837 10.4713L5.52837 8.47131C5.26771 8.21064 5.26771 7.78931 5.52837 7.52864Z'
        fill={color}
      />
    </svg>
  );
};

export const SendIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.4995 6.0027C8.4995 6.0017 8.5 6.0012 8.5 6.0002C8.5 5.9837 8.492 5.9702 8.4905 5.9542C8.4865 5.9062 8.4805 5.8582 8.462 5.8132C8.4485 5.7792 8.4255 5.7522 8.405 5.7222C8.3895 5.7002 8.381 5.6747 8.362 5.6547L6.9305 4.1547C6.7395 3.9547 6.4235 3.9477 6.2235 4.1382C6.024 4.3287 6.0165 4.6452 6.207 4.8452L6.832 5.5002H4C3.724 5.5002 3.5 5.7237 3.5 6.0002C3.5 6.2762 3.724 6.5002 4 6.5002H6.793L6.1465 7.1467C5.951 7.3417 5.951 7.6582 6.1465 7.8537C6.244 7.9512 6.372 8.0002 6.5 8.0002C6.628 8.0002 6.756 7.9512 6.8535 7.8537L8.3535 6.3537C8.399 6.3082 8.436 6.2532 8.461 6.1927C8.4865 6.1322 8.499 6.0677 8.4995 6.0027ZM6 10C3.7945 10 2 8.2055 2 6C2 3.7945 3.7945 2 6 2C8.2055 2 10 3.7945 10 6C10 8.2055 8.2055 10 6 10ZM6 1C3.243 1 1 3.243 1 6C1 8.757 3.243 11 6 11C8.757 11 11 8.757 11 6C11 3.243 8.757 1 6 1Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.3323 8.00364C11.3323 8.00231 11.333 8.00164 11.333 8.00031C11.333 7.97831 11.3223 7.96031 11.3203 7.93897C11.315 7.87497 11.307 7.81097 11.2823 7.75097C11.2643 7.70564 11.2337 7.66964 11.2063 7.62964C11.1857 7.60031 11.1743 7.56631 11.149 7.53964L9.24034 5.53964C8.98567 5.27297 8.56434 5.26364 8.29767 5.51764C8.03167 5.77164 8.02167 6.19364 8.27567 6.46031L9.10901 7.33364H5.33301C4.96501 7.33364 4.66634 7.63164 4.66634 8.00031C4.66634 8.36831 4.96501 8.66697 5.33301 8.66697H9.05701L8.19501 9.52897C7.93434 9.78897 7.93434 10.211 8.19501 10.4716C8.32501 10.6016 8.49567 10.667 8.66634 10.667C8.83701 10.667 9.00767 10.6016 9.13767 10.4716L11.1377 8.47164C11.1983 8.41097 11.2477 8.33764 11.281 8.25697C11.315 8.17631 11.3317 8.09031 11.3323 8.00364ZM7.99967 13.3334C5.05901 13.3334 2.66634 10.9407 2.66634 8.00004C2.66634 5.05937 5.05901 2.66671 7.99967 2.66671C10.9403 2.66671 13.333 5.05937 13.333 8.00004C13.333 10.9407 10.9403 13.3334 7.99967 13.3334ZM7.99967 1.33337C4.32367 1.33337 1.33301 4.32404 1.33301 8.00004C1.33301 11.676 4.32367 14.6667 7.99967 14.6667C11.6757 14.6667 14.6663 11.676 14.6663 8.00004C14.6663 4.32404 11.6757 1.33337 7.99967 1.33337Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.91641 7.00311C9.91641 7.00194 9.91699 7.00136 9.91699 7.00019C9.91699 6.98094 9.90766 6.96519 9.90591 6.94653C9.90124 6.89053 9.89424 6.83453 9.87266 6.78203C9.85691 6.74236 9.83008 6.71086 9.80616 6.67586C9.78808 6.65019 9.77816 6.62044 9.75599 6.59711L8.08591 4.84711C7.86308 4.61378 7.49441 4.60561 7.26108 4.82786C7.02833 5.05011 7.01958 5.41936 7.24183 5.65269L7.97099 6.41686H4.66699C4.34499 6.41686 4.08366 6.67761 4.08366 7.00019C4.08366 7.32219 4.34499 7.58353 4.66699 7.58353H7.92549L7.17124 8.33778C6.94316 8.56528 6.94316 8.93453 7.17124 9.16261C7.28499 9.27636 7.43433 9.33353 7.58366 9.33353C7.73299 9.33353 7.88233 9.27636 7.99608 9.16261L9.74608 7.41261C9.79916 7.35953 9.84233 7.29536 9.87149 7.22478C9.90124 7.15419 9.91583 7.07894 9.91641 7.00311ZM7.00033 11.6666C4.42724 11.6666 2.33366 9.57304 2.33366 6.99996C2.33366 4.42688 4.42724 2.33329 7.00033 2.33329C9.57341 2.33329 11.667 4.42688 11.667 6.99996C11.667 9.57304 9.57341 11.6666 7.00033 11.6666ZM7.00033 1.16663C3.78383 1.16663 1.16699 3.78346 1.16699 6.99996C1.16699 10.2165 3.78383 12.8333 7.00033 12.8333C10.2168 12.8333 12.8337 10.2165 12.8337 6.99996C12.8337 3.78346 10.2168 1.16663 7.00033 1.16663Z'
        fill={color}
      />
    </svg>
  );
};

export const TrendUpIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.2456 4.06175C12.2445 4.01975 12.2322 3.98008 12.2211 3.93983C12.2124 3.906 12.2083 3.87158 12.1937 3.84067C12.1803 3.81033 12.1575 3.78583 12.1377 3.75783C12.1132 3.72225 12.091 3.68667 12.0595 3.6575C12.0543 3.65225 12.052 3.64525 12.0461 3.64058C12.0251 3.6225 11.9995 3.61608 11.9767 3.6015C11.9417 3.57875 11.9073 3.55542 11.8676 3.54025C11.8285 3.52625 11.79 3.52275 11.7498 3.51692C11.7218 3.51283 11.6967 3.5 11.667 3.5H8.75029C8.42771 3.5 8.16696 3.76133 8.16696 4.08333C8.16696 4.40533 8.42771 4.66667 8.75029 4.66667H10.3988L8.04446 7.413L5.55012 5.91675C5.30337 5.76742 4.98604 5.82225 4.80171 6.04333L1.88504 9.54333C1.67912 9.79067 1.71237 10.1587 1.95971 10.3647C2.06937 10.4557 2.20121 10.5 2.33304 10.5C2.50046 10.5 2.66612 10.4288 2.78162 10.29L5.37862 7.17383L7.86654 8.66717C8.11096 8.81358 8.42479 8.76225 8.60971 8.54642L11.0836 5.66008V7C11.0836 7.322 11.3444 7.58333 11.667 7.58333C11.9895 7.58333 12.2503 7.322 12.2503 7V4.08333C12.2503 4.07575 12.2462 4.06933 12.2456 4.06175'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M15.7444 5.22213C15.7429 5.16813 15.7271 5.11713 15.7129 5.06538C15.7016 5.02188 15.6964 4.97763 15.6776 4.93788C15.6604 4.89888 15.6311 4.86738 15.6056 4.83138C15.5741 4.78563 15.5456 4.73988 15.5051 4.70238C15.4984 4.69563 15.4954 4.68663 15.4879 4.68063C15.4609 4.65738 15.4279 4.64913 15.3986 4.63038C15.3536 4.60113 15.3094 4.57113 15.2584 4.55163C15.2081 4.53363 15.1586 4.52913 15.1069 4.52163C15.0709 4.51638 15.0386 4.49988 15.0004 4.49988H11.2504C10.8356 4.49988 10.5004 4.83588 10.5004 5.24988C10.5004 5.66388 10.8356 5.99988 11.2504 5.99988H13.3699L10.3429 9.53088L7.13587 7.60713C6.81862 7.41513 6.41062 7.48563 6.17362 7.76988L2.42362 12.2699C2.15887 12.5879 2.20162 13.0611 2.51962 13.3259C2.66062 13.4429 2.83012 13.4999 2.99962 13.4999C3.21487 13.4999 3.42787 13.4084 3.57637 13.2299L6.91537 9.22338L10.1141 11.1434C10.4284 11.3316 10.8319 11.2656 11.0696 10.9881L14.2504 7.27713V8.99988C14.2504 9.41388 14.5856 9.74988 15.0004 9.74988C15.4151 9.74988 15.7504 9.41388 15.7504 8.99988V5.24988C15.7504 5.24013 15.7451 5.23188 15.7444 5.22213'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.995 4.64188C13.9937 4.59388 13.9797 4.54854 13.967 4.50254C13.957 4.46388 13.9523 4.42454 13.9357 4.38921C13.9203 4.35454 13.8943 4.32654 13.8717 4.29454C13.8437 4.25388 13.8183 4.21321 13.7823 4.17988C13.7763 4.17388 13.7737 4.16588 13.767 4.16054C13.743 4.13988 13.7137 4.13254 13.6877 4.11588C13.6477 4.08988 13.6083 4.06321 13.563 4.04588C13.5183 4.02988 13.4743 4.02588 13.4283 4.01921C13.3963 4.01454 13.3677 3.99988 13.3337 3.99988H10.0003C9.63166 3.99988 9.33366 4.29854 9.33366 4.66654C9.33366 5.03454 9.63166 5.33321 10.0003 5.33321H11.8843L9.19366 8.47188L6.343 6.76188C6.061 6.59121 5.69833 6.65388 5.48766 6.90654L2.15433 10.9065C1.919 11.1892 1.957 11.6099 2.23966 11.8452C2.365 11.9492 2.51566 11.9999 2.66633 11.9999C2.85766 11.9999 3.047 11.9185 3.179 11.7599L6.147 8.19854L8.99033 9.90521C9.26966 10.0725 9.62833 10.0139 9.83966 9.76721L12.667 6.46854V7.99988C12.667 8.36788 12.965 8.66654 13.3337 8.66654C13.7023 8.66654 14.0003 8.36788 14.0003 7.99988V4.66654C14.0003 4.65788 13.9957 4.65054 13.995 4.64188'
        fill={color}
      />
    </svg>
  );
};

export const BiddersIcon = ({ color, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M10.7799 2.16044C10.6293 1.9474 10.444 1.77809 10.2367 1.66416C10.0294 1.55023 9.80498 1.49438 9.57896 1.50045L1.47376 1.50844C0.663258 1.50844 0 2.20753 0 3.07183V10.9282C0 11.7925 0.663258 12.4916 1.47376 12.4916L9.57896 12.4996C9.80498 12.5056 10.0294 12.4498 10.2367 12.3358C10.444 12.2219 10.6293 12.0526 10.7799 11.8396L14 7.00014L10.7799 2.16044ZM9.57896 10.9282H1.47376V3.07183H9.57896L12.1947 7.00014L9.57896 10.9282Z'
          fill={color}
        />
      </svg>
    );
  }
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M12.3199 2.28052C12.1478 2.02875 11.936 1.82866 11.6991 1.69401C11.4621 1.55936 11.2057 1.49336 10.9474 1.50053L1.68429 1.50997C0.758009 1.50997 0 2.33617 0 3.35762V12.6424C0 13.6638 0.758009 14.49 1.68429 14.49L10.9474 14.4995C11.2057 14.5066 11.4621 14.4406 11.6991 14.306C11.936 14.1713 12.1478 13.9713 12.3199 13.7195L16 8.00017L12.3199 2.28052ZM10.9474 12.6424H1.68429V3.35762H10.9474L13.9368 8.00017L10.9474 12.6424Z'
        fill={color}
      />
    </svg>
  );
};

export const ChannelsIcon = ({ color, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.8997 11.9001C11.8997 12.2865 11.5861 12.6001 11.1997 12.6001H2.79983C2.41343 12.6001 2.09984 12.2865 2.09984 11.9001V4.90019C2.09984 4.5138 2.41343 4.2002 2.79983 4.2002H11.1997C11.5861 4.2002 11.8997 4.5138 11.8997 4.90019V11.9001ZM11.2001 2.80014H8.68989L10.295 1.19506C10.5687 0.921363 10.5687 0.478969 10.295 0.205272C10.0213 -0.0684241 9.57888 -0.0684241 9.30519 0.205272L7.00012 2.51034L4.69504 0.205272C4.42135 -0.0684241 3.97895 -0.0684241 3.70526 0.205272C3.43156 0.478969 3.43156 0.921363 3.70526 1.19506L5.31034 2.80014H2.80017C1.64238 2.80014 0.700195 3.74233 0.700195 4.90011V11.9C0.700195 13.0578 1.64238 14 2.80017 14H11.2001C12.3578 14 13.3 13.0578 13.3 11.9V4.90011C13.3 3.74233 12.3578 2.80014 11.2001 2.80014Z'
          fill={color}
        />
        <path
          d='M4.78485 10.0308L6.74 8.09378C6.85811 7.97677 6.92695 7.81957 6.93129 7.65692C6.93562 7.49426 6.87509 7.33931 6.76311 7.22628C6.52991 6.9909 6.14139 6.99764 5.89543 7.24132L3.94466 9.17402C3.82655 9.29103 3.7577 9.44823 3.75337 9.61088C3.74904 9.77354 3.80957 9.92849 3.92155 10.0415C4.15306 10.2752 4.53822 10.2706 4.78485 10.0308Z'
          fill={color}
        />
        <path
          d='M5.85141 7.98865L7.40946 10.0441C7.50358 10.1683 7.64427 10.2493 7.80048 10.2691C7.95668 10.2889 8.11575 10.246 8.24255 10.1499C8.5066 9.94977 8.56177 9.57781 8.36577 9.31923L6.81121 7.26836C6.71709 7.1442 6.5764 7.06323 6.42019 7.04339C6.26399 7.02355 6.10492 7.06645 5.97812 7.16256C5.71599 7.36126 5.65923 7.7298 5.85141 7.98865Z'
          fill={color}
        />
        <path
          d='M9.37428 7.23863L7.52196 9.1826C7.41006 9.30003 7.34845 9.45633 7.35078 9.61697C7.35311 9.77761 7.41918 9.92959 7.53437 10.0393C7.77425 10.2679 8.1577 10.255 8.39072 10.0104L10.2389 8.07079C10.3508 7.95336 10.4124 7.79706 10.4101 7.63642C10.4077 7.47578 10.3417 7.3238 10.2265 7.21404C9.98835 6.98714 9.60813 6.99788 9.37428 7.23863Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.5996 13.6C13.5996 14.0416 13.2412 14.4 12.7996 14.4H3.19975C2.75815 14.4 2.39976 14.0416 2.39976 13.6V5.60011C2.39976 5.15852 2.75815 4.80012 3.19975 4.80012H12.7996C13.2412 4.80012 13.5996 5.15852 13.5996 5.60011V13.6ZM12.7997 3.20016H9.93089L11.7653 1.36578C12.0781 1.05299 12.0781 0.547393 11.7653 0.234597C11.4525 -0.078199 10.9469 -0.078199 10.6341 0.234597L7.99971 2.86896L5.36535 0.234597C5.05255 -0.078199 4.54696 -0.078199 4.23416 0.234597C3.92137 0.547393 3.92137 1.05299 4.23416 1.36578L6.06854 3.20016H3.19977C1.87659 3.20016 0.799805 4.27695 0.799805 5.60013V13.6C0.799805 14.9232 1.87659 16 3.19977 16H12.7997C14.1228 16 15.1996 14.9232 15.1996 13.6V5.60013C15.1996 4.27695 14.1228 3.20016 12.7997 3.20016Z'
        fill={color}
      />
      <path
        d='M5.46784 11.4638L7.7023 9.25004C7.83728 9.11631 7.91596 8.93666 7.92091 8.75076C7.92586 8.56487 7.85668 8.38778 7.72871 8.25861C7.46219 7.9896 7.01817 7.9973 6.73707 8.27579L4.50762 10.4846C4.37264 10.6183 4.29396 10.798 4.28901 10.9839C4.28406 11.1698 4.35324 11.3468 4.48121 11.476C4.74579 11.7431 5.18598 11.7379 5.46784 11.4638Z'
        fill={color}
      />
      <path
        d='M6.68663 9.12987L8.46725 11.479C8.57482 11.6209 8.73561 11.7134 8.91413 11.7361C9.09265 11.7588 9.27444 11.7097 9.41935 11.5999C9.72113 11.3711 9.78419 10.946 9.56018 10.6505L7.78355 8.30668C7.67598 8.16478 7.51518 8.07224 7.33667 8.04957C7.15815 8.0269 6.97635 8.07592 6.83144 8.18577C6.53186 8.41285 6.467 8.83404 6.68663 9.12987Z'
        fill={color}
      />
      <path
        d='M10.7128 8.27257L8.59583 10.4942C8.46795 10.6284 8.39753 10.8071 8.40019 10.9907C8.40285 11.1742 8.47837 11.3479 8.61001 11.4734C8.88416 11.7346 9.32238 11.7198 9.5887 11.4403L11.7009 9.2236C11.8288 9.0894 11.8992 8.91077 11.8965 8.72718C11.8939 8.5436 11.8184 8.3699 11.6867 8.24446C11.4146 7.98514 10.98 7.99742 10.7128 8.27257Z'
        fill={color}
      />
    </svg>
  );
};

export const MonitorIcon = ({ color, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M8.10784 2.63396C7.89858 2.66987 7.72824 2.82235 7.66939 3.02634L5.73097 9.07269L4.20783 5.47256L4.20764 5.47237C4.12811 5.27665 3.94385 5.14316 3.73308 5.1283C3.52213 5.11364 3.32133 5.22025 3.21528 5.40299L2.03831 7.45689H0.56123C0.413074 7.45501 0.270367 7.51254 0.164891 7.61651C0.0594141 7.72067 0 7.86263 0 8.01078C0 8.15894 0.0594141 8.30107 0.164891 8.40505C0.270367 8.50921 0.413069 8.56674 0.56123 8.56467H2.36127C2.56094 8.56655 2.74614 8.4607 2.84596 8.28773L3.63056 6.92612L5.29223 10.8955V10.8957C5.38191 11.1097 5.59568 11.245 5.8275 11.2347C6.05933 11.2246 6.26013 11.0709 6.33063 10.8498L8.19988 4.98783L9.69987 9.51114H9.70006C9.76812 9.72265 9.95595 9.87307 10.1772 9.89319C10.3985 9.9133 10.6104 9.79918 10.7156 9.60346L11.7771 7.75716H13.4388C13.5869 7.75923 13.7296 7.7017 13.8351 7.59753C13.9406 7.49356 14 7.35142 14 7.20326C14 7.05511 13.9406 6.91316 13.8351 6.80899C13.7296 6.70502 13.5869 6.64749 13.4388 6.64937H11.4541C11.2544 6.64768 11.0692 6.75353 10.9694 6.92632L10.3694 7.98787L8.73088 3.00283V3.00302C8.64345 2.74243 8.37835 2.58525 8.10781 2.63376L8.10784 2.63396Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M9.2661 3.01024C9.02695 3.05128 8.83227 3.22554 8.76501 3.45868L6.54967 10.3688L4.80894 6.25435L4.80873 6.25414C4.71784 6.03045 4.50726 5.87789 4.26638 5.86092C4.02529 5.84416 3.7958 5.966 3.67461 6.17485L2.32949 8.52215H0.641405C0.472085 8.52001 0.308991 8.58576 0.188446 8.70458C0.0679018 8.82363 0 8.98586 0 9.15518C0 9.3245 0.0679018 9.48694 0.188446 9.60577C0.308991 9.72481 0.472079 9.79056 0.641405 9.7882H2.6986C2.92679 9.79035 3.13845 9.66937 3.25253 9.47169L4.14921 7.91557L6.04826 12.452V12.4522C6.15076 12.6968 6.39507 12.8515 6.66 12.8397C6.92494 12.8281 7.15443 12.6525 7.235 12.3998L9.37129 5.70038L11.0856 10.8699H11.0858C11.1636 11.1116 11.3782 11.2835 11.6311 11.3065C11.884 11.3295 12.1262 11.1991 12.2463 10.9754L13.4596 8.86532H15.3586C15.5279 8.86769 15.691 8.80194 15.8116 8.6829C15.9321 8.56407 16 8.40162 16 8.2323C16 8.06298 15.9321 7.90075 15.8116 7.78171C15.691 7.66288 15.5279 7.59713 15.3586 7.59928H13.0904C12.8622 7.59734 12.6505 7.71832 12.5365 7.91579L11.8508 9.12899L9.97814 3.43181V3.43202C9.87823 3.1342 9.57525 2.95457 9.26607 3.01001L9.2661 3.01024Z'
        fill={color}
      />
    </svg>
  );
};

export const HandshakeIcon = ({ color, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.57602 11.0131C2.26653 11.3521 1.75101 11.4434 1.3355 11.2056L0.500003 10.7267C0.0219997 10.4528 -0.141973 9.84584 0.134029 9.3709L2.42199 5.43745C2.698 4.963 3.30994 4.80024 3.78797 5.0742L4.62346 5.5531C5.04144 5.79283 5.21944 6.28656 5.07301 6.72437L5.69198 7.10402L6.88999 7.37355L6.99345 7.26288C7.08899 7.16019 7.22348 7.10203 7.36443 7.10303L8.50149 7.11144L8.96255 6.76061C8.78655 6.31196 8.96211 5.79086 9.39504 5.54272L10.212 5.07422C10.69 4.80026 11.302 4.963 11.578 5.43747L13.866 9.37092C14.142 9.84583 13.978 10.4528 13.5 10.7268L12.683 11.1953C12.3296 11.3978 11.903 11.3615 11.5931 11.1372L11.1455 11.5382L10.4215 12.5422C10.3961 12.7139 10.3405 12.8822 10.2545 13.039C10.0166 13.4722 9.57808 13.7606 9.08356 13.8092L7.24158 13.9893C6.83454 14.029 6.4236 13.9575 6.05451 13.7818L4.81844 13.1943C4.51196 13.0484 4.27793 12.7858 4.1689 12.4662L3.98184 11.9193C3.95483 11.8389 3.89881 11.7714 3.82481 11.7292L2.5758 11.013L2.57602 11.0131ZM4.59055 7.59523L3.09557 10.165L4.32503 10.8698C4.60907 11.0325 4.82404 11.2926 4.92949 11.6013L5.11599 12.1482C5.13853 12.2147 5.18697 12.2689 5.25104 12.2991L6.48653 12.8867C6.69099 12.984 6.91802 13.0236 7.14356 13.0018L8.98509 12.8211C9.15061 12.8053 9.29715 12.7085 9.37661 12.564C9.45607 12.4191 9.45808 12.2449 9.38208 12.098L8.29701 10.0016L7.15046 10.6706C6.74343 10.9077 6.2404 10.9153 5.82645 10.69C5.41251 10.4652 5.14845 10.0398 5.1309 9.57185C5.12387 9.38231 5.1924 9.19765 5.32186 9.05872L6.10693 8.21503L5.38941 8.05373C5.33539 8.04132 5.28394 8.0205 5.23695 7.9917L4.59041 7.59512L4.59055 7.59523ZM9.45744 7.63489L8.97395 8.00268C8.88545 8.07015 8.77696 8.10593 8.66592 8.10537L7.57797 8.09696L6.1485 9.63347C6.17596 9.7119 6.23199 9.77892 6.30699 9.82002C6.41246 9.87707 6.54047 9.87508 6.64405 9.81503L8.24651 8.88005C8.36549 8.81104 8.50757 8.7932 8.63949 8.83142C8.77152 8.86909 8.88201 8.95992 8.94452 9.08101L10.0911 11.2955L10.3636 10.9173C10.3846 10.888 10.4086 10.8617 10.4352 10.8374L11.0172 10.3163L9.45769 7.63489L9.45744 7.63489ZM0.99995 9.8672L1.83544 10.3461L4.1234 6.41266L3.28791 5.93375L0.99995 9.8672ZM9.89487 6.40225L12.1828 10.3354L12.9998 9.86737L10.7118 5.93392L9.89487 6.40225Z'
          fill={color}
        />
        <path
          d='M7.78608 3.13072V0.58087C7.78608 0.426836 7.72692 0.279023 7.62164 0.170112C7.51636 0.0612004 7.37348 0 7.22458 0C6.91451 0 6.66309 0.260097 6.66309 0.58087V3.12501C6.66309 3.27905 6.72224 3.42686 6.82752 3.53577C6.9328 3.64468 7.07569 3.70588 7.22458 3.70588C7.53241 3.70588 7.78307 3.44942 7.78608 3.13072Z'
          fill={color}
        />
        <path
          d='M3.50593 1.34101C3.39443 1.43013 3.32018 1.56368 3.2997 1.71213C3.27921 1.86083 3.3139 2.01205 3.3963 2.13273L4.59038 3.88583C4.68768 4.03024 4.84247 4.11632 5.0075 4.11758C5.12039 4.11758 5.23002 4.07795 5.32033 4.00448C5.43648 3.91511 5.51376 3.77827 5.53448 3.62553C5.55496 3.47279 5.51726 3.31753 5.42974 3.19585L4.2254 1.45968C4.05502 1.21505 3.73565 1.16251 3.50593 1.34101Z'
          fill={color}
        />
        <path
          d='M10.632 1.39557L9.0883 3.01274C8.86739 3.24514 8.84819 3.64365 9.04532 3.9037C9.24149 4.16487 9.58078 4.19054 9.80361 3.96039L11.3473 2.34322C11.5699 2.1128 11.5915 1.71428 11.3958 1.45254C11.3014 1.32507 11.1674 1.24722 11.0239 1.2365C10.8805 1.22579 10.7393 1.28304 10.632 1.39557Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.94402 12.5865C2.59032 12.9739 2.00116 13.0782 1.52628 12.8065L0.571432 12.2592C0.0251425 11.9461 -0.162255 11.2524 0.153176 10.7097L2.76799 6.21428C3.08342 5.67205 3.78279 5.48605 4.32911 5.79913L5.28396 6.34645C5.76164 6.62042 5.96507 7.18469 5.79772 7.68505L6.50512 8.11893L7.87428 8.42696L7.99252 8.30049C8.10171 8.18312 8.2554 8.11665 8.41649 8.1178L9.71599 8.12742L10.2429 7.72646C10.0418 7.21373 10.2424 6.61818 10.7372 6.33458L11.6709 5.79916C12.2172 5.48606 12.9165 5.67205 13.232 6.21431L15.8468 10.7097C16.1623 11.2524 15.9749 11.9461 15.4286 12.2592L14.4949 12.7946C14.0909 13.0261 13.6034 12.9847 13.2492 12.7283L12.7377 13.1866L11.9103 14.334C11.8812 14.5303 11.8177 14.7226 11.7195 14.9017C11.4475 15.3969 10.9464 15.7264 10.3812 15.782L8.27609 15.9879C7.81091 16.0332 7.34126 15.9515 6.91944 15.7507L5.50679 15.0792C5.15652 14.9125 4.88906 14.6124 4.76445 14.2472L4.55067 13.6221C4.51981 13.5302 4.45578 13.4531 4.37121 13.4049L2.94377 12.5864L2.94402 12.5865ZM5.24634 8.68032L3.53779 11.6172L4.94289 12.4226C5.26751 12.6086 5.51318 12.9059 5.63371 13.2587L5.84684 13.8838C5.87261 13.9597 5.92797 14.0216 6.00118 14.0562L7.41318 14.7277C7.64685 14.8389 7.90631 14.8842 8.16407 14.8593L10.2687 14.6528C10.4578 14.6347 10.6253 14.524 10.7161 14.3589C10.8069 14.1933 10.8092 13.9942 10.7224 13.8263L9.4823 11.4304L8.17196 12.195C7.70678 12.466 7.13188 12.4747 6.6588 12.2171C6.18572 11.9603 5.88394 11.4741 5.86389 10.9393C5.85585 10.7227 5.93417 10.5117 6.08213 10.3529L6.97935 9.38865L6.15932 9.20432C6.09759 9.19014 6.03879 9.16634 5.98509 9.13342L5.24618 8.68019L5.24634 8.68032ZM10.8085 8.72564L10.2559 9.14597C10.1548 9.22308 10.0308 9.26397 9.90391 9.26334L8.66054 9.25372L7.02686 11.0097C7.05824 11.0994 7.12227 11.176 7.20798 11.2229C7.32852 11.2881 7.47482 11.2859 7.59319 11.2172L9.42459 10.1487C9.56056 10.0698 9.72293 10.0494 9.8737 10.0931C10.0246 10.1362 10.1509 10.24 10.2223 10.3783L11.5327 12.9092L11.8441 12.4769C11.8681 12.4435 11.8955 12.4134 11.9259 12.3857L12.5911 11.7901L10.8088 8.72564L10.8085 8.72564ZM1.1428 11.2769L2.09765 11.8242L4.71246 7.3288L3.75761 6.78148L1.1428 11.2769ZM11.3084 7.31691L13.9232 11.812L14.8569 11.277L12.2421 6.78168L11.3084 7.31691Z'
        fill={color}
      />
      <path
        d='M8.89768 3.57797V0.663851C8.89768 0.487813 8.83007 0.318884 8.70975 0.194414C8.58943 0.0699434 8.42614 0 8.25597 0C7.9016 0 7.61426 0.297254 7.61426 0.663851V3.57144C7.61426 3.74748 7.68187 3.91641 7.80219 4.04088C7.92251 4.16535 8.0858 4.23529 8.25597 4.23529C8.60777 4.23529 8.89424 3.9422 8.89768 3.57797Z'
        fill={color}
      />
      <path
        d='M4.00691 1.53264C3.87949 1.63448 3.79463 1.78712 3.77122 1.95677C3.74781 2.12672 3.78745 2.29954 3.88162 2.43746L5.24629 4.441C5.35748 4.60604 5.53439 4.70442 5.72299 4.70586C5.85201 4.70586 5.97731 4.66056 6.08052 4.5766C6.21326 4.47446 6.30158 4.31808 6.32526 4.14352C6.34867 3.96896 6.30558 3.79152 6.20555 3.65245L4.82917 1.66826C4.63445 1.38868 4.26945 1.32864 4.00691 1.53264Z'
        fill={color}
      />
      <path
        d='M12.1506 1.59499L10.3864 3.44318C10.1339 3.70878 10.1119 4.16423 10.3372 4.46143C10.5614 4.7599 10.9492 4.78924 11.2038 4.52622L12.9681 2.67802C13.2224 2.41468 13.2471 1.95923 13.0235 1.6601C12.9156 1.51441 12.7625 1.42544 12.5984 1.4132C12.4346 1.40095 12.2732 1.46638 12.1506 1.59499Z'
        fill={color}
      />
    </svg>
  );
};

export const LightBulbIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.1817 3.77225L10.3428 4.58309C10.2297 4.69217 10.0832 4.747 9.93741 4.747C9.78458 4.747 9.63233 4.68692 9.51799 4.5685C9.29457 4.3375 9.30041 3.96767 9.53257 3.74425L10.3714 2.934C10.603 2.71059 10.974 2.71642 11.1957 2.948C11.4197 3.179 11.4132 3.54884 11.1817 3.77225ZM4.48266 4.5685C4.36833 4.68692 4.21608 4.747 4.06324 4.747C3.91741 4.747 3.77099 4.69275 3.65783 4.58367L2.81841 3.77284C2.58683 3.54884 2.58041 3.179 2.80441 2.948C3.02841 2.71642 3.39708 2.70942 3.62924 2.93342L4.46866 3.74367C4.70024 3.96767 4.70666 4.3375 4.48266 4.5685ZM3.50033 6.99984C3.50033 7.32242 3.23899 7.58317 2.91699 7.58317H1.75033C1.42833 7.58317 1.16699 7.32242 1.16699 6.99984C1.16699 6.67725 1.42833 6.4165 1.75033 6.4165H2.91699C3.23899 6.4165 3.50033 6.67725 3.50033 6.99984ZM12.8337 6.99984C12.8337 7.32242 12.5729 7.58317 12.2503 7.58317H11.0837C10.7611 7.58317 10.5003 7.32242 10.5003 6.99984C10.5003 6.67725 10.7611 6.4165 11.0837 6.4165H12.2503C12.5729 6.4165 12.8337 6.67725 12.8337 6.99984ZM6.41699 2.9165V1.74984C6.41699 1.42725 6.67833 1.1665 7.00033 1.1665C7.32233 1.1665 7.58366 1.42725 7.58366 1.74984V2.9165C7.58366 3.23909 7.32233 3.49984 7.00033 3.49984C6.67833 3.49984 6.41699 3.23909 6.41699 2.9165ZM7.87591 8.51242C7.69508 8.61684 7.58366 8.80992 7.58366 9.01817V11.6665H6.41699V9.01817C6.41699 8.80992 6.30558 8.61684 6.12474 8.51242C5.58516 8.20267 5.25033 7.62284 5.25033 6.99984C5.25033 6.035 6.03549 5.24984 7.00033 5.24984C7.96516 5.24984 8.75033 6.035 8.75033 6.99984C8.75033 7.62284 8.41549 8.20267 7.87591 8.51242ZM7.00033 4.08317C5.39208 4.08317 4.08366 5.39159 4.08366 6.99984C4.08366 7.92092 4.52291 8.786 5.25033 9.33084V11.6665C5.25033 12.3099 5.77358 12.8332 6.41699 12.8332H7.58366C8.22708 12.8332 8.75033 12.3099 8.75033 11.6665V9.33084C9.47716 8.786 9.91699 7.92092 9.91699 6.99984C9.91699 5.39159 8.60858 4.08317 7.00033 4.08317Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.376 4.85013L13.2975 5.89263C13.152 6.03288 12.9637 6.10338 12.7762 6.10338C12.5798 6.10338 12.384 6.02613 12.237 5.87388C11.9497 5.57688 11.9572 5.10138 12.2557 4.81413L13.3342 3.77238C13.632 3.48513 14.109 3.49263 14.394 3.79038C14.682 4.08738 14.6737 4.56288 14.376 4.85013ZM5.763 5.87388C5.616 6.02613 5.42025 6.10338 5.22375 6.10338C5.03625 6.10338 4.848 6.03363 4.7025 5.89338L3.62325 4.85088C3.3255 4.56288 3.31725 4.08738 3.60525 3.79038C3.89325 3.49263 4.36725 3.48363 4.66575 3.77163L5.745 4.81338C6.04275 5.10138 6.051 5.57688 5.763 5.87388ZM4.5 8.99988C4.5 9.41463 4.164 9.74988 3.75 9.74988H2.25C1.836 9.74988 1.5 9.41463 1.5 8.99988C1.5 8.58513 1.836 8.24988 2.25 8.24988H3.75C4.164 8.24988 4.5 8.58513 4.5 8.99988ZM16.5 8.99988C16.5 9.41463 16.1648 9.74988 15.75 9.74988H14.25C13.8352 9.74988 13.5 9.41463 13.5 8.99988C13.5 8.58513 13.8352 8.24988 14.25 8.24988H15.75C16.1648 8.24988 16.5 8.58513 16.5 8.99988ZM8.25 3.74988V2.24988C8.25 1.83513 8.586 1.49988 9 1.49988C9.414 1.49988 9.75 1.83513 9.75 2.24988V3.74988C9.75 4.16463 9.414 4.49988 9 4.49988C8.586 4.49988 8.25 4.16463 8.25 3.74988ZM10.1257 10.9446C9.89325 11.0789 9.75 11.3271 9.75 11.5949V14.9999H8.25V11.5949C8.25 11.3271 8.10675 11.0789 7.87425 10.9446C7.1805 10.5464 6.75 9.80088 6.75 8.99988C6.75 7.75938 7.7595 6.74988 9 6.74988C10.2405 6.74988 11.25 7.75938 11.25 8.99988C11.25 9.80088 10.8195 10.5464 10.1257 10.9446ZM9 5.24988C6.93225 5.24988 5.25 6.93213 5.25 8.99988C5.25 10.1841 5.81475 11.2964 6.75 11.9969V14.9999C6.75 15.8271 7.42275 16.4999 8.25 16.4999H9.75C10.5773 16.4999 11.25 15.8271 11.25 14.9999V11.9969C12.1845 11.2964 12.75 10.1841 12.75 8.99988C12.75 6.93213 11.0677 5.24988 9 5.24988Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.7783 4.31125L11.8197 5.23792C11.6903 5.36259 11.523 5.42525 11.3563 5.42525C11.1817 5.42525 11.0077 5.35659 10.877 5.22125C10.6217 4.95725 10.6283 4.53459 10.8937 4.27925L11.8523 3.35325C12.117 3.09792 12.541 3.10459 12.7943 3.36925C13.0503 3.63325 13.043 4.05592 12.7783 4.31125ZM5.12234 5.22125C4.99167 5.35659 4.81767 5.42525 4.64301 5.42525C4.47634 5.42525 4.30901 5.36325 4.17967 5.23859L3.22034 4.31192C2.95567 4.05592 2.94834 3.63325 3.20434 3.36925C3.46034 3.10459 3.88167 3.09659 4.14701 3.35259L5.10634 4.27859C5.37101 4.53459 5.37834 4.95725 5.12234 5.22125ZM3.99967 7.99992C3.99967 8.36859 3.70101 8.66659 3.33301 8.66659H1.99967C1.63167 8.66659 1.33301 8.36859 1.33301 7.99992C1.33301 7.63125 1.63167 7.33325 1.99967 7.33325H3.33301C3.70101 7.33325 3.99967 7.63125 3.99967 7.99992ZM14.6663 7.99992C14.6663 8.36859 14.3683 8.66659 13.9997 8.66659H12.6663C12.2977 8.66659 11.9997 8.36859 11.9997 7.99992C11.9997 7.63125 12.2977 7.33325 12.6663 7.33325H13.9997C14.3683 7.33325 14.6663 7.63125 14.6663 7.99992ZM7.33301 3.33325V1.99992C7.33301 1.63125 7.63167 1.33325 7.99967 1.33325C8.36767 1.33325 8.66634 1.63125 8.66634 1.99992V3.33325C8.66634 3.70192 8.36767 3.99992 7.99967 3.99992C7.63167 3.99992 7.33301 3.70192 7.33301 3.33325ZM9.00034 9.72859C8.79367 9.84792 8.66634 10.0686 8.66634 10.3066V13.3333H7.33301V10.3066C7.33301 10.0686 7.20567 9.84792 6.99901 9.72859C6.38234 9.37459 5.99967 8.71192 5.99967 7.99992C5.99967 6.89725 6.89701 5.99992 7.99967 5.99992C9.10234 5.99992 9.99967 6.89725 9.99967 7.99992C9.99967 8.71192 9.61701 9.37459 9.00034 9.72859ZM7.99967 4.66659C6.16167 4.66659 4.66634 6.16192 4.66634 7.99992C4.66634 9.05259 5.16834 10.0413 5.99967 10.6639V13.3333C5.99967 14.0686 6.59767 14.6666 7.33301 14.6666H8.66634C9.40167 14.6666 9.99967 14.0686 9.99967 13.3333V10.6639C10.8303 10.0413 11.333 9.05259 11.333 7.99992C11.333 6.16192 9.83767 4.66659 7.99967 4.66659Z'
        fill={color}
      />
    </svg>
  );
};

export const RadioIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.99935 8.75033C6.03452 8.75033 5.24935 7.96516 5.24935 7.00033C5.24935 6.03549 6.03452 5.25033 6.99935 5.25033C7.96418 5.25033 8.74935 6.03549 8.74935 7.00033C8.74935 7.96516 7.96418 8.75033 6.99935 8.75033ZM6.99935 4.08366C5.3911 4.08366 4.08268 5.39208 4.08268 7.00033C4.08268 8.60857 5.3911 9.91699 6.99935 9.91699C8.6076 9.91699 9.91601 8.60857 9.91601 7.00033C9.91601 5.39208 8.6076 4.08366 6.99935 4.08366ZM6.99935 11.667C4.42627 11.667 2.33268 9.57341 2.33268 7.00033C2.33268 4.42724 4.42627 2.33366 6.99935 2.33366C9.57243 2.33366 11.666 4.42724 11.666 7.00033C11.666 9.57341 9.57243 11.667 6.99935 11.667ZM6.99935 1.16699C3.78285 1.16699 1.16602 3.78383 1.16602 7.00033C1.16602 10.2168 3.78285 12.8337 6.99935 12.8337C10.2158 12.8337 12.8327 10.2168 12.8327 7.00033C12.8327 3.78383 10.2158 1.16699 6.99935 1.16699Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9 11.25C7.7595 11.25 6.75 10.2405 6.75 9C6.75 7.7595 7.7595 6.75 9 6.75C10.2405 6.75 11.25 7.7595 11.25 9C11.25 10.2405 10.2405 11.25 9 11.25ZM9 5.25C6.93225 5.25 5.25 6.93225 5.25 9C5.25 11.0677 6.93225 12.75 9 12.75C11.0677 12.75 12.75 11.0677 12.75 9C12.75 6.93225 11.0677 5.25 9 5.25ZM9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15ZM9 1.5C4.8645 1.5 1.5 4.8645 1.5 9C1.5 13.1355 4.8645 16.5 9 16.5C13.1355 16.5 16.5 13.1355 16.5 9C16.5 4.8645 13.1355 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.00065 9.99967C6.89798 9.99967 6.00065 9.10234 6.00065 7.99967C6.00065 6.89701 6.89798 5.99967 8.00065 5.99967C9.10332 5.99967 10.0007 6.89701 10.0007 7.99967C10.0007 9.10234 9.10332 9.99967 8.00065 9.99967ZM8.00065 4.66634C6.16265 4.66634 4.66732 6.16167 4.66732 7.99967C4.66732 9.83767 6.16265 11.333 8.00065 11.333C9.83865 11.333 11.334 9.83767 11.334 7.99967C11.334 6.16167 9.83865 4.66634 8.00065 4.66634ZM8.00065 13.333C5.05998 13.333 2.66732 10.9403 2.66732 7.99967C2.66732 5.05901 5.05998 2.66634 8.00065 2.66634C10.9413 2.66634 13.334 5.05901 13.334 7.99967C13.334 10.9403 10.9413 13.333 8.00065 13.333ZM8.00065 1.33301C4.32465 1.33301 1.33398 4.32367 1.33398 7.99967C1.33398 11.6757 4.32465 14.6663 8.00065 14.6663C11.6767 14.6663 14.6673 11.6757 14.6673 7.99967C14.6673 4.32367 11.6767 1.33301 8.00065 1.33301Z'
        fill={color}
      />
    </svg>
  );
};

export const PresetIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M7.48435 6.81247H8.44522C8.53016 6.81247 8.61163 6.77296 8.67169 6.70264C8.73176 6.63231 8.7655 6.53694 8.7655 6.43748C8.7655 6.33803 8.73176 6.24265 8.67169 6.17233C8.61163 6.10201 8.53016 6.0625 8.44522 6.0625H7.48435C7.39941 6.0625 7.31794 6.10201 7.25787 6.17233C7.19781 6.24265 7.16406 6.33803 7.16406 6.43748C7.16406 6.53694 7.19781 6.63231 7.25787 6.70264C7.31794 6.77296 7.39941 6.81247 7.48435 6.81247Z'
          fill={color}
        />
        <path
          d='M7.48435 5.31247H9.40608C9.49103 5.31247 9.57249 5.27296 9.63256 5.20264C9.69262 5.13231 9.72637 5.03694 9.72637 4.93748C9.72637 4.83803 9.69262 4.74265 9.63256 4.67233C9.57249 4.60201 9.49103 4.5625 9.40608 4.5625H7.48435C7.39941 4.5625 7.31794 4.60201 7.25787 4.67233C7.19781 4.74265 7.16406 4.83803 7.16406 4.93748C7.16406 5.03694 7.19781 5.13231 7.25787 5.20264C7.31794 5.27296 7.39941 5.31247 7.48435 5.31247Z'
          fill={color}
        />
        <path
          d='M7.48435 9.06247H9.40608C9.49103 9.06247 9.57249 9.02296 9.63256 8.95264C9.69262 8.88231 9.72637 8.78694 9.72637 8.68748C9.72637 8.58803 9.69262 8.49265 9.63256 8.42233C9.57249 8.35201 9.49103 8.3125 9.40608 8.3125H7.48435C7.39941 8.3125 7.31794 8.35201 7.25787 8.42233C7.19781 8.49265 7.16406 8.58803 7.16406 8.68748C7.16406 8.78694 7.19781 8.88231 7.25787 8.95264C7.31794 9.02296 7.39941 9.06247 7.48435 9.06247Z'
          fill={color}
        />
        <path
          d='M7.48435 10.5625H8.44522C8.53016 10.5625 8.61163 10.523 8.67169 10.4526C8.73176 10.3823 8.7655 10.2869 8.7655 10.1875C8.7655 10.088 8.73176 9.99265 8.67169 9.92233C8.61163 9.85201 8.53016 9.8125 8.44522 9.8125H7.48435C7.39941 9.8125 7.31794 9.85201 7.25787 9.92233C7.19781 9.99265 7.16406 10.088 7.16406 10.1875C7.16406 10.2869 7.19781 10.3823 7.25787 10.4526C7.31794 10.523 7.39941 10.5625 7.48435 10.5625Z'
          fill={color}
        />
        <path
          d='M5.40226 6.99989C5.62397 6.99989 5.84071 6.92291 6.02506 6.7787C6.20941 6.63449 6.35309 6.42951 6.43794 6.18969C6.52278 5.94988 6.54498 5.68599 6.50173 5.4314C6.45847 5.17681 6.35171 4.94295 6.19493 4.75941C6.03816 4.57586 5.83841 4.45086 5.62096 4.40022C5.4035 4.34958 5.1781 4.37557 4.97327 4.4749C4.76843 4.57424 4.59335 4.74246 4.47017 4.95829C4.347 5.17412 4.28125 5.42787 4.28125 5.68744C4.28125 6.03553 4.39936 6.36935 4.60959 6.61548C4.81982 6.86161 5.10495 6.99989 5.40226 6.99989ZM5.40226 5.12497C5.49728 5.12497 5.59017 5.15796 5.66917 5.21976C5.74818 5.28157 5.80976 5.36941 5.84612 5.47219C5.88248 5.57497 5.892 5.68807 5.87346 5.79718C5.85492 5.90629 5.80917 6.00651 5.74198 6.08517C5.67479 6.16384 5.58918 6.21741 5.49599 6.23911C5.40279 6.26081 5.30619 6.24968 5.21841 6.2071C5.13062 6.16453 5.05558 6.09244 5.00279 5.99994C4.95 5.90744 4.92183 5.79869 4.92183 5.68744C4.92183 5.53827 4.97244 5.3952 5.06254 5.28971C5.15264 5.18423 5.27484 5.12497 5.40226 5.12497Z'
          fill={color}
        />
        <path
          d='M5.40226 10.7499C5.62397 10.7499 5.84071 10.6729 6.02506 10.5287C6.20941 10.3845 6.35309 10.1795 6.43794 9.93969C6.52278 9.69988 6.54498 9.43599 6.50173 9.1814C6.45847 8.92681 6.35171 8.69295 6.19493 8.50941C6.03816 8.32586 5.83841 8.20086 5.62096 8.15022C5.4035 8.09958 5.1781 8.12557 4.97327 8.2249C4.76843 8.32424 4.59335 8.49246 4.47017 8.70829C4.347 8.92412 4.28125 9.17787 4.28125 9.43744C4.28125 9.78553 4.39936 10.1193 4.60959 10.3655C4.81982 10.6116 5.10495 10.7499 5.40226 10.7499ZM5.40226 8.87497C5.49728 8.87497 5.59017 8.90796 5.66917 8.96976C5.74818 9.03157 5.80976 9.11941 5.84612 9.22219C5.88248 9.32497 5.892 9.43807 5.87346 9.54718C5.85492 9.65629 5.80917 9.75651 5.74198 9.83517C5.67479 9.91384 5.58918 9.96741 5.49599 9.98911C5.40279 10.0108 5.30619 9.99968 5.21841 9.9571C5.13062 9.91453 5.05558 9.84244 5.00279 9.74994C4.95 9.65744 4.92183 9.54869 4.92183 9.43744C4.92183 9.28827 4.97244 9.1452 5.06254 9.03971C5.15264 8.93423 5.27484 8.87497 5.40226 8.87497Z'
          fill={color}
        />
        <path
          d='M4.03173 12.8594L4.15184 12.8706C5.09829 12.9569 6.05115 13 7.004 13C7.95686 13 8.90972 12.9569 9.85617 12.8706L9.97628 12.8594C10.4743 12.8125 10.8731 12.2857 10.9051 11.6332V11.4701C11.0316 8.86728 11.0316 6.25819 10.9051 3.65541V3.49416C10.8731 2.83982 10.4727 2.31296 9.97308 2.26797L9.74087 2.24734C9.40617 2.21734 9.06986 2.19484 8.73196 2.17609C8.71915 1.70736 8.57182 1.18989 8.2179 1.12052L8.16825 1.11114C7.39617 0.962953 6.60863 0.962953 5.83655 1.11114L5.79171 1.12052C5.42979 1.18989 5.28886 1.70924 5.27605 2.17422C4.85967 2.19672 4.44437 2.22672 4.03013 2.26422C3.77599 2.30536 3.54282 2.4516 3.37276 2.67649C3.2027 2.90138 3.10697 3.19009 3.10289 3.49041L3.09489 3.65541C2.96837 6.25819 2.96837 8.86728 3.09489 11.4701L3.10289 11.6332C3.13492 12.2857 3.53368 12.8125 4.03173 12.8594ZM3.73066 3.69853L3.73866 3.53354C3.73546 3.41421 3.76747 3.29723 3.82931 3.20229C3.89114 3.10736 3.97903 3.04026 4.07817 3.01231C5.03903 2.92231 6.00951 2.87544 6.97838 2.87544C7.88319 2.87544 8.78961 2.91669 9.68962 2.99543L9.92183 3.01606C10.0213 3.04293 10.1097 3.10942 10.1719 3.20415C10.2341 3.29888 10.2663 3.41598 10.2629 3.53541V3.69853C10.3862 6.27264 10.3862 8.85283 10.2629 11.4269V11.5919C10.2657 11.7112 10.2333 11.8279 10.1712 11.9225C10.109 12.0171 10.021 12.0838 9.92183 12.1113L9.80332 12.1225C7.93782 12.2932 6.06378 12.2932 4.19828 12.1225L4.07977 12.1113C3.98033 12.0837 3.89208 12.0168 3.82993 11.9218C3.76778 11.8268 3.73554 11.7096 3.73866 11.5901L3.73066 11.4269C3.60841 8.85276 3.60948 6.27257 3.73386 3.69853H3.73066Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M9.75584 8.74996H11.2558C11.3884 8.74996 11.5155 8.69728 11.6093 8.60352C11.7031 8.50975 11.7558 8.38258 11.7558 8.24998C11.7558 8.11738 11.7031 7.9902 11.6093 7.89644C11.5155 7.80268 11.3884 7.75 11.2558 7.75H9.75584C9.62324 7.75 9.49606 7.80268 9.4023 7.89644C9.30854 7.9902 9.25586 8.11738 9.25586 8.24998C9.25586 8.38258 9.30854 8.50975 9.4023 8.60352C9.49606 8.69728 9.62324 8.74996 9.75584 8.74996Z'
          fill={color}
        />
        <path
          d='M9.75584 6.74996H12.7557C12.8883 6.74996 13.0155 6.69728 13.1092 6.60352C13.203 6.50975 13.2557 6.38258 13.2557 6.24998C13.2557 6.11738 13.203 5.9902 13.1092 5.89644C13.0155 5.80268 12.8883 5.75 12.7557 5.75H9.75584C9.62324 5.75 9.49606 5.80268 9.4023 5.89644C9.30854 5.9902 9.25586 6.11738 9.25586 6.24998C9.25586 6.38258 9.30854 6.50975 9.4023 6.60352C9.49606 6.69728 9.62324 6.74996 9.75584 6.74996Z'
          fill={color}
        />
        <path
          d='M9.75584 11.75H12.7557C12.8883 11.75 13.0155 11.6973 13.1092 11.6035C13.203 11.5098 13.2557 11.3826 13.2557 11.25C13.2557 11.1174 13.203 10.9902 13.1092 10.8964C13.0155 10.8027 12.8883 10.75 12.7557 10.75H9.75584C9.62324 10.75 9.49606 10.8027 9.4023 10.8964C9.30854 10.9902 9.25586 11.1174 9.25586 11.25C9.25586 11.3826 9.30854 11.5098 9.4023 11.6035C9.49606 11.6973 9.62324 11.75 9.75584 11.75Z'
          fill={color}
        />
        <path
          d='M9.75584 13.75H11.2558C11.3884 13.75 11.5155 13.6973 11.6093 13.6035C11.7031 13.5098 11.7558 13.3826 11.7558 13.25C11.7558 13.1174 11.7031 12.9902 11.6093 12.8964C11.5155 12.8027 11.3884 12.75 11.2558 12.75H9.75584C9.62324 12.75 9.49606 12.8027 9.4023 12.8964C9.30854 12.9902 9.25586 13.1174 9.25586 13.25C9.25586 13.3826 9.30854 13.5098 9.4023 13.6035C9.49606 13.6973 9.62324 13.75 9.75584 13.75Z'
          fill={color}
        />
        <path
          d='M6.50578 8.99985C6.85189 8.99985 7.19022 8.89722 7.47799 8.70493C7.76576 8.51265 7.99005 8.23935 8.1225 7.91959C8.25495 7.59983 8.2896 7.24798 8.22208 6.90853C8.15456 6.56908 7.9879 6.25727 7.74317 6.01254C7.49844 5.76781 7.18663 5.60115 6.84718 5.53362C6.50772 5.4661 6.15587 5.50076 5.83612 5.63321C5.51636 5.76565 5.24306 5.98995 5.05078 6.27772C4.85849 6.56549 4.75586 6.90382 4.75586 7.24992C4.75586 7.71403 4.94023 8.15913 5.2684 8.48731C5.59657 8.81548 6.04167 8.99985 6.50578 8.99985ZM6.50578 6.49996C6.65411 6.49996 6.79911 6.54394 6.92244 6.62635C7.04577 6.70876 7.1419 6.82589 7.19866 6.96293C7.25543 7.09996 7.27028 7.25076 7.24134 7.39624C7.2124 7.54172 7.14097 7.67535 7.03609 7.78023C6.93121 7.88512 6.79757 7.95654 6.65209 7.98548C6.50662 8.01442 6.35582 7.99957 6.21878 7.9428C6.08175 7.88604 5.96462 7.78992 5.88221 7.66658C5.7998 7.54325 5.75582 7.39825 5.75582 7.24992C5.75582 7.05102 5.83483 6.86026 5.97548 6.71962C6.11612 6.57897 6.30688 6.49996 6.50578 6.49996Z'
          fill={color}
        />
        <path
          d='M6.50578 13.9998C6.85189 13.9998 7.19022 13.8972 7.47799 13.7049C7.76576 13.5127 7.99005 13.2393 8.1225 12.9196C8.25495 12.5998 8.2896 12.248 8.22208 11.9085C8.15456 11.5691 7.9879 11.2573 7.74317 11.0125C7.49844 10.7678 7.18663 10.6011 6.84718 10.5336C6.50772 10.4661 6.15587 10.5008 5.83612 10.6332C5.51636 10.7657 5.24306 10.9899 5.05078 11.2777C4.85849 11.5655 4.75586 11.9038 4.75586 12.2499C4.75586 12.714 4.94023 13.1591 5.2684 13.4873C5.59657 13.8155 6.04167 13.9998 6.50578 13.9998ZM6.50578 11.5C6.65411 11.5 6.79911 11.5439 6.92244 11.6264C7.04577 11.7088 7.1419 11.8259 7.19866 11.9629C7.25543 12.1 7.27028 12.2508 7.24134 12.3962C7.2124 12.5417 7.14097 12.6753 7.03609 12.7802C6.93121 12.8851 6.79757 12.9565 6.65209 12.9855C6.50662 13.0144 6.35582 12.9996 6.21878 12.9428C6.08175 12.886 5.96462 12.7899 5.88221 12.6666C5.7998 12.5433 5.75582 12.3983 5.75582 12.2499C5.75582 12.051 5.83483 11.8603 5.97548 11.7196C6.11612 11.579 6.30688 11.5 6.50578 11.5Z'
          fill={color}
        />
        <path
          d='M4.36641 16.8125L4.55391 16.8275C6.03134 16.9425 7.51878 17 9.00621 17C10.4936 17 11.9811 16.9425 13.4585 16.8275L13.646 16.8125C14.4235 16.75 15.046 16.0475 15.0959 15.1776V14.9601C15.2934 11.4897 15.2934 8.01092 15.0959 4.54054V4.32555C15.046 3.45309 14.421 2.75062 13.641 2.69062L13.2785 2.66312C12.756 2.62312 12.2311 2.59312 11.7036 2.56813C11.6836 1.94315 11.4536 1.25318 10.9011 1.16069L10.8236 1.14819C9.6184 0.950604 8.38903 0.950604 7.18379 1.14819L7.11379 1.16069C6.54882 1.25318 6.32883 1.94565 6.30883 2.56563C5.65886 2.59562 5.01055 2.63562 4.36391 2.68562C3.96721 2.74048 3.60321 2.93546 3.33774 3.23532C3.07228 3.53518 2.92285 3.92012 2.91648 4.32055L2.90398 4.54054C2.70649 8.01092 2.70649 11.4897 2.90398 14.9601L2.91648 15.1776C2.96647 16.0475 3.58895 16.75 4.36641 16.8125ZM3.89643 4.59804L3.90893 4.37805C3.90393 4.21894 3.9539 4.06297 4.05043 3.93639C4.14696 3.80981 4.28415 3.72035 4.43891 3.68308C5.93885 3.56308 7.45378 3.50059 8.96621 3.50059C10.3787 3.50059 11.7936 3.55558 13.1985 3.66058L13.561 3.68808C13.7163 3.72391 13.8542 3.81256 13.9514 3.93887C14.0485 4.06518 14.0987 4.2213 14.0935 4.38055V4.59804C14.286 8.03019 14.286 11.4704 14.0935 14.9026V15.1226C14.0978 15.2816 14.0472 15.4373 13.9502 15.5634C13.8532 15.6895 13.7158 15.7784 13.561 15.8151L13.376 15.8301C10.4639 16.0575 7.53851 16.0575 4.6264 15.8301L4.44141 15.8151C4.28619 15.7783 4.14842 15.689 4.0514 15.5624C3.95438 15.4358 3.90406 15.2795 3.90893 15.1201L3.89643 14.9026C3.70561 11.4703 3.70728 8.0301 3.90143 4.59804H3.89643Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M8.60544 7.78121H9.80652C9.9127 7.78121 10.0145 7.73512 10.0896 7.65308C10.1647 7.57103 10.2069 7.45976 10.2069 7.34373C10.2069 7.2277 10.1647 7.11643 10.0896 7.03438C10.0145 6.95234 9.9127 6.90625 9.80652 6.90625H8.60544C8.49926 6.90625 8.39742 6.95234 8.32234 7.03438C8.24726 7.11643 8.20508 7.2277 8.20508 7.34373C8.20508 7.45976 8.24726 7.57103 8.32234 7.65308C8.39742 7.73512 8.49926 7.78121 8.60544 7.78121Z'
        fill={color}
      />
      <path
        d='M8.60544 6.03121H11.0076C11.1138 6.03121 11.2156 5.98512 11.2907 5.90308C11.3658 5.82103 11.408 5.70976 11.408 5.59373C11.408 5.4777 11.3658 5.36643 11.2907 5.28438C11.2156 5.20234 11.1138 5.15625 11.0076 5.15625H8.60544C8.49926 5.15625 8.39742 5.20234 8.32234 5.28438C8.24726 5.36643 8.20508 5.4777 8.20508 5.59373C8.20508 5.70976 8.24726 5.82103 8.32234 5.90308C8.39742 5.98512 8.49926 6.03121 8.60544 6.03121Z'
        fill={color}
      />
      <path
        d='M8.60544 10.4062H11.0076C11.1138 10.4062 11.2156 10.3601 11.2907 10.2781C11.3658 10.196 11.408 10.0848 11.408 9.96873C11.408 9.8527 11.3658 9.74143 11.2907 9.65938C11.2156 9.57734 11.1138 9.53125 11.0076 9.53125H8.60544C8.49926 9.53125 8.39742 9.57734 8.32234 9.65938C8.24726 9.74143 8.20508 9.8527 8.20508 9.96873C8.20508 10.0848 8.24726 10.196 8.32234 10.2781C8.39742 10.3601 8.49926 10.4062 8.60544 10.4062Z'
        fill={color}
      />
      <path
        d='M8.60544 12.1562H9.80652C9.9127 12.1562 10.0145 12.1101 10.0896 12.0281C10.1647 11.946 10.2069 11.8348 10.2069 11.7187C10.2069 11.6027 10.1647 11.4914 10.0896 11.4094C10.0145 11.3273 9.9127 11.2812 9.80652 11.2812H8.60544C8.49926 11.2812 8.39742 11.3273 8.32234 11.4094C8.24726 11.4914 8.20508 11.6027 8.20508 11.7187C8.20508 11.8348 8.24726 11.946 8.32234 12.0281C8.39742 12.1101 8.49926 12.1562 8.60544 12.1562Z'
        fill={color}
      />
      <path
        d='M6.00282 7.99987C6.27997 7.99987 6.55089 7.91007 6.78132 7.74182C7.01176 7.57357 7.19136 7.33443 7.29742 7.05464C7.40348 6.77486 7.43123 6.46699 7.37716 6.16997C7.32309 5.87294 7.18964 5.60011 6.99367 5.38597C6.7977 5.17183 6.54801 5.026 6.2762 4.96692C6.00438 4.90784 5.72263 4.93816 5.46658 5.05406C5.21054 5.16995 4.99169 5.3662 4.83772 5.618C4.68375 5.86981 4.60156 6.16584 4.60156 6.46868C4.60156 6.87478 4.74919 7.26424 5.01198 7.55139C5.27477 7.83855 5.63119 7.99987 6.00282 7.99987ZM6.00282 5.81246C6.1216 5.81246 6.23771 5.85095 6.33647 5.92306C6.43522 5.99516 6.5122 6.09765 6.55765 6.21756C6.6031 6.33747 6.615 6.46941 6.59183 6.59671C6.56865 6.724 6.51146 6.84093 6.42747 6.9327C6.34348 7.02448 6.23648 7.08698 6.11998 7.1123C6.00349 7.13762 5.88274 7.12462 5.77301 7.07495C5.66327 7.02529 5.56948 6.94118 5.50349 6.83326C5.4375 6.72535 5.40228 6.59847 5.40228 6.46868C5.40228 6.29464 5.46555 6.12773 5.57818 6.00467C5.6908 5.8816 5.84355 5.81246 6.00282 5.81246Z'
        fill={color}
      />
      <path
        d='M6.00282 12.3749C6.27997 12.3749 6.55089 12.2851 6.78132 12.1168C7.01176 11.9486 7.19136 11.7094 7.29742 11.4296C7.40348 11.1499 7.43123 10.842 7.37716 10.545C7.32309 10.2479 7.18964 9.97511 6.99367 9.76097C6.7977 9.54683 6.54801 9.401 6.2762 9.34192C6.00438 9.28284 5.72263 9.31316 5.46658 9.42906C5.21054 9.54495 4.99169 9.7412 4.83772 9.993C4.68375 10.2448 4.60156 10.5408 4.60156 10.8437C4.60156 11.2498 4.74919 11.6392 5.01198 11.9264C5.27477 12.2135 5.63119 12.3749 6.00282 12.3749ZM6.00282 10.1875C6.1216 10.1875 6.23771 10.2259 6.33647 10.2981C6.43522 10.3702 6.5122 10.4727 6.55765 10.5926C6.6031 10.7125 6.615 10.8444 6.59183 10.9717C6.56865 11.099 6.51146 11.2159 6.42747 11.3077C6.34348 11.3995 6.23648 11.462 6.11998 11.4873C6.00349 11.5126 5.88274 11.4996 5.77301 11.45C5.66327 11.4003 5.56948 11.3162 5.50349 11.2083C5.4375 11.1003 5.40228 10.9735 5.40228 10.8437C5.40228 10.6696 5.46555 10.5027 5.57818 10.3797C5.6908 10.2566 5.84355 10.1875 6.00282 10.1875Z'
        fill={color}
      />
      <path
        d='M4.28966 14.8359L4.4398 14.8491C5.62286 14.9497 6.81393 15 8.005 15C9.19608 15 10.3871 14.9497 11.5702 14.8491L11.7203 14.8359C12.3429 14.7813 12.8414 14.1666 12.8814 13.4054V13.2151C13.0395 10.1785 13.0395 7.13455 12.8814 4.09797V3.90986C12.8414 3.14645 12.3409 2.53179 11.7163 2.47929L11.4261 2.45523C11.0077 2.42023 10.5873 2.39398 10.1649 2.37211C10.1489 1.82526 9.96477 1.22153 9.52237 1.1406L9.46031 1.12966C8.49521 0.956779 7.51079 0.956779 6.54569 1.12966L6.48964 1.1406C6.03723 1.22153 5.86107 1.82745 5.84506 2.36992C5.32459 2.39617 4.80546 2.43117 4.28766 2.47492C3.96999 2.52292 3.67852 2.69353 3.46595 2.9559C3.25337 3.21828 3.13372 3.5551 3.12862 3.90548L3.11861 4.09797C2.96046 7.13455 2.96046 10.1785 3.11861 13.2151L3.12862 13.4054C3.16865 14.1666 3.6671 14.7813 4.28966 14.8359ZM3.91332 4.14828L3.92333 3.95579C3.91933 3.81657 3.95934 3.6801 4.03664 3.56934C4.11393 3.45858 4.22379 3.38031 4.34771 3.34769C5.54879 3.2427 6.76189 3.18801 7.97298 3.18801C9.10399 3.18801 10.237 3.23614 11.362 3.32801L11.6523 3.35207C11.7766 3.38342 11.8871 3.46099 11.9649 3.57151C12.0426 3.68203 12.0829 3.81864 12.0787 3.95798V4.14828C12.2328 7.15142 12.2328 10.1616 12.0787 13.1648V13.3573C12.0821 13.4964 12.0416 13.6326 11.9639 13.7429C11.8863 13.8533 11.7762 13.9311 11.6523 13.9632L11.5042 13.9763C9.17227 14.1753 6.82973 14.1753 4.49785 13.9763L4.34971 13.9632C4.22542 13.931 4.1151 13.8529 4.03741 13.7421C3.95973 13.6313 3.91943 13.4946 3.92333 13.3551L3.91332 13.1648C3.76052 10.1616 3.76185 7.15134 3.91733 4.14828H3.91332Z'
        fill={color}
      />
    </svg>
  );
};

export const CastIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M3.26651 1.75H10.7338C11.5703 1.75 12.2504 2.47683 12.2504 3.36992V10.6301C12.2504 11.5232 11.5703 12.25 10.7338 12.25H9.91709C9.59451 12.25 9.33376 11.9892 9.33376 11.6667C9.33376 11.3441 9.59451 11.0833 9.91709 11.0833H10.7338C10.9233 11.0833 11.0838 10.8757 11.0838 10.6301V3.36992C11.0838 3.12433 10.9233 2.91667 10.7338 2.91667H3.26651C3.07693 2.91667 2.91709 3.12433 2.91709 3.36992V4.08333C2.91709 4.40592 2.65576 4.66667 2.33376 4.66667C2.01118 4.66667 1.75043 4.40592 1.75043 4.08333V3.36992C1.75043 2.47683 2.43059 1.75 3.26651 1.75ZM1.75562 8.84917C1.71129 8.53008 1.9347 8.2355 2.25379 8.19175C3.08212 8.07858 3.89062 8.34983 4.47862 8.93725C5.25854 9.71833 5.47029 10.9142 5.0042 11.9134C4.90504 12.1252 4.69504 12.25 4.47512 12.25C4.39229 12.25 4.30829 12.2325 4.22895 12.1952C3.93729 12.0592 3.8107 11.7122 3.94662 11.4199C4.2062 10.864 4.08895 10.1973 3.65379 9.76267C3.32595 9.43542 2.87445 9.2855 2.41304 9.34675C2.09045 9.39283 1.79937 9.16825 1.75562 8.84917ZM2.2532 5.87831C1.93412 5.92264 1.71129 6.21723 1.75562 6.53631C1.79995 6.85481 2.09337 7.07823 2.41362 7.03331C3.5167 6.88281 4.59995 7.24331 5.38687 8.02964C6.29454 8.93789 6.63579 10.2691 6.27645 11.504C6.18662 11.8131 6.36454 12.1369 6.6737 12.2267C6.72854 12.2425 6.78337 12.2501 6.83645 12.2501C7.08962 12.2501 7.32237 12.085 7.39645 11.8295C7.87479 10.1868 7.42037 8.41464 6.2117 7.20481C5.16462 6.15773 3.72437 5.67356 2.2532 5.87831ZM1.75019 11.0833C1.75019 10.7607 2.01094 10.5 2.33353 10.5C2.65611 10.5 2.91686 10.7607 2.91686 11.0833C2.91686 11.4059 2.65611 11.6667 2.33353 11.6667C2.01094 11.6667 1.75019 11.4059 1.75019 11.0833Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.19998 2.25H13.8007C14.8762 2.25 15.7507 3.1845 15.7507 4.33275V13.6672C15.7507 14.8155 14.8762 15.75 13.8007 15.75H12.7507C12.336 15.75 12.0007 15.4148 12.0007 15C12.0007 14.5852 12.336 14.25 12.7507 14.25H13.8007C14.0445 14.25 14.2507 13.983 14.2507 13.6672V4.33275C14.2507 4.017 14.0445 3.75 13.8007 3.75H4.19998C3.95623 3.75 3.75073 4.017 3.75073 4.33275V5.25C3.75073 5.66475 3.41473 6 3.00073 6C2.58598 6 2.25073 5.66475 2.25073 5.25V4.33275C2.25073 3.1845 3.12523 2.25 4.19998 2.25ZM2.25722 11.3775C2.20022 10.9672 2.48747 10.5885 2.89772 10.5323C3.96272 10.3868 5.00222 10.7355 5.75822 11.4908C6.76097 12.495 7.03322 14.0325 6.43397 15.3173C6.30647 15.5895 6.03647 15.75 5.75372 15.75C5.64722 15.75 5.53922 15.7275 5.43722 15.6795C5.06222 15.5048 4.89947 15.0585 5.07422 14.6827C5.40797 13.968 5.25722 13.1108 4.69772 12.552C4.27622 12.1313 3.69572 11.9385 3.10247 12.0173C2.68772 12.0765 2.31347 11.7878 2.25722 11.3775ZM2.89697 7.55783C2.48672 7.61483 2.20022 7.99358 2.25722 8.40383C2.31422 8.81332 2.69147 9.10057 3.10322 9.04283C4.52147 8.84933 5.91423 9.31282 6.92598 10.3238C8.09298 11.4916 8.53173 13.2031 8.06973 14.7908C7.95423 15.1883 8.18298 15.6046 8.58048 15.7201C8.65098 15.7403 8.72148 15.7501 8.78973 15.7501C9.11523 15.7501 9.41448 15.5378 9.50973 15.2093C10.1247 13.0973 9.54048 10.8188 7.98647 9.26332C6.64022 7.91708 4.78848 7.29458 2.89697 7.55783ZM2.25025 14.25C2.25025 13.8352 2.5855 13.5 3.00025 13.5C3.415 13.5 3.75025 13.8352 3.75025 14.25C3.75025 14.6648 3.415 15 3.00025 15C2.5855 15 2.25025 14.6648 2.25025 14.25Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.73316 2H12.2672C13.2232 2 14.0005 2.83067 14.0005 3.85133V12.1487C14.0005 13.1693 13.2232 14 12.2672 14H11.3338C10.9652 14 10.6672 13.702 10.6672 13.3333C10.6672 12.9647 10.9652 12.6667 11.3338 12.6667H12.2672C12.4838 12.6667 12.6672 12.4293 12.6672 12.1487V3.85133C12.6672 3.57067 12.4838 3.33333 12.2672 3.33333H3.73316C3.51649 3.33333 3.33382 3.57067 3.33382 3.85133V4.66667C3.33382 5.03533 3.03516 5.33333 2.66716 5.33333C2.29849 5.33333 2.00049 5.03533 2.00049 4.66667V3.85133C2.00049 2.83067 2.77782 2 3.73316 2ZM2.00642 10.1133C1.95576 9.74867 2.21109 9.412 2.57576 9.362C3.52242 9.23267 4.44642 9.54267 5.11842 10.214C6.00976 11.1067 6.25176 12.4733 5.71909 13.6153C5.60576 13.8573 5.36576 14 5.11442 14C5.01976 14 4.92376 13.98 4.83309 13.9373C4.49976 13.782 4.35509 13.3853 4.51042 13.0513C4.80709 12.416 4.67309 11.654 4.17576 11.1573C3.80109 10.7833 3.28509 10.612 2.75776 10.682C2.38909 10.7347 2.05642 10.478 2.00642 10.1133ZM2.57509 6.71807C2.21042 6.76873 1.95576 7.1054 2.00642 7.47007C2.05709 7.83407 2.39242 8.0894 2.75842 8.03807C4.01909 7.86607 5.25709 8.27807 6.15642 9.17673C7.19376 10.2147 7.58376 11.7361 7.17309 13.1474C7.07042 13.5007 7.27376 13.8707 7.62709 13.9734C7.68976 13.9914 7.75242 14.0001 7.81309 14.0001C8.10242 14.0001 8.36842 13.8114 8.45309 13.5194C8.99976 11.6421 8.48042 9.61673 7.09909 8.23407C5.90242 7.0374 4.25642 6.48407 2.57509 6.71807ZM2.00022 12.6667C2.00022 12.298 2.29822 12 2.66689 12C3.03556 12 3.33356 12.298 3.33356 12.6667C3.33356 13.0353 3.03556 13.3333 2.66689 13.3333C2.29822 13.3333 2.00022 13.0353 2.00022 12.6667Z'
        fill={color}
      />
    </svg>
  );
};

export const Checkmark2Icon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M11.0833 7.48592C11.0833 7.16392 11.3447 6.90258 11.6667 6.90258C11.9887 6.90258 12.25 7.16392 12.25 7.48592V10.7327C12.25 11.5693 11.5692 12.25 10.7333 12.25H3.26667C2.43075 12.25 1.75 11.5693 1.75 10.7327V3.26667C1.75 2.43017 2.43075 1.75 3.26667 1.75H8.84742C9.16942 1.75 9.43075 2.01075 9.43075 2.33333C9.43075 2.65533 9.16942 2.91667 8.84742 2.91667H3.26667C3.07358 2.91667 2.91667 3.07358 2.91667 3.26667V10.7327C2.91667 10.9258 3.07358 11.0833 3.26667 11.0833H10.7333C10.9264 11.0833 11.0833 10.9258 11.0833 10.7327V7.48592ZM5.4306 6.38517C5.66393 6.16233 6.0326 6.17167 6.25543 6.40442L7.13335 7.32492L10.6643 3.67733C10.8877 3.44633 11.2569 3.43933 11.4891 3.66392C11.7207 3.88792 11.7265 4.25717 11.5025 4.48875L7.54927 8.57208C7.4396 8.68583 7.28852 8.75 7.13043 8.75H7.1281C6.96943 8.74942 6.81777 8.68408 6.7081 8.56917L5.41135 7.21C5.18852 6.97667 5.19785 6.60742 5.4306 6.38517Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M14.25 9.62475C14.25 9.21075 14.586 8.87475 15 8.87475C15.414 8.87475 15.75 9.21075 15.75 9.62475V13.7992C15.75 14.8748 14.8748 15.75 13.8 15.75H4.2C3.12525 15.75 2.25 14.8748 2.25 13.7992V4.2C2.25 3.1245 3.12525 2.25 4.2 2.25H11.3752C11.7892 2.25 12.1252 2.58525 12.1252 3C12.1252 3.414 11.7892 3.75 11.3752 3.75H4.2C3.95175 3.75 3.75 3.95175 3.75 4.2V13.7992C3.75 14.0475 3.95175 14.25 4.2 14.25H13.8C14.0482 14.25 14.25 14.0475 14.25 13.7992V9.62475ZM6.9822 8.2095C7.2822 7.923 7.7562 7.935 8.0427 8.23425L9.17145 9.41775L13.7112 4.728C13.9984 4.431 14.4732 4.422 14.7717 4.71075C15.0694 4.99875 15.0769 5.4735 14.7889 5.77125L9.7062 11.0212C9.5652 11.1675 9.37095 11.25 9.1677 11.25H9.1647C8.9607 11.2492 8.7657 11.1652 8.6247 11.0175L6.95745 9.27C6.67095 8.97 6.68295 8.49525 6.9822 8.2095Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.6667 8.55533C12.6667 8.18733 12.9653 7.88867 13.3333 7.88867C13.7013 7.88867 14 8.18733 14 8.55533V12.266C14 13.222 13.222 14 12.2667 14H3.73333C2.778 14 2 13.222 2 12.266V3.73333C2 2.77733 2.778 2 3.73333 2H10.1113C10.4793 2 10.778 2.298 10.778 2.66667C10.778 3.03467 10.4793 3.33333 10.1113 3.33333H3.73333C3.51267 3.33333 3.33333 3.51267 3.33333 3.73333V12.266C3.33333 12.4867 3.51267 12.6667 3.73333 12.6667H12.2667C12.4873 12.6667 12.6667 12.4867 12.6667 12.266V8.55533ZM6.2064 7.29733C6.47307 7.04267 6.8944 7.05333 7.14907 7.31933L8.1524 8.37133L12.1877 4.20267C12.4431 3.93867 12.8651 3.93067 13.1304 4.18733C13.3951 4.44333 13.4017 4.86533 13.1457 5.13L8.62773 9.79667C8.5024 9.92667 8.32973 10 8.14907 10H8.1464C7.96507 9.99933 7.79173 9.92467 7.6664 9.79333L6.1844 8.24C5.92973 7.97333 5.9404 7.55133 6.2064 7.29733Z'
        fill={color}
      />
    </svg>
  );
};

export const UmbrellaIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.36943 6.41699C2.65702 4.11866 4.62402 2.33366 6.99935 2.33366C9.37527 2.33366 11.3423 4.11866 11.6298 6.41699H2.36943ZM6.99935 1.16699C3.78343 1.16699 1.16602 3.78383 1.16602 7.00033C1.16602 7.32291 1.42735 7.58366 1.74993 7.58366H6.41602V11.0837C6.41602 12.0485 7.20118 12.8337 8.1666 12.8337C9.13143 12.8337 9.9166 12.0485 9.9166 11.0837C9.9166 10.7611 9.65527 10.5003 9.33327 10.5003C9.01068 10.5003 8.74993 10.7611 8.74993 11.0837C8.74993 11.4057 8.48802 11.667 8.1666 11.667C7.8446 11.667 7.58327 11.4057 7.58327 11.0837V7.58366H12.2493C12.5719 7.58366 12.8327 7.32291 12.8327 7.00033C12.8327 3.78383 10.2158 1.16699 6.99935 1.16699Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M3.04725 8.25C3.417 5.295 5.946 3 9 3C12.0547 3 14.5837 5.295 14.9535 8.25H3.04725ZM9 1.5C4.86525 1.5 1.5 4.8645 1.5 9C1.5 9.41475 1.836 9.75 2.25075 9.75H8.25V14.25C8.25 15.4905 9.2595 16.5 10.5007 16.5C11.7412 16.5 12.7507 15.4905 12.7507 14.25C12.7507 13.8352 12.4147 13.5 12.0007 13.5C11.586 13.5 11.2507 13.8352 11.2507 14.25C11.2507 14.664 10.914 15 10.5007 15C10.0868 15 9.75075 14.664 9.75075 14.25V9.75H15.75C16.1647 9.75 16.5 9.41475 16.5 9C16.5 4.8645 13.1355 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.70736 7.33301C3.03603 4.70634 5.28403 2.66634 7.9987 2.66634C10.714 2.66634 12.962 4.70634 13.2907 7.33301H2.70736ZM7.9987 1.33301C4.32336 1.33301 1.33203 4.32367 1.33203 7.99967C1.33203 8.36834 1.6307 8.66634 1.99936 8.66634H7.33203V12.6663C7.33203 13.769 8.22936 14.6663 9.3327 14.6663C10.4354 14.6663 11.3327 13.769 11.3327 12.6663C11.3327 12.2977 11.034 11.9997 10.666 11.9997C10.2974 11.9997 9.99936 12.2977 9.99936 12.6663C9.99936 13.0343 9.70003 13.333 9.3327 13.333C8.9647 13.333 8.66603 13.0343 8.66603 12.6663V8.66634H13.9987C14.3674 8.66634 14.6654 8.36834 14.6654 7.99967C14.6654 4.32367 11.6747 1.33301 7.9987 1.33301Z'
        fill={color}
      />
    </svg>
  );
};

export const AllDoneIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.69286 3.62444C9.43969 3.42494 9.07336 3.47044 8.87444 3.72419L4.75903 8.97885L2.78794 6.53061C2.58494 6.28036 2.21861 6.23952 1.96778 6.44194C1.71636 6.64436 1.67728 7.01185 1.87853 7.2621L4.31044 10.2826C4.42186 10.4203 4.58869 10.5002 4.76544 10.5002H4.76953C4.94686 10.499 5.11486 10.4168 5.22453 10.2762L9.79261 4.44286C9.99153 4.18969 9.94719 3.82277 9.69286 3.62444ZM12.6095 3.62444C12.3558 3.42494 11.99 3.47044 11.7911 3.72419L7.67569 8.97885L7.32336 8.54194L6.58544 9.48519L7.22711 10.2826C7.33853 10.4203 7.50536 10.5002 7.68211 10.5002H7.68619C7.86353 10.499 8.03153 10.4168 8.14119 10.2762L12.7093 4.44286C12.9082 4.18969 12.8639 3.82277 12.6095 3.62444ZM5.82168 6.67621L5.0826 7.61887L4.7956 7.26246C4.59377 7.01162 4.63285 6.64412 4.88427 6.44171C5.13568 6.23987 5.5026 6.28012 5.70443 6.53096L5.82168 6.67621Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12.4622 4.65999C12.1367 4.40349 11.6657 4.46199 11.41 4.78824L6.11875 11.5442L3.5845 8.39649C3.3235 8.07474 2.8525 8.02224 2.53 8.28249C2.20675 8.54274 2.1565 9.01524 2.41525 9.33699L5.542 13.2205C5.68525 13.3975 5.89975 13.5002 6.127 13.5002H6.13225C6.36025 13.4987 6.57625 13.393 6.71725 13.2122L12.5905 5.71224C12.8462 5.38674 12.7892 4.91499 12.4622 4.65999ZM16.2122 4.65999C15.886 4.40349 15.4157 4.46199 15.16 4.78824L9.86875 11.5442L9.41575 10.9825L8.467 12.1952L9.292 13.2205C9.43525 13.3975 9.64975 13.5002 9.877 13.5002H9.88225C10.1102 13.4987 10.3262 13.393 10.4672 13.2122L16.3405 5.71224C16.5962 5.38674 16.5392 4.91499 16.2122 4.65999ZM7.48502 8.58369L6.53477 9.79569L6.16577 9.33744C5.90627 9.01494 5.95652 8.54244 6.27977 8.28219C6.60302 8.02269 7.07477 8.07444 7.33427 8.39694L7.48502 8.58369Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.0776 4.14222C10.7882 3.91422 10.3696 3.96622 10.1422 4.25622L5.43889 10.2615L3.18622 7.46355C2.95422 7.17755 2.53555 7.13088 2.24889 7.36222C1.96155 7.59355 1.91689 8.01355 2.14689 8.29955L4.92622 11.7515C5.05355 11.9089 5.24422 12.0002 5.44622 12.0002H5.45089C5.65355 11.9989 5.84555 11.9049 5.97089 11.7442L11.1916 5.07755C11.4189 4.78822 11.3682 4.36888 11.0776 4.14222ZM14.4109 4.14222C14.1209 3.91422 13.7029 3.96622 13.4756 4.25622L8.77222 10.2615L8.36955 9.76222L7.52622 10.8402L8.25955 11.7515C8.38689 11.9089 8.57755 12.0002 8.77955 12.0002H8.78422C8.98689 11.9989 9.17889 11.9049 9.30422 11.7442L14.5249 5.07755C14.7522 4.78822 14.7016 4.36888 14.4109 4.14222ZM6.65335 7.62995L5.80869 8.70728L5.48069 8.29995C5.25002 8.01328 5.29469 7.59328 5.58202 7.36195C5.86935 7.13128 6.28869 7.17728 6.51935 7.46395L6.65335 7.62995Z'
        fill={color}
      />
    </svg>
  );
};

export const ShakeIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.58314 4.16625C7.39589 4.11783 7.20222 4.08342 6.9998 4.08342C6.79739 4.08342 6.60372 4.11783 6.41647 4.16625V1.75008C6.41647 1.4275 6.6778 1.16675 6.9998 1.16675C7.3218 1.16675 7.58314 1.4275 7.58314 1.75008V4.16625ZM3.20784 10.5001C3.07485 10.5001 2.94184 10.4552 2.83218 10.363C1.56984 9.30017 0.874512 7.899 0.874512 6.41675C0.874512 4.9345 1.56984 3.53333 2.83218 2.4705C3.07834 2.26225 3.44643 2.29433 3.65468 2.54108C3.86176 2.78725 3.83026 3.15533 3.5841 3.363C2.58893 4.20008 2.04118 5.28508 2.04118 6.41675C2.04118 7.54841 2.58893 8.63341 3.5841 9.4705C3.83026 9.67816 3.86176 10.0462 3.65468 10.2924C3.53918 10.4295 3.37409 10.5001 3.20784 10.5001ZM6.9998 7.00008C6.67839 7.00008 6.41647 6.73875 6.41647 6.41675C6.41647 6.09475 6.67839 5.83341 6.9998 5.83341C7.32122 5.83341 7.58314 6.09475 7.58314 6.41675C7.58314 6.73875 7.32122 7.00008 6.9998 7.00008ZM6.9998 8.75008C6.79739 8.75008 6.60372 8.71566 6.41647 8.66725V11.6667C6.41647 11.9893 6.6778 12.2501 6.9998 12.2501C7.3218 12.2501 7.58314 11.9893 7.58314 11.6667V8.66725C7.39589 8.71566 7.20222 8.75008 6.9998 8.75008ZM8.88659 9.12633C9.00268 9.26283 9.16718 9.33342 9.33343 9.33342C9.46643 9.33342 9.59943 9.2885 9.7091 9.19633C10.5952 8.44967 11.0834 7.46267 11.0834 6.41675C11.0834 5.37083 10.5952 4.38383 9.7091 3.63716C9.46293 3.4295 9.09426 3.46158 8.88659 3.70716C8.67951 3.95391 8.71101 4.322 8.95718 4.52966C9.57609 5.05 9.91676 5.72083 9.91676 6.41675C9.91676 7.11267 9.57609 7.7835 8.95718 8.30383C8.71101 8.5115 8.67951 8.87958 8.88659 9.12633ZM4.66618 9.33342C4.53318 9.33342 4.40018 9.2885 4.29051 9.19633C3.40443 8.44967 2.91618 7.46267 2.91618 6.41675C2.91618 5.37083 3.40443 4.38383 4.29051 3.63716C4.53668 3.4295 4.90476 3.461 5.11301 3.70716C5.3201 3.95391 5.2886 4.322 5.04243 4.52966C4.42351 5.05 4.08284 5.72083 4.08284 6.41675C4.08284 7.11267 4.42351 7.7835 5.04243 8.30383C5.2886 8.5115 5.3201 8.87958 5.11301 9.12633C4.99751 9.26283 4.83243 9.33342 4.66618 9.33342ZM10.3449 10.2924C10.4604 10.4295 10.6255 10.5001 10.7918 10.5001C10.9248 10.5001 11.0578 10.4552 11.1674 10.363C12.4298 9.30016 13.1251 7.899 13.1251 6.41675C13.1251 4.9345 12.4298 3.53333 11.1674 2.4705C10.9207 2.26283 10.5526 2.29433 10.3449 2.54108C10.1378 2.78725 10.1693 3.15533 10.4155 3.363C11.4107 4.20008 11.9584 5.28508 11.9584 6.41675C11.9584 7.54841 11.4107 8.63341 10.4155 9.4705C10.1693 9.67816 10.1378 10.0462 10.3449 10.2924Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M9.74989 5.35662C9.50914 5.29437 9.26014 5.25012 8.99989 5.25012C8.73964 5.25012 8.49064 5.29437 8.24989 5.35662V2.25012C8.24989 1.83537 8.58589 1.50012 8.99989 1.50012C9.41389 1.50012 9.74989 1.83537 9.74989 2.25012V5.35662ZM4.12451 13.5001C3.95351 13.5001 3.78251 13.4424 3.64151 13.3239C2.01851 11.9574 1.12451 10.1559 1.12451 8.25012C1.12451 6.34437 2.01851 4.54287 3.64151 3.17637C3.95801 2.90862 4.43126 2.94987 4.69901 3.26712C4.96526 3.58362 4.92476 4.05687 4.60826 4.32387C3.32876 5.40012 2.62451 6.79512 2.62451 8.25012C2.62451 9.70512 3.32876 11.1001 4.60826 12.1764C4.92476 12.4434 4.96526 12.9166 4.69901 13.2331C4.55051 13.4094 4.33826 13.5001 4.12451 13.5001ZM8.99989 9.00012C8.58664 9.00012 8.24989 8.66412 8.24989 8.25012C8.24989 7.83612 8.58664 7.50012 8.99989 7.50012C9.41314 7.50012 9.74989 7.83612 9.74989 8.25012C9.74989 8.66412 9.41314 9.00012 8.99989 9.00012ZM8.99989 11.2501C8.73964 11.2501 8.49064 11.2059 8.24989 11.1436V15.0001C8.24989 15.4149 8.58589 15.7501 8.99989 15.7501C9.41389 15.7501 9.74989 15.4149 9.74989 15.0001V11.1436C9.50914 11.2059 9.26014 11.2501 8.99989 11.2501ZM11.4258 11.7339C11.575 11.9094 11.7865 12.0001 12.0003 12.0001C12.1713 12.0001 12.3423 11.9424 12.4833 11.8239C13.6225 10.8639 14.2503 9.59487 14.2503 8.25012C14.2503 6.90537 13.6225 5.63637 12.4833 4.67637C12.1668 4.40937 11.6928 4.45062 11.4258 4.76637C11.1595 5.08362 11.2 5.55687 11.5165 5.82387C12.3123 6.49287 12.7503 7.35537 12.7503 8.25012C12.7503 9.14487 12.3123 10.0074 11.5165 10.6764C11.2 10.9434 11.1595 11.4166 11.4258 11.7339ZM5.99951 12.0001C5.82851 12.0001 5.65751 11.9424 5.51651 11.8239C4.37726 10.8639 3.74951 9.59487 3.74951 8.25012C3.74951 6.90537 4.37726 5.63637 5.51651 4.67637C5.83301 4.40937 6.30626 4.44987 6.57401 4.76637C6.84026 5.08362 6.79976 5.55687 6.48326 5.82387C5.68751 6.49287 5.24951 7.35537 5.24951 8.25012C5.24951 9.14487 5.68751 10.0074 6.48326 10.6764C6.79976 10.9434 6.84026 11.4166 6.57401 11.7339C6.42551 11.9094 6.21326 12.0001 5.99951 12.0001ZM13.3008 13.2331C13.4493 13.4094 13.6615 13.5001 13.8753 13.5001C14.0463 13.5001 14.2173 13.4424 14.3583 13.3239C15.9813 11.9574 16.8753 10.1559 16.8753 8.25012C16.8753 6.34437 15.9813 4.54287 14.3583 3.17637C14.041 2.90937 13.5678 2.94987 13.3008 3.26712C13.0345 3.58362 13.075 4.05687 13.3915 4.32387C14.671 5.40012 15.3753 6.79512 15.3753 8.25012C15.3753 9.70512 14.671 11.1001 13.3915 12.1764C13.075 12.4434 13.0345 12.9166 13.3008 13.2331Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.66651 4.7615C8.45251 4.70616 8.23118 4.66683 7.99984 4.66683C7.76851 4.66683 7.54718 4.70616 7.33318 4.7615V2.00016C7.33318 1.6315 7.63184 1.3335 7.99984 1.3335C8.36784 1.3335 8.66651 1.6315 8.66651 2.00016V4.7615ZM3.66618 12.0002C3.51418 12.0002 3.36218 11.9488 3.23684 11.8435C1.79418 10.6288 0.999512 9.0275 0.999512 7.3335C0.999512 5.6395 1.79418 4.03816 3.23684 2.8235C3.51818 2.5855 3.93884 2.62216 4.17684 2.90416C4.41351 3.1855 4.37751 3.60616 4.09618 3.8435C2.95884 4.80016 2.33284 6.04016 2.33284 7.3335C2.33284 8.62683 2.95884 9.86683 4.09618 10.8235C4.37751 11.0608 4.41351 11.4815 4.17684 11.7628C4.04484 11.9195 3.85618 12.0002 3.66618 12.0002ZM7.99984 8.00016C7.63251 8.00016 7.33318 7.7015 7.33318 7.3335C7.33318 6.9655 7.63251 6.66683 7.99984 6.66683C8.36718 6.66683 8.66651 6.9655 8.66651 7.3335C8.66651 7.7015 8.36718 8.00016 7.99984 8.00016ZM7.99984 10.0002C7.76851 10.0002 7.54718 9.96083 7.33318 9.9055V13.3335C7.33318 13.7022 7.63184 14.0002 7.99984 14.0002C8.36784 14.0002 8.66651 13.7022 8.66651 13.3335V9.9055C8.45251 9.96083 8.23118 10.0002 7.99984 10.0002ZM10.1562 10.4302C10.2888 10.5862 10.4768 10.6668 10.6668 10.6668C10.8188 10.6668 10.9708 10.6155 11.0962 10.5102C12.1088 9.65683 12.6668 8.52883 12.6668 7.3335C12.6668 6.13816 12.1088 5.01016 11.0962 4.15683C10.8148 3.9195 10.3935 3.95616 10.1562 4.23683C9.91951 4.51883 9.95551 4.9395 10.2368 5.17683C10.9442 5.7715 11.3335 6.53816 11.3335 7.3335C11.3335 8.12883 10.9442 8.8955 10.2368 9.49016C9.95551 9.7275 9.91951 10.1482 10.1562 10.4302ZM5.33285 10.6668C5.18085 10.6668 5.02885 10.6155 4.90351 10.5102C3.89085 9.65683 3.33284 8.52883 3.33284 7.3335C3.33284 6.13816 3.89085 5.01016 4.90351 4.15683C5.18484 3.9195 5.60551 3.9555 5.84351 4.23683C6.08018 4.51883 6.04418 4.9395 5.76285 5.17683C5.05551 5.7715 4.66618 6.53816 4.66618 7.3335C4.66618 8.12883 5.05551 8.8955 5.76285 9.49016C6.04418 9.7275 6.08018 10.1482 5.84351 10.4302C5.71151 10.5862 5.52285 10.6668 5.33285 10.6668ZM11.8228 11.7628C11.9548 11.9195 12.1435 12.0002 12.3335 12.0002C12.4855 12.0002 12.6375 11.9488 12.7628 11.8435C14.2055 10.6288 15.0002 9.0275 15.0002 7.3335C15.0002 5.6395 14.2055 4.03816 12.7628 2.8235C12.4808 2.58616 12.0602 2.62216 11.8228 2.90416C11.5862 3.1855 11.6222 3.60616 11.9035 3.8435C13.0408 4.80016 13.6668 6.04016 13.6668 7.3335C13.6668 8.62683 13.0408 9.86683 11.9035 10.8235C11.6222 11.0608 11.5862 11.4815 11.8228 11.7628Z'
        fill={color}
      />
    </svg>
  );
};

export const CirclePlayIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.70817 8.51639V5.48364L8.34675 6.99973L6.70817 8.51639ZM7.19759 4.34731C6.90709 4.07781 6.483 4.00781 6.11784 4.16823C5.762 4.32339 5.5415 4.65531 5.5415 5.03389V8.96614C5.5415 9.34473 5.762 9.67664 6.11784 9.83181C6.24792 9.88898 6.38617 9.91639 6.52209 9.91639C6.76884 9.91639 7.01092 9.82598 7.197 9.65331L9.3215 7.68748C9.51459 7.50898 9.62484 7.25873 9.62484 6.99973C9.62484 6.74131 9.51459 6.49048 9.3215 6.31256L7.19759 4.34731ZM6.99984 11.6666C4.42675 11.6666 2.33317 9.57304 2.33317 6.99996C2.33317 4.42688 4.42675 2.33329 6.99984 2.33329C9.57292 2.33329 11.6665 4.42688 11.6665 6.99996C11.6665 9.57304 9.57292 11.6666 6.99984 11.6666ZM6.99984 1.16663C3.78334 1.16663 1.1665 3.78346 1.1665 6.99996C1.1665 10.2165 3.78334 12.8333 6.99984 12.8333C10.2163 12.8333 12.8332 10.2165 12.8332 6.99996C12.8332 3.78346 10.2163 1.16663 6.99984 1.16663Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8.625 10.9497V7.05045L10.7318 8.9997L8.625 10.9497ZM9.25425 5.58945C8.88075 5.24295 8.3355 5.15295 7.866 5.3592C7.4085 5.5587 7.125 5.98545 7.125 6.4722V11.528C7.125 12.0147 7.4085 12.4415 7.866 12.641C8.03325 12.7144 8.211 12.7497 8.38575 12.7497C8.703 12.7497 9.01425 12.6334 9.2535 12.4114L11.985 9.88395C12.2332 9.65445 12.375 9.3327 12.375 8.9997C12.375 8.66745 12.2332 8.34495 11.985 8.1162L9.25425 5.58945ZM9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15ZM9 1.5C4.8645 1.5 1.5 4.8645 1.5 9C1.5 13.1355 4.8645 16.5 9 16.5C13.1355 16.5 16.5 13.1355 16.5 9C16.5 4.8645 13.1355 1.5 9 1.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.66683 9.73311V6.26711L9.5395 7.99977L7.66683 9.73311ZM8.22616 4.96844C7.89416 4.66044 7.4095 4.58044 6.99216 4.76377C6.5855 4.94111 6.3335 5.32044 6.3335 5.75311V10.2471C6.3335 10.6798 6.5855 11.0591 6.99216 11.2364C7.14083 11.3018 7.29883 11.3331 7.45416 11.3331C7.73616 11.3331 8.01283 11.2298 8.2255 11.0324L10.6535 8.78577C10.8742 8.58177 11.0002 8.29577 11.0002 7.99977C11.0002 7.70444 10.8742 7.41777 10.6535 7.21444L8.22616 4.96844ZM8.00016 13.3334C5.0595 13.3334 2.66683 10.9407 2.66683 8.00004C2.66683 5.05937 5.0595 2.66671 8.00016 2.66671C10.9408 2.66671 13.3335 5.05937 13.3335 8.00004C13.3335 10.9407 10.9408 13.3334 8.00016 13.3334ZM8.00016 1.33337C4.32416 1.33337 1.3335 4.32404 1.3335 8.00004C1.3335 11.676 4.32416 14.6667 8.00016 14.6667C11.6762 14.6667 14.6668 11.676 14.6668 8.00004C14.6668 4.32404 11.6762 1.33337 8.00016 1.33337Z'
        fill={color}
      />
    </svg>
  );
};

export const HeartIcon = ({ color, large, small, style, className }: IIconProps) => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.21169 3.50004C3.70769 3.50004 3.23519 3.69487 2.88169 4.04896C2.14786 4.78396 2.14786 5.98037 2.88228 6.71654L7.00003 10.8413L11.1184 6.71654C11.8528 5.98037 11.8528 4.78396 11.1184 4.04896C10.4114 3.34021 9.16536 3.34137 8.45836 4.04896L7.41303 5.09604C7.19369 5.31596 6.80636 5.31596 6.58703 5.09604L5.54169 4.04837C5.18819 3.69487 4.71628 3.50004 4.21169 3.50004ZM7.00003 12.25C6.84544 12.25 6.69669 12.1888 6.58761 12.0785L2.05628 7.54021C0.868611 6.35021 0.868611 4.41412 2.05628 3.22412C2.63028 2.65012 3.39561 2.33337 4.21169 2.33337C5.02778 2.33337 5.79369 2.65012 6.36711 3.22412L7.00003 3.85821L7.63294 3.22471C8.20694 2.65012 8.97228 2.33337 9.78894 2.33337C10.6044 2.33337 11.3704 2.65012 11.9438 3.22412C13.132 4.41412 13.132 6.35021 11.9444 7.54021L7.41303 12.0791C7.30336 12.1888 7.15519 12.25 7.00003 12.25Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M5.41455 4.5C4.76655 4.5 4.15905 4.7505 3.70455 5.20575C2.76105 6.15075 2.76105 7.689 3.7053 8.6355L8.99955 13.9388L14.2945 8.6355C15.2388 7.689 15.2388 6.15075 14.2945 5.20575C13.3855 4.2945 11.7835 4.296 10.8745 5.20575L9.53055 6.552C9.24855 6.83475 8.75055 6.83475 8.46855 6.552L7.12455 5.205C6.67005 4.7505 6.0633 4.5 5.41455 4.5ZM8.99955 15.75C8.8008 15.75 8.60955 15.6712 8.4693 15.5295L2.6433 9.6945C1.1163 8.1645 1.1163 5.67525 2.6433 4.14525C3.3813 3.40725 4.3653 3 5.41455 3C6.4638 3 7.44855 3.40725 8.1858 4.14525L8.99955 4.9605L9.8133 4.146C10.5513 3.40725 11.5353 3 12.5853 3C13.6338 3 14.6185 3.40725 15.3558 4.14525C16.8835 5.67525 16.8835 8.1645 15.3565 9.6945L9.53055 15.5303C9.38955 15.6713 9.19905 15.75 8.99955 15.75Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.81336 3.99996C4.23736 3.99996 3.69736 4.22263 3.29336 4.62729C2.4547 5.46729 2.4547 6.83463 3.29403 7.67596L8.00003 12.39L12.7067 7.67596C13.546 6.83463 13.546 5.46729 12.7067 4.62729C11.8987 3.81729 10.4747 3.81863 9.6667 4.62729L8.47203 5.82396C8.22136 6.07529 7.7787 6.07529 7.52803 5.82396L6.33336 4.62663C5.92936 4.22263 5.39003 3.99996 4.81336 3.99996ZM8.00003 14C7.82336 14 7.65336 13.93 7.5287 13.804L2.35003 8.61729C0.992698 7.25729 0.992698 5.04463 2.35003 3.68463C3.00603 3.02863 3.8807 2.66663 4.81336 2.66663C5.74603 2.66663 6.62136 3.02863 7.2767 3.68463L8.00003 4.40929L8.72336 3.68529C9.37936 3.02863 10.254 2.66663 11.1874 2.66663C12.1194 2.66663 12.9947 3.02863 13.65 3.68463C15.008 5.04463 15.008 7.25729 13.6507 8.61729L8.47203 13.8046C8.3467 13.93 8.17736 14 8.00003 14Z'
        fill={color}
      />
    </svg>
  );
};

export const UnreviewedIcon = ({
  color,
  large,
  small,
  style,
  className,
}: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='10'
        height='8'
        viewBox='0 0 10 8'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M8.75 7.38462C8.75 7.54783 8.68415 7.70435 8.56694 7.81976C8.44973 7.93517 8.29076 8 8.125 8H1.875C1.70924 8 1.55027 7.93517 1.43306 7.81976C1.31585 7.70435 1.25 7.54783 1.25 7.38462C1.25 7.22141 1.31585 7.06488 1.43306 6.94947C1.55027 6.83407 1.70924 6.76923 1.875 6.76923H8.125C8.29076 6.76923 8.44973 6.83407 8.56694 6.94947C8.68415 7.06488 8.75 7.22141 8.75 7.38462ZM8.75 4.30769H1.25C1.08424 4.30769 0.925269 4.37253 0.808058 4.48793C0.690848 4.60334 0.625 4.75987 0.625 4.92308C0.625 5.08629 0.690848 5.24281 0.808058 5.35822C0.925269 5.47363 1.08424 5.53846 1.25 5.53846H8.75C8.91576 5.53846 9.07473 5.47363 9.19194 5.35822C9.30915 5.24281 9.375 5.08629 9.375 4.92308C9.375 4.75987 9.30915 4.60334 9.19194 4.48793C9.07473 4.37253 8.91576 4.30769 8.75 4.30769ZM10 1.53846C9.99951 1.94634 9.83474 2.33738 9.54182 2.62579C9.2489 2.9142 8.85175 3.07644 8.4375 3.07692H1.5625C1.1481 3.07692 0.750671 2.91484 0.457646 2.62632C0.16462 2.3378 0 1.94649 0 1.53846C0 1.13044 0.16462 0.739123 0.457646 0.450605C0.750671 0.162087 1.1481 0 1.5625 0H8.4375C8.85175 0.000478821 9.2489 0.16272 9.54182 0.451134C9.83474 0.739548 9.99951 1.13058 10 1.53846ZM8.75 1.53846C8.74994 1.45687 8.717 1.37864 8.65841 1.32095C8.59982 1.26326 8.52036 1.23082 8.4375 1.23077H1.5625C1.47962 1.23077 1.40013 1.26319 1.34153 1.32089C1.28292 1.37859 1.25 1.45686 1.25 1.53846C1.25 1.62007 1.28292 1.69833 1.34153 1.75603C1.40013 1.81374 1.47962 1.84615 1.5625 1.84615H8.4375C8.52036 1.8461 8.59982 1.81366 8.65841 1.75597C8.717 1.69828 8.74994 1.62005 8.75 1.53846Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='16'
        height='14'
        viewBox='0 0 16 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M14 12.5C14 12.7652 13.8946 13.0196 13.7071 13.2071C13.5196 13.3946 13.2652 13.5 13 13.5H3C2.73478 13.5 2.48043 13.3946 2.29289 13.2071C2.10536 13.0196 2 12.7652 2 12.5C2 12.2348 2.10536 11.9804 2.29289 11.7929C2.48043 11.6054 2.73478 11.5 3 11.5H13C13.2652 11.5 13.5196 11.6054 13.7071 11.7929C13.8946 11.9804 14 12.2348 14 12.5ZM14 7.5H2C1.73478 7.5 1.48043 7.60536 1.29289 7.79289C1.10536 7.98043 1 8.23478 1 8.5C1 8.76522 1.10536 9.01957 1.29289 9.20711C1.48043 9.39464 1.73478 9.5 2 9.5H14C14.2652 9.5 14.5196 9.39464 14.7071 9.20711C14.8946 9.01957 15 8.76522 15 8.5C15 8.23478 14.8946 7.98043 14.7071 7.79289C14.5196 7.60536 14.2652 7.5 14 7.5ZM16 3C15.9992 3.6628 15.7356 4.29824 15.2669 4.76691C14.7982 5.23558 14.1628 5.49922 13.5 5.5H2.5C1.83696 5.5 1.20107 5.23661 0.732233 4.76777C0.263392 4.29893 0 3.66304 0 3C0 2.33696 0.263392 1.70107 0.732233 1.23223C1.20107 0.763392 1.83696 0.5 2.5 0.5H13.5C14.1628 0.500778 14.7982 0.76442 15.2669 1.23309C15.7356 1.70176 15.9992 2.3372 16 3ZM14 3C13.9999 2.86742 13.9472 2.74029 13.8535 2.64655C13.7597 2.5528 13.6326 2.50009 13.5 2.5H2.5C2.36739 2.5 2.24021 2.55268 2.14645 2.64645C2.05268 2.74021 2 2.86739 2 3C2 3.13261 2.05268 3.25979 2.14645 3.35355C2.24021 3.44732 2.36739 3.5 2.5 3.5H13.5C13.6326 3.49991 13.7597 3.4472 13.8535 3.35345C13.9472 3.25971 13.9999 3.13258 14 3Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='14'
      height='10'
      viewBox='0 0 14 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M11.875 9.23077C11.875 9.43478 11.7894 9.63044 11.637 9.7747C11.4847 9.91896 11.278 10 11.0625 10H2.9375C2.72201 10 2.51535 9.91896 2.36298 9.7747C2.2106 9.63044 2.125 9.43478 2.125 9.23077C2.125 9.02676 2.2106 8.8311 2.36298 8.68684C2.51535 8.54258 2.72201 8.46154 2.9375 8.46154H11.0625C11.278 8.46154 11.4847 8.54258 11.637 8.68684C11.7894 8.8311 11.875 9.02676 11.875 9.23077ZM11.875 5.38462H2.125C1.90951 5.38462 1.70285 5.46566 1.55048 5.60992C1.3981 5.75418 1.3125 5.94983 1.3125 6.15385C1.3125 6.35786 1.3981 6.55352 1.55048 6.69777C1.70285 6.84203 1.90951 6.92308 2.125 6.92308H11.875C12.0905 6.92308 12.2972 6.84203 12.4495 6.69777C12.6019 6.55352 12.6875 6.35786 12.6875 6.15385C12.6875 5.94983 12.6019 5.75418 12.4495 5.60992C12.2972 5.46566 12.0905 5.38462 11.875 5.38462ZM13.5 1.92308C13.4994 2.43292 13.2852 2.92172 12.9044 3.28224C12.5236 3.64275 12.0073 3.84556 11.4688 3.84615H2.53125C1.99253 3.84615 1.47587 3.64354 1.09494 3.2829C0.714006 2.92225 0.5 2.43311 0.5 1.92308C0.5 1.41305 0.714006 0.923903 1.09494 0.563256C1.47587 0.202609 1.99253 0 2.53125 0H11.4688C12.0073 0.000598526 12.5236 0.2034 12.9044 0.563917C13.2852 0.924434 13.4994 1.41323 13.5 1.92308ZM11.875 1.92308C11.8749 1.82109 11.8321 1.7233 11.7559 1.65119C11.6798 1.57907 11.5765 1.53853 11.4688 1.53846H2.53125C2.42351 1.53846 2.32017 1.57898 2.24399 1.65111C2.1678 1.72324 2.125 1.82107 2.125 1.92308C2.125 2.02508 2.1678 2.12291 2.24399 2.19504C2.32017 2.26717 2.42351 2.30769 2.53125 2.30769H11.4688C11.5765 2.30762 11.6798 2.26708 11.7559 2.19496C11.8321 2.12285 11.8749 2.02506 11.875 1.92308Z'
        fill={color}
      />
    </svg>
  );
};

export const UnlockIcon = ({ color, large, small, style, className }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='10'
        height='12'
        viewBox='0 0 10 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.99967 8.33329C4.67767 8.33329 4.41634 8.07196 4.41634 7.74996C4.41634 7.42796 4.67767 7.16663 4.99967 7.16663C5.32167 7.16663 5.58301 7.42796 5.58301 7.74996C5.58301 8.07196 5.32167 8.33329 4.99967 8.33329ZM4.99967 5.99996C4.03484 5.99996 3.24967 6.78513 3.24967 7.74996C3.24967 8.71479 4.03484 9.49996 4.99967 9.49996C5.96451 9.49996 6.74967 8.71479 6.74967 7.74996C6.74967 6.78513 5.96451 5.99996 4.99967 5.99996ZM8.49967 10.0833C8.49967 10.4053 8.23834 10.6666 7.91634 10.6666H2.08301C1.76101 10.6666 1.49967 10.4053 1.49967 10.0833V5.41663C1.49967 5.09463 1.76101 4.83329 2.08301 4.83329H7.91634C8.23834 4.83329 8.49967 5.09463 8.49967 5.41663V10.0833ZM7.91634 3.66663H3.83301V2.49996C3.83301 1.85654 4.35626 1.33329 4.99967 1.33329C5.64309 1.33329 6.16634 1.85654 6.16634 2.49996C6.16634 2.82254 6.42709 3.08329 6.74967 3.08329C7.07226 3.08329 7.33301 2.82254 7.33301 2.49996C7.33301 1.21313 6.28651 0.166626 4.99967 0.166626C3.71284 0.166626 2.66634 1.21313 2.66634 2.49996V3.66663H2.08301C1.11817 3.66663 0.333008 4.45179 0.333008 5.41663V10.0833C0.333008 11.0481 1.11817 11.8333 2.08301 11.8333H7.91634C8.88117 11.8333 9.66634 11.0481 9.66634 10.0833V5.41663C9.66634 4.45179 8.88117 3.66663 7.91634 3.66663Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='12'
        height='16'
        viewBox='0 0 12 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6 11C5.586 11 5.25 10.664 5.25 10.25C5.25 9.836 5.586 9.5 6 9.5C6.414 9.5 6.75 9.836 6.75 10.25C6.75 10.664 6.414 11 6 11ZM6 8C4.7595 8 3.75 9.0095 3.75 10.25C3.75 11.4905 4.7595 12.5 6 12.5C7.2405 12.5 8.25 11.4905 8.25 10.25C8.25 9.0095 7.2405 8 6 8ZM10.5 13.25C10.5 13.664 10.164 14 9.75 14H2.25C1.836 14 1.5 13.664 1.5 13.25V7.25C1.5 6.836 1.836 6.5 2.25 6.5H9.75C10.164 6.5 10.5 6.836 10.5 7.25V13.25ZM9.75 5H4.5V3.5C4.5 2.67275 5.17275 2 6 2C6.82725 2 7.5 2.67275 7.5 3.5C7.5 3.91475 7.83525 4.25 8.25 4.25C8.66475 4.25 9 3.91475 9 3.5C9 1.8455 7.6545 0.5 6 0.5C4.3455 0.5 3 1.8455 3 3.5V5H2.25C1.0095 5 0 6.0095 0 7.25V13.25C0 14.4905 1.0095 15.5 2.25 15.5H9.75C10.9905 15.5 12 14.4905 12 13.25V7.25C12 6.0095 10.9905 5 9.75 5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.00033 9.66671C5.63233 9.66671 5.33366 9.36804 5.33366 9.00004C5.33366 8.63204 5.63233 8.33337 6.00033 8.33337C6.36833 8.33337 6.66699 8.63204 6.66699 9.00004C6.66699 9.36804 6.36833 9.66671 6.00033 9.66671ZM6.00033 7.00004C4.89766 7.00004 4.00033 7.89737 4.00033 9.00004C4.00033 10.1027 4.89766 11 6.00033 11C7.10299 11 8.00033 10.1027 8.00033 9.00004C8.00033 7.89737 7.10299 7.00004 6.00033 7.00004ZM10.0003 11.6667C10.0003 12.0347 9.70166 12.3334 9.33366 12.3334H2.66699C2.29899 12.3334 2.00033 12.0347 2.00033 11.6667V6.33337C2.00033 5.96537 2.29899 5.66671 2.66699 5.66671H9.33366C9.70166 5.66671 10.0003 5.96537 10.0003 6.33337V11.6667ZM9.33366 4.33337H4.66699V3.00004C4.66699 2.26471 5.26499 1.66671 6.00033 1.66671C6.73566 1.66671 7.33366 2.26471 7.33366 3.00004C7.33366 3.36871 7.63166 3.66671 8.00033 3.66671C8.36899 3.66671 8.66699 3.36871 8.66699 3.00004C8.66699 1.52937 7.47099 0.333374 6.00033 0.333374C4.52966 0.333374 3.33366 1.52937 3.33366 3.00004V4.33337H2.66699C1.56433 4.33337 0.666992 5.23071 0.666992 6.33337V11.6667C0.666992 12.7694 1.56433 13.6667 2.66699 13.6667H9.33366C10.4363 13.6667 11.3337 12.7694 11.3337 11.6667V6.33337C11.3337 5.23071 10.4363 4.33337 9.33366 4.33337Z'
        fill={color}
      />
    </svg>
  );
};

export const PillDataIcon = ({
  color,
  large,
  small,
  style,
  className,
}: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M7 1C5.42798 1 4.00298 1.23618 2.92708 1.64859C2.38905 1.8548 1.93854 2.1014 1.59372 2.41383C1.24902 2.72625 1 3.13664 1 3.59451V10.4053C1 10.8632 1.24891 11.2685 1.59372 11.5811C1.93854 11.8935 2.38905 12.1401 2.92708 12.3463C4.00304 12.7587 5.42801 13 7 13C8.57199 13 9.99702 12.7587 11.0729 12.3463C11.611 12.1401 12.0615 11.8936 12.4063 11.5811C12.7511 11.2687 13 10.8634 13 10.4053V3.59451C13 3.13664 12.7511 2.72625 12.4063 2.41383C12.0615 2.1014 11.611 1.8548 11.0729 1.64859C9.99697 1.23618 8.57199 1 7 1ZM7 1.97303C8.46554 1.97303 9.79378 2.20526 10.7083 2.5558C11.1657 2.73113 11.5174 2.93645 11.7292 3.12838C11.941 3.32034 12.0001 3.47034 12.0001 3.59466C12.0001 3.71886 11.9411 3.86387 11.7292 4.05584C11.5174 4.24779 11.1657 4.45322 10.7083 4.62842C9.79375 4.97895 8.46563 5.21628 7 5.21628C5.53446 5.21628 4.20634 4.97897 3.29167 4.62842C2.83432 4.45309 2.48262 4.24777 2.2708 4.05584C2.05898 3.86388 1.99992 3.71886 1.99992 3.59466C1.99992 3.47046 2.05887 3.32035 2.2708 3.12838C2.48263 2.93643 2.83432 2.731 3.29167 2.5558C4.20625 2.20527 5.53449 1.97303 7 1.97303ZM2 5.07932C2.26937 5.25283 2.58 5.40237 2.92702 5.5354C4.00298 5.94781 5.42795 6.18909 6.99994 6.18909C8.57193 6.18909 9.99696 5.94781 11.0729 5.5354C11.42 5.40237 11.7305 5.25283 11.9999 5.07932V5.86479C11.9999 5.98899 11.9409 6.13401 11.729 6.32597C11.5172 6.51793 11.1655 6.72335 10.7081 6.89855C9.79355 7.24908 8.46543 7.48642 6.9998 7.48642C5.53427 7.48642 4.20614 7.2491 3.29147 6.89855C2.83412 6.72322 2.48242 6.5179 2.27061 6.32597C2.0589 6.1339 1.99996 5.98899 1.99996 5.86479L2 5.07932ZM2 7.34458C2.26937 7.51923 2.57851 7.67206 2.92702 7.80576C4.00298 8.21817 5.42795 8.45945 6.99994 8.45945C8.57193 8.45945 9.99696 8.21817 11.0729 7.80576C11.4215 7.67217 11.7305 7.51924 11.9999 7.34458V8.13515C11.9999 8.25935 11.9409 8.40437 11.729 8.59633C11.5172 8.78829 11.1655 8.99372 10.7081 9.16891C9.79355 9.51944 8.46543 9.75678 6.9998 9.75678C5.53427 9.75678 4.20614 9.51946 3.29147 9.16891C2.83412 8.99358 2.48242 8.78826 2.27061 8.59633C2.05879 8.4044 1.99973 8.25935 1.99973 8.13515V7.34458H2ZM2 9.6148C2.26937 9.78945 2.57851 9.94228 2.92702 10.076C4.00298 10.4884 5.42795 10.7297 6.99994 10.7297C8.57193 10.7297 9.99696 10.4884 11.0729 10.076C11.4215 9.94239 11.7305 9.78946 11.9999 9.6148V10.4054C11.9999 10.5296 11.9409 10.6746 11.729 10.8665C11.5172 11.0585 11.1655 11.2639 10.7081 11.4391C9.79355 11.7897 8.46543 12.027 6.9998 12.027C5.53427 12.027 4.20614 11.7897 3.29147 11.4391C2.83412 11.2638 2.48242 11.0585 2.27061 10.8665C2.05879 10.6746 1.99973 10.5296 1.99973 10.4054V9.6148H2Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M9 1C6.90397 1 5.00397 1.31491 3.56944 1.86479C2.85206 2.13974 2.25139 2.46854 1.79163 2.8851C1.33202 3.30167 1 3.84885 1 4.45935V13.5405C1 14.151 1.33188 14.6914 1.79163 15.1081C2.25139 15.5247 2.85206 15.8535 3.56944 16.1284C5.00405 16.6783 6.90401 17 9 17C11.096 17 12.996 16.6783 14.4306 16.1284C15.1479 15.8535 15.7486 15.5248 16.2084 15.1081C16.6681 14.6915 17 14.1512 17 13.5405V4.45935C17 3.84885 16.6681 3.30167 16.2084 2.8851C15.7486 2.46854 15.1479 2.13973 14.4306 1.86479C12.996 1.3149 11.096 1 9 1ZM9 2.29738C10.954 2.29738 12.725 2.60701 13.9444 3.07441C14.5542 3.30818 15.0232 3.58194 15.3056 3.83784C15.588 4.09379 15.6668 4.29379 15.6668 4.45954C15.6668 4.62515 15.5882 4.8185 15.3056 5.07445C15.0232 5.33039 14.5542 5.6043 13.9444 5.83789C12.725 6.30526 10.9542 6.62171 9 6.62171C7.04595 6.62171 5.27512 6.30529 4.05556 5.83789C3.44575 5.60412 2.97683 5.33036 2.69441 5.07445C2.41198 4.81851 2.33323 4.62514 2.33323 4.45954C2.33323 4.29394 2.41182 4.0938 2.69441 3.83784C2.97683 3.5819 3.44575 3.308 4.05556 3.07441C5.275 2.60703 7.04599 2.29738 9 2.29738ZM2.33333 6.43909C2.69249 6.67045 3.10667 6.86982 3.56937 7.0472C5.00397 7.59708 6.90393 7.91878 8.99992 7.91878C11.0959 7.91878 12.996 7.59708 14.4305 7.0472C14.8933 6.86983 15.3074 6.67045 15.6665 6.43909V7.48639C15.6665 7.65199 15.5879 7.84534 15.3053 8.10129C15.0229 8.35723 14.554 8.63114 13.9442 8.86473C12.7247 9.33211 10.9539 9.64855 8.99974 9.64855C7.04569 9.64855 5.27486 9.33213 4.05529 8.86473C3.44549 8.63096 2.97656 8.3572 2.69414 8.10129C2.41187 7.8452 2.33328 7.65199 2.33328 7.48639L2.33333 6.43909ZM2.33333 9.45944C2.69249 9.69231 3.10468 9.89608 3.56937 10.0743C5.00397 10.6242 6.90393 10.9459 8.99992 10.9459C11.0959 10.9459 12.996 10.6242 14.4305 10.0743C14.8954 9.89623 15.3074 9.69232 15.6665 9.45944V10.5135C15.6665 10.6791 15.5879 10.8725 15.3053 11.1284C15.0229 11.3844 14.554 11.6583 13.9442 11.8919C12.7247 12.3593 10.9539 12.6757 8.99974 12.6757C7.04569 12.6757 5.27486 12.3593 4.05529 11.8919C3.44549 11.6581 2.97656 11.3843 2.69414 11.1284C2.41172 10.8725 2.33297 10.6791 2.33297 10.5135V9.45944H2.33333ZM2.33333 12.4864C2.69249 12.7193 3.10468 12.923 3.56937 13.1013C5.00397 13.6512 6.90393 13.9729 8.99992 13.9729C11.0959 13.9729 12.996 13.6512 14.4305 13.1013C14.8954 12.9232 15.3074 12.7193 15.6665 12.4864V13.5405C15.6665 13.7061 15.5879 13.8994 15.3053 14.1554C15.0229 14.4113 14.554 14.6852 13.9442 14.9188C12.7247 15.3862 10.9539 15.7027 8.99974 15.7027C7.04569 15.7027 5.27486 15.3862 4.05529 14.9188C3.44549 14.6851 2.97656 14.4113 2.69414 14.1554C2.41172 13.8995 2.33297 13.7061 2.33297 13.5405V12.4864H2.33333Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M8 1C6.16597 1 4.50347 1.27555 3.24826 1.75669C2.62056 1.99727 2.09497 2.28497 1.69267 2.64946C1.29052 3.01396 1 3.49274 1 4.02693V11.9729C1 12.5071 1.29039 12.98 1.69267 13.3446C2.09497 13.7091 2.62056 13.9968 3.24826 14.2374C4.50354 14.7185 6.16601 15 8 15C9.83399 15 11.4965 14.7185 12.7517 14.2374C13.3794 13.9968 13.905 13.7092 14.3073 13.3446C14.7096 12.9801 15 12.5073 15 11.9729V4.02693C15 3.49274 14.7096 3.01396 14.3073 2.64946C13.905 2.28497 13.3794 1.99727 12.7517 1.75669C11.4965 1.27554 9.83399 1 8 1ZM8 2.13521C9.70979 2.13521 11.2594 2.40613 12.3264 2.81511C12.86 3.01966 13.2703 3.25919 13.5174 3.48311C13.7645 3.70706 13.8334 3.88207 13.8334 4.0271C13.8334 4.172 13.7647 4.34119 13.5174 4.56514C13.2703 4.78909 12.86 5.02876 12.3264 5.23315C11.2594 5.64211 9.7099 5.919 8 5.919C6.29021 5.919 4.74073 5.64213 3.67361 5.23315C3.14003 5.0286 2.72972 4.78906 2.4826 4.56514C2.23548 4.34119 2.16658 4.172 2.16658 4.0271C2.16658 3.8822 2.23534 3.70708 2.4826 3.48311C2.72973 3.25916 3.14003 3.0195 3.67361 2.81511C4.74063 2.40615 6.29024 2.13521 8 2.13521ZM2.16667 5.7592C2.48093 5.96164 2.84333 6.13609 3.24819 6.2913C4.50347 6.77245 6.16594 7.05393 7.99993 7.05393C9.83392 7.05393 11.4965 6.77245 12.7517 6.2913C13.1567 6.1361 13.519 5.96164 13.8332 5.7592V6.67559C13.8332 6.82049 13.7644 6.98967 13.5172 7.21363C13.27 7.43758 12.8597 7.67725 12.3262 7.88164C11.2591 8.29059 9.70967 8.56748 7.99977 8.56748C6.28998 8.56748 4.7405 8.29062 3.67338 7.88164C3.13981 7.67709 2.72949 7.43755 2.48238 7.21363C2.23539 6.98955 2.16662 6.82049 2.16662 6.67559L2.16667 5.7592ZM2.16667 8.40201C2.48093 8.60577 2.8416 8.78407 3.24819 8.94005C4.50347 9.4212 6.16594 9.70269 7.99993 9.70269C9.83392 9.70269 11.4965 9.4212 12.7517 8.94005C13.1584 8.7842 13.519 8.60578 13.8332 8.40201V9.32434C13.8332 9.46925 13.7644 9.63843 13.5172 9.86239C13.27 10.0863 12.8597 10.326 12.3262 10.5304C11.2591 10.9393 9.70967 11.2162 7.99977 11.2162C6.28998 11.2162 4.7405 10.9394 3.67338 10.5304C3.13981 10.3258 2.72949 10.0863 2.48238 9.86239C2.23526 9.63847 2.16635 9.46924 2.16635 9.32434V8.40201H2.16667ZM2.16667 11.0506C2.48093 11.2544 2.8416 11.4327 3.24819 11.5886C4.50347 12.0698 6.16594 12.3513 7.99993 12.3513C9.83392 12.3513 11.4965 12.0698 12.7517 11.5886C13.1584 11.4328 13.519 11.2544 13.8332 11.0506V11.9729C13.8332 12.1178 13.7644 12.287 13.5172 12.511C13.27 12.7349 12.8597 12.9746 12.3262 13.179C11.2591 13.5879 9.70967 13.8648 7.99977 13.8648C6.28998 13.8648 4.7405 13.588 3.67338 13.179C3.13981 12.9744 2.72949 12.7349 2.48238 12.511C2.23526 12.2871 2.16635 12.1178 2.16635 11.9729V11.0506H2.16667Z'
        fill={color}
      />
    </svg>
  );
};

export const PillStatusIcon = ({ color, style, className }: IIconProps): JSX.Element => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.79995 6.57144C7.46875 6.57144 7.19995 6.31544 7.19995 6.00001C7.19995 5.68458 7.46875 5.42858 7.79995 5.42858C8.13115 5.42858 8.39995 5.68458 8.39995 6.00001C8.39995 6.31544 8.13115 6.57144 7.79995 6.57144ZM7.8 4.28573C6.8076 4.28573 6 5.05487 6 6.00002C6 6.94516 6.8076 7.7143 7.8 7.7143C8.7924 7.7143 9.6 6.94516 9.6 6.00002C9.6 5.05487 8.7924 4.28573 7.8 4.28573ZM7.80019 8.85713H4.2002C2.546 8.85713 1.2002 7.57542 1.2002 5.99999C1.2002 4.42456 2.546 3.14285 4.2002 3.14285H7.80019C9.45439 3.14285 10.8002 4.42456 10.8002 5.99999C10.8002 7.57542 9.45439 8.85713 7.80019 8.85713ZM7.8 2H4.2C1.8846 2 0 3.79486 0 6C0 8.20514 1.8846 10 4.2 10H7.8C10.1154 10 12 8.20514 12 6C12 3.79486 10.1154 2 7.8 2Z'
        fill={color}
      />
    </svg>
  );
};

export const UndoIcon = ({ color, large, small, style, className }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.10519 6.41208C8.16798 6.41208 10.0287 7.37323 11.2057 8.9173C10.6644 6.64148 8.58308 4.94153 6.10519 4.94153C5.78503 4.94153 5.52624 4.6786 5.52624 4.35331V3.22217L2.7334 5.67739L5.52624 8.15497V7.0003C5.52624 6.67501 5.78503 6.41208 6.10519 6.41208ZM11.7595 12C11.4926 12 11.2599 11.8147 11.1968 11.5512C10.6815 9.40478 8.86884 7.85423 6.6839 7.61953V8.27893C6.6839 8.69421 6.44132 9.0642 6.05111 9.24361C5.62789 9.43948 5.13405 9.3689 4.79074 9.06479L1.85779 6.46251C1.63026 6.26016 1.5 5.9737 1.5 5.67665C1.5 5.3796 1.63026 5.09313 1.85779 4.89079L4.79074 2.2885C5.13405 1.9844 5.62789 1.91381 6.05111 2.10969C6.44132 2.28909 6.6839 2.65908 6.6839 3.07436V3.79082C9.93989 4.08081 12.5 6.79426 12.5 10.0883C12.5 10.5647 12.4398 11.0565 12.3217 11.5506C12.2592 11.8147 12.027 12 11.7595 12Z'
          fill={color}
        />
      </svg>
    );
  }

  if (large) {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7.8607 8.2357C10.4861 8.2357 12.8543 9.4852 14.3523 11.4925C13.6633 8.53393 11.0144 6.32399 7.8607 6.32399C7.45323 6.32399 7.12386 5.98218 7.12386 5.55931V4.08882L3.56934 7.28061L7.12386 10.5015V9.00039C7.12386 8.57752 7.45323 8.2357 7.8607 8.2357ZM15.0576 15.5C14.7179 15.5 14.4217 15.2591 14.3414 14.9165C13.6856 12.1262 11.3785 10.1105 8.59768 9.80539V10.6626C8.59768 11.2025 8.28895 11.6835 7.79232 11.9167C7.25368 12.1713 6.62516 12.0796 6.18821 11.6842L2.45537 8.30126C2.16579 8.03821 2 7.66581 2 7.27964C2 6.89347 2.16579 6.52107 2.45537 6.25802L6.18821 2.87506C6.62516 2.47971 7.25368 2.38795 7.79232 2.64259C8.28895 2.87582 8.59768 3.35681 8.59768 3.89667V4.82806C12.7417 5.20505 16 8.73254 16 13.0148C16 13.6342 15.9234 14.2734 15.7731 14.9158C15.6935 15.2591 15.398 15.5 15.0576 15.5Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.94236 7.35312C9.3802 7.35312 11.5793 8.41039 12.9703 10.1089C12.3305 7.60547 9.87078 5.73552 6.94236 5.73552C6.56399 5.73552 6.25815 5.44629 6.25815 5.08848V3.84422L2.95752 6.54497L6.25815 9.2703V8.00016C6.25815 7.64235 6.56399 7.35312 6.94236 7.35312ZM13.6249 13.5C13.3095 13.5 13.0344 13.2962 12.9598 13.0063C12.3509 10.6453 10.2086 8.93966 7.62642 8.68149V9.40682C7.62642 9.86363 7.33974 10.2706 6.87858 10.468C6.37842 10.6834 5.79479 10.6058 5.38905 10.2713L1.92284 7.40876C1.65395 7.18617 1.5 6.87107 1.5 6.54431C1.5 6.21755 1.65395 5.90245 1.92284 5.67986L5.38905 2.81735C5.79479 2.48283 6.37842 2.40519 6.87858 2.62065C7.33974 2.818 7.62642 3.22499 7.62642 3.6818V4.4699C11.4744 4.78889 14.5 7.77369 14.5 11.3971C14.5 11.9212 14.4288 12.4621 14.2893 13.0057C14.2154 13.2962 13.941 13.5 13.6249 13.5Z'
        fill={color}
      />
    </svg>
  );
};

export const UploadIcon = ({ color, small, style, className }: IIconProps): JSX.Element => {
  if (small) {
    return (
      <svg
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
        className={className}
      >
        <path
          d='M6.6499 5.36653C6.85165 5.21493 7.12956 5.21073 7.33545 5.35579L9.66846 6.99739C9.93199 7.18279 9.99618 7.54684 9.81104 7.80989C9.62566 8.0728 9.26216 8.13751 8.99854 7.95247L7.57861 6.95345C7.57984 6.96888 7.5835 6.98457 7.5835 7.00032V11.6663C7.5835 11.9882 7.32292 12.2501 7.00049 12.2503C6.67791 12.2503 6.4165 11.9883 6.4165 11.6663V6.99934L5.01709 8.05013C4.91211 8.12886 4.78937 8.16632 4.66748 8.16634C4.48956 8.16634 4.31462 8.08577 4.19971 7.93294C4.00646 7.67513 4.05922 7.3095 4.31689 7.11653L6.6499 5.36653ZM11.0835 2.33333C11.4042 2.33333 11.6663 2.59565 11.6665 2.91634V4.08333C11.6665 4.40416 11.4043 4.66634 11.0835 4.66634C10.7627 4.66634 10.5005 4.40416 10.5005 4.08333V3.50032H3.50049V4.08333C3.50049 4.40416 3.23734 4.66634 2.9165 4.66634C2.59582 4.66616 2.3335 4.40405 2.3335 4.08333V2.91634C2.33367 2.59576 2.59593 2.33351 2.9165 2.33333H11.0835Z'
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      className={className}
    >
      <path
        d='M7.6001 6.13347C7.83076 5.96021 8.148 5.95577 8.3833 6.12175L11.0503 7.99773C11.3512 8.20983 11.4233 8.62593 11.2114 8.92644C10.9993 9.2267 10.5839 9.29946 10.2827 9.08757L8.66064 7.94695C8.66203 7.96444 8.6665 7.98183 8.6665 7.99968V13.3337C8.66633 13.7015 8.36807 13.9997 7.99951 13.9997C7.6311 13.9995 7.33367 13.7014 7.3335 13.3337L7.33252 7.99968L5.73291 9.19987C5.61293 9.28982 5.47279 9.33366 5.3335 9.33366C5.13046 9.33356 4.93156 9.24133 4.80029 9.06706C4.57899 8.77243 4.63853 8.35416 4.93311 8.13347L7.6001 6.13347ZM12.8003 2.68034C12.8436 2.68926 12.8854 2.70247 12.9253 2.71941C13.0051 2.75329 13.0768 2.80247 13.1372 2.86296C13.2579 2.98378 13.3335 3.15041 13.3335 3.33366V4.66667C13.3335 5.03334 13.0332 5.33366 12.6665 5.33366C12.2998 5.33366 11.9995 5.03334 11.9995 4.66667V3.99968H3.99951V4.66667C3.99951 5.03323 3.70001 5.33349 3.3335 5.33366C2.96683 5.33366 2.6665 5.03334 2.6665 4.66667V3.33366C2.6665 3.15033 2.74196 2.98379 2.86279 2.86296C2.92328 2.80247 2.99491 2.75326 3.07471 2.71941C3.1146 2.70248 3.15636 2.68924 3.19971 2.68034C3.24287 2.67148 3.28781 2.66667 3.3335 2.66667H12.6665C12.7123 2.66667 12.757 2.67144 12.8003 2.68034Z'
        fill={color}
      />
    </svg>
  );
};
